/* ty-show.js: נבנה אוטומטית מ-shopify-agent/docs/iphone18-compare-2026-09-14/build-showcase-store.mjs. אין לערוך ביד. */
/* ── js/data.js ── */
/* הנתונים. המקור: apple.com/iphone/compare (נשלף 14.09.2026), כולל מידות הגוף במ"מ.
   טרייד אין: המחירון החי מ-09.09.2026 (הנפח הגבוה, מכשיר תקין).
   batSim: שעות וידאו לדגם עם חריץ SIM פיזי, כשהוא שונה מהמספר של Apple (שנמדד על eSIM). null = לא ידוע עדיין. */
(() => {
  const RAW = [
    // name, slug, ser, year, chip, gen, bat, esim, mp, zoom, fps, selfie, hz, screen, charge, trade, h, w, island
    ['iPhone 17 Pro Max', 'iphone-17-pro-max', 17, 2025, 'A19 Pro', 19, 37, false, 48, 8, 120, 18, 120, 6.9, 20, 3500, 163.4, 78.0, true],
    ['iPhone 17 Pro', 'iphone-17-pro', 17, 2025, 'A19 Pro', 19, 31, false, 48, 8, 120, 18, 120, 6.3, 20, 3300, 150.0, 71.9, true],
    ['iPhone 17 Air', 'iphone-air', 17, 2025, 'A19 Pro', 19, 27, false, 48, 2, 60, 18, 120, 6.5, 30, 1800, 156.2, 74.7, true],
    ['iPhone 17', 'iphone-17', 17, 2025, 'A19', 19, 30, false, 48, 2, 60, 18, 120, 6.3, 20, 2000, 149.6, 71.5, true],
    ['iPhone 16 Pro Max', 'iphone-16-pro-max', 16, 2024, 'A18 Pro', 18, 33, false, 48, 5, 120, 12, 120, 6.9, 35, 2600, 163.0, 77.6, true],
    ['iPhone 16 Pro', 'iphone-16-pro', 16, 2024, 'A18 Pro', 18, 27, false, 48, 5, 120, 12, 120, 6.3, 30, 2200, 149.6, 71.5, true],
    ['iPhone 16 Plus', 'iphone-16-plus', 16, 2024, 'A18', 18, 27, false, 48, 2, 60, 12, 60, 6.7, 35, 1500, 160.9, 77.8, true],
    ['iPhone 16', 'iphone-16', 16, 2024, 'A18', 18, 22, false, 48, 2, 60, 12, 60, 6.1, 30, 1500, 147.6, 71.6, true],
    ['iPhone 16e', 'iphone-16e', 16, 2025, 'A18', 18, 26, false, 48, 2, 60, 12, 60, 6.1, 30, null, 146.7, 71.5, false],
    ['iPhone 15 Pro Max', 'iphone-15-pro-max', 15, 2023, 'A17 Pro', 17, 29, false, 48, 5, 60, 12, 120, 6.7, 35, 1900, 159.9, 76.7, true],
    ['iPhone 15 Pro', 'iphone-15-pro', 15, 2023, 'A17 Pro', 17, 23, false, 48, 3, 60, 12, 120, 6.1, 30, 1600, 146.6, 70.6, true],
    ['iPhone 15 Plus', 'iphone-15-plus', 15, 2023, 'A16 Bionic', 16, 26, false, 48, 2, 60, 12, 60, 6.7, 35, 1100, 160.9, 77.8, true],
    ['iPhone 15', 'iphone-15', 15, 2023, 'A16 Bionic', 16, 20, false, 48, 2, 60, 12, 60, 6.1, 30, 1100, 147.6, 71.6, true],
    ['iPhone 14 Pro Max', 'iphone-14-pro-max', 14, 2022, 'A16 Bionic', 16, 29, false, 48, 3, 60, 12, 120, 6.7, 35, 1500, 160.7, 77.6, true],
    ['iPhone 14 Pro', 'iphone-14-pro', 14, 2022, 'A16 Bionic', 16, 23, false, 48, 3, 60, 12, 120, 6.1, 30, 1300, 147.5, 71.5, true],
    ['iPhone 14 Plus', 'iphone-14-plus', 14, 2022, 'A15 Bionic', 15, 26, false, 12, 1, 60, 12, 60, 6.7, 35, 900, 160.8, 78.1, false],
    ['iPhone 14', 'iphone-14', 14, 2022, 'A15 Bionic', 15, 20, false, 12, 1, 60, 12, 60, 6.1, 30, 850, 146.7, 71.5, false],
    ['iPhone 13 Pro Max', 'iphone-13-pro-max', 13, 2021, 'A15 Bionic', 15, 28, false, 12, 3, 60, 12, 120, 6.7, 35, 1150, 160.8, 78.1, false],
    ['iPhone 13 Pro', 'iphone-13-pro', 13, 2021, 'A15 Bionic', 15, 22, false, 12, 3, 60, 12, 120, 6.1, 30, 950, 146.7, 71.5, false],
    ['iPhone 13', 'iphone-13', 13, 2021, 'A15 Bionic', 15, 19, false, 12, 1, 60, 12, 60, 6.1, 30, 800, 146.7, 71.5, false],
    /* שלושת הבאים נוספו 23.09.2026, כי הם היו במחירון הטרייד אין החי ולא היה להם מפרט להשוואה.
       המקור הוא דפי המפרט הרשמיים של Apple, נשלפו באותו יום:
         iPhone 13 mini   support.apple.com/en-us/111873
         iPhone 12 Pro    support.apple.com/en-us/111875
         iPhone 12 Pro Max support.apple.com/en-us/111874
       🔴 ל-13 mini ול-13 יש «זום אופטי פי 2 החוצה» בלבד, ואין זום פנימה, ולכן z = 1 בשניהם.
       ל-12 Pro Max יש 2.5 פנימה, וזה הערך הלא שלם היחיד בטבלה. `zf` מדפיס «פי 2.5» ותקין. */
    ['iPhone 13 mini', 'iphone-13-mini', 13, 2021, 'A15 Bionic', 15, 17, false, 12, 1, 60, 12, 60, 5.4, 30, 600, 131.5, 64.2, false],
    ['iPhone 12 Pro Max', 'iphone-12-pro-max', 12, 2020, 'A14 Bionic', 14, 20, false, 12, 2.5, 60, 12, 60, 6.7, 30, 750, 160.8, 78.1, false],
    ['iPhone 12 Pro', 'iphone-12-pro', 12, 2020, 'A14 Bionic', 14, 17, false, 12, 2, 60, 12, 60, 6.1, 30, 600, 146.7, 71.5, false],
  ];
  const M = RAW.map(([name, slug, ser, year, chip, gen, bat, esim, mp, z, fps, sm, hz, s, ch, tr, h, w, island]) =>
    ({ name, slug, ser, year, chip, gen, bat, batSim: null, esim, mp, z, fps, sm, hz, s, ch, tr, h, w, island,
      cs: ser === 17, chW: ser === 17 && slug !== 'iphone-air' ? 40 : 20 }));

  /* סוללה: מספרי הדגם עם חריץ SIM, כמו שנמכר בישראל (apple.com/uk ו-apple.com/il, 14.09.2026).
     17 Pro 31 · 17 Pro Max 37 · 18 Pro 34 · 18 Pro Max 43. דגמי eSIM בארה"ב מקבלים שעתיים יותר. */
  /* use: «Typical use» של Apple, מדד חדש מ-2026: הודעות, תמונות, מוזיקה, רשתות, סרטונים, משחקים, גלישה וניווט (claims.md).
     18 Pro 23 · Pro Max 29 בדגם עם חריץ SIM (UK, כמו בישראל) · Duo 24 (eSIM בכל העולם). הכרעת יובל 17.09: «אף אחד לא רואה סרטים» */
  const base18 = { year: 2026, chip: 'A20 Pro', gen: 20, esim: false, batSim: null, mp: 48, va: true, z: 8, fps: 120, sm: 18, hz: 120, ch: 15, island: true, cs: true, chW: 60 };
  const T = {
    pro: { ...base18, key: 'pro', name: 'iPhone 18 Pro', short: '18 Pro', slug: 'iphone-18-pro', bat: 34, use: 23, s: 6.3, h: 150.0, w: 71.9, /* בורדו: הכרעת יובל 17.09.2026, הצבע החדש של 18 Pro */ finish: 'Burgundy', finishHe: 'בורדו', acc: '#E6A2B3', accRgb: '230,162,179', line: 'Pro' },
    max: { ...base18, key: 'max', name: 'iPhone 18 Pro Max', short: '18 Pro Max', slug: 'iphone-18-pro-max', bat: 43, use: 29, s: 6.9, h: 163.4, w: 78.0, finish: 'Burgundy', finishHe: 'בורדו', acc: '#E6A2B3', accRgb: '230,162,179', line: 'Pro Max' },
    duo: { ...base18, key: 'duo', name: 'iPhone Duo', short: 'Duo', slug: 'iphone-duo', duo: true, esim: false, bat: 31, use: 24, batOuter: 44, va: false, z: 2, sm: 12, ch: 20, s: 7.6, sOuter: 5.4, h: 117.8, w: 84.1, wOpen: 117.8, hOpen: 164.6, /* פתוח מוצג לאורך, כמו במסגרת הרשמית: 117.8 רוחב, 164.6 גובה */ finish: 'Night Sky', finishHe: 'כחול לילה', acc: '#A9B7EE', accRgb: '169,183,238', line: 'Pro' },
  };

  /* ביצועים: הטבלאות של Apple עצמה, «Compare with» בדף 18 Pro ובדף Duo (14.09.2026). [מעבד %, גרפיקה].
     דגם שאינו בטבלה: אין טענה, ומוצג מספר הדורות בלבד. */
  const CLAIMS = {
    pro: { 'iPhone 14': [80, '4x'], 'iPhone 14 Pro': [60, '2.8x'], 'iPhone 14 Pro Max': [60, '2.8x'], 'iPhone 15': [60, '2.8x'], 'iPhone 15 Pro': [50, '2.1x'], 'iPhone 15 Pro Max': [50, '2.1x'], 'iPhone 16': [30, '2x'], 'iPhone 16 Pro': [30, '80%'], 'iPhone 16 Pro Max': [30, '80%'], 'iPhone 17': [20, '60%'], 'iPhone 17 Pro': [20, '40%'], 'iPhone 17 Pro Max': [20, '40%'] },
    duo: { 'iPhone 13': [80, '3.4x'], 'iPhone 13 Pro': [80, '3x'], 'iPhone 13 Pro Max': [80, '3x'], 'iPhone 14': [80, '3x'], 'iPhone 14 Pro': [60, '2.8x'], 'iPhone 14 Pro Max': [60, '2.8x'], 'iPhone 15': [60, '2.8x'], 'iPhone 15 Pro': [50, '2.1x'], 'iPhone 15 Pro Max': [50, '2.1x'], 'iPhone 16': [30, '2x'], 'iPhone 16 Pro': [30, '80%'], 'iPhone 16 Pro Max': [30, '80%'], 'iPhone 17': [20, '60%'], 'iPhone 17 Pro': [20, '40%'], 'iPhone 17 Pro Max': [20, '40%'] },
  };
  CLAIMS.max = CLAIMS.pro;
  const claimFor = (t, o) => { const r = (CLAIMS[t.key] || {})[o.name]; return r ? { cpu: r[0], gpu: r[1] } : null; };
  const gpuHe = g => (g.endsWith('x') ? `מהירה עד פי ${g.slice(0, -1)}` : `מהירה עד ${g} יותר`);

  const ORDER = ['bat', 'zoom', 'cam', 'chip', 'hz', 'vid', 'self', 'scr', 'chg'];
  const LABELS = { chip: 'מהירות', bat: 'סוללה', cam: 'מצלמה ראשית', zoom: 'זום אופטי', vid: 'צילום וידאו', self: 'מצלמת סלפי', hz: 'חלקות מסך', scr: 'גודל מסך', chg: 'טעינה מהירה' };
  const zf = z => (z === 1 ? 'בלי זום' : `פי ${z}`);

  /* כל נתון: ערכים, מצב, משקל לבחירת השלושה, ומשפט אנושי. יחידה נפרדת מהמספר, לתצוגה גדולה. */
  function compare(o, t) {
    const L = {};
    let d;
    d = t.bat - o.bat;
    L.bat = { o: o.bat, n: t.bat, unit: 'שעות', ostar: o.esim, nstar: t.esim, st: d > 0 ? 'up' : d < 0 ? 'down' : 'same', score: d > 0 ? (d / o.bat) * 2.2 : 0,
      gain: d > 0 ? `עוד ${d} שעות צפייה` : d < 0 ? `${-d} שעות פחות` : 'אותה סוללה',
      human: d > 0 ? `הטלפון שלכם כבר כבה, ו-${t.short} ממשיך עוד ${d} שעות. זה עוד ${Math.floor(d / 2)} סרטים באורך מלא.` : `באותו מבחן, ${t.short} מחזיק ${t.bat} שעות.` };
    L.zoom = { o: zf(o.z), n: zf(t.z), unit: '', st: t.z > o.z ? 'up' : t.z < o.z ? 'down' : 'same', score: t.z > o.z ? Math.min(1.6, Math.log2(t.z / o.z) * 0.8) : 0,
      gain: t.z > o.z ? `פי ${+(t.z / o.z).toFixed(1)} קרוב יותר` : t.z < o.z ? 'פחות זום' : 'אותו זום',
      human: t.z > o.z ? `מאותה נקודה, בלי ללכת צעד. ${o.z === 1 ? 'בלי זום אופטי בכלל' : `עד פי ${o.z}`} מול עד פי ${t.z} באיכות אופטית.`
        : t.z < o.z ? `ב-${t.short} זום אופטי עד פי ${t.z}, ובטלפון שלכם עד פי ${o.z}.` : 'אותו טווח זום אופטי.' };
    if (t.mp > o.mp) L.cam = { st: 'up', score: 1.3, gain: `פי ${t.mp / o.mp} פיקסלים`, human: `${t.mp} מגה פיקסל מול ${o.mp}. כשמגדילים חלק מהתמונה, הפרטים נשארים.` };
    else if (t.va) L.cam = { st: 'up', score: 0.35, gain: 'חדש: צמצם משתנה', human: 'אותה רזולוציה, וצמצם שנפתח ונסגר כמו במצלמה מקצועית: רקע מטושטש לפורטרט, או הכול חד לנוף.' };
    else L.cam = { st: 'same', score: 0, gain: 'אותה מצלמה ראשית', human: 'אותה רזולוציה במצלמה הראשית.' };
    Object.assign(L.cam, { o: `${o.mp}MP`, n: `${t.mp}MP`, unit: '' });
    d = t.gen - o.gen;
    const cl = claimFor(t, o), oc = o.chip.replace(' Bionic', '');
    L.chip = { o: oc, n: t.chip, unit: '', st: d > 0 ? 'up' : 'same', score: d * 0.33 + (cl ? cl.cpu / 200 : 0), claim: cl,
      gain: cl ? `מעבד עד ${cl.cpu}% מהיר יותר` : d > 0 ? (d === 1 ? 'דור אחד קדימה' : `${d} דורות קדימה`) : 'אותו דור',
      human: cl
        ? `לפי Apple, מול ${o.name}: המעבד עד ${cl.cpu}% מהיר יותר, והגרפיקה ${gpuHe(cl.gpu)}. אפליקציות, משחקים ועריכה בלי האטה.`
        : d > 0 ? `${d === 1 ? 'דור אחד' : d + ' דורות'} של שבבים מאז ה-${oc}. אפליקציות נפתחות מהר, ומשחקים ועריכה לא מאטים את הטלפון.` : 'אותו דור שבב.' };
    L.hz = { o: `${o.hz}Hz`, n: `${t.hz}Hz`, unit: '', st: t.hz > o.hz ? 'up' : 'same', score: t.hz > o.hz ? 1.2 : 0,
      gain: t.hz > o.hz ? 'חלק פי 2' : 'אותה חלקות',
      human: t.hz > o.hz ? 'המסך מצייר כל תנועה 120 פעמים בשנייה במקום 60. גלילה, מעבר בין אפליקציות ומשחקים מרגישים חלקים.' : 'גם אצלכם 120Hz. אותה חלקות.' };
    L.vid = { o: `${o.fps}fps`, n: `${t.fps}fps`, unit: '', st: t.fps > o.fps ? 'up' : 'same', score: t.fps > o.fps ? 0.8 : 0,
      gain: t.fps > o.fps ? 'פי 2 פריימים' : 'אותו קצב',
      human: t.fps > o.fps ? 'וידאו 4K ב-120 פריימים בשנייה. תנועה מהירה נשארת חדה, ואפשר להאט אותה בעריכה.' : 'אותו קצב צילום.' };
    /* Center Stage: מ-17 ואילך, וגם ב-Duo. אצל הלקוח עם 12MP בלי Center Stage זה שדרוג גם כשהפיקסלים שווים */
    const csUp = t.cs && !o.cs;
    L.self = { o: `${o.sm}MP`, n: `${t.sm}MP`, unit: '', st: t.sm > o.sm || csUp ? 'up' : t.sm < o.sm ? 'down' : 'same',
      score: (t.sm > o.sm ? 0.45 : 0) + (csUp ? 0.25 : 0),
      gain: csUp ? 'חדש: Center Stage' : t.sm > o.sm ? `${t.sm}MP` : t.sm < o.sm ? 'פחות פיקסלים' : 'אותה מצלמה',
      human: csUp ? 'מחזיקים את הטלפון לאורך, והתמונה נפתחת לרוחב לבד כשחברים נכנסים לפריים. בלי לסובב.' : t.sm < o.sm ? 'פחות פיקסלים במצלמה הקדמית.' : 'אותה מצלמה קדמית.' };
    d = +(t.s - o.s).toFixed(1);
    if (t.duo) L.scr = { st: 'up', score: 2, gain: 'נפתח ל-7.6 אינץ\'', human: 'בכיס הוא טלפון עם מסך של 5.4 אינץ\'. פותחים, ויש מסך של 7.6 אינץ\'.' };
    else L.scr = { st: d >= 0.1 ? 'up' : d <= -0.1 ? 'diff' : 'same', score: d >= 0.1 ? Math.min(1.8, d * 1.5) : 0,
      gain: d >= 0.1 ? `גדול ב-${d} אינץ'` : d <= -0.1 ? 'קטן יותר' : 'אותו גודל',
      human: d >= 0.1 ? 'יותר מסך, והגוף כמעט לא גדל.' : d <= -0.1 ? 'מסך קטן יותר, קל יותר ליד אחת.' : 'אותו גודל מסך.' };
    Object.assign(L.scr, { o: o.s, n: t.s, unit: 'אינץ\'' });
    d = o.ch - t.ch;
    L.chg = { o: o.ch, n: t.ch, unit: 'דקות', st: d > 0 ? 'up' : d < 0 ? 'down' : 'same', score: d > 0 ? (d / o.ch) * 1.8 : 0,
      gain: d > 0 ? `מהיר ב-${d} דקות` : d < 0 ? 'איטי יותר' : 'אותה מהירות',
      human: d > 0 ? `חצי סוללה ב-${t.ch} דקות. בזמן של קפה.` : `חצי סוללה ב-${t.ch} דקות.` };

    ORDER.forEach(k => { L[k].k = k; L[k].label = LABELS[k]; });
    const all = ORDER.map(k => L[k]);
    const top = all.filter(x => x.st === 'up').sort((a, b) => b.score - a.score).slice(0, 3);
    top.forEach(x => (x.top = true));
    return { all, top, byKey: L };
  }

  window.TYSH = { M, T, ORDER, LABELS, compare, zf, byName: n => M.find(x => x.name === n) };
})();

/* ── js/core.js ── */
/* התשתית: מצב, תמונות, מכשיר בגודל אמיתי, ונגן אחד שמצייר רק את מה שבמסך. */
(() => {
  const L = window.TYSH;
  const A = window.TYSH_ASSETS || { bezels: {}, images: {} };
  L.A = A;
  L.reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

  // ── מצב משותף
  L.S = { t: 'pro', m: 'iPhone 15 Pro', w: 'desk' };
  const subs = [];
  L.on = fn => subs.push(fn);
  L.set = patch => { Object.assign(L.S, patch); subs.forEach(fn => fn(L.S, patch)); };

  // ── עזרי ציור
  const u = L.u = {};
  /* ty-lgrad-guard >>> */
  /* clb-06, 14.10.2026: createLinearGradient זורק על ערך לא סופי (NaN/Infinity), למשל כשהבד עוד ברוחב 0.
     אז מחזירים מעבר צבע דמה תקין: addColorStop עובד, והציור עם הקואורדינטות הלא סופיות פשוט לא מצייר. */
  u.lgrad = (c, x0, y0, x1, y1) => ([x0, y0, x1, y1].every(Number.isFinite) ? c.createLinearGradient(x0, y0, x1, y1) : c.createLinearGradient(0, 0, 0, 1));
  /* <<< ty-lgrad-guard */
  u.clamp = (v, a = 0, b = 1) => Math.min(b, Math.max(a, v));
  u.ease = x => (x < 0.5 ? 4 * x * x * x : 1 - Math.pow(-2 * x + 2, 3) / 2);
  u.easeOut = x => 1 - Math.pow(1 - x, 3);
  u.lerp = (a, b, x) => a + (b - a) * x;
  u.rnd = seed => () => { seed |= 0; seed = (seed + 0x6D2B79F5) | 0; let t = Math.imul(seed ^ (seed >>> 15), 1 | seed); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296; };
  u.font = (w, px) => `${w} ${Math.max(7, px)}px Rubik, "SF Pro Text", "Segoe UI", Arial, sans-serif`;
  u.text = (c, s, x, y, px, color, weight = 500, align = 'center', dir = 'rtl') => {
    c.font = u.font(weight, px); c.fillStyle = color; c.textAlign = align; c.textBaseline = 'middle'; c.direction = dir; c.fillText(s, x, y);
  };
  u.rr = (c, x, y, w, h, r, fill) => { c.beginPath(); c.roundRect(x, y, w, h, r); if (fill) { c.fillStyle = fill; c.fill(); } };
  u.pill = (c, s, x, y, px, fg, bg, dir = 'rtl') => {
    c.font = u.font(500, px); c.direction = dir;
    const w = c.measureText(s).width + px * 1.5, h = px * 2;
    u.rr(c, x - w / 2, y - h / 2, w, h, h / 2, bg); u.text(c, s, x, y + 0.5, px, fg, 500, 'center', dir);
    return w;
  };
  u.acc = (I, a = 1) => `rgba(${I.acc},${a})`;
  u.sideCol = (side, I, a = 1) => (side === 'new' ? `rgba(${I.acc},${a})` : `rgba(235,235,240,${a})`);
  u.cover = (c, img, x, y, w, h, fx = 0.5, fy = 0.5, zoom = 1) => {
    const iw = img.naturalWidth, ih = img.naturalHeight;
    const s = Math.max(w / iw, h / ih) * zoom, dw = iw * s, dh = ih * s;
    c.drawImage(img, x + (w - dw) * fx, y + (h - dh) * fy, dw, dh);
  };
  /* שורת סטטוס בסגנון iOS: שעה משמאל, סוללה מימין. iOS אינו הופך אותה בעברית. */
  u.status = (c, W, H, { time = '9:41', level = 1, charging = false, color = '#fff' } = {}) => {
    const m = Math.min(W, H), y = Math.max(10, H * 0.035), px = Math.max(7, m * 0.05);
    u.text(c, time, W * 0.16, y, px, color, 600, 'center', 'ltr');
    const bw = px * 2.1, bh = px * 1.0, bx = W * 0.84 - bw / 2, by = y - bh / 2;
    c.strokeStyle = color; c.globalAlpha = 0.45; c.lineWidth = Math.max(1, px * 0.1); c.beginPath(); c.roundRect(bx, by, bw, bh, bh * 0.3); c.stroke();
    c.fillStyle = color; c.fillRect(bx + bw + px * 0.1, by + bh * 0.3, px * 0.12, bh * 0.4); c.globalAlpha = 1;
    const lw = Math.max(0.5, (bw - px * 0.3) * level);
    u.rr(c, bx + px * 0.15, by + px * 0.15, lw, bh - px * 0.3, bh * 0.2, level < 0.2 && !charging ? '#FF453A' : charging ? '#30D158' : color);
  };

  // ── תמונות
  const cache = {};
  L.img = src => {
    if (!src) return null;
    if (!cache[src]) { const im = new Image(); im.decoding = 'async'; im.src = src; cache[src] = im; im.onload = () => L.kick && L.kick(); }
    const im = cache[src];
    return im.complete && im.naturalWidth ? im : null;
  };

  /* גאומטריית החזית, נמדדה מהמסגרות הרשמיות (יחסים לגוף): ix/iy שוליים, sw/sh מסך, sr רדיוס מסך. */
  L.GEO = {"iphone-13":{"ix":0.0557,"iy":0.0237,"sw":0.8904,"sh":0.9525,"sr":0.1065},"iphone-13-pro":{"ix":0.0557,"iy":0.0237,"sw":0.8904,"sh":0.9525,"sr":0.1065},"iphone-13-pro-max":{"ix":0.0511,"iy":0.0214,"sw":0.8998,"sh":0.9573,"sr":0.1129},"iphone-14":{"ix":0.0556,"iy":0.0233,"sw":0.8911,"sh":0.9533,"sr":0.1066},"iphone-14-plus":{"ix":0.0504,"iy":0.0213,"sw":0.8998,"sh":0.9573,"sr":0.1129},"iphone-14-pro":{"ix":0.0519,"iy":0.0217,"sw":0.8986,"sh":0.9566,"sr":0.1251},"iphone-14-pro-max":{"ix":0.0471,"iy":0.0196,"sw":0.9072,"sh":0.9608,"sr":0.1154},"iphone-15":{"ix":0.0532,"iy":0.022,"sw":0.8959,"sh":0.9558,"sr":0.1247},"iphone-15-plus":{"ix":0.0483,"iy":0.0202,"sw":0.9047,"sh":0.9595,"sr":0.115},"iphone-15-pro":{"ix":0.0449,"iy":0.0188,"sw":0.9118,"sh":0.9623,"sr":0.1269},"iphone-15-pro-max":{"ix":0.0406,"iy":0.0173,"sw":0.9188,"sh":0.9655,"sr":0.1168},"iphone-16":{"ix":0.051,"iy":0.022,"sw":0.8979,"sh":0.9558,"sr":0.1249},"iphone-16-plus":{"ix":0.0471,"iy":0.0202,"sw":0.9059,"sh":0.9595,"sr":0.1152},"iphone-16e":{"ix":0.0556,"iy":0.0233,"sw":0.8911,"sh":0.9533,"sr":0.1066},"iphone-16-pro":{"ix":0.0388,"iy":0.0162,"sw":0.9219,"sh":0.9675,"sr":0.143},"iphone-16-pro-max":{"ix":0.0366,"iy":0.0149,"sw":0.9269,"sh":0.9703,"sr":0.1321},"iphone-17":{"ix":0.0404,"iy":0.0159,"sw":0.9198,"sh":0.9682,"sr":0.1435},"iphone-air":{"ix":0.0395,"iy":0.0163,"sw":0.9204,"sh":0.9678,"sr":0.1374},"iphone-17-pro":{"ix":0.0424,"iy":0.0173,"sw":0.9149,"sh":0.9654,"sr":0.1427},"iphone-17-pro-max":{"ix":0.0379,"iy":0.0155,"sw":0.9243,"sh":0.9693,"sr":0.1323},"iphone-18-pro":{"ix":0.0424,"iy":0.0173,"sw":0.9149,"sh":0.9654,"sr":0.1427},"iphone-18-pro-max":{"ix":0.0379,"iy":0.0155,"sw":0.9243,"sh":0.9693,"sr":0.1317},"duo-open":{"ix":0.0327,"iy":0.0234,"sw":0.9383,"sh":0.9557,"sr":0.0753},"duo-closed":{"ix":0.0503,"iy":0.0262,"sw":0.9132,"sh":0.9513,"sr":0.0646}};

  /* iPhone 18 Pro ו-Pro Max מצוירים לפי המסגרת הרשמית של Apple בבורדו, במ"מ. נמדד 17.09.2026
     (qa/tripley-tests/scripts/_studio_phone_measure.mjs על bezels/iphone-18-pro-burgundy.png, 18.08 פיקסל למ"מ).
     האי צר ב-25% מזה של 17 Pro: 15.6 מול 20.7 מ"מ. המצלמה בתוכו ב-80.7% מרוחבו.
     כפתורים: מ"מ מראש הגוף. שמאל: פעולה ושני עוצמה. ימין: צד. */
  L.FRAME = {
    'iphone-18-pro': { bezel: 2.6, scrR: 10.4, island: { w: 15.6, h: 5.97, top: 2.38 }, cam: { at: 0.807, d: 1.77 }, left: [[30.8, 37.7], [42.8, 54.0], [57.0, 68.2]], right: [[46.7, 64.4]] },
    'iphone-18-pro-max': { bezel: 2.55, scrR: 10.4, island: { w: 15.5, h: 5.92, top: 2.43 }, cam: { at: 0.807, d: 1.74 }, left: [[30.8, 37.8], [42.8, 54.0], [57.0, 68.2]], right: [[46.7, 64.4]] },
  };

  // ── מכשיר בגודל אמיתי. עם bezel רשמי אם יש, אחרת ציור וקטורי מדויק במידות
  L.bezelFor = (v, side) => {
    const S = L.S, B = A.bezels || {};
    if (side === 'new') {
      const t = v;
      if (t.duo) return B['iphone-duo-open-nightsky'] || B['iphone-duo-open'] || null;
      return B[`${t.slug}-${t.finish.toLowerCase()}`] || B[t.slug] || null;
    }
    return B[v.slug] || null;
  };
  L.device = (v, side, cap) => {
    const fig = document.createElement('figure');
    fig.className = `dev dev-${side}`;
    const open = side === 'new' && v.duo;
    const wmm = open ? v.wOpen : v.w, hmm = open ? v.hOpen : v.h;
    fig.style.setProperty('--w', wmm); fig.style.setProperty('--h', hmm);
    const bz = L.bezelFor(v, side);
    const box = document.createElement('div');
    box.className = 'dev-box' + (bz ? '' : ' vector');
    box.dataset.w = wmm; box.dataset.h = hmm;
    box.dataset.geo = side === 'new' ? (v.duo ? 'duo-open' : v.slug) : v.slug;
    const cv = document.createElement('canvas');
    if (bz) {
      const img = document.createElement('img');
      img.className = 'bezel'; img.src = bz.file; img.alt = ''; img.decoding = 'async';
      box.append(cv, img);
      box._bz = bz;
    } else {
      const scr = document.createElement('div'); scr.className = 'scr'; scr.append(cv);
      if (!open) { const cut = document.createElement('i'); cut.className = `cut ${v.island ? 'island' : 'notch'}`; scr.append(cut); }
      box.append(scr);
      const fr = side === 'new' && !v.duo && L.FRAME[v.slug];
      if (fr) {
        box.classList.add('f18', `fin-${(v.finish || '').toLowerCase()}`);
        const cut = scr.querySelector('.cut'); if (cut) cut.append(document.createElement('b'));
        [...fr.left.map(b => ['l', b]), ...fr.right.map(b => ['r', b])].forEach(([sd, b]) => { const el = document.createElement('i'); el.className = `hw hw-${sd}`; el._mm = b; box.append(el); });
      }
    }
    const fc = document.createElement('figcaption');
    fc.innerHTML = cap;
    fig.append(box, fc);
    fig._canvas = cv; fig._box = box;
    return fig;
  };
  /* ממקם bezel ומסך לפי k (פיקסלים למ"מ). גוף המכשיר בתמונה ממופה בדיוק לממדים הפיזיים */
  L.layoutDevice = (fig, k) => {
    const box = fig._box, wmm = +box.dataset.w, hmm = +box.dataset.h;
    const W = wmm * k, H = hmm * k;
    box.style.width = W + 'px'; box.style.height = H + 'px';
    fig.style.setProperty('--k', k);
    const bz = box._bz;
    if (!bz) {
      /* מסגרת מצוירת, במידות שנמדדו מהמסגרות הרשמיות של Apple: שוליים, רדיוס מסך, אי או נוץ' */
      const fr = box.classList.contains('f18') && L.FRAME[box.dataset.geo];
      if (fr) {
        /* במ"מ, כפי שנמדד: מסגרת אחידה מכל הצדדים, אי, מצלמה וכפתורים */
        box.style.setProperty('--km', k);
        box.style.padding = `${fr.bezel * k}px`;
        box.style.borderRadius = `${(fr.scrR + fr.bezel) * k}px`;
        const scr = box.querySelector('.scr'); if (scr) scr.style.borderRadius = `${fr.scrR * k}px`;
        const cut = box.querySelector('.cut');
        if (cut) {
          Object.assign(cut.style, { width: fr.island.w * k + 'px', height: fr.island.h * k + 'px', top: fr.island.top * k + 'px', borderRadius: '999px' });
          const cam = cut.querySelector('b');
          if (cam) Object.assign(cam.style, { width: fr.cam.d * k + 'px', height: fr.cam.d * k + 'px', left: fr.cam.at * fr.island.w * k - (fr.cam.d * k) / 2 + 'px', top: (fr.island.h - fr.cam.d) * k / 2 + 'px' });
        }
        box.querySelectorAll('.hw').forEach(el => { const [a, b] = el._mm; Object.assign(el.style, { top: a * k + 'px', height: (b - a) * k + 'px', width: 0.9 * k + 'px' }); });
        return;
      }
      const g = L.GEO[box.dataset.geo] || L.GEO['iphone-17-pro'];
      box.style.padding = `${g.iy * H}px ${g.ix * W}px`;
      box.style.borderRadius = `${(g.sr + g.ix) * W}px`;
      const scr = box.querySelector('.scr'); if (scr) scr.style.borderRadius = `${g.sr * W}px`;
      const cut = box.querySelector('.cut');
      if (cut) {
        const sw = W * g.sw, sh = H * g.sh;
        if (cut.classList.contains('island')) Object.assign(cut.style, { width: sw * 0.31 + 'px', height: sh * 0.038 + 'px', top: sh * 0.013 + 'px', borderRadius: '999px' });
        else Object.assign(cut.style, { width: sw * 0.42 + 'px', height: sh * 0.035 + 'px', top: '0px', borderRadius: `0 0 ${sw * 0.06}px ${sw * 0.06}px` });
      }
      return;
    }
    const s = W / bz.body.w;
    const img = box.querySelector('img.bezel');
    img.style.width = bz.width * s + 'px'; img.style.height = bz.height * s + 'px';
    img.style.left = -bz.body.x * s + 'px'; img.style.top = -bz.body.y * s + 'px';
    const cv = fig._canvas, pad = 1.5;
    cv.style.left = (bz.screen.x - bz.body.x) * s - pad + 'px';
    cv.style.top = (bz.screen.y - bz.body.y) * s - pad + 'px';
    cv.style.width = bz.screen.w * s + pad * 2 + 'px';
    cv.style.height = bz.screen.h * s + pad * 2 + 'px';
    cv.style.borderRadius = (bz.screen.r || 0) * s + 'px';
  };

  /* החלפת מסגרת באמצע הדגמה (ה-Duo נפתח): מעמעם, מחליף, ומגדיר מידות חדשות */
  L.setBezel = (fig, bz, wmm, hmm, k) => {
    const box = fig._box;
    box.dataset.w = wmm; box.dataset.h = hmm;
    const img = box.querySelector('img.bezel');
    if (bz && img && img.getAttribute('src') !== bz.file) {
      img.style.opacity = '0';
      setTimeout(() => { box._bz = bz; img.src = bz.file; L.layoutDevice(fig, k); img.style.opacity = '1'; L.kick(); }, 180);
      return;
    }
    L.layoutDevice(fig, k);
  };

  // ── הנגן: כל פרק נרשם, והלולאה מציירת רק פרקים גלויים שמתנגנים או שהשתנו
  const players = [];
  L.players = players;
  L.register = p => { players.push(p); return p; };
  let raf = 0;
  const tick = now => {
    raf = 0;
    let again = false;
    players.forEach(p => {
      if (!p.visible && !p.dirty) return;
      if (p.playing) {
        p.t += Math.min(0.05, (now - (p.last || now)) / 1000);
        p.last = now;
        if (p.t >= p.dur) { p.t = p.dur; p.playing = false; p.onEnd && p.onEnd(); }
        again = true;
      }
      if (p.playing || p.dirty) { p.draw(); p.dirty = false; }
    });
    if (again) raf = requestAnimationFrame(tick);
  };
  L.kick = () => { players.forEach(p => (p.dirty = true)); if (!raf) raf = requestAnimationFrame(tick); };
  L.loop = () => { if (!raf) raf = requestAnimationFrame(tick); };

  L.fitCanvas = cv => {
    /* 🔴 cv.dataset.dpr הוא תקרה לקנבס הזה בלבד. בלי התכונה ההתנהגות אינה משתנה.
       נוסף 21.09.2026 אחרי שנמדד שקנבס במה במסך מלא עולה 8M פיקסל בטלפון. */
    const cap = Number(cv.dataset.dpr) || 2;
    const r = cv.getBoundingClientRect(), dpr = Math.min(cap, window.devicePixelRatio || 1);
    const W = Math.max(1, r.width), H = Math.max(1, r.height);
    if (cv.width !== Math.round(W * dpr) || cv.height !== Math.round(H * dpr)) { cv.width = Math.round(W * dpr); cv.height = Math.round(H * dpr); }
    const c = cv.getContext('2d');
    c.setTransform(dpr, 0, 0, dpr, 0, 0);
    return { c, W, H };
  };
})();

/* ── js/scenes-kit.js ── */
/* ערכת ציור משותפת לסצנות של דף הבית (טלפון אחד). 16.09.2026.
   במה: הבד שמאחורי הטלפון. scr: מלבן המסך בקואורדינטות הבמה. הטלפון זז ימינה (shift), והשטח הפנוי משמאלו.
   🔴 כל מחרוזת שמגיעה ללקוח: בלי מקף ארוך ובלי מקף בינוני. */
(() => {
  const L = window.TYSH, u = L.u;
  const IMG = () => L.A.images || {};
  const K = L.kit = {};

  K.img = key => IMG()[key] && L.img(IMG()[key].file);
  K.meta = key => IMG()[key] || null;

  /* השטח הפנוי משמאל לטלפון: [0, room], ומרכזו */
  K.room = (W, H, scr) => { const m = Math.min(W, H), room = Math.max(40, scr.x - m * 0.08); return { room, ax: room / 2 + m * 0.02, m }; };

  /* מספר גדול בשטח הפנוי. sample: המחרוזת הרחבה ביותר בסצנה, כדי שהגודל לא יקפוץ כשהמספר מתחלף */
  K.bigNumber = (c, W, H, scr, label, caption, I, { sample = label, maxH = 0.42, y = 0.5, alpha = 1 } = {}) => {
    const { room, ax } = K.room(W, H, scr);
    c.save();
    c.globalAlpha = alpha;
    c.font = u.font(700, 100); c.direction = 'ltr';
    const per = c.measureText(sample).width / 100;
    const px = Math.min(H * maxH, (room * 0.92) / per), yb = H * y + px * 0.3;
    c.font = u.font(700, px); c.textAlign = 'center'; c.textBaseline = 'alphabetic';
    const gr = u.lgrad(c, 0, yb - px * 0.74, 0, yb);
    gr.addColorStop(0, u.acc(I, 1)); gr.addColorStop(1, u.acc(I, 0.35));
    c.fillStyle = gr; c.fillText(label, ax, yb);
    if (caption) u.text(c, caption, ax, yb + Math.max(14, px * 0.24), Math.max(13, px * 0.14), 'rgba(255,255,255,0.62)', 500, 'center', 'rtl');
    c.restore();
    return { ax, yb, px, room };
  };

  /* מכניס דהייה אליפטית לשחור על מה שכבר צויר. רק על בד שהכיל עד עכשיו את הצילום לבדו */
  K.fade = (c, W, H, cx, cy, rx, ry, inner = 0.44) => {
    c.save();
    c.globalCompositeOperation = 'destination-in';
    c.translate(cx, cy); c.scale(rx / ry, 1);
    const g = c.createRadialGradient(0, 0, ry * inner, 0, 0, ry);
    g.addColorStop(0, '#000'); g.addColorStop(1, 'rgba(0,0,0,0)');
    c.fillStyle = g; c.fillRect(-W * 4, -H * 4, W * 8, H * 8);
    c.restore();
  };

  /* דהייה לינארית בקצה השמאלי של הבמה. צילום שנחתך בקצה הבמה נראה כקו חד, בעיקר בטלפון */
  K.edgeFade = (c, W, H, px) => {
    c.save();
    c.globalCompositeOperation = 'destination-in';
    const g = c.createLinearGradient(0, 0, px, 0); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(1, '#000');
    /* על כל הבד ולא רק על הרצועה: destination-in מוחק כל מה שמחוץ לצורה שמציירים */
    c.fillStyle = g; c.fillRect(0, 0, W, H);
    c.restore();
  };

  /* מסגרת עינית על הבמה, עם הטלה אל שולי המסך */
  K.frame = (c, W, H, fx, fy, fw, fh, scr, I, { dim = 0.45, lines = true } = {}) => {
    if (dim) { c.fillStyle = `rgba(0,0,0,${dim})`; c.beginPath(); c.rect(0, 0, W, H); c.rect(fx, fy, fw, fh); c.fill('evenodd'); }
    if (lines) {
      const ex = fx + fw, gr = u.lgrad(c, ex, 0, scr.x, 0);
      gr.addColorStop(0, u.acc(I, 0.26)); gr.addColorStop(1, u.acc(I, 0.05));
      c.fillStyle = gr;
      c.beginPath(); c.moveTo(ex, fy); c.lineTo(scr.x + 2, scr.y + scr.h * 0.02); c.lineTo(scr.x + 2, scr.y + scr.h * 0.98); c.lineTo(ex, fy + fh); c.closePath(); c.fill();
      c.strokeStyle = u.acc(I, 0.6); c.lineWidth = 1;
      c.beginPath(); c.moveTo(ex, fy); c.lineTo(scr.x + 2, scr.y + scr.h * 0.02); c.moveTo(ex, fy + fh); c.lineTo(scr.x + 2, scr.y + scr.h * 0.98); c.stroke();
    }
    c.strokeStyle = 'rgba(255,255,255,0.9)'; c.lineWidth = 1; c.strokeRect(fx, fy, fw, fh);
    K.brackets(c, fx, fy, fw, fh, '#fff', 2.5);
  };
  K.brackets = (c, x, y, w, h, color, lw, kk) => {
    const k = kk || Math.max(6, Math.min(w, h) * 0.22);
    c.save(); c.lineWidth = lw; c.strokeStyle = color; c.lineCap = 'round';
    c.shadowColor = 'rgba(0,0,0,0.55)'; c.shadowBlur = lw * 2.5;
    c.beginPath();
    [[x, y, 1, 1], [x + w, y, -1, 1], [x, y + h, 1, -1], [x + w, y + h, -1, -1]].forEach(([px, py, dx, dy]) => { c.moveTo(px + dx * k, py); c.lineTo(px, py); c.lineTo(px, py + dy * k); });
    c.stroke(); c.restore();
  };

  /* צמצם: עיגול כהה עם פתח מצולע. open 0 סגור ⟵ 1 פתוח לגמרי. קווי הלהבים יוצאים מקודקודי הפתח */
  K.iris = (c, cx, cy, R, open, { blades = 7, fill = '#0B0B0D', edge = 'rgba(255,255,255,0.16)', rot = 0 } = {}) => {
    const r = Math.max(0.001, R * open), a0 = rot + (1 - open) * 0.9;
    const pts = Array.from({ length: blades }, (_, i) => { const a = a0 + (i / blades) * Math.PI * 2; return [cx + Math.cos(a) * r, cy + Math.sin(a) * r, a]; });
    c.save();
    c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2);
    c.moveTo(pts[0][0], pts[0][1]); pts.slice(1).forEach(p => c.lineTo(p[0], p[1])); c.closePath();
    c.fillStyle = fill; c.fill('evenodd');
    c.strokeStyle = edge; c.lineWidth = Math.max(1, R * 0.012);
    c.beginPath();
    pts.forEach(([x, y, a]) => { const b = a + 1.25; c.moveTo(x, y); c.lineTo(cx + Math.cos(b) * R, cy + Math.sin(b) * R); });
    c.stroke();
    c.restore();
  };

  /* ממשק מצלמה מינימלי: כפתור צילום ותווית בפינה */
  K.shutter = (c, W, H, label) => {
    const m = Math.min(W, H), sy = H * 0.93;
    c.strokeStyle = '#fff'; c.lineWidth = m * 0.01; c.beginPath(); c.arc(W / 2, sy, m * 0.07, 0, Math.PI * 2); c.stroke();
    c.fillStyle = '#fff'; c.beginPath(); c.arc(W / 2, sy, m * 0.056, 0, Math.PI * 2); c.fill();
    if (label) u.text(c, label, W * 0.18, sy, m * 0.045, 'rgba(255,255,255,0.75)', 600, 'center', 'ltr');
  };

  /* כרטיס צילום מודפס, מסובב סביב מרכזו */
  K.print = (c, img, cx, cy, w, rot, { fx = 0.5, fy = 0.5, border = 0.045, caption = '' } = {}) => {
    const h = w * 0.75, b = w * border;
    c.save();
    c.translate(cx, cy); c.rotate(rot);
    c.shadowColor = 'rgba(0,0,0,0.6)'; c.shadowBlur = w * 0.12; c.shadowOffsetY = w * 0.04;
    u.rr(c, -w / 2 - b, -h / 2 - b, w + b * 2, h + b * (caption ? 5 : 2), b * 0.6, '#F4F4F2');
    c.shadowColor = 'transparent';
    c.save(); c.beginPath(); c.rect(-w / 2, -h / 2, w, h); c.clip();
    if (img) u.cover(c, img, -w / 2, -h / 2, w, h, fx, fy); else { c.fillStyle = '#222'; c.fillRect(-w / 2, -h / 2, w, h); }
    c.restore();
    if (caption) u.text(c, caption, 0, h / 2 + b * 2.4, Math.max(9, w * 0.07), '#1C1C1E', 500, 'center', 'rtl');
    c.restore();
  };

  K.mmss = s => `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(Math.floor(s % 60)).padStart(2, '0')}`;
})();

/* ── js/scenes-kit2.js ── */
/* ערכת ציור לסבב 2 של הסטודיו (17.09.2026). נשען על scenes-kit.js.
   ציר עם עצירות · מספר גדול שקופץ כשמתחלף · עדשות iOS · בד צדדי · האי הדינמי של 18 Pro · אייקונים בקו דק.
   🔴 כל מחרוזת שמגיעה ללקוח: בלי מקף ארוך ובלי מקף בינוני. */
(() => {
  const L = window.TYSH, u = L.u;
  const K2 = L.kit2 = {};

  /* ציר עם עצירות: stops ערכים, holds זמן עמידה בכל עצירה, move זמן מעבר.
     מחזיר את הערך, העצירה הנוכחית (idx, מתחלף באמצע המעבר) ומתי היא התחילה (since) */
  K2.steps = (t, stops, holds, move, { geo = true } = {}) => {
    const n = stops.length, starts = [0];
    let acc = 0;
    for (let i = 0; i < n - 1; i++) { acc += holds[i]; starts.push(acc + move / 2); acc += move; }
    let idx = 0;
    for (let i = 1; i < n; i++) if (t >= starts[i]) idx = i;
    /* המעבר הנוכחי, אם יש */
    let a0 = 0, from = 0, k = 0;
    for (let i = 0; i < n - 1; i++) { const ts = starts[i + 1] - move / 2; if (t >= ts && t < ts + move) { from = i; k = u.ease((t - ts) / move); a0 = 1; } }
    let val;
    if (a0) { const a = stops[from], b = stops[from + 1]; val = geo ? a * Math.pow(b / a, k) : u.lerp(a, b, k); }
    else val = stops[idx];
    return { val, idx, age: t - starts[idx], k: a0 ? k : 0, moving: !!a0, from: a0 ? from : idx, to: a0 ? from + 1 : idx, starts };
  };
  K2.total = (holds, move) => holds.reduce((a, b) => a + b, 0) + move * (holds.length - 1);

  /* מספר גדול במרכז (x, y), עם קפיצה קטנה כשמתחלף. age: שניות מאז שהתחלף */
  K2.pop = (c, text, x, y, px, I, { age = 9, caption = '', capPx = 0, dir = 'ltr', alpha = 1, weight = 700, solid = false } = {}) => {
    const k = u.clamp(age / 0.38), s = 1 + 0.16 * (1 - u.easeOut(k));
    c.save();
    c.globalAlpha = alpha * u.lerp(0.35, 1, u.easeOut(u.clamp(age / 0.22)));
    c.translate(x, y); c.scale(s, s);
    c.font = u.font(weight, px); c.textAlign = 'center'; c.textBaseline = 'alphabetic'; c.direction = dir;
    const yb = px * 0.36;
    if (solid) c.fillStyle = solid;
    else { const gr = u.lgrad(c, 0, yb - px * 0.74, 0, yb); gr.addColorStop(0, u.acc(I, 1)); gr.addColorStop(1, u.acc(I, 0.45)); c.fillStyle = gr; }
    c.fillText(text, 0, yb);
    c.restore();
    if (caption) u.text(c, caption, x, y + px * 0.36 + Math.max(14, (capPx || px * 0.16) * 1.3), capPx || Math.max(12, px * 0.16), `rgba(255,255,255,${0.66 * alpha})`, 500, 'center', 'rtl');
  };

  /* גודל גופן שבו המחרוזת הרחבה ביותר נכנסת ברוחב w */
  K2.fit = (c, sample, w, max, weight = 700) => { c.font = u.font(weight, 100); c.direction = 'ltr'; return Math.min(max, (w / (c.measureText(sample).width / 100))); };

  /* שורת העדשות של המצלמה ב-iOS: העדשה הפעילה גדולה, בצהוב ועם ×. y במרכז השורה */
  K2.lenses = (c, W, H, labels, active, y, { live = '' } = {}) => {
    const m = Math.min(W, H), pr = m * 0.05, gap = pr * 2.3, n = labels.length;
    u.rr(c, W / 2 - (n * gap) / 2 - pr * 0.25, y - pr * 1.2, n * gap + pr * 0.5, pr * 2.4, pr * 1.2, 'rgba(0,0,0,0.42)');
    labels.forEach((lb, i) => {
      const x = W / 2 + (i - (n - 1) / 2) * gap, on = i === active;
      c.fillStyle = on ? 'rgba(18,18,18,0.9)' : 'rgba(40,40,40,0.55)';
      c.beginPath(); c.arc(x, y, on ? pr * 1.05 : pr * 0.76, 0, Math.PI * 2); c.fill();
      u.text(c, on ? `${live || lb}×` : lb, x, y + 0.5, on ? pr * 0.66 : pr * 0.58, on ? '#FFD60A' : '#fff', 600, 'center', 'ltr');
    });
  };

  /* בד צדדי, פעם אחת לכל גודל. מאפשר destination-in על שכבה אחת בלי למחוק את מה שמתחתיה */
  const pool = {};
  K2.layer = (name, W, H) => {
    const dpr = Math.min(2, window.devicePixelRatio || 1);
    let cv = pool[name];
    if (!cv) cv = pool[name] = document.createElement('canvas');
    const w = Math.max(1, Math.round(W * dpr)), h = Math.max(1, Math.round(H * dpr));
    if (cv.width !== w || cv.height !== h) { cv.width = w; cv.height = h; }
    const x = cv.getContext('2d'); x.setTransform(dpr, 0, 0, dpr, 0, 0); x.clearRect(0, 0, W, H);
    return { cv, x };
  };

  /* האי הדינמי במסך של 18 Pro, בקואורדינטות המסך: 15.6 על 5.97 מ"מ, 2.38 מ"מ מראש המסך. המסך 66.7 על 144.8 מ"מ */
  K2.island = (W, H) => { const w = W * (15.6 / 66.7), h = H * (5.97 / 144.8), y = H * (2.38 / 144.8); return { x: (W - w) / 2, y, w, h, cx: W / 2, cy: y + h / 2 }; };
  /* פעילות חיה באי: האי מתרחב לצדדים, ובכל צד תוכן. left/right מקבלים (c, x, y, s) */
  K2.live = (c, W, H, { grow = 1, left, right } = {}) => {
    const d = K2.island(W, H), ext = W * 0.1 * grow, x = d.x - ext, w = d.w + ext * 2;
    u.rr(c, x, d.y, w, d.h, d.h / 2, '#000');
    const s = d.h * 0.62;
    if (grow > 0.6) {
      c.save(); c.globalAlpha = u.clamp((grow - 0.6) / 0.4);
      if (left) left(c, x + d.h * 0.55, d.cy, s);
      if (right) right(c, x + w - d.h * 0.55, d.cy, s);
      c.restore();
    }
  };

  /* פעילות חיה מורחבת: האי נפתח לכרטיס שחור גדול מתחת לו. grow 0 האי עצמו ⟵ 1 כרטיס.
     icon שם אייקון מ-K2.icon, color צבע האייקון והפס, title ו-sub טקסט, prog 0 עד 1 או null */
  K2.liveBig = (c, W, H, { grow = 1, icon = 'pin', color = '#30D158', title = '', sub = '', prog = null } = {}) => {
    const d = K2.island(W, H), g = u.easeOut(u.clamp(grow));
    const w = u.lerp(d.w, W * 0.92, g), h = u.lerp(d.h, H * 0.13, g), x = (W - w) / 2, y = d.y, r = u.lerp(d.h / 2, H * 0.05, g);
    u.rr(c, x, y, w, h, r, '#000');
    if (g < 0.7) return;
    const a = u.clamp((g - 0.7) / 0.3), m = Math.min(W, H);
    c.save(); c.globalAlpha = a;
    const ir = h * 0.24, ix = x + w - ir - w * 0.05, iy = y + h * 0.42;
    c.fillStyle = 'rgba(255,255,255,0.1)'; c.beginPath(); c.arc(ix, iy, ir, 0, Math.PI * 2); c.fill();
    c.strokeStyle = color; IC[icon](c, ix, iy, ir * 1.1);
    u.text(c, title, ix - ir - w * 0.04, iy - h * 0.1, Math.max(8, m * 0.055), '#fff', 700, 'right', 'rtl');
    if (sub) u.text(c, sub, ix - ir - w * 0.04, iy + h * 0.13, Math.max(7, m * 0.038), 'rgba(255,255,255,0.65)', 500, 'right', 'rtl');
    if (prog !== null) { const bx = x + w * 0.08, bw = w * 0.84, by = y + h * 0.8; u.rr(c, bx, by, bw, Math.max(2, h * 0.05), 2, 'rgba(255,255,255,0.18)'); u.rr(c, bx + bw * (1 - prog), by, bw * prog, Math.max(2, h * 0.05), 2, color); }
    c.restore();
  };

  /* אייקונים בקו דק. (c, x, y, s): מרכז וגודל. צבע מ-strokeStyle */
  const IC = K2.icon = {};
  const line = (c, s) => { c.lineWidth = Math.max(1.4, s * 0.075); c.lineCap = 'round'; c.lineJoin = 'round'; };
  IC.cup = (c, x, y, s) => { line(c, s); c.beginPath(); c.moveTo(x - s * 0.34, y - s * 0.2); c.lineTo(x + s * 0.22, y - s * 0.2); c.lineTo(x + s * 0.16, y + s * 0.34); c.lineTo(x - s * 0.28, y + s * 0.34); c.closePath(); c.stroke(); c.beginPath(); c.arc(x + s * 0.28, y + s * 0.02, s * 0.12, -Math.PI / 2, Math.PI / 2); c.stroke(); [-0.2, 0, 0.14].forEach(dx => { c.beginPath(); c.moveTo(x + dx * s, y - s * 0.32); c.quadraticCurveTo(x + dx * s + s * 0.06, y - s * 0.4, x + dx * s, y - s * 0.48); c.stroke(); }); };
  IC.shower = (c, x, y, s) => { line(c, s); c.beginPath(); c.moveTo(x - s * 0.36, y + s * 0.44); c.lineTo(x - s * 0.36, y - s * 0.3); c.quadraticCurveTo(x - s * 0.36, y - s * 0.44, x - s * 0.16, y - s * 0.44); c.lineTo(x + s * 0.02, y - s * 0.44); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.12, y - s * 0.2); c.quadraticCurveTo(x + s * 0.02, y - s * 0.44, x + s * 0.2, y - s * 0.2); c.closePath(); c.stroke(); [[-0.06, 0], [0.06, 0.02], [0.18, 0], [0, 0.18], [0.12, 0.2], [0.24, 0.16]].forEach(([dx, dy]) => { c.beginPath(); c.moveTo(x + dx * s, y + dy * s); c.lineTo(x + dx * s - s * 0.02, y + dy * s + s * 0.08); c.stroke(); }); };
  IC.shirt = (c, x, y, s) => { line(c, s); c.beginPath(); c.moveTo(x - s * 0.14, y - s * 0.4); c.quadraticCurveTo(x, y - s * 0.28, x + s * 0.14, y - s * 0.4); c.lineTo(x + s * 0.44, y - s * 0.24); c.lineTo(x + s * 0.34, y - s * 0.02); c.lineTo(x + s * 0.24, y - s * 0.08); c.lineTo(x + s * 0.24, y + s * 0.42); c.lineTo(x - s * 0.24, y + s * 0.42); c.lineTo(x - s * 0.24, y - s * 0.08); c.lineTo(x - s * 0.34, y - s * 0.02); c.lineTo(x - s * 0.44, y - s * 0.24); c.closePath(); c.stroke(); };
  IC.news = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.36, y - s * 0.38, s * 0.72, s * 0.76, s * 0.06); c.stroke(); c.beginPath(); c.rect(x - s * 0.22, y - s * 0.24, s * 0.18, s * 0.16); c.stroke(); [[-0.24, 0.06], [-0.24, 0.18], [-0.24, 0.3], [0.04, -0.2], [0.04, -0.1]].forEach(([dx, dy]) => { c.beginPath(); c.moveTo(x + (dx < 0 ? -0.22 : 0.04) * s, y + dy * s); c.lineTo(x + s * 0.24, y + dy * s); c.stroke(); }); };
  IC.car = (c, x, y, s) => { line(c, s); c.beginPath(); c.moveTo(x - s * 0.44, y + s * 0.14); c.lineTo(x - s * 0.44, y - s * 0.02); c.lineTo(x - s * 0.3, y - s * 0.08); c.lineTo(x - s * 0.18, y - s * 0.3); c.lineTo(x + s * 0.2, y - s * 0.3); c.lineTo(x + s * 0.32, y - s * 0.08); c.lineTo(x + s * 0.44, y - s * 0.02); c.lineTo(x + s * 0.44, y + s * 0.14); c.closePath(); c.stroke(); [-0.24, 0.24].forEach(dx => { c.beginPath(); c.arc(x + dx * s, y + s * 0.18, s * 0.1, 0, Math.PI * 2); c.stroke(); }); };
  IC.pin = (c, x, y, s) => { line(c, s); c.beginPath(); c.moveTo(x, y + s * 0.44); c.bezierCurveTo(x - s * 0.5, y - s * 0.02, x - s * 0.3, y - s * 0.44, x, y - s * 0.44); c.bezierCurveTo(x + s * 0.3, y - s * 0.44, x + s * 0.5, y - s * 0.02, x, y + s * 0.44); c.stroke(); c.beginPath(); c.arc(x, y - s * 0.14, s * 0.1, 0, Math.PI * 2); c.stroke(); };
  IC.chat = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.42, y - s * 0.34, s * 0.84, s * 0.56, s * 0.2); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.18, y + s * 0.22); c.lineTo(x - s * 0.3, y + s * 0.42); c.lineTo(x, y + s * 0.22); c.stroke(); };
  IC.note = (c, x, y, s) => { line(c, s); c.beginPath(); c.moveTo(x - s * 0.1, y + s * 0.28); c.lineTo(x - s * 0.1, y - s * 0.36); c.lineTo(x + s * 0.32, y - s * 0.44); c.lineTo(x + s * 0.32, y + s * 0.2); c.stroke(); c.fillStyle = c.strokeStyle; [[-0.22, 0.3], [0.2, 0.22]].forEach(([dx, dy]) => { c.beginPath(); c.ellipse(x + dx * s, y + dy * s, s * 0.13, s * 0.1, -0.4, 0, Math.PI * 2); c.fill(); }); };
  IC.camera = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.44, y - s * 0.24, s * 0.88, s * 0.6, s * 0.1); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.16, y - s * 0.24); c.lineTo(x - s * 0.1, y - s * 0.36); c.lineTo(x + s * 0.1, y - s * 0.36); c.lineTo(x + s * 0.16, y - s * 0.24); c.stroke(); c.beginPath(); c.arc(x, y + s * 0.06, s * 0.16, 0, Math.PI * 2); c.stroke(); };
  IC.tv = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.44, y - s * 0.3, s * 0.88, s * 0.58, s * 0.08); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.16, y + s * 0.42); c.lineTo(x + s * 0.16, y + s * 0.42); c.stroke(); c.fillStyle = c.strokeStyle; c.beginPath(); c.moveTo(x - s * 0.08, y - s * 0.13); c.lineTo(x + s * 0.14, y); c.lineTo(x - s * 0.08, y + s * 0.13); c.closePath(); c.fill(); };
  IC.moon = (c, x, y, s) => { line(c, s); c.beginPath(); c.arc(x, y, s * 0.36, Math.PI * 0.3, Math.PI * 1.7); c.arc(x + s * 0.16, y - s * 0.08, s * 0.28, Math.PI * 1.45, Math.PI * 0.55, true); c.closePath(); c.stroke(); };
  IC.sun = (c, x, y, s) => { line(c, s); c.beginPath(); c.arc(x, y, s * 0.18, 0, Math.PI * 2); c.stroke(); for (let i = 0; i < 8; i++) { const a = (i / 8) * Math.PI * 2; c.beginPath(); c.moveTo(x + Math.cos(a) * s * 0.3, y + Math.sin(a) * s * 0.3); c.lineTo(x + Math.cos(a) * s * 0.42, y + Math.sin(a) * s * 0.42); c.stroke(); } };
  IC.game = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.46, y - s * 0.22, s * 0.92, s * 0.48, s * 0.24); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.28, y + s * 0.02); c.lineTo(x - s * 0.1, y + s * 0.02); c.moveTo(x - s * 0.19, y - s * 0.07); c.lineTo(x - s * 0.19, y + s * 0.11); c.stroke(); c.fillStyle = c.strokeStyle; [[0.18, -0.04], [0.3, 0.07]].forEach(([dx, dy]) => { c.beginPath(); c.arc(x + dx * s, y + dy * s, s * 0.05, 0, Math.PI * 2); c.fill(); }); };
  IC.film = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.34, y - s * 0.42, s * 0.68, s * 0.84, s * 0.06); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.18, y - s * 0.42); c.lineTo(x - s * 0.18, y + s * 0.42); c.moveTo(x + s * 0.18, y - s * 0.42); c.lineTo(x + s * 0.18, y + s * 0.42); c.stroke(); };
  IC.bolt = (c, x, y, s) => { c.fillStyle = c.strokeStyle; c.beginPath(); c.moveTo(x + s * 0.08, y - s * 0.46); c.lineTo(x - s * 0.26, y + s * 0.06); c.lineTo(x - s * 0.02, y + s * 0.06); c.lineTo(x - s * 0.1, y + s * 0.46); c.lineTo(x + s * 0.26, y - s * 0.08); c.lineTo(x + s * 0.02, y - s * 0.08); c.closePath(); c.fill(); };
  IC.phoneUp = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.22, y - s * 0.44, s * 0.44, s * 0.88, s * 0.1); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.06, y - s * 0.34); c.lineTo(x + s * 0.06, y - s * 0.34); c.stroke(); };
  IC.photoWide = (c, x, y, s) => { line(c, s); c.beginPath(); c.roundRect(x - s * 0.46, y - s * 0.3, s * 0.92, s * 0.6, s * 0.06); c.stroke(); c.beginPath(); c.moveTo(x - s * 0.38, y + s * 0.2); c.lineTo(x - s * 0.1, y - s * 0.06); c.lineTo(x + s * 0.08, y + s * 0.1); c.lineTo(x + s * 0.2, y); c.lineTo(x + s * 0.38, y + s * 0.2); c.stroke(); };
  IC.walk = (c, x, y, s) => { line(c, s); c.beginPath(); c.arc(x + s * 0.04, y - s * 0.36, s * 0.08, 0, Math.PI * 2); c.stroke(); c.beginPath(); c.moveTo(x, y - s * 0.22); c.lineTo(x - s * 0.04, y + s * 0.08); c.lineTo(x - s * 0.2, y + s * 0.42); c.moveTo(x - s * 0.04, y + s * 0.08); c.lineTo(x + s * 0.16, y + s * 0.42); c.moveTo(x - s * 0.02, y - s * 0.14); c.lineTo(x - s * 0.24, y + s * 0.02); c.moveTo(x - s * 0.01, y - s * 0.14); c.lineTo(x + s * 0.22, y - s * 0.02); c.stroke(); };

  /* עיגול עם אייקון, לרשימות ולכרטיסים */
  K2.badge = (c, name, x, y, r, { fg = '#fff', bg = 'rgba(255,255,255,0.1)', ring = '' } = {}) => {
    c.save();
    c.fillStyle = bg; c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.fill();
    if (ring) { c.strokeStyle = ring; c.lineWidth = Math.max(1.5, r * 0.08); c.stroke(); }
    c.strokeStyle = fg; IC[name](c, x, y, r * 1.08);
    c.restore();
  };
})();

/* ── js/scenes-kit3.js ── */
/* ערכה לסבב 3 (17.09.2026): עומק שדה מדומה על צילום אמיתי של iPhone 18 Pro (mp-stairs).
   יובל על הצמצם בסבב 2: «התמונה לא טובה, לא רואים הבדלים». ⟹ צילום המדרגות: איש מקדימה, אישה באמצע, איש מאחור.
   הצילום עצמו חד מקדימה ועד אחורה (Apple מתייגת אותו ƒ/2.8 בדף המוצר ו-ƒ/4 בניוזרום). לכן ƒ/4 = הצילום כמו שהוא,
   וצמצם פתוח יותר מטשטש כל שכבה לפי המרחק שלה מנקודת הפוקוס. 🔴 זו המחשה, והנוסח צריך לומר זאת.
   השכבות סומנו ביד על רשת (qa/tripley-tests/scripts/_studio_grid.mjs, _studio_polys.mjs), בקואורדינטות יחסיות.
   d: עומק יחסי, 0 המישור של האיש שמקדימה ⟵ 1 הקיר הרחוק.
   🔴 הטשטוש בהקטנה והגדלה של הבד, כי ל-Safari אין ctx.filter. */
(() => {
  const L = window.TYSH, u = L.u, K = L.kit;
  const K3 = L.kit3 = {};

  /* מאחור לפנים. הרקע (d = 1) הוא כל מה שלא בפוליגון */
  const LAYERS = [
    ['rightWall', 0.6, [[0.83, 0.33], [0.87, 0.28], [1, 0.27], [1, 0.8], [0.93, 0.72], [0.86, 0.6], [0.84, 0.45]]],
    ['stairsFar', 0.62, [[0.59, 0.44], [0.84, 0.43], [0.86, 0.6], [0.93, 0.72], [0.52, 0.74], [0.52, 0.55]]],
    ['stairsNear', 0.38, [[0.52, 0.74], [0.93, 0.72], [1, 0.8], [1, 1], [0.52, 1]]],
    ['backMan', 0.6, [[0.665, 0.245], [0.695, 0.25], [0.705, 0.32], [0.72, 0.345], [0.72, 0.55], [0.705, 0.57], [0.7, 0.715], [0.66, 0.72], [0.66, 0.6], [0.62, 0.67], [0.6, 0.66], [0.605, 0.56], [0.615, 0.44], [0.635, 0.34], [0.65, 0.32], [0.648, 0.27]]],
    ['woman', 0.4, [[0.545, 0.255], [0.57, 0.26], [0.585, 0.32], [0.6, 0.36], [0.605, 0.5], [0.615, 0.57], [0.615, 0.74], [0.575, 0.76], [0.57, 0.9], [0.53, 0.9], [0.525, 0.76], [0.51, 0.74], [0.5, 0.6], [0.49, 0.5], [0.48, 0.42], [0.49, 0.34], [0.53, 0.3]]],
    ['rail', 0.06, [[0, 0.74], [0.175, 0.53], [0.21, 0.62], [0.26, 1], [0, 1]]],
    ['frontMan', 0, [[0.35, 0.095], [0.4, 0.1], [0.43, 0.17], [0.435, 0.3], [0.45, 0.34], [0.475, 0.45], [0.5, 0.58], [0.51, 0.72], [0.52, 0.8], [0.535, 1], [0.265, 1], [0.225, 0.86], [0.185, 0.61], [0.172, 0.53], [0.195, 0.37], [0.215, 0.32], [0.29, 0.31], [0.3, 0.2], [0.32, 0.13]]],
  ];
  K3.LAYERS = LAYERS;
  /* מרכזי הפנים, לזכוכית מגדלת ולפוקוס */
  K3.FACES = { front: [0.378, 0.2], woman: [0.563, 0.3], back: [0.673, 0.285] };

  /* כמה טשטוש יש בצמצם N, יחסית ל-ƒ/1.48. ƒ/4 = 0, הצילום כמו שהוא */
  K3.amount = N => u.clamp((1.48 / N - 0.37) / 0.63);

  /* הצילום בגודל היעד, פעם אחת לכל גודל וחיתוך */
  const bases = {};
  const baseOf = (im, crop, w, h) => {
    const dpr = Math.min(2, window.devicePixelRatio || 1), W = Math.max(2, Math.round(w * dpr)), H = Math.max(2, Math.round(h * dpr));
    const key = `${W}x${H}:${crop.join(',')}`;
    if (bases[key]) return bases[key];
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const x = cv.getContext('2d'); x.imageSmoothingQuality = 'high';
    x.drawImage(im, crop[0] * im.naturalWidth, crop[1] * im.naturalHeight, crop[2] * im.naturalWidth, crop[3] * im.naturalHeight, 0, 0, W, H);
    const keys = Object.keys(bases); if (keys.length > 24) delete bases[keys[0]];
    return (bases[key] = cv);
  };

  /* טשטוש: הקטנה לקנבס קטן, הגדלה לקנבס ביניים, ואז לגודל מלא. r בפיקסלים של המכשיר */
  const pool = [];
  const blurred = (src, r, slot) => {
    if (r < 0.7) return src;
    const P = pool[slot] || (pool[slot] = [document.createElement('canvas'), document.createElement('canvas')]);
    const f = Math.max(1.3, r * 0.85), w1 = Math.max(2, Math.round(src.width / f)), h1 = Math.max(2, Math.round(src.height / f));
    const w2 = Math.min(src.width, w1 * 2), h2 = Math.min(src.height, h1 * 2);
    P[0].width = w1; P[0].height = h1; P[1].width = w2; P[1].height = h2;
    const a = P[0].getContext('2d'); a.imageSmoothingQuality = 'high'; a.drawImage(src, 0, 0, w1, h1);
    const b = P[1].getContext('2d'); b.imageSmoothingQuality = 'high'; b.drawImage(P[0], 0, 0, w2, h2);
    return P[1];
  };

  /* מצייר את הצילום במלבן (x, y, w, h) בצמצם N.
     crop [x, y, w, h] יחסי · focus העומק שבפוקוס (0 האיש שמקדימה) · strength מכפיל לטשטוש (1 = 6% מהרוחב ב-ƒ/1.48, לשכבה הרחוקה) */
  K3.photo = (c, x, y, w, h, N, { crop = [0, 0, 1, 1], focus = 0, strength = 1, amount = null } = {}) => {
    const im = K.img('mp-stairs');
    if (!im) { c.fillStyle = '#16161A'; c.fillRect(x, y, w, h); return false; }
    const base = baseOf(im, crop, w, h), dpr = base.width / w, A = amount === null ? K3.amount(N) : amount;
    /* מוגזם בכוונה: בכרטיס קטן 3% מהרוחב לא נראה (צילום 17.09). 6% ב-d = 1 */
    const rOf = d => w * 0.06 * strength * Math.abs(d - focus) * A * dpr;
    const map = ([px, py]) => [x + ((px - crop[0]) / crop[2]) * w, y + ((py - crop[1]) / crop[3]) * h];
    c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip();
    c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
    c.drawImage(blurred(base, rOf(1), 0), x, y, w, h);
    LAYERS.forEach(([, d, pts], i) => {
      c.save();
      c.beginPath(); pts.forEach((p, j) => { const [X, Y] = map(p); j ? c.lineTo(X, Y) : c.moveTo(X, Y); }); c.closePath(); c.clip();
      c.drawImage(blurred(base, rOf(d), i + 1), x, y, w, h);
      c.restore();
    });
    c.restore();
    return true;
  };

  /* מפת העומק עצמה: כל שכבה בגוון אפור לפי המרחק. לסצנת הקולנוע */
  K3.depthMap = (c, x, y, w, h, { crop = [0, 0, 1, 1], focus = 0, I } = {}) => {
    const map = ([px, py]) => [x + ((px - crop[0]) / crop[2]) * w, y + ((py - crop[1]) / crop[3]) * h];
    c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip();
    c.fillStyle = '#1B1B20'; c.fillRect(x, y, w, h);
    LAYERS.forEach(([, d, pts]) => {
      const inF = Math.abs(d - focus) < 0.12, v = Math.round(u.lerp(235, 40, d));
      c.beginPath(); pts.forEach((p, j) => { const [X, Y] = map(p); j ? c.lineTo(X, Y) : c.moveTo(X, Y); }); c.closePath();
      c.fillStyle = inF && I ? u.acc(I, 0.95) : `rgb(${v},${v},${v})`; c.fill();
    });
    c.restore();
  };
})();

/* ── js/scenes-ui2.js ── */
/* מסכי אפליקציות מצוירים לסבב 2 (17.09.2026): לסוללה (יום רגיל) ולמהירות (מעבר בין אפליקציות).
   כל מסך מצויר במלבן (x, y, w, h), ולכן אותו מסך משמש גם מסך מלא וגם כרטיס קטן.
   בלי שמות מותגים ובלי אייקונים של אפליקציות אמיתיות. טקסט קצר בעברית, רק איפה שהוא עוזר להבין. */
(() => {
  const L = window.TYSH, u = L.u, K = L.kit, K2 = L.kit2;
  const UI = L.ui2 = {};
  const T = (c, s, x, y, px, col, w = 500, al = 'center', dir = 'rtl') => u.text(c, s, x, y, px, col, w, al, dir);
  const clip = (c, x, y, w, h, r = 0) => { c.save(); c.beginPath(); r ? c.roundRect(x, y, w, h, r) : c.rect(x, y, w, h); c.clip(); };

  /* טפט בגווני בורדו: light 0 לילה ⟵ 1 צהריים */
  UI.wall = (c, x, y, w, h, light = 1, I) => {
    const g = c.createLinearGradient(x, y, x + w * 0.4, y + h);
    const a = u.lerp(0.35, 1, light);
    g.addColorStop(0, `rgb(${Math.round(92 * a)},${Math.round(34 * a)},${Math.round(48 * a)})`);
    g.addColorStop(0.55, `rgb(${Math.round(40 * a)},${Math.round(16 * a)},${Math.round(26 * a)})`);
    g.addColorStop(1, `rgb(${Math.round(14 * a)},${Math.round(8 * a)},${Math.round(12 * a)})`);
    c.fillStyle = g; c.fillRect(x, y, w, h);
    /* קשתות רכות, כמו הטפט של 18 Pro */
    c.save(); c.globalAlpha = 0.25 * a; c.strokeStyle = I ? u.acc(I, 1) : '#E6A2B3'; c.lineWidth = Math.max(1, w * 0.006);
    [[0.9, 0.35, 0.55], [0.1, 0.8, 0.6], [0.55, 1.05, 0.5]].forEach(([fx, fy, fr]) => { c.beginPath(); c.arc(x + w * fx, y + h * fy, w * fr, 0, Math.PI * 2); c.stroke(); });
    c.restore();
  };

  /* מסך נעילה */
  UI.lock = (c, x, y, w, h, { time = '7:00', date = 'יום רביעי, 17 בספטמבר', light = 0.8, note = '', I } = {}) => {
    UI.wall(c, x, y, w, h, light, I);
    T(c, date, x + w / 2, y + h * 0.13, w * 0.045, 'rgba(255,255,255,0.85)', 500);
    T(c, time, x + w / 2, y + h * 0.215, w * 0.24, '#fff', 500, 'center', 'ltr');
    if (note) {
      u.rr(c, x + w * 0.05, y + h * 0.62, w * 0.9, h * 0.085, w * 0.05, 'rgba(255,255,255,0.16)');
      T(c, note, x + w * 0.9, y + h * 0.662, w * 0.042, '#fff', 500, 'right');
    }
    [[0.18, 'bolt'], [0.82, 'camera']].forEach(([fx, ic]) => {
      c.fillStyle = 'rgba(0,0,0,0.35)'; c.beginPath(); c.arc(x + w * fx, y + h * 0.9, w * 0.07, 0, Math.PI * 2); c.fill();
      c.strokeStyle = '#fff'; K2.icon[ic === 'bolt' ? 'sun' : 'camera'](c, x + w * fx, y + h * 0.9, w * 0.08);
    });
  };

  /* מפות: כבישים, מסלול כחול, חץ שנוסע, ובאנר פנייה */
  UI.maps = (c, x, y, w, h, t = 0) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#E9E5DA'; c.fillRect(x, y, w, h);
    c.fillStyle = '#CFE3C4'; c.beginPath(); c.roundRect(x + w * 0.05, y + h * 0.52, w * 0.36, h * 0.2, w * 0.04); c.fill();
    c.fillStyle = '#AFCFEA'; c.beginPath(); c.moveTo(x + w * 0.62, y + h); c.bezierCurveTo(x + w * 0.7, y + h * 0.8, x + w * 1.05, y + h * 0.78, x + w * 1.1, y + h * 0.7); c.lineTo(x + w * 1.1, y + h); c.fill();
    const road = (pts, wd) => { c.lineCap = 'round'; c.lineJoin = 'round'; c.strokeStyle = '#C9C3B6'; c.lineWidth = wd + 2; c.beginPath(); pts.forEach(([px, py], i) => (i ? c.lineTo(x + px * w, y + py * h) : c.moveTo(x + px * w, y + py * h))); c.stroke(); c.strokeStyle = '#fff'; c.lineWidth = wd; c.stroke(); };
    road([[-0.1, 0.3], [1.1, 0.36]], w * 0.03); road([[0.2, -0.1], [0.28, 1.1]], w * 0.028); road([[0.62, -0.1], [0.55, 0.5], [0.8, 1.1]], w * 0.035); road([[-0.1, 0.78], [1.1, 0.62]], w * 0.022);
    const route = [[0.25, 0.95], [0.25, 0.56], [0.55, 0.47], [0.6, 0.3], [0.6, 0.12]];
    c.strokeStyle = '#0A84FF'; c.lineWidth = w * 0.035; c.lineCap = 'round'; c.lineJoin = 'round';
    c.beginPath(); route.forEach(([px, py], i) => (i ? c.lineTo(x + px * w, y + py * h) : c.moveTo(x + px * w, y + py * h))); c.stroke();
    /* החץ לאורך המסלול */
    const seg = []; let tot = 0; for (let i = 1; i < route.length; i++) { const d = Math.hypot((route[i][0] - route[i - 1][0]) * w, (route[i][1] - route[i - 1][1]) * h); seg.push(d); tot += d; }
    let d = ((t * 0.08) % 0.55 + 0.15) * tot, i = 0; while (i < seg.length - 1 && d > seg[i]) { d -= seg[i]; i++; }
    const f = d / seg[i], ax = x + u.lerp(route[i][0], route[i + 1][0], f) * w, ay = y + u.lerp(route[i][1], route[i + 1][1], f) * h;
    const ang = Math.atan2((route[i + 1][1] - route[i][1]) * h, (route[i + 1][0] - route[i][0]) * w);
    c.save(); c.translate(ax, ay); c.rotate(ang + Math.PI / 2);
    c.fillStyle = '#fff'; c.beginPath(); c.arc(0, 0, w * 0.05, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#0A84FF'; c.beginPath(); c.moveTo(0, -w * 0.035); c.lineTo(w * 0.025, w * 0.025); c.lineTo(0, w * 0.012); c.lineTo(-w * 0.025, w * 0.025); c.closePath(); c.fill();
    c.restore();
    /* באנר פנייה */
    u.rr(c, x + w * 0.04, y + h * 0.08, w * 0.92, h * 0.1, w * 0.05, '#1C1C1E');
    T(c, "300 מ'", x + w * 0.8, y + h * 0.115, w * 0.06, '#fff', 700, 'center', 'rtl');
    T(c, 'פנו ימינה', x + w * 0.8, y + h * 0.152, w * 0.04, 'rgba(255,255,255,0.7)', 500, 'center', 'rtl');
    c.save(); c.strokeStyle = '#fff'; c.lineWidth = w * 0.014; c.lineCap = 'round'; c.lineJoin = 'round';
    const bx = x + w * 0.2, by = y + h * 0.13; c.beginPath(); c.moveTo(bx, by + w * 0.05); c.lineTo(bx, by); c.lineTo(bx + w * 0.06, by); c.stroke();
    c.beginPath(); c.moveTo(bx + w * 0.035, by - w * 0.025); c.lineTo(bx + w * 0.065, by); c.lineTo(bx + w * 0.035, by + w * 0.025); c.stroke(); c.restore();
    u.rr(c, x + w * 0.04, y + h * 0.84, w * 0.92, h * 0.1, w * 0.05, 'rgba(255,255,255,0.95)');
    T(c, "12 דק'", x + w * 0.8, y + h * 0.89, w * 0.06, '#1C1C1E', 700, 'center', 'rtl');
    T(c, 'הגעה 8:42', x + w * 0.32, y + h * 0.89, w * 0.042, '#6E6E73', 500, 'center', 'rtl');
    c.restore();
  };

  /* הודעות: בועות שנכנסות לפי t */
  const MSGS = [['in', 'מגיעים בשמונה?'], ['out', 'כן, אני בדרך'], ['in', 'מעולה, שומרים מקום'], ['out', 'תודה!'], ['in', 'מביאים עוגה?'], ['out', 'כבר קניתי']];
  UI.chat = (c, x, y, w, h, t = 9, I, { msgs = MSGS, title = 'משפחה' } = {}) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    c.fillStyle = '#121214'; c.fillRect(x, y, w, h * 0.13);
    c.fillStyle = '#3A3A3C'; c.beginPath(); c.arc(x + w / 2, y + h * 0.075, w * 0.045, 0, Math.PI * 2); c.fill();
    T(c, title, x + w / 2, y + h * 0.115, w * 0.035, 'rgba(255,255,255,0.85)', 500);
    const n = Math.min(msgs.length, Math.floor(t * 1.2) + 2);
    let yy = y + h * 0.17;
    const px = w * 0.042;
    msgs.slice(0, n).forEach(([who, s], i) => {
      c.font = u.font(500, px); c.direction = 'rtl';
      const bw = Math.min(w * 0.7, c.measureText(s).width + px * 1.6), bh = px * 2.1, a = i === n - 1 ? u.clamp((t * 1.2 - (n - 2)) * 3) : 1;
      const bx = who === 'in' ? x + w * 0.95 - bw : x + w * 0.05;
      c.save(); c.globalAlpha = Math.max(0.2, a);
      u.rr(c, bx, yy, bw, bh, bh / 2, who === 'in' ? '#262629' : (I ? u.acc(I, 1) : '#0A84FF'));
      T(c, s, bx + bw / 2, yy + bh / 2 + 0.5, px, who === 'in' ? '#fff' : '#000', 500);
      c.restore();
      yy += bh + px * 0.8;
    });
    u.rr(c, x + w * 0.05, y + h * 0.9, w * 0.9, h * 0.055, h * 0.0275, '#1C1C1E');
    c.restore();
  };

  /* מוזיקה: עטיפה מופשטת, שם, פס התקדמות וכפתורים */
  UI.music = (c, x, y, w, h, t = 0) => {
    clip(c, x, y, w, h);
    const g = c.createLinearGradient(x, y, x, y + h); g.addColorStop(0, '#5B2A1F'); g.addColorStop(0.6, '#23110E'); g.addColorStop(1, '#0B0605');
    c.fillStyle = g; c.fillRect(x, y, w, h);
    const s = w * 0.78, ax = x + (w - s) / 2, ay = y + h * 0.13;
    clip(c, ax, ay, s, s, w * 0.04);
    const ag = c.createLinearGradient(ax, ay, ax + s, ay + s); ag.addColorStop(0, '#F08A4B'); ag.addColorStop(1, '#8E2C48');
    c.fillStyle = ag; c.fillRect(ax, ay, s, s);
    c.globalAlpha = 0.55; c.fillStyle = '#FFD27A'; c.beginPath(); c.arc(ax + s * 0.66, ay + s * 0.4, s * 0.22, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#2A0F1A'; c.beginPath(); c.moveTo(ax, ay + s * 0.78); c.bezierCurveTo(ax + s * 0.3, ay + s * 0.6, ax + s * 0.6, ay + s * 0.86, ax + s, ay + s * 0.7); c.lineTo(ax + s, ay + s); c.lineTo(ax, ay + s); c.fill();
    c.globalAlpha = 1; c.restore();
    T(c, 'שיר הבוקר', x + w * 0.89, y + h * 0.62, w * 0.058, '#fff', 700, 'right');
    T(c, 'הפלייליסט שלי', x + w * 0.89, y + h * 0.66, w * 0.042, 'rgba(255,255,255,0.6)', 500, 'right');
    const p = (t * 0.07) % 1, bx0 = x + w * 0.11, bx1 = x + w * 0.89, by = y + h * 0.72;
    u.rr(c, bx0, by, bx1 - bx0, h * 0.006, h * 0.003, 'rgba(255,255,255,0.25)');
    u.rr(c, bx1 - (bx1 - bx0) * p, by, (bx1 - bx0) * p, h * 0.006, h * 0.003, '#fff');
    const cy = y + h * 0.82;
    c.fillStyle = '#fff';
    c.beginPath(); c.roundRect(x + w / 2 - w * 0.04, cy - w * 0.05, w * 0.028, w * 0.1, 2); c.roundRect(x + w / 2 + w * 0.012, cy - w * 0.05, w * 0.028, w * 0.1, 2); c.fill();
    [[-1, 0.26], [1, 0.74]].forEach(([dir, fx]) => { const bx = x + w * fx; c.beginPath(); c.moveTo(bx - dir * w * 0.04, cy - w * 0.035); c.lineTo(bx + dir * w * 0.01, cy); c.lineTo(bx - dir * w * 0.04, cy + w * 0.035); c.fill(); c.beginPath(); c.moveTo(bx + dir * w * 0.0, cy - w * 0.035); c.lineTo(bx + dir * w * 0.05, cy); c.lineTo(bx + dir * w * 0.0, cy + w * 0.035); c.fill(); });
    c.restore();
  };

  /* תמונות: גריד של צילומים של Apple */
  const GRID = [['cam-photo', 0.5], ['selfie-group', 0.5], ['zoom-8x', 0.6], ['ap-148', 0.57], ['ap-28', 0.55], ['bat-video', 0.5], ['ap-4', 0.69], ['zoom-wide', 0.5], ['ap-18', 0.52], ['cam-photo', 0.3], ['selfie-group', 0.75], ['zoom-wide', 0.7]];
  UI.photos = (c, x, y, w, h, t = 0) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    T(c, 'תמונות', x + w * 0.93, y + h * 0.1, w * 0.075, '#fff', 700, 'right');
    const cols = 3, gap = Math.max(1, w * 0.008), tw = (w - gap * 2) / cols, top = y + h * 0.15 - (t * h * 0.02) % (tw + gap);
    GRID.forEach(([key, fx], i) => {
      const col = i % cols, row = Math.floor(i / cols), tx = x + w - (col + 1) * tw - col * gap, ty = top + row * (tw + gap), im = K.img(key);
      if (ty > y + h) return;
      if (im) { clip(c, tx, ty, tw, tw); u.cover(c, im, tx, ty, tw, tw, fx, 0.5); c.restore(); } else { c.fillStyle = '#1C1C1E'; c.fillRect(tx, ty, tw, tw); }
    });
    c.restore();
  };

  /* סדרה: נגן לאורך, צילום, פס ושם */
  UI.video = (c, x, y, w, h, t = 0) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    const im = K.img('bat-video'), vh = w * 0.62, vy = y + h * 0.3;
    if (im) { clip(c, x, vy, w, vh); u.cover(c, im, x, vy, w, vh, 0.5, 0.45, 1.04 + 0.02 * Math.sin(t)); c.restore(); }
    const p = (t * 0.05) % 1, bx0 = x + w * 0.06, bx1 = x + w * 0.94, by = vy + vh + h * 0.03;
    u.rr(c, bx0, by, bx1 - bx0, h * 0.005, 2, 'rgba(255,255,255,0.25)');
    u.rr(c, bx1 - (bx1 - bx0) * p, by, (bx1 - bx0) * p, h * 0.005, 2, '#fff');
    T(c, 'פרק 3', x + w * 0.94, by + h * 0.045, w * 0.055, '#fff', 700, 'right');
    T(c, 'עונה 2', x + w * 0.94, by + h * 0.08, w * 0.04, 'rgba(255,255,255,0.6)', 500, 'right');
    c.restore();
  };

  /* מסך הבית: ווידג'ט סוללה, אייקונים צבעוניים בלי סמלים, ורציף */
  const ICONS = ['#0A84FF', '#30D158', '#FF9F0A', '#FF375F', '#BF5AF2', '#64D2FF', '#FFD60A', '#5E5CE6', '#FF6961', '#32ADE6', '#AC8E68', '#8E8E93'];
  UI.home = (c, x, y, w, h, { light = 1, level = 1, charging = false, widget = true, rows = 0, I } = {}) => {
    clip(c, x, y, w, h);
    UI.wall(c, x, y, w, h, light, I);
    const iw = w * 0.16, gx = (w - iw * 4) / 5;
    let top = y + h * 0.1;
    if (widget) {
      const ww = w - gx * 2, wh = iw * 2 + gx;
      u.rr(c, x + gx, top, ww, wh, w * 0.06, 'rgba(20,12,16,0.55)');
      const R = wh * 0.3, cx = x + w - gx - wh * 0.45, cy = top + wh / 2;
      c.lineWidth = R * 0.22; c.lineCap = 'round';
      c.strokeStyle = 'rgba(255,255,255,0.14)'; c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.stroke();
      c.strokeStyle = level < 0.2 && !charging ? '#FF453A' : charging ? '#30D158' : '#fff';
      c.beginPath(); c.arc(cx, cy, R, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * Math.max(0.01, level)); c.stroke(); c.lineCap = 'butt';
      c.strokeStyle = '#fff'; K2.icon.phoneUp(c, cx, cy, R * 0.9);
      T(c, `${Math.round(level * 100)}%`, x + gx + w * 0.3, cy - wh * 0.06, w * 0.12, '#fff', 500, 'center', 'ltr');
      T(c, 'סוללה', x + gx + w * 0.3, cy + wh * 0.2, w * 0.045, 'rgba(255,255,255,0.7)', 500);
      top += wh + gx * 1.4;
    }
    const nr = rows || (widget ? 3 : 5);
    /* בלי ווידג'ט ועם מעט שורות: האייקונים יורדים מעל הרציף, והטפט נשאר גלוי למעלה */
    if (rows && !widget) top = y + h * 0.86 - nr * (iw + gx * 1.5) - gx;
    for (let r = 0; r < nr; r++) for (let k = 0; k < 4; k++) {
      const ix = x + w - gx - (k + 1) * iw - k * gx, iy = top + r * (iw + gx * 1.5);
      u.rr(c, ix, iy, iw, iw, iw * 0.24, ICONS[(r * 4 + k) % ICONS.length]);
      c.fillStyle = 'rgba(255,255,255,0.25)'; c.beginPath(); c.arc(ix + iw / 2, iy + iw / 2, iw * 0.2, 0, Math.PI * 2); c.fill();
    }
    u.rr(c, x + gx * 0.6, y + h * 0.86, w - gx * 1.2, iw + gx * 1.2, w * 0.08, 'rgba(255,255,255,0.18)');
    for (let k = 0; k < 4; k++) { const ix = x + w - gx - (k + 1) * iw - k * gx; u.rr(c, ix, y + h * 0.86 + gx * 0.6, iw, iw, iw * 0.24, ICONS[(k * 5 + 2) % ICONS.length]); }
    c.restore();
  };

  /* משחק מרוץ: שקיעה, הרים, כביש בפרספקטיבה, רכב ומד מהירות */
  UI.game = (c, x, y, w, h, t = 0, { fps = 0 } = {}) => {
    clip(c, x, y, w, h);
    const hz = y + h * 0.42;
    const sky = c.createLinearGradient(0, y, 0, hz); sky.addColorStop(0, '#1B1B4A'); sky.addColorStop(0.6, '#B04A6A'); sky.addColorStop(1, '#F7A55B');
    c.fillStyle = sky; c.fillRect(x, y, w, hz - y);
    c.fillStyle = '#FFD9A0'; c.beginPath(); c.arc(x + w * 0.5, hz, w * 0.16, Math.PI, 0); c.fill();
    c.fillStyle = '#3B1D3A'; c.beginPath(); c.moveTo(x, hz); [[0.15, -0.08], [0.3, -0.03], [0.45, -0.1], [0.62, -0.04], [0.8, -0.09], [1, -0.02]].forEach(([fx, fy]) => c.lineTo(x + w * fx, hz + h * fy)); c.lineTo(x + w, hz); c.fill();
    const gr = c.createLinearGradient(0, hz, 0, y + h); gr.addColorStop(0, '#2A1830'); gr.addColorStop(1, '#0A060C'); c.fillStyle = gr; c.fillRect(x, hz, w, y + h - hz);
    /* הכביש */
    const cx = x + w * 0.5;
    c.fillStyle = '#26232B'; c.beginPath(); c.moveTo(cx - w * 0.02, hz); c.lineTo(cx + w * 0.02, hz); c.lineTo(x + w * 1.05, y + h); c.lineTo(x - w * 0.05, y + h); c.fill();
    /* פסים שזזים: קצב קבוע, כדי שהמשחק ייראה חלק */
    for (let i = 0; i < 9; i++) {
      const s = ((i / 9 + t * 0.9) % 1), p0 = s * s, p1 = Math.min(1, (s + 0.04) * (s + 0.04));
      const y0 = u.lerp(hz, y + h, p0), y1 = u.lerp(hz, y + h, p1), w0 = u.lerp(w * 0.002, w * 0.03, p0), w1 = u.lerp(w * 0.002, w * 0.03, p1);
      c.fillStyle = 'rgba(255,230,160,0.85)'; c.beginPath(); c.moveTo(cx - w0, y0); c.lineTo(cx + w0, y0); c.lineTo(cx + w1, y1); c.lineTo(cx - w1, y1); c.fill();
      [-1, 1].forEach(sd => { c.fillStyle = i % 2 ? '#E8E8EE' : '#D0302F'; const e0 = cx + sd * u.lerp(w * 0.02, w * 0.55, p0), e1 = cx + sd * u.lerp(w * 0.02, w * 0.55, p1); c.beginPath(); c.moveTo(e0, y0); c.lineTo(e0 + sd * w * 0.01 * p0, y0); c.lineTo(e1 + sd * w * 0.03 * p1, y1); c.lineTo(e1, y1); c.fill(); });
    }
    /* הרכב */
    const car = (px, py, s, body) => {
      c.fillStyle = 'rgba(0,0,0,0.5)'; c.beginPath(); c.ellipse(px, py + s * 0.28, s * 0.55, s * 0.08, 0, 0, Math.PI * 2); c.fill();
      c.fillStyle = body; c.beginPath(); c.roundRect(px - s * 0.5, py - s * 0.05, s, s * 0.3, s * 0.08); c.fill();
      c.beginPath(); c.moveTo(px - s * 0.34, py - s * 0.05); c.lineTo(px - s * 0.22, py - s * 0.28); c.lineTo(px + s * 0.22, py - s * 0.28); c.lineTo(px + s * 0.34, py - s * 0.05); c.fill();
      c.fillStyle = '#1A2338'; c.beginPath(); c.moveTo(px - s * 0.27, py - s * 0.07); c.lineTo(px - s * 0.18, py - s * 0.24); c.lineTo(px + s * 0.18, py - s * 0.24); c.lineTo(px + s * 0.27, py - s * 0.07); c.fill();
      c.fillStyle = '#FF3B30'; c.fillRect(px - s * 0.46, py + s * 0.04, s * 0.14, s * 0.06); c.fillRect(px + s * 0.32, py + s * 0.04, s * 0.14, s * 0.06);
      c.fillStyle = '#111'; c.fillRect(px - s * 0.48, py + s * 0.22, s * 0.16, s * 0.1); c.fillRect(px + s * 0.32, py + s * 0.22, s * 0.16, s * 0.1);
    };
    car(cx + Math.sin(t * 2.6) * w * 0.12 + w * 0.12, hz + h * 0.14, w * 0.14, '#3EA0FF');
    car(cx + Math.sin(t * 1.3) * w * 0.05, y + h * 0.8, w * 0.42, '#E23B4E');
    T(c, '1/8', x + w * 0.1, y + h * 0.08, w * 0.06, '#fff', 700, 'center', 'ltr');
    T(c, `${Math.round(212 + 6 * Math.sin(t * 3))}`, x + w * 0.86, y + h * 0.075, w * 0.08, '#fff', 700, 'center', 'ltr');
    T(c, 'קמ"ש', x + w * 0.86, y + h * 0.115, w * 0.035, 'rgba(255,255,255,0.7)', 500);
    if (fps) T(c, `${fps} FPS`, x + w * 0.5, y + h * 0.06, w * 0.04, 'rgba(255,255,255,0.85)', 600, 'center', 'ltr');
    c.restore();
  };

  /* עריכת וידאו: תצוגה, פס קליפים, סמן וכפתור ייצוא */
  UI.editor = (c, x, y, w, h, t = 0, { exp = -1, I } = {}) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#0B0B0D'; c.fillRect(x, y, w, h);
    const im = K.img('zoom-8x'), vh = w * 0.72, vy = y + h * 0.13;
    if (im) { clip(c, x, vy, w, vh); u.cover(c, im, x, vy, w, vh, 0.55, 0.45, 1.05 + 0.03 * Math.sin(t * 0.7)); c.restore(); }
    /* פס צבע שעובר על התמונה: אפקט שמוחל בזמן אמת */
    const sweep = (t * 0.45) % 1;
    c.save(); clip(c, x, vy, w * sweep, vh); c.fillStyle = 'rgba(255,170,90,0.22)'; c.fillRect(x, vy, w, vh); c.restore(); c.restore();
    c.fillStyle = 'rgba(255,255,255,0.8)'; c.fillRect(x + w * sweep - 1, vy, 2, vh);
    /* ציר */
    const ty = vy + vh + h * 0.06, th = h * 0.07, clips = [['zoom-wide', 0.5], ['zoom-8x', 0.6], ['cam-photo', 0.4], ['selfie-group', 0.5], ['bat-video', 0.5]];
    clips.forEach(([k, fx], i) => {
      const cw = w * 0.36, cx0 = x + w * 0.9 - (i + 1) * (cw + 3) + ((t * w * 0.05) % (cw + 3)), ci = K.img(k);
      if (cx0 > x + w || cx0 + cw < x) return;
      clip(c, cx0, ty, cw, th, 4); if (ci) u.cover(c, ci, cx0, ty, cw, th, fx, 0.5); else { c.fillStyle = '#222'; c.fillRect(cx0, ty, cw, th); } c.restore();
    });
    c.fillStyle = '#FFD60A'; c.fillRect(x + w / 2 - 1, ty - h * 0.015, 2, th + h * 0.03);
    u.rr(c, x + w * 0.06, ty + th + h * 0.03, w * 0.88, h * 0.035, 3, 'rgba(255,255,255,0.08)');
    for (let k = 0; k < 40; k++) { const bh = h * 0.028 * (0.3 + 0.7 * Math.abs(Math.sin(k * 1.7 + t))); c.fillStyle = 'rgba(80,200,120,0.7)'; c.fillRect(x + w * 0.08 + k * w * 0.021, ty + th + h * 0.047 - bh / 2, w * 0.012, bh); }
    if (exp >= 0) {
      const by = y + h * 0.86;
      u.rr(c, x + w * 0.1, by, w * 0.8, h * 0.07, h * 0.035, 'rgba(255,255,255,0.12)');
      u.rr(c, x + w * 0.9 - w * 0.8 * exp, by, w * 0.8 * exp, h * 0.07, h * 0.035, I ? u.acc(I, 1) : '#0A84FF');
      T(c, exp >= 1 ? 'הסרטון מוכן' : `מייצא 4K · ${Math.round(exp * 100)}%`, x + w / 2, by + h * 0.036, w * 0.045, exp > 0.5 ? '#000' : '#fff', 600, 'center', 'rtl');
    }
    c.restore();
  };

  /* מצלמה: עינית עם צילום ושורת מצבים */
  UI.camera = (c, x, y, w, h, t = 0) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    const im = K.img('cam-photo'), vy = y + h * 0.12, vh = w * 1.333;
    if (im) { clip(c, x, vy, w, vh); u.cover(c, im, x, vy, w, vh, 0.4 + 0.05 * Math.sin(t * 0.5), 0.5); c.restore(); }
    T(c, 'תמונה', x + w / 2, vy + vh + h * 0.04, w * 0.045, '#FFD60A', 600);
    c.strokeStyle = '#fff'; c.lineWidth = w * 0.012; c.beginPath(); c.arc(x + w / 2, y + h * 0.9, w * 0.09, 0, Math.PI * 2); c.stroke();
    c.fillStyle = '#fff'; c.beginPath(); c.arc(x + w / 2, y + h * 0.9, w * 0.072, 0, Math.PI * 2); c.fill();
    c.restore();
  };
})();

/* ── js/scenes-ui3.js ── */
/* מסכים לסבב 3 (17.09.2026): היום של הסוללה, עם חיוך. שעון מעורר, סרטונים קצרים, פיד, צלחת, הפרק הבא, כיוון שעון.
   בלי שמות ובלי סמלים של אפליקציות אמיתיות. המסכים נראים כמו הסוג, לא כמו מותג. */
(() => {
  const L = window.TYSH, u = L.u, K = L.kit, K2 = L.kit2, UI = L.ui2;
  const T = (c, s, x, y, px, col, w = 500, al = 'center', dir = 'rtl') => u.text(c, s, x, y, px, col, w, al, dir);
  const clip = (c, x, y, w, h, r = 0) => { c.save(); c.beginPath(); r ? c.roundRect(x, y, w, h, r) : c.rect(x, y, w, h); c.clip(); };

  /* שעון מעורר מצלצל: השעה רועדת קצת, ושני כפתורים. press: 0 עד 1, כמה «נודניק» לחוץ */
  UI.alarm = (c, x, y, w, h, t = 0, { time = '6:30', press = 0, I } = {}) => {
    UI.wall(c, x, y, w, h, 0.45, I);
    c.fillStyle = 'rgba(0,0,0,0.25)'; c.fillRect(x, y, w, h);
    const shake = Math.sin(t * 60) * w * 0.006 * (1 - press);
    T(c, 'שעון מעורר', x + w / 2, y + h * 0.16, w * 0.05, 'rgba(255,255,255,0.85)', 500);
    T(c, time, x + w / 2 + shake, y + h * 0.26, w * 0.26, '#fff', 500, 'center', 'ltr');
    /* גלים סביב השעון */
    c.save(); c.strokeStyle = 'rgba(255,255,255,0.18)'; c.lineWidth = Math.max(1, w * 0.006);
    for (let k = 0; k < 3; k++) { const r = w * (0.2 + ((t * 0.9 + k / 3) % 1) * 0.25); c.globalAlpha = 1 - ((t * 0.9 + k / 3) % 1); c.beginPath(); c.arc(x + w / 2, y + h * 0.42, r, 0, Math.PI * 2); c.stroke(); }
    c.restore();
    const bw = w * 0.84, bh = h * 0.085, bx = x + (w - bw) / 2;
    u.rr(c, bx, y + h * 0.68, bw, bh, bh / 2, press > 0.5 ? '#E08A1E' : '#FF9F0A');
    T(c, 'נודניק', x + w / 2, y + h * 0.68 + bh / 2, w * 0.065, '#000', 700);
    u.rr(c, bx, y + h * 0.8, bw, bh, bh / 2, 'rgba(255,255,255,0.22)');
    T(c, 'עצירה', x + w / 2, y + h * 0.8 + bh / 2, w * 0.06, '#fff', 600);
  };

  /* סרטונים קצרים לאורך: מסך מלא, החלקה למעלה בכל כמה עשיריות, ועמודת אייקונים */
  const CLIPS = [['selfie-group', 0.45], ['zoom-8x', 0.62], ['ap-148', 0.55], ['bat-video', 0.5], ['cam-photo', 0.3], ['ap-4', 0.69], ['zoom-wide', 0.5]];
  UI.shorts = (c, x, y, w, h, t = 0, { seed = 0 } = {}) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    const per = 0.75, i = Math.floor(t / per), f = t / per - i, sw = u.ease(u.clamp((f - 0.72) / 0.28));
    [[i, -sw * h], [i + 1, h - sw * h]].forEach(([k, dy]) => {
      if (dy >= h) return;
      const [key, fx] = CLIPS[(k + seed) % CLIPS.length], im = K.img(key);
      if (im) { clip(c, x, y + dy, w, h); u.cover(c, im, x, y + dy, w, h, fx, 0.45, 1.04); c.restore(); } else { c.fillStyle = '#1C1C1E'; c.fillRect(x, y + dy, w, h); }
      const gr = c.createLinearGradient(0, y + dy + h * 0.6, 0, y + dy + h); gr.addColorStop(0, 'rgba(0,0,0,0)'); gr.addColorStop(1, 'rgba(0,0,0,0.7)');
      c.fillStyle = gr; c.fillRect(x, y + dy + h * 0.6, w, h * 0.4);
    });
    T(c, 'בשבילך', x + w / 2, y + h * 0.1, w * 0.05, '#fff', 700);
    const ix = x + w * 0.1;
    [['heart', 0.56], ['chat', 0.66], ['share', 0.76]].forEach(([k, fy]) => {
      const iy = y + h * fy, s = w * 0.07;
      c.save(); c.fillStyle = '#fff'; c.strokeStyle = '#fff'; c.lineWidth = Math.max(1.5, s * 0.12);
      if (k === 'heart') { c.beginPath(); c.moveTo(ix, iy + s * 0.5); c.bezierCurveTo(ix - s * 1.1, iy - s * 0.2, ix - s * 0.4, iy - s * 0.9, ix, iy - s * 0.25); c.bezierCurveTo(ix + s * 0.4, iy - s * 0.9, ix + s * 1.1, iy - s * 0.2, ix, iy + s * 0.5); c.fill(); }
      else if (k === 'chat') { K2.icon.chat(c, ix, iy, s * 1.3); }
      else { c.beginPath(); c.moveTo(ix - s * 0.5, iy + s * 0.4); c.quadraticCurveTo(ix - s * 0.4, iy - s * 0.3, ix + s * 0.3, iy - s * 0.3); c.lineTo(ix + s * 0.3, iy - s * 0.6); c.lineTo(ix + s * 0.7, iy - s * 0.1); c.lineTo(ix + s * 0.3, iy + s * 0.3); c.lineTo(ix + s * 0.3, iy); c.quadraticCurveTo(ix - s * 0.2, iy, ix - s * 0.5, iy + s * 0.4); c.fill(); }
      c.restore();
    });
    u.rr(c, x + w * 0.35, y + h * 0.86, w * 0.58, h * 0.018, 3, 'rgba(255,255,255,0.85)');
    u.rr(c, x + w * 0.5, y + h * 0.895, w * 0.43, h * 0.014, 3, 'rgba(255,255,255,0.55)');
    c.restore();
  };

  /* פיד של רשת חברתית: פוסטים עם תמונה, נגללים */
  UI.feed = (c, x, y, w, h, t = 0) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    const ph = w * 1.28, off = (t * h * 0.35) % ph;
    for (let k = -1; k < 3; k++) {
      const py = y + h * 0.12 + k * ph - off, [key, fx] = CLIPS[((k + 2) + Math.floor(t * 0.35 * h / ph)) % CLIPS.length];
      c.fillStyle = '#3A3A3C'; c.beginPath(); c.arc(x + w * 0.9, py + w * 0.07, w * 0.045, 0, Math.PI * 2); c.fill();
      u.rr(c, x + w * 0.5, py + w * 0.055, w * 0.33, w * 0.03, 3, 'rgba(255,255,255,0.75)');
      const im = K.img(key), iy = py + w * 0.14;
      if (im) { clip(c, x, iy, w, w); u.cover(c, im, x, iy, w, w, fx, 0.5); c.restore(); } else { c.fillStyle = '#1C1C1E'; c.fillRect(x, iy, w, w); }
      c.save(); c.strokeStyle = '#fff'; K2.icon.chat(c, x + w * 0.8, iy + w * 1.07, w * 0.07); c.restore();
      c.fillStyle = '#fff'; c.beginPath(); const hx = x + w * 0.92, hy = iy + w * 1.07, s = w * 0.035; c.moveTo(hx, hy + s * 0.5); c.bezierCurveTo(hx - s * 1.1, hy - s * 0.2, hx - s * 0.4, hy - s * 0.9, hx, hy - s * 0.25); c.bezierCurveTo(hx + s * 0.4, hy - s * 0.9, hx + s * 1.1, hy - s * 0.2, hx, hy + s * 0.5); c.fill();
    }
    c.fillStyle = '#000'; c.fillRect(x, y, w, h * 0.1);
    T(c, 'הפיד', x + w * 0.92, y + h * 0.075, w * 0.065, '#fff', 700, 'right');
    c.restore();
  };

  /* צלחת צהריים במצלמה: מבט מלמעלה על שולחן עץ */
  UI.lunch = (c, x, y, w, h, t = 0, { flash = 0 } = {}) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    const vy = y + h * 0.12, vh = w * 1.333;
    clip(c, x, vy, w, vh);
    const wood = c.createLinearGradient(x, vy, x + w, vy + vh); wood.addColorStop(0, '#8A5A36'); wood.addColorStop(1, '#5A3A22');
    c.fillStyle = wood; c.fillRect(x, vy, w, vh);
    c.strokeStyle = 'rgba(0,0,0,0.12)'; c.lineWidth = 1; for (let k = 0; k < 9; k++) { c.beginPath(); c.moveTo(x, vy + (k / 9) * vh); c.bezierCurveTo(x + w * 0.3, vy + (k / 9) * vh + 6, x + w * 0.7, vy + (k / 9) * vh - 6, x + w, vy + (k / 9) * vh); c.stroke(); }
    const cx = x + w / 2, cy = vy + vh * 0.5, R = w * 0.36;
    c.fillStyle = 'rgba(0,0,0,0.25)'; c.beginPath(); c.arc(cx + R * 0.06, cy + R * 0.08, R, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#F4F2EC'; c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.fill();
    c.fillStyle = '#E6E2D8'; c.beginPath(); c.arc(cx, cy, R * 0.78, 0, Math.PI * 2); c.fill();
    const rng = u.rnd(4);
    for (let k = 0; k < 26; k++) { const a = rng() * Math.PI * 2, r = Math.sqrt(rng()) * R * 0.62; c.fillStyle = ['#6BAA3A', '#3F8A2E', '#E84B3A', '#F2C14E', '#8FC45A'][k % 5]; c.beginPath(); c.ellipse(cx + Math.cos(a) * r, cy + Math.sin(a) * r, R * 0.1, R * 0.06, a, 0, Math.PI * 2); c.fill(); }
    c.fillStyle = '#C9CCD2'; c.fillRect(cx + R * 1.12, cy - R * 0.9, R * 0.05, R * 1.7);
    c.restore();
    T(c, 'תמונה', x + w / 2, vy + vh + h * 0.04, w * 0.045, '#FFD60A', 600);
    c.strokeStyle = '#fff'; c.lineWidth = w * 0.012; c.beginPath(); c.arc(x + w / 2, y + h * 0.9, w * 0.09, 0, Math.PI * 2); c.stroke();
    c.fillStyle = '#fff'; c.beginPath(); c.arc(x + w / 2, y + h * 0.9, w * 0.072, 0, Math.PI * 2); c.fill();
    if (flash > 0) { c.fillStyle = `rgba(255,255,255,${flash})`; c.fillRect(x, y, w, h); }
    c.restore();
  };

  /* הסדרה, ובסוף הפרק כרטיס «הפרק הבא» עם ספירה */
  UI.nextEp = (c, x, y, w, h, t = 0, { count = 5 } = {}) => {
    UI.video(c, x, y, w, h, t);
    const cw = w * 0.86, ch = h * 0.16, cx = x + (w - cw) / 2, cy = y + h * 0.72;
    u.rr(c, cx, cy, cw, ch, w * 0.04, 'rgba(40,40,44,0.96)');
    T(c, 'הפרק הבא', cx + cw - w * 0.05, cy + ch * 0.3, w * 0.05, '#fff', 700, 'right');
    T(c, `מתחיל בעוד ${count}`, cx + cw - w * 0.05, cy + ch * 0.62, w * 0.04, 'rgba(255,255,255,0.7)', 500, 'right');
    const r = ch * 0.28, rx = cx + w * 0.14, ry = cy + ch / 2;
    c.lineWidth = Math.max(2, r * 0.18); c.strokeStyle = 'rgba(255,255,255,0.2)'; c.beginPath(); c.arc(rx, ry, r, 0, Math.PI * 2); c.stroke();
    c.strokeStyle = '#fff'; c.beginPath(); c.arc(rx, ry, r, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * (1 - count / 5)); c.stroke();
    T(c, String(count), rx, ry + 0.5, r * 0.9, '#fff', 700, 'center', 'ltr');
  };

  /* כיוון שעון מעורר: שורה פעילה 6:30, ושתיים כבויות */
  UI.setAlarm = (c, x, y, w, h, t = 0) => {
    clip(c, x, y, w, h);
    c.fillStyle = '#000'; c.fillRect(x, y, w, h);
    T(c, 'שעון מעורר', x + w * 0.92, y + h * 0.13, w * 0.075, '#fff', 700, 'right');
    const on = u.clamp(t * 2.5);
    [['6:30', 'עבודה', on], ['6:39', 'ליתר ביטחון', on], ['9:00', 'סוף שבוע', 0]].forEach(([tm, lb, a], i) => {
      const ry = y + h * (0.22 + i * 0.13);
      c.fillStyle = 'rgba(255,255,255,0.12)'; c.fillRect(x + w * 0.06, ry + h * 0.11, w * 0.88, 1);
      T(c, tm, x + w * 0.92, ry + h * 0.045, w * 0.13, a > 0.5 ? '#fff' : 'rgba(255,255,255,0.4)', 300, 'right', 'ltr');
      T(c, lb, x + w * 0.92, ry + h * 0.095, w * 0.038, 'rgba(255,255,255,0.55)', 500, 'right');
      const tw = w * 0.16, th = tw * 0.6, tx = x + w * 0.08, ty = ry + h * 0.045 - th / 2;
      u.rr(c, tx, ty, tw, th, th / 2, a > 0 ? `rgba(48,209,88,${0.35 + 0.65 * a})` : 'rgba(120,120,128,0.32)');
      c.fillStyle = '#fff'; c.beginPath(); c.arc(tx + th / 2 + (tw - th) * a, ty + th / 2, th * 0.42, 0, Math.PI * 2); c.fill();
    });
    c.restore();
  };

  /* מסך כבוי, עם השתקפות חלשה */
  UI.off = (c, x, y, w, h) => {
    c.fillStyle = '#030304'; c.fillRect(x, y, w, h);
    const g = c.createLinearGradient(x, y, x + w, y + h); g.addColorStop(0, 'rgba(255,255,255,0.05)'); g.addColorStop(0.4, 'rgba(255,255,255,0)'); c.fillStyle = g; c.fillRect(x, y, w, h);
  };
})();

/* ── js/scenes-a.js ── */
/* ההדגמות, חלק א: סוללה · זום · מצלמה ראשית · מהירות. על צילומים רשמיים של Apple.
   draw(c, W, H, t, side, I): I = { o, tg, acc, x, cmp }. side = 'old' | 'new'. */
(() => {
  const L = window.TYSH, u = L.u, IMG = () => L.A.images || {};
  L.scenes = L.scenes || {};
  const S = L.scenes;
  const val = (side, I) => (side === 'new' ? I.tg : I.o);
  const COMPARE = '<a href="https://www.apple.com/iphone/compare/" target="_blank" rel="noopener">דף ההשוואה של Apple</a>';
  const credit = key => (IMG()[key] ? IMG()[key].credit : '');
  const img = key => IMG()[key] && L.img(IMG()[key].file);

  /* ───────────────────────── 01 סוללה ───────────────────────── */
  const batEnd = I => { const lo = Math.min(I.o.bat, I.tg.bat), hi = Math.max(I.o.bat, I.tg.bat); return lo === hi ? hi : Math.min(hi, lo + 3); };
  const hourAt = (t, I) => Math.min(batEnd(I), (t / 6.6) * batEnd(I));
  S.bat = {
    dur: 8,
    what: I => `שני הטלפונים מנגנים וידאו ברצף מ-100%, עד שהסוללה נגמרת. בהדגמה כל שנייה היא כ-${(batEnd(I) / 6.6).toFixed(1)} שעות צפייה.`,
    source: I => `${COMPARE}, שורת Video playback. ${[I.o, I.tg].some(v => /Pro/.test(v.name) && (v.ser === 17 || v.year === 2026)) ? 'ל-17 Pro ו-18 Pro: המספר של הדגם עם חריץ SIM, כמו שנמכר בישראל (apple.com/il ו-apple.com/uk). ' : ''}התמונה: ${credit('bat-video') || 'Apple'}.`,
    clock: (t, I) => `${Math.floor(hourAt(t, I))} שעות צפייה`,
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H), hour = hourAt(t, I);
      const level = u.clamp(1 - hour / v.bat), dead = hour >= v.bat, other = side === 'new' ? I.o.bat : I.tg.bat;
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      if (dead) {
        const bw = W * 0.34, bh = bw * 0.46, bx = (W - bw) / 2, by = H * 0.44 - bh / 2;
        c.strokeStyle = 'rgba(255,255,255,0.75)'; c.lineWidth = Math.max(1.5, m * 0.012); c.beginPath(); c.roundRect(bx, by, bw, bh, bh * 0.22); c.stroke();
        c.fillStyle = 'rgba(255,255,255,0.75)'; c.fillRect(bx + bw + m * 0.012, by + bh * 0.32, m * 0.02, bh * 0.36);
        u.rr(c, bx + m * 0.02, by + m * 0.02, bw * 0.08, bh - m * 0.04, 2, '#FF453A');
        u.text(c, `כבה אחרי ${v.bat} שעות`, W / 2, H * 0.6, m * 0.058, 'rgba(255,255,255,0.62)', 500);
        return;
      }
      u.status(c, W, H, { time: `${Math.floor(((8 + hour) % 24))}:${String(Math.floor((hour % 1) * 60)).padStart(2, '0')}`, level });
      const still = img('bat-video'), my = H * 0.13;
      let mh = W * 0.77;
      if (still) {
        mh = W / (still.naturalWidth / still.naturalHeight);
        const zz = 1.02 + 0.03 * Math.sin(t * 0.45);
        c.save(); c.beginPath(); c.rect(0, my, W, mh); c.clip();
        c.drawImage(still, W / 2 - (W * zz) / 2, my + mh / 2 - (mh * zz) / 2, W * zz, mh * zz); c.restore();
      } else { const g = c.createLinearGradient(0, my, W, my + mh); g.addColorStop(0, u.acc(I, 0.5)); g.addColorStop(1, '#111'); c.fillStyle = g; c.fillRect(0, my, W, mh); }
      // שורת הנגן
      const py = my + mh + m * 0.07, x0 = W * 0.08, x1 = W * 0.92, frac = (hour % 2) / 2, lw = Math.max(2, m * 0.008);
      c.fillStyle = 'rgba(255,255,255,0.22)'; c.fillRect(x0, py, x1 - x0, lw);
      c.fillStyle = '#fff'; c.fillRect(x1 - (x1 - x0) * frac, py, (x1 - x0) * frac, lw);
      u.text(c, `סרט ${Math.floor(hour / 2) + 1}`, x1, py + m * 0.055, m * 0.042, 'rgba(255,255,255,0.7)', 500, 'right');
      const cy = py + (H - py) * 0.46;
      u.text(c, `${Math.round(level * 100)}%`, W / 2, cy, m * 0.19, level < 0.2 ? '#FF6961' : '#FFFFFF', 500, 'center', 'ltr');
      u.text(c, 'סוללה', W / 2, cy + m * 0.13, m * 0.05, 'rgba(255,255,255,0.6)', 400);
      if (hour >= other && v.bat > other) u.pill(c, `עוד ${Math.round(v.bat - hour)} שעות`, W / 2, H * 0.92, m * 0.05, '#000', u.acc(I, 1));
    },
  };

  /* ───────────────────────── 02 זום ───────────────────────── */
  const lensesOf = v => {
    const out = [];
    if (!(v.slug === 'iphone-16e' || v.slug === 'iphone-air')) out.push(0.5);
    out.push(1);
    if (v.mp === 48 || v.z >= 2) out.push(2);
    if (v.z === 3) out.push(3);
    if (v.z === 5) out.push(5);
    if (v.z === 8) out.push(4, 8);
    return [...new Set(out)].sort((a, b) => a - b);
  };
  const zoomAt = (t, v) => {
    const stops = lensesOf(v).filter(z => z >= 1);
    let z = 1, tt = t - 0.9;
    for (let i = 1; i < stops.length && tt > 0; i++) {
      const e = u.ease(u.clamp(tt / 0.95));
      z = stops[i - 1] * Math.pow(stops[i] / stops[i - 1], e);
      tt -= 1.35;
    }
    return z;
  };
  S.zoom = {
    dur: 7,
    what: I => `אותו צילום של Apple, מאותה נקודה. כל טלפון עובר בין העדשות שלו עד הזום האופטי המרבי. ${I.o.z === 1 ? `ל-${I.o.name} אין עדשת זום. ` : ''}הצילום הרחב והצילום בפי 8 אמיתיים. הביניים חתוכים מהרחב, ולכן רכים יותר מעדשה אמיתית.`,
    source: () => `${COMPARE}, שורת Optical zoom. הצילומים: ${credit('zoom-wide') || 'Apple'}. המיקום של פי 8 בתוך הרחב נמדד בהתאמת פיקסלים.`,
    clock: (t, I) => `פי ${zoomAt(t, I.tg).toFixed(1)}`,
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H), z = zoomAt(t, v);
      const top = H * 0.09, band = H * 0.2, vfY = top, vfH = H - top - band;
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      const A = IMG()['zoom-wide'], wide = img('zoom-wide'), tele = img('zoom-8x');
      c.save(); c.beginPath(); c.rect(0, vfY, W, vfH); c.clip();
      if (wide) {
        const iw = wide.naturalWidth, ih = wide.naturalHeight, base = A.base || 0.5, [fx, fy] = A.focus || [0.5, 0.5];
        const s8 = 8 / base, Rw = iw / s8, Rh = ih / s8, Rx = fx * iw - Rw / 2, Ry = fy * ih - Rh / 2;
        const sxs = Rx + Rw * 0.62, sys = Ry + Rh * 0.44;          // הפנים בתוך צילום פי 8
        const f = z / base;
        let ch = ih / f, cw = (ch * W) / vfH;
        if (cw > iw) { cw = iw; ch = (cw * vfH) / W; }
        const sx = u.clamp(u.lerp(iw / 2, sxs, u.clamp(f / 4)) - cw / 2, 0, iw - cw), sy = u.clamp(u.lerp(ih / 2, sys, u.clamp(f / 4)) - ch / 2, 0, ih - ch);
        c.drawImage(wide, sx, sy, cw, ch, 0, vfY, W, vfH);
        if (tele && z > 5.2) {
          c.globalAlpha = u.clamp((z - 5.2) / 2.6);
          c.drawImage(tele, ((Rx - sx) / cw) * W, vfY + ((Ry - sy) / ch) * vfH, (Rw / cw) * W, (Rh / ch) * vfH);
          c.globalAlpha = 1;
        }
      }
      c.restore();
      // ממשק המצלמה של iOS
      const lens = lensesOf(v), pr = m * 0.052, gap = pr * 2.35, y = vfY + vfH - pr * 1.8;
      const cur = lens.reduce((a, b) => (Math.abs(Math.log(b / z)) < Math.abs(Math.log(a / z)) ? b : a), lens[0]);
      u.rr(c, W / 2 - (lens.length * gap) / 2 - pr * 0.3, y - pr * 1.22, lens.length * gap + pr * 0.6, pr * 2.44, pr * 1.22, 'rgba(0,0,0,0.35)');
      lens.forEach((lv, i) => {
        const x = W / 2 + (i - (lens.length - 1) / 2) * gap, active = lv === cur;
        c.fillStyle = active ? 'rgba(18,18,18,0.85)' : 'rgba(40,40,40,0.5)'; c.beginPath(); c.arc(x, y, active ? pr * 1.06 : pr * 0.76, 0, Math.PI * 2); c.fill();
        const label = active ? `${z < 1.05 ? 1 : +z.toFixed(1)}×` : (lv === 0.5 ? '.5' : String(lv));
        u.text(c, label, x, y + 0.5, active ? pr * 0.7 : pr * 0.6, active ? '#FFD60A' : '#FFFFFF', 600, 'center', 'ltr');
      });
      u.text(c, 'תמונה', W / 2, H - band + band * 0.16, m * 0.042, '#FFD60A', 600);
      const sy2 = H - band * 0.45;
      c.strokeStyle = '#fff'; c.lineWidth = m * 0.011; c.beginPath(); c.arc(W / 2, sy2, m * 0.08, 0, Math.PI * 2); c.stroke();
      c.fillStyle = '#fff'; c.beginPath(); c.arc(W / 2, sy2, m * 0.064, 0, Math.PI * 2); c.fill();
    },
  };

  /* ───────────────────────── 03 מצלמה ראשית ───────────────────────── */
  const OFF = document.createElement('canvas');
  const APS = [['ap-148', 'ƒ/1.48', 'מקסימום אור', 0.575], ['ap-18', 'ƒ/1.8', 'ברירת מחדל', 0.52], ['ap-28', 'ƒ/2.8', 'יותר בפוקוס', 0.55], ['ap-4', 'ƒ/4.0', 'מקסימום עומק', 0.69]];
  const apAt = t => Math.min(3, Math.max(0, Math.floor((t - 0.5) / 1.55)));
  const drawCrop = (c, im, fx, fy, zoom, x, y, w, h) => {
    const iw = im.naturalWidth, ih = im.naturalHeight;
    let ch = ih / zoom, cw = (ch * w) / h;
    if (cw > iw / zoom) { cw = iw / zoom; ch = (cw * h) / w; }
    const sx = u.clamp(fx * iw - cw / 2, 0, iw - cw), sy = u.clamp(fy * ih - ch / 2, 0, ih - ch);
    c.drawImage(im, sx, sy, cw, ch, x, y, w, h);
    return { sx, sy, cw, ch };
  };
  S.cam = {
    dur: 7,
    what: I => I.tg.mp > I.o.mp
      ? `אותו צילום של Apple, ומגדילים פי 3 לאזור הקרחון. ב-${I.o.mp}MP יש חצי מהפיקסלים לאורך ולרוחב, ולכן הפרטים מתפרקים מוקדם.`
      : I.tg.va ? 'ארבעה צילומים של Apple, כל אחד בצמצם אחר שהטלפון בוחר: מקסימום אור, ברירת מחדל, יותר בפוקוס, מקסימום עומק. אצלכם הצמצם קבוע.' : 'אותה מצלמה ראשית.',
    source: I => `${COMPARE}, שורות Rear Cameras ו-Variable Aperture. הצילומים: ${I.tg.mp > I.o.mp ? credit('cam-photo') : 'Apple, דף iPhone 18 Pro'}.`,
    clock: (t, I) => (I.tg.mp > I.o.mp ? `הגדלה פי ${(1 + 2.2 * u.ease(u.clamp((t - 0.9) / 3.4))).toFixed(1)}` : I.tg.va ? APS[apAt(t)][1] : ''),
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H);
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      u.status(c, W, H, { level: 0.8 });
      const vy = H * 0.12, vh = H * 0.7;
      if (I.tg.mp > I.o.mp) {
        const im = img('cam-photo');
        if (!im) return;
        /* יחס אמיתי בין החיישנים: ל-12MP חצי מהפיקסלים של 48MP לאורך ולרוחב. בהגדלה המלאה
           ל-48MP פיקסל אחד לכל פיקסל מסך, ול-12MP פיקסל אחד לכל שניים. כך ההבדל נראה בכל מסך. */
        const z = 1 + 2.2 * u.ease(u.clamp((t - 0.9) / 3.4)), lin = Math.sqrt(v.mp / 48), pr = u.clamp((z - 1) / 2.2);
        const dpr = Math.min(2, window.devicePixelRatio || 1);
        const ih = im.naturalHeight, ch = ih / z, cw = (ch * W) / vh;
        const screenPx = W * dpr * (lin < 1 ? 1 - 0.5 * pr : 1);
        const ow = Math.max(4, Math.round(Math.min(cw * lin, screenPx))), oh = Math.max(4, Math.round((ow * vh) / W));
        OFF.width = ow; OFF.height = oh;
        const o = OFF.getContext('2d'); o.imageSmoothingQuality = 'high';
        drawCrop(o, im, 0.47, 0.5, z, 0, 0, ow, oh);
        c.imageSmoothingEnabled = (W * dpr) / ow < 1.6;
        c.drawImage(OFF, 0, vy, W, vh); c.imageSmoothingEnabled = true;
        /* זכוכית מגדלת על אזור קטן: שני הטלפונים מוגדלים באותה מידה, ורואים כמה פיקסלים יש לכל אחד */
        const lk = u.easeOut(u.clamp((t - 4.6) / 0.6));
        if (lk > 0) {
          const R = m * 0.27, lx = W / 2, ly = vy + vh * 0.5, src = ow * 0.2;
          c.save(); c.globalAlpha = lk;
          c.beginPath(); c.arc(lx, ly, R, 0, Math.PI * 2); c.clip();
          c.imageSmoothingEnabled = false;
          c.drawImage(OFF, ow * 0.5 - src / 2, oh * 0.42 - src / 2, src, src, lx - R, ly - R, R * 2, R * 2);
          c.restore(); c.imageSmoothingEnabled = true;
          c.globalAlpha = lk; c.strokeStyle = '#fff'; c.lineWidth = Math.max(2, m * 0.012); c.beginPath(); c.arc(lx, ly, R, 0, Math.PI * 2); c.stroke(); c.globalAlpha = 1;
        }
        u.pill(c, `${v.mp}MP`, W / 2, H * 0.9, m * 0.056, '#000', side === 'new' ? u.acc(I, 1) : '#EBEBF0', 'ltr');
        return;
      }
      if (!I.tg.va) { const im = img('ap-18'); if (im) drawCrop(c, im, 0.52, 0.5, 1, 0, vy, W, vh); return; }
      if (side === 'old') {
        const im = img('ap-18'); if (im) drawCrop(c, im, 0.52, 0.5, 1, 0, vy, W, vh);
        u.pill(c, 'צמצם קבוע', W / 2, H * 0.9, m * 0.052, '#000', '#EBEBF0');
        return;
      }
      const i = apAt(t), prev = Math.max(0, i - 1), tIn = u.clamp((t - 0.5 - i * 1.55) / 0.35);
      const a = img(APS[prev][0]), b = img(APS[i][0]);
      if (a) drawCrop(c, a, APS[prev][3], 0.5, 1, 0, vy, W, vh);
      if (b) { c.globalAlpha = i === prev ? 1 : tIn; drawCrop(c, b, APS[i][3], 0.5, 1, 0, vy, W, vh); c.globalAlpha = 1; }
      // חוגת הצמצם
      const y = H * 0.88, gap = W * 0.2;
      u.text(c, APS[i][2], W / 2, H * 0.845 - m * 0.02, m * 0.045, '#FFD60A', 600);
      APS.forEach((row, k) => {
        const x = W / 2 + (1.5 - k) * gap * -1, on = k === i;
        u.text(c, row[1].replace('ƒ/', ''), x, y + m * 0.045, on ? m * 0.052 : m * 0.042, on ? '#FFD60A' : 'rgba(255,255,255,0.65)', on ? 700 : 500, 'center', 'ltr');
      });
      u.text(c, 'ƒ', W * 0.08, y + m * 0.045, m * 0.05, 'rgba(255,255,255,0.8)', 600, 'center', 'ltr');
    },
  };

  /* ───────────────────────── 04 מהירות ───────────────────────── */
  const CHIPS = [[15, 'A15', 2021], [16, 'A16', 2022], [17, 'A17 Pro', 2023], [18, 'A18 Pro', 2024], [19, 'A19 Pro', 2025], [20, 'A20 Pro', 2026]];
  const silverChip = (c, cx, cy, size, name, glowCol) => {
    if (glowCol) { c.save(); c.shadowColor = glowCol; c.shadowBlur = size * 0.35; u.rr(c, cx - size / 2, cy - size / 2, size, size, size * 0.04, '#DADADF'); c.restore(); }
    const g = c.createLinearGradient(cx - size / 2, cy - size / 2, cx + size / 2, cy + size / 2);
    g.addColorStop(0, '#F2F2F4'); g.addColorStop(0.55, '#D5D6DA'); g.addColorStop(1, '#B9BABF');
    u.rr(c, cx - size / 2, cy - size / 2, size, size, size * 0.04, g);
    u.text(c, name, cx, cy, size * (name.length > 4 ? 0.17 : 0.24), '#1C1C1E', 700, 'center', 'ltr');
  };
  S.chip = {
    dur: 6.5,
    what: I => (I.x.claim
      ? `השבב של כל טלפון, והנתון של Apple עצמה מול ${I.o.name}: מעבד עד ${I.x.claim.cpu}% מהיר יותר, וגרפיקה ${I.x.claim.gpu.endsWith('x') ? 'עד פי ' + I.x.claim.gpu.slice(0, -1) : 'עד ' + I.x.claim.gpu + ' מהירה יותר'}.`
      : `השבב של כל טלפון, ומספר הדורות ביניהם. Apple לא פרסמה השוואה ישירה מול ${I.o.name}, ולכן אין כאן אחוזים.`),
    source: I => `${COMPARE}, שורת Chip.${I.x.claim ? ` האחוזים: טבלת «Compare with» בדף ${I.tg.duo ? 'iPhone Duo' : 'iPhone 18 Pro'} של Apple.` : ''} התמונה: Apple Newsroom.`,
    clock: (t, I) => { const g = Math.floor(u.lerp(I.o.gen, I.tg.gen, u.ease(u.clamp((t - 0.6) / 3))) + 1e-6); const row = CHIPS.find(r => r[0] === g); return row ? `${row[2]}` : ''; },
    draw(c, W, H, t, side, I) {
      const m = Math.min(W, H), g0 = I.o.gen, g1 = val(side, I).gen;
      const cur = side === 'old' ? g0 : u.lerp(g0, g1, u.ease(u.clamp((t - 0.6) / 3))), gi = Math.floor(cur + 1e-6);
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      const done = side === 'new' && gi === g1, cx = W / 2, cy = H * 0.36, size = m * 0.5;
      const apple = img('chip-a20');
      if (done && apple) {
        const k = u.easeOut(u.clamp((t - 3.6) / 0.6));
        c.globalAlpha = k; c.drawImage(apple, cx - size * 0.72, cy - size * 0.72, size * 1.44, size * 1.44); c.globalAlpha = 1;
        if (k < 1) { c.globalAlpha = 1 - k; silverChip(c, cx, cy, size * 0.62, 'A20 Pro'); c.globalAlpha = 1; }
      } else {
        const row = CHIPS.find(r => r[0] === gi);
        silverChip(c, cx, cy, size * 0.62, side === 'old' ? I.o.chip.replace(' Bionic', '') : (row ? row[1] : `A${gi}`), side === 'new' ? u.acc(I, 0.5) : null);
      }
      const list = CHIPS.filter(r => r[0] >= g0), y0 = H * 0.66, gap = Math.min((W * 0.74) / Math.max(1, list.length - 1), m * 0.16);
      const xOf = i => cx - ((list.length - 1) / 2 - i) * gap;
      c.strokeStyle = 'rgba(255,255,255,0.14)'; c.lineWidth = 2; c.beginPath(); c.moveTo(xOf(0), y0); c.lineTo(xOf(list.length - 1), y0); c.stroke();
      list.forEach((r, i) => {
        const lit = side === 'old' ? i === 0 : r[0] <= gi;
        c.fillStyle = lit ? u.sideCol(side, I, 1) : 'rgba(255,255,255,0.18)';
        c.beginPath(); c.arc(xOf(list.length - 1 - i), y0, m * (r[0] === gi || (side === 'old' && i === 0) ? 0.022 : 0.014), 0, Math.PI * 2); c.fill();
      });
      if (side === 'old') { u.text(c, `${I.o.year}`, cx, H * 0.75, m * 0.055, 'rgba(255,255,255,0.6)', 500); return; }
      if (!done) { u.text(c, `${(CHIPS.find(r => r[0] === gi) || [0, '', ''])[2]}`, cx, H * 0.75, m * 0.055, 'rgba(255,255,255,0.6)', 500); return; }
      const cl = I.x.claim, k2 = u.easeOut(u.clamp((t - 4) / 0.6));
      c.globalAlpha = k2;
      if (cl) {
        u.text(c, `מעבד עד ${cl.cpu}% מהיר יותר`, cx, H * 0.77, m * 0.06, '#fff', 600);
        u.text(c, cl.gpu.endsWith('x') ? `גרפיקה עד פי ${cl.gpu.slice(0, -1)}` : `גרפיקה עד ${cl.gpu} מהירה יותר`, cx, H * 0.84, m * 0.052, u.acc(I, 1), 500);
      } else u.text(c, g1 - g0 === 1 ? 'דור אחד קדימה' : `${g1 - g0} דורות קדימה`, cx, H * 0.8, m * 0.06, u.acc(I, 1), 600);
      c.globalAlpha = 1;
    },
  };
})();

/* ── js/scenes-b.js ── */
/* ההדגמות, חלק ב: חלקות מסך · וידאו · סלפי · גודל מסך · טעינה. */
(() => {
  const L = window.TYSH, u = L.u, IMG = () => L.A.images || {};
  const S = L.scenes;
  const val = (side, I) => (side === 'new' ? I.tg : I.o);
  const COMPARE = '<a href="https://www.apple.com/iphone/compare/" target="_blank" rel="noopener">דף ההשוואה של Apple</a>';

  /* ───────────────────────── 05 חלקות מסך ───────────────────────── */
  const SLOW_HZ = 8;
  /* רשת «תמונות» מצילומי Apple שכבר בדף. [מפתח, מיקוד אופקי] */
  const TILES = [['cam-photo', 0.5], ['ap-148', 0.57], ['selfie-group', 0.5], ['zoom-8x', 0.6], ['ap-28', 0.55], ['bat-video', 0.5], ['ap-4', 0.69], ['zoom-wide', 0.5], ['ap-18', 0.52]];
  S.hz = {
    dur: 7.5,
    slow: `הילוך איטי פי ${SLOW_HZ}. במהירות אמיתית ההבדל מורגש ביד, אבל לא נראה בווידאו על מסך רגיל.`,
    what: I => `אותה גלילה בדיוק, בהילוך איטי. המסך מתעדכן ${I.o.hz} פעמים בשנייה מול ${I.tg.hz}. כל קפיצה היא ציור אחד של המסך.`,
    source: () => `${COMPARE}, שורת ProMotion (עד 120Hz).`,
    clock: t => `${Math.round(Math.min(1, t / 6.5) * 100)} מתוך 100 מ"ש אמיתיות`,
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H);
      const per = (1 / v.hz) * SLOW_HZ, tq = Math.floor(Math.min(t, 6.5) / per) * per;
      const off = tq * H * 0.34;
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      const cols = 3, gap = Math.max(1.5, W * 0.008), tw = (W - gap * (cols - 1)) / cols, top = H * 0.16;
      const r = u.rnd(4);
      const hues = Array.from({ length: 90 }, () => [r() * 360, 30 + r() * 40, 30 + r() * 35]);
      c.save(); c.beginPath(); c.rect(0, top, W, H - top); c.clip();
      const row0 = Math.floor(off / (tw + gap));
      for (let row = row0; row < row0 + Math.ceil((H - top) / (tw + gap)) + 1; row++) {
        const y = top + row * (tw + gap) - off;
        for (let col = 0; col < cols; col++) {
          const idx = (((row * 4 + col * 7) % TILES.length) + TILES.length) % TILES.length, x = W - (col + 1) * tw - col * gap;
          const tile = IMG()[TILES[idx][0]], im = tile && L.img(tile.file);
          if (im) { c.save(); c.beginPath(); c.rect(x, y, tw, tw); c.clip(); u.cover(c, im, x, y, tw, tw, TILES[idx][1], 0.5); c.restore(); }
          else { const hsl = hues[idx % hues.length]; c.fillStyle = `hsl(${hsl[0]},${hsl[1]}%,${hsl[2]}%)`; c.fillRect(x, y, tw, tw); }
        }
      }
      c.restore();
      const hdr = c.createLinearGradient(0, 0, 0, top * 1.2); hdr.addColorStop(0, '#000'); hdr.addColorStop(0.75, 'rgba(0,0,0,0.88)'); hdr.addColorStop(1, 'rgba(0,0,0,0)');
      c.fillStyle = hdr; c.fillRect(0, 0, W, top * 1.2);
      u.status(c, W, H, { level: 0.76 });
      u.text(c, 'תמונות', W * 0.92, top * 0.62, m * 0.085, '#fff', 700, 'right');
      u.pill(c, `${v.hz}Hz`, W / 2, H * 0.92, m * 0.056, '#000', side === 'new' ? u.acc(I, 1) : '#EBEBF0', 'ltr');
    },
  };

  /* ───────────────────────── 06 צילום וידאו ───────────────────────── */
  const SLOW_V = 12;
  S.vid = {
    dur: 7,
    slow: `הילוך איטי פי ${SLOW_V}. כל נקודה היא פריים שנשמר בסרטון.`,
    what: I => I.tg.fps > I.o.fps
      ? `כדור נזרק, ושני הטלפונים מצלמים חצי שנייה. ב-${I.o.fps} פריימים בשנייה נשמרים ${I.o.fps / 2} רגעים, וב-${I.tg.fps} נשמרים ${I.tg.fps / 2}.`
      : 'אותו קצב צילום בשני הטלפונים: 4K ב-120 פריימים בשנייה.',
    source: () => `${COMPARE}, שורת Dolby Vision (4K עד 60 או עד 120 פריימים).`,
    clock: (t, I) => `00:00:${String(Math.min(50, Math.floor((Math.min(t, 6) / 6) * 50))).padStart(2, '0')}`,
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H), rt = Math.min(0.5, (t / 6) * 0.5), n = Math.floor(rt * v.fps);
      c.fillStyle = '#050507'; c.fillRect(0, 0, W, H);
      const sky = c.createLinearGradient(0, H * 0.1, 0, H * 0.8); sky.addColorStop(0, '#0E1420'); sky.addColorStop(1, '#1B1712'); c.fillStyle = sky; c.fillRect(0, H * 0.1, W, H * 0.72);
      const floorY = H * 0.74;
      c.fillStyle = '#231D16'; c.fillRect(0, floorY, W, H * 0.08);
      const pos = x => [W * (0.86 - 0.72 * x), floorY - m * 0.04 - H * 0.5 * 4 * x * (1 - x)];
      for (let k = 0; k <= n; k++) { const [x, y] = pos(k / v.fps / 0.5); c.fillStyle = u.sideCol(side, I, 0.5); c.beginPath(); c.arc(x, y, m * 0.012, 0, Math.PI * 2); c.fill(); }
      const [bx, by] = pos(n / v.fps / 0.5);
      const bg = c.createRadialGradient(bx - m * 0.012, by - m * 0.014, m * 0.004, bx, by, m * 0.042); bg.addColorStop(0, '#fff'); bg.addColorStop(1, u.sideCol(side, I, 1));
      c.fillStyle = bg; c.beginPath(); c.arc(bx, by, m * 0.04, 0, Math.PI * 2); c.fill();
      // ממשק וידאו: שורה עליונה עם REC וסטריפ פריימים למטה
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H * 0.1); c.fillRect(0, H * 0.82, W, H * 0.18);
      u.pill(c, `4K · ${v.fps}`, W * 0.22, H * 0.055, m * 0.045, '#fff', 'rgba(255,255,255,0.14)', 'ltr');
      u.rr(c, W * 0.62, H * 0.03, W * 0.3, H * 0.05, H * 0.025, '#FF3B30');
      u.text(c, `00:00:${String(Math.floor(rt * 100)).padStart(2, '0')}`, W * 0.77, H * 0.056, m * 0.042, '#fff', 600, 'center', 'ltr');
      const sx0 = W * 0.08, sx1 = W * 0.92, sy = H * 0.9, total = v.fps / 2;
      for (let k = 0; k < total; k++) {
        const x = sx1 - (sx1 - sx0) * (k / (total - 1));
        c.fillStyle = k <= n ? u.sideCol(side, I, 0.95) : 'rgba(255,255,255,0.16)';
        c.fillRect(x - 0.6, sy - m * 0.03, Math.max(1, (sx1 - sx0) / total * 0.55), m * 0.06);
      }
      u.text(c, `${n + 1} פריימים`, W / 2, H * 0.965, m * 0.04, 'rgba(255,255,255,0.7)', 500);
    },
  };

  /* ───────────────────────── 07 מצלמת סלפי ───────────────────────── */
  S.self = {
    dur: 7.5,
    what: I => (I.tg.cs && !I.o.cs)
      ? `ארבעה חברים בסלפי, והטלפון מוחזק לאורך. ב-${I.o.name} הפריים נשאר לאורך והקצוות נחתכים, צריך לסובב את הטלפון. ב-${I.tg.short} Center Stage פותח את התמונה לרוחב לבד.`
      : 'שני הטלפונים מרחיבים את הפריים לבד כשחברים נכנסים.',
    source: I => `${COMPARE}, שורת Front Camera (${I.tg.sm}MP Center Stage).${IMG()['selfie-group'] ? ' הצילום: Apple.' : ''}`,
    clock: t => (t < 1.1 ? 'שניים בפריים' : t < 2.6 ? 'עוד שניים נכנסים' : t < 4.3 ? 'הפריים נפתח' : 'צילום'),
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H), smart = v.cs;
      const enter = u.ease(u.clamp((t - 1.1) / 1.4)), open = smart ? u.ease(u.clamp((t - 2.9) / 1.2)) : 0;
      const flash = u.clamp(1 - Math.abs(t - 5.4) * 5);
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      // תצוגה מקדימה: פריים לאורך, ובפתיחה הוא הופך למלבן לרוחב בתוך המסך
      /* תצוגה לאורך (3:4). ב-Center Stage היא נפתחת ל-4:3 לרוחב, בזמן שהטלפון עדיין מוחזק לאורך */
      const pvW = W, pvHtall = Math.min(H * 0.74, W * 4 / 3), pvHwide = W * 0.75;
      const pvH = u.lerp(pvHtall, pvHwide, open), pvY = H * 0.47 - pvH / 2;
      c.save(); c.beginPath(); c.roundRect(0, pvY, pvW, pvH, open * m * 0.03); c.clip();
      const photo = IMG()['selfie-group'], img = photo && L.img(photo.file);
      const worldW = u.lerp(520, 1080, open), s = pvW / worldW;
      if (img) {
        const iw = img.naturalWidth, ih = img.naturalHeight, aspect = pvW / pvH;
        let ch = ih * u.lerp(0.62, 1, enter), cw = ch * aspect;
        if (cw > iw) { cw = iw; ch = cw / aspect; }
        const sx = u.clamp(iw * 0.52 - cw / 2, 0, iw - cw), sy = u.clamp(ih * 0.48 - ch / 2, 0, ih - ch);
        c.drawImage(img, sx, sy, cw, ch, 0, pvY, pvW, pvH);
      }
      else {
        c.translate(pvW / 2, pvY + pvH / 2); c.scale(s, s); c.translate(-500, -760);
        const g = c.createLinearGradient(0, 300, 0, 1300); g.addColorStop(0, '#3A3548'); g.addColorStop(1, '#16141C'); c.fillStyle = g; c.fillRect(-300, -300, 1600, 2200);
        c.fillStyle = 'rgba(255,220,160,0.12)'; c.fillRect(660, 360, 220, 280);
        const person = (x, y, sc, tone) => {
          c.fillStyle = tone; c.beginPath(); c.arc(x, y, 70 * sc, 0, Math.PI * 2); c.fill();
          c.beginPath(); c.ellipse(x, y + 240 * sc, 160 * sc, 140 * sc, 0, Math.PI, 0); c.fill();
        };
        person(u.lerp(-260, 175, enter), 745, 0.84, '#C9A48A');
        person(u.lerp(1260, 825, enter), 745, 0.84, '#8E6C58');
        person(500, 700, 1, '#D8B79E');
      }
      c.restore();
      c.fillStyle = `rgba(255,255,255,${flash * 0.8})`; c.fillRect(0, 0, W, H);
      u.status(c, W, H, { level: 0.7 });
      if (!smart && enter > 0.8 && t > 2.9) u.pill(c, 'צריך לסובב את הטלפון', W / 2, pvY + pvH * 0.12, m * 0.045, '#000', 'rgba(255,214,10,0.95)');
      if (smart && open > 0.15) u.pill(c, 'Center Stage', W / 2, pvY + m * 0.07, m * 0.045, '#000', side === 'new' ? u.acc(I, 1) : '#FFD60A', 'ltr');
      const sy = H * 0.93;
      c.strokeStyle = '#fff'; c.lineWidth = m * 0.01; c.beginPath(); c.arc(W / 2, sy, m * 0.07, 0, Math.PI * 2); c.stroke();
      c.fillStyle = '#fff'; c.beginPath(); c.arc(W / 2, sy, m * 0.056, 0, Math.PI * 2); c.fill();
      u.text(c, `${v.sm}MP`, W * 0.18, sy, m * 0.045, 'rgba(255,255,255,0.75)', 600, 'center', 'ltr');
    },
  };

  /* ───────────────────────── 08 גודל מסך ───────────────────────── */
  /* ה-Duo: מסגרת סגורה ⟵ פתוחה. עם מסגרות רשמיות מחליפים תמונה, בלעדיהן מותחים את הציור */
  const setDuoWidth = (p, I, k, x) => {
    if (!I.tg.duo) return;
    const fig = p.figs.new, B = L.A.bezels || {};
    const open = x >= 0.5;
    I.duoOpen = open;
    const bzO = B['iphone-duo-open-nightsky'], bzC = B['iphone-duo-closed-nightsky'];
    if (fig._box._bz && bzO && bzC) { L.setBezel(fig, open ? bzO : bzC, open ? I.tg.wOpen : I.tg.w, open ? I.tg.hOpen : I.tg.h, k); return; }
    fig._box.dataset.w = u.lerp(I.tg.w, I.tg.wOpen, x).toFixed(1);
    fig._box.dataset.h = u.lerp(I.tg.h, I.tg.hOpen, x).toFixed(1);
    L.layoutDevice(fig, k);
  };
  S.scr = {
    dur: 5.5,
    what: I => I.tg.duo
      ? 'ה-Duo נפתח מול העיניים: 5.4 אינץ\' סגור, 7.6 אינץ\' פתוח. שני המכשירים בקנה מידה אמיתי, לפי המידות של Apple.'
      : 'שני המכשירים בקנה מידה אמיתי, לפי המידות של Apple במ"מ. הקו האלכסוני הוא אלכסון המסך.',
    source: () => `${COMPARE}, שורות Screen Size, Height ו-Width.`,
    clock: (t, I) => (I.tg.duo ? (t < 0.8 ? 'סגור' : t < 1.8 ? 'נפתח' : 'פתוח') : ''),
    onStart(p, I, k) {
      if (!I.tg.duo) return;
      clearTimeout(p._duoTimer);
      setDuoWidth(p, I, k, 0);
      p._duoTimer = setTimeout(() => setDuoWidth(p, I, k, 1), 1100);
    },
    onScrub(p, I, k) { clearTimeout(p._duoTimer); setDuoWidth(p, I, k, p.t > 1.1 ? 1 : 0); },
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H);
      const wp = IMG()['wallpaper'] || IMG()['cam-photo'], img = wp && L.img(wp.file);
      if (img) { u.cover(c, img, 0, 0, W, H, 0.45, 0.5); const sh = c.createLinearGradient(0, 0, 0, H); sh.addColorStop(0, 'rgba(0,0,0,0.35)'); sh.addColorStop(0.5, 'rgba(0,0,0,0.05)'); sh.addColorStop(1, 'rgba(0,0,0,0.3)'); c.fillStyle = sh; c.fillRect(0, 0, W, H); }
      else {
        const g = c.createLinearGradient(0, 0, W * 0.4, H);
        if (side === 'new') { g.addColorStop(0, u.acc(I, 1)); g.addColorStop(0.55, '#3B3F66'); g.addColorStop(1, '#0B0C18'); }
        else { g.addColorStop(0, '#8E93A3'); g.addColorStop(0.55, '#3A3D48'); g.addColorStop(1, '#0E0F14'); }
        c.fillStyle = g; c.fillRect(0, 0, W, H);
        const b = c.createRadialGradient(W * 0.2, H * 0.8, 0, W * 0.2, H * 0.8, m); b.addColorStop(0, 'rgba(255,255,255,0.18)'); b.addColorStop(1, 'rgba(255,255,255,0)'); c.fillStyle = b; c.fillRect(0, 0, W, H);
      }
      u.status(c, W, H, { level: 0.9 });
      u.text(c, '9:41', W / 2, H * 0.2, Math.min(W * 0.26, H * 0.14), 'rgba(255,255,255,0.95)', 500, 'center', 'ltr');
      u.text(c, 'יום שני, 14 בספטמבר', W / 2, H * 0.2 - Math.min(W * 0.26, H * 0.14) * 0.72, m * 0.045, 'rgba(255,255,255,0.85)', 500);
      const draw = u.easeOut(u.clamp((t - 1.9) / 1.2));
      const x0 = W * 0.08, y0 = H * 0.94, x1 = W * 0.92, y1 = H * 0.32;
      c.setLineDash([4, 4]); c.strokeStyle = 'rgba(255,255,255,0.8)'; c.lineWidth = 1.2;
      c.beginPath(); c.moveTo(x0, y0); c.lineTo(u.lerp(x0, x1, draw), u.lerp(y0, y1, draw)); c.stroke(); c.setLineDash([]);
      if (draw > 0.9) {
        const label = side === 'new' && v.duo ? (I.duoOpen === false ? `5.4 אינץ', חיצוני` : `7.6 אינץ', פנימי`) : `${v.s} אינץ'`;
        u.pill(c, label, W / 2, (y0 + y1) / 2, m * 0.062, '#000', side === 'new' ? u.acc(I, 1) : '#EBEBF0', 'rtl');
      }
    },
  };

  /* ───────────────────────── 09 טעינה מהירה ───────────────────────── */
  const chgEnd = I => Math.max(I.o.ch, I.tg.ch) + 3;
  const minAt = (t, I) => Math.min(chgEnd(I), (t / 5.8) * chgEnd(I));
  S.chg = {
    dur: 7,
    what: I => `שני הטלפונים מתחילים מסוללה ריקה ונטענים עד 50%. כל אחד עם המטען שמולו Apple מדדה: ${I.o.chW}W מול ${I.tg.chW}W.`,
    source: I => `${COMPARE}, שורת Fast-charge capable. המטען נמכר בנפרד.`,
    open: I => `הלקוח צריך מטען ${I.tg.chW}W כדי לקבל ${I.tg.ch} דקות. שווה לשקול להציע אותו בחבילה.`,
    clock: (t, I) => { const s = Math.round(minAt(t, I) * 60); return `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`; },
    draw(c, W, H, t, side, I) {
      const v = val(side, I), m = Math.min(W, H), mins = minAt(t, I);
      const lvl = Math.min(0.5, (mins / v.ch) * 0.5), done = mins >= v.ch;
      const g = c.createLinearGradient(0, 0, 0, H); g.addColorStop(0, '#0B0F12'); g.addColorStop(1, '#040506'); c.fillStyle = g; c.fillRect(0, 0, W, H);
      u.status(c, W, H, { level: lvl, charging: true });
      u.text(c, '9:41', W / 2, H * 0.19, Math.min(W * 0.24, H * 0.13), 'rgba(255,255,255,0.92)', 500, 'center', 'ltr');
      const cx = W / 2, cy = H * 0.52, r = m * 0.27;
      c.lineCap = 'round'; c.lineWidth = m * 0.05;
      c.strokeStyle = 'rgba(48,209,88,0.16)'; c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.stroke();
      c.strokeStyle = '#30D158'; c.beginPath(); c.arc(cx, cy, r, -Math.PI / 2, -Math.PI / 2 + lvl * Math.PI * 2); c.stroke(); c.lineCap = 'butt';
      u.text(c, `${Math.round(lvl * 100)}%`, cx, cy, m * 0.13, '#fff', 500, 'center', 'ltr');
      c.fillStyle = '#30D158'; const bs = m * 0.05;
      c.beginPath(); c.moveTo(cx + bs * 0.2, cy - r * 0.62); c.lineTo(cx - bs * 0.45, cy - r * 0.3); c.lineTo(cx - bs * 0.02, cy - r * 0.3); c.lineTo(cx - bs * 0.2, cy - r * 0.02 - bs * 0.1); c.lineTo(cx + bs * 0.45, cy - r * 0.36); c.lineTo(cx + bs * 0.02, cy - r * 0.36); c.closePath(); c.fill();
      const s = Math.round(Math.min(mins, v.ch) * 60);
      u.text(c, `${String(Math.floor(s / 60)).padStart(2, '0')}:${String(s % 60).padStart(2, '0')}`, cx, H * 0.8, m * 0.08, done ? '#30D158' : 'rgba(255,255,255,0.85)', 500, 'center', 'ltr');
      u.pill(c, `מטען ${v.chW}W`, cx, H * 0.9, m * 0.042, '#fff', 'rgba(255,255,255,0.14)');
      if (done) u.text(c, `50% אחרי ${v.ch} דקות`, cx, H * 0.72, m * 0.05, side === 'new' ? u.acc(I, 1) : 'rgba(255,255,255,0.8)', 500);
    },
  };
})();

/* ── js/scenes-zoom.js ── */
/* זום בדף הבית: שלוש דרכים להציג אותו בלי השוואה. 16.09.2026.
   רק על שני הצילומים של Apple: הרחב (עדשת 0.5) ופי 8 של אותה סצנה, והמיקום של פי 8 בתוך הרחב
   שנמדד בהתאמת פיקסלים (images.json: focus, base).

   zoom-1 זכוכית מגדלת · zoom-2 מסגרת על הנוף · zoom-3 מספר ענק. 'zoom' (בלי מספר) הוא הקיים, ב-scenes-a.

   draw(c, W, H, t, side, I) מצייר את מסך הטלפון.
   stage(c, W, H, t, I, scr) מצייר על הבמה מאחורי הטלפון. scr הוא מלבן המסך בקואורדינטות הבמה.
   shift: כמה מרוחב הבמה הטלפון זז ימינה כשהיכולת פעילה. glow: false מכבה את הזוהר שמאחוריו. */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes;
  const IMG = () => L.A.images || {};
  const img = k => IMG()[k] && L.img(IMG()[k].file);
  /* הפנים בתוך צילום פי 8, כמו ב-scenes-a */
  const FACE = [0.62, 0.44];

  const geo = () => {
    const A = IMG()['zoom-wide'], wide = img('zoom-wide');
    if (!A || !wide) return null;
    const iw = wide.naturalWidth, ih = wide.naturalHeight, base = A.base || 0.5, [fx, fy] = A.focus || [0.5, 0.5];
    const Rw = iw / (8 / base), Rh = ih / (8 / base), Rx = fx * iw - Rw / 2, Ry = fy * ih - Rh / 2;
    return { wide, tele: img('zoom-8x'), iw, ih, base, Rx, Ry, Rw, Rh, fcx: Rx + Rw * FACE[0], fcy: Ry + Rh * FACE[1] };
  };

  /* האזור שהמסך רואה בזום z, בקואורדינטות הצילום הרחב. המרכז נודד מאמצע הצילום אל הפנים */
  const viewAt = (g, z, W, H) => {
    const f = Math.max(1, z / g.base);
    let ch = g.ih / f, cw = (ch * W) / H;
    if (cw > g.iw) { cw = g.iw; ch = (cw * H) / W; }
    const k = u.clamp((Math.log(f) / Math.log(8 / g.base)) * 1.6);
    const cx = u.lerp(g.iw / 2, g.fcx, k), cy = u.lerp(g.ih / 2, g.fcy, k);
    return { sx: u.clamp(cx - cw / 2, 0, g.iw - cw), sy: u.clamp(cy - ch / 2, 0, g.ih - ch), cw, ch };
  };

  /* פי 8 עם שוליים שקופים, פעם אחת לכל צילום. באמצע הזום הוא יושב על הרחב בלי קו תפר */
  let fSrc = null, fCv = null;
  const feathered = tele => {
    if (fSrc === tele && fCv) return fCv;
    const w = tele.naturalWidth, h = tele.naturalHeight, cv = document.createElement('canvas');
    cv.width = w; cv.height = h;
    const x = cv.getContext('2d');
    x.drawImage(tele, 0, 0);
    x.globalCompositeOperation = 'destination-in';
    [[w, 0], [0, h]].forEach(([gw, gh]) => {
      const gr = x.createLinearGradient(0, 0, gw, gh);
      gr.addColorStop(0, 'rgba(0,0,0,0)'); gr.addColorStop(0.2, '#000'); gr.addColorStop(0.8, '#000'); gr.addColorStop(1, 'rgba(0,0,0,0)');
      x.fillStyle = gr; x.fillRect(0, 0, w, h);
    });
    fSrc = tele; fCv = cv;
    return cv;
  };

  /* הרחב, ומעליו פי 8 במקומו המדויק. מהרגע שפי 8 רחב כמעט כמו המסך הוא נכנס, ולכן הפנים חדות כמעט כל הדרך.
     קרוב לפי 8 הוא מצויר גם בלי השוליים המרוככים, כדי שהפריים האחרון יהיה הצילום עצמו */
  const drawView = (c, g, v, W, H) => {
    c.drawImage(g.wide, v.sx, v.sy, v.cw, v.ch, 0, 0, W, H);
    if (!g.tele) return;
    const tx = ((g.Rx - v.sx) / v.cw) * W, ty = ((g.Ry - v.sy) / v.ch) * H, tw = (g.Rw / v.cw) * W, th = (g.Rh / v.ch) * H;
    const a = u.clamp((tw / W - 0.55) / 0.6);
    if (a <= 0) return;
    c.globalAlpha = a; c.drawImage(feathered(g.tele), tx, ty, tw, th);
    const b = u.clamp((th / H - 0.8) / 0.2);
    if (b > 0) { c.globalAlpha = b; c.drawImage(g.tele, tx, ty, tw, th); }
    c.globalAlpha = 1;
  };

  /* עדשה: 0.5 · 1 · 2 · 4 · 8, לפי נקודת האמצע הלוגריתמית בין עדשות */
  const lensOf = z => (z < 0.707 ? '0.5' : z < 1.414 ? '1' : z < 2.83 ? '2' : z < 5.66 ? '4' : '8');
  const lensPill = (c, W, H, label, I) => {
    const m = Math.min(W, H), on = label === '8';
    u.pill(c, `${label}×`, W / 2, H * 0.92, m * 0.058, on ? '#000' : '#fff', on ? u.acc(I, 1) : 'rgba(0,0,0,0.55)', 'ltr');
  };
  const blank = (c, W, H) => { c.fillStyle = '#000'; c.fillRect(0, 0, W, H); };

  /* ───────── 1 · זכוכית מגדלת ─────────
     הצילום הרחב, ועדשה עגולה נפתחת מעל האישה. בתוכה פי 8 החד, והיא גדלה עד שהוא ממלא את המסך.
     אין אף פריים רך: בחוץ הרחב האמיתי, בפנים פי 8 האמיתי */
  S['zoom-1'] = {
    dur: 6.5,
    draw(c, W, H, t, side, I) {
      blank(c, W, H);
      const g = geo(); if (!g) return;
      const m = Math.min(W, H);
      /* תנועה איטית ברקע, כדי שהצילום לא ייראה קפוא */
      const v = viewAt(g, g.base * u.lerp(1, 1.15, u.clamp(t / 6.5)), W, H);
      c.drawImage(g.wide, v.sx, v.sy, v.cw, v.ch, 0, 0, W, H);
      const appear = u.easeOut(u.clamp((t - 0.6) / 0.9)), grow = u.ease(u.clamp((t - 2.2) / 2.6));
      if (!g.tele || appear <= 0) { lensPill(c, W, H, '0.5', I); return; }

      const tw = g.tele.naturalWidth, th = g.tele.naturalHeight;
      /* המבט הסופי: פי 8 לאורך, על כל המסך. qx, qy: הפנים בו */
      const fcw = (th * W) / H, fsx = u.clamp(FACE[0] * tw - fcw / 2, 0, tw - fcw);
      const qx = ((FACE[0] * tw - fsx) / fcw) * W, qy = FACE[1] * H;
      const px = ((g.fcx - v.sx) / v.cw) * W, py = ((g.fcy - v.sy) / v.ch) * H;
      const cx = u.lerp(px, qx, grow), cy = u.lerp(py, qy, grow);
      const r = appear * u.lerp(m * 0.21, Math.hypot(W, H), grow);
      /* התוכן מתקרב לגודלו המלא מהר יותר מהעדשה, ולעולם אינו קטן ממה שנדרש כדי לכסות את העיגול בתוך המסך */
      const x0 = -(fsx / fcw) * W, x1 = x0 + (tw / fcw) * W;
      const need = Math.max(Math.min(r, cy) / qy, Math.min(r, H - cy) / (H - qy), Math.min(r, cx) / Math.max(1, qx - x0), Math.min(r, W - cx) / Math.max(1, x1 - qx));
      const sc = u.clamp(Math.max(u.lerp(0.42, 1, u.clamp(grow * 3)), need));

      c.fillStyle = `rgba(0,0,0,${0.5 * appear * (1 - grow)})`;
      c.beginPath(); c.rect(0, 0, W, H); c.arc(cx, cy, r, 0, Math.PI * 2); c.fill('evenodd');

      c.save();
      c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.clip();
      c.translate(cx, cy); c.scale(sc, sc); c.translate(-qx, -qy);
      c.drawImage(g.tele, -(fsx / fcw) * W, 0, (tw / fcw) * W, H);
      c.restore();

      if (grow < 0.97) {
        c.save();
        c.shadowColor = 'rgba(0,0,0,0.6)'; c.shadowBlur = m * 0.05;
        c.lineWidth = Math.max(1.5, m * 0.009); c.strokeStyle = `rgba(255,255,255,${0.95 * (1 - grow)})`;
        c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.stroke();
        c.restore();
        const la = appear * u.clamp(1 - grow * 3);
        if (la > 0.02) { c.globalAlpha = la; u.pill(c, '8×', cx, Math.max(m * 0.07, cy - r - m * 0.075), m * 0.06, '#000', u.acc(I, 1), 'ltr'); c.globalAlpha = 1; }
      }
      lensPill(c, W, H, grow > 0.55 ? '8' : '0.5', I);
    },
  };

  /* ───────── 2 · מסגרת על הנוף ─────────
     הצילום הרחב גדול על הבמה, משמאל לטלפון. מסגרת עליו מתכווצת אל האישה, וקווים מחברים אותה למסך.
     רואים גם מאיפה הזום נלקח וגם מה הוא נותן */
  const zAt2 = (t, g) => g.base * Math.pow(8 / g.base, u.ease(u.clamp((t - 0.8) / 4.4)));
  S['zoom-2'] = {
    dur: 6.5,
    shift: 0.2,
    glow: false,
    draw(c, W, H, t, side, I) {
      blank(c, W, H);
      const g = geo(); if (!g) return;
      const z = zAt2(t, g);
      drawView(c, g, viewAt(g, z, W, H), W, H);
      lensPill(c, W, H, z > 7.9 ? '8' : z.toFixed(1).replace(/\.0$/, ''), I);
    },
    stage(c, W, H, t, I, scr) {
      const g = geo(); if (!g) return;
      const z = zAt2(t, g), v = viewAt(g, z, scr.w, scr.h);
      /* הפנים באמצע השטח הפנוי משמאל לטלפון */
      const bh = H * 0.8, sc = bh / g.ih, bw = g.iw * sc;
      const fw0 = ((g.ih * scr.w) / scr.h) * sc;
      const ax = Math.max(scr.x * 0.5, fw0 / 2 + 16), ay = H / 2;
      const ox = ax - g.fcx * sc, oy = ay - g.fcy * sc;
      c.drawImage(g.wide, ox, oy, bw, bh);
      /* הנוף נמוג לשחור לכל הכיוונים, בלי קצה חד. הבד ריק לפני הציור, ולכן destination-in נוגע רק בו */
      c.save();
      c.globalCompositeOperation = 'destination-in';
      c.translate(ax, ay); c.scale(1.6, 1);
      const mg = c.createRadialGradient(0, 0, bh * 0.22, 0, 0, bh * 0.5);
      mg.addColorStop(0, '#000'); mg.addColorStop(1, 'rgba(0,0,0,0)');
      c.fillStyle = mg; c.fillRect(-W * 2, -H * 2, W * 4, H * 4);
      c.restore();
      L.kit && L.kit.edgeFade(c, W, H, Math.min(W, H) * 0.12);

      const fx = ox + v.sx * sc, fy = oy + v.sy * sc, fw = v.cw * sc, fh = v.ch * sc;
      c.fillStyle = 'rgba(0,0,0,0.45)';
      c.beginPath(); c.rect(0, 0, W, H); c.rect(fx, fy, fw, fh); c.fill('evenodd');

      /* ההטלה: מהצלע של המסגרת אל שולי המסך */
      const ex = fx + fw;
      const gr = u.lgrad(c, ex, 0, scr.x, 0);
      gr.addColorStop(0, u.acc(I, 0.26)); gr.addColorStop(1, u.acc(I, 0.05));
      c.fillStyle = gr;
      c.beginPath(); c.moveTo(ex, fy); c.lineTo(scr.x + 2, scr.y + scr.h * 0.02); c.lineTo(scr.x + 2, scr.y + scr.h * 0.98); c.lineTo(ex, fy + fh); c.closePath(); c.fill();
      c.strokeStyle = u.acc(I, 0.6); c.lineWidth = 1;
      c.beginPath(); c.moveTo(ex, fy); c.lineTo(scr.x + 2, scr.y + scr.h * 0.02); c.moveTo(ex, fy + fh); c.lineTo(scr.x + 2, scr.y + scr.h * 0.98); c.stroke();

      /* המסגרת: קו דק וסוגרי פינה של עינית */
      c.strokeStyle = 'rgba(255,255,255,0.9)'; c.lineWidth = 1;
      c.strokeRect(fx, fy, fw, fh);
      const k = Math.max(6, Math.min(fw, fh) * 0.22);
      c.lineWidth = 2.5; c.strokeStyle = '#fff';
      c.beginPath();
      [[fx, fy, 1, 1], [fx + fw, fy, -1, 1], [fx, fy + fh, 1, -1], [fx + fw, fy + fh, -1, -1]].forEach(([x, y, dx, dy]) => { c.moveTo(x + dx * k, y); c.lineTo(x, y); c.lineTo(x, y + dy * k); });
      c.stroke();

      const la = u.clamp((z - 5) / 2.5);
      if (la > 0) { c.globalAlpha = la; u.pill(c, '8×', fx + fw / 2, fy - Math.min(W, H) * 0.06, Math.min(W, H) * 0.036, '#000', u.acc(I, 1), 'ltr'); c.globalAlpha = 1; }
    },
  };

  /* ───────── 3 · מספר ענק ─────────
     משמאל לטלפון מספר גדול, העדשה הנוכחית. לא מאחוריו: שם הטלפון חתך את «0.5×» ל«0 ×» (נמדד בצילום 16.09). המסך מחזיק את הרחב, ואז נדחף פנימה עד פי 8 החד.
     המספר עובר 0.5 · 1 · 2 · 4 · 8 בזמן הדחיפה, ולכן העין קוראת את המספר ולא את הפריימים הרכים */
  const zAt3 = (t, g) => (t < 2.2 ? g.base * u.lerp(1, 1.06, t / 2.2) : g.base * 1.06 * Math.pow(8 / (g.base * 1.06), u.ease(u.clamp((t - 2.2) / 2))));
  S['zoom-3'] = {
    dur: 6.5,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      blank(c, W, H);
      const g = geo(); if (!g) return;
      const z = zAt3(t, g);
      drawView(c, g, viewAt(g, z, W, H), W, H);
      lensPill(c, W, H, lensOf(z), I);
    },
    stage(c, W, H, t, I, scr) {
      const g = geo();
      const label = lensOf(g ? zAt3(t, g) : 0.5) + '×';
      /* גודל אחד שנכנס בשטח הפנוי גם ל-0.5×, כדי שהמספר לא יקפוץ בגודל כשהוא מתחלף */
      c.font = u.font(700, 100); c.direction = 'ltr';
      const per = c.measureText('0.5×').width / 100;
      const room = Math.max(40, scr.x - Math.min(W, H) * 0.08), px = Math.min(H * 0.42, (room * 0.92) / per);
      const ax = room / 2 + Math.min(W, H) * 0.02, yb = H / 2 + px * 0.3;
      c.font = u.font(700, px); c.textAlign = 'center'; c.textBaseline = 'alphabetic';
      const gr = u.lgrad(c, 0, yb - px * 0.74, 0, yb);
      gr.addColorStop(0, u.acc(I, 1)); gr.addColorStop(1, u.acc(I, 0.35));
      c.fillStyle = gr;
      c.fillText(label, ax, yb);
      u.text(c, 'זום אופטי', ax, yb + Math.max(14, px * 0.2), Math.max(13, px * 0.13), 'rgba(255,255,255,0.6)', 500, 'center', 'rtl');
    },
  };

  /* לסבב 2 (scenes-r2-zoom.js): אותה גאומטריה, בלי להעתיק אותה */
  L.zoomKit = { geo, viewAt, feathered, FACE };
})();

/* ── js/scenes-r2-self.js ── */
/* סלפי, סבב 2 (17.09.2026). יובל: «באף אחד זה לא מספיק ברור מה קורה». אולי לכיוון «כבר לא צריך לסובב».
   הרעיון שחסר בסבב 1: לראות קודם את הבעיה. חברים נחתכים בקצה הפריים, ורק אז הפריים נפתח ומכניס אותם.
   צילום אחד של Apple (selfie-group, 1600x1200), ארבע פנים שנמדדו ממנו (scenes-r2 משתמש באותן מידות של scenes-self).
   self-4 העולם שמחוץ למסך · self-5 חתוכים, ואז בפנים · self-6 שלושה צעדים */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2;
  const FACES = [[0.29, 0.40, 0.14], [0.45, 0.42, 0.13], [0.585, 0.40, 0.13], [0.74, 0.33, 0.14]];
  const RED = '#FF453A', GREEN = '#30D158';
  const CX = 0.515, CY = 0.4;

  /* הציר: לאורך עם שני חברים שלמים ושניים חתוכים, ואז הפריים נפתח לרוחב */
  const T = { cut: 0.9, open0: 2.3, open1: 3.7, done: 3.9, flash: 5.2, dur: 7 };
  const openAt = t => u.ease(u.clamp((t - T.open0) / (T.open1 - T.open0)));
  /* כמה מרוחב הצילום נכנס למסך: 0.42 לאורך ⟵ 1 לרוחב, לוגריתמי כדי שהתנועה תהיה אחידה */
  const fracAt = (t, f0) => f0 * Math.pow(1 / f0, openAt(t));

  /* מיפוי מהצילום אל מלבן (המסך, או המסך בקואורדינטות הבמה) */
  const mapper = (img, rx, ry, rw, rh, frac) => {
    const iw = img.naturalWidth, ih = img.naturalHeight, s = rw / (frac * iw);
    const ox = rx + rw / 2 - CX * iw * s, oy = ry + rh * 0.46 - CY * ih * s;
    /* רצועת התצוגה: בין 10% ל-82% מגובה המסך, ובתוך גבולות הצילום */
    const by0 = Math.max(ry + rh * 0.1, oy), by1 = Math.min(ry + rh * 0.82, oy + ih * s);
    return { iw, ih, s, ox, oy, bx0: Math.max(rx, ox), bx1: Math.min(rx + rw, ox + iw * s), by0, by1, px: (fx, fy) => [ox + fx * iw * s, oy + fy * ih * s] };
  };

  /* סימון פנים: סוגריים ותווית */
  const mark = (c, x, y, sz, col, lw, label, m) => {
    K.brackets(c, x - sz / 2, y - sz / 2, sz, sz, col, lw, sz * 0.28);
    if (label) u.pill(c, label, x, y - sz / 2 - m * 0.05, Math.max(9, m * 0.036), col === RED ? '#fff' : '#000', col, 'rtl');
  };
  /* גלולה שלא יוצאת מהבד: מודדים רוחב, ומזיזים פנימה */
  /* גם לא מתחת לטלפון: הטלפון מונח מעל הבמה ומסתיר (צילום 17.09, «וץ לפריים»). x0 עד x1 הם הגבולות.
     אם אין מקום בשורה אחת, שתי שורות */
  const pillIn = (c, s, x, y, px, fg, bg, x0, x1) => {
    c.font = u.font(500, px); c.direction = 'rtl';
    const w = c.measureText(s).width + px * 1.5;
    if (w <= x1 - x0) return u.pill(c, s, u.clamp(x, x0 + w / 2, x1 - w / 2), y, px, fg, bg, 'rtl');
    const words = s.split(' '), ww = Math.max(...words.map(q => c.measureText(q).width)) + px * 1.2, hh = px * 1.3 * words.length + px * 0.7;
    const cx = u.clamp(x, x0 + ww / 2, x1 - ww / 2);
    u.rr(c, cx - ww / 2, y - hh / 2, ww, hh, px * 0.6, bg);
    words.forEach((q, i) => u.text(c, q, cx, y - hh / 2 + px * 0.35 + px * 1.3 * (i + 0.5), px, fg, 500, 'center', 'rtl'));
    return ww;
  };
  /* פנים שנכנסו כולן למסך */
  const inside = (M, f, x0, x1) => { const [x] = M.px(f[0], f[1]), h = (f[2] * M.iw * M.s) / 2; return x - h >= x0 - 1 && x + h <= x1 + 1; };

  /* המסך: תצוגה מקדימה של המצלמה הקדמית */
  const screen = (c, W, H, t, I, { f0 = 0.42, labels = true } = {}) => {
    const m = Math.min(W, H), img = K.img('selfie-group');
    c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
    u.status(c, W, H, { level: 0.7 });
    if (!img) { K.shutter(c, W, H, `${I.tg.sm}MP`); return; }
    const M = mapper(img, 0, 0, W, H, fracAt(t, f0)), op = openAt(t);
    c.save(); c.beginPath(); c.roundRect(M.bx0, M.by0, M.bx1 - M.bx0, M.by1 - M.by0, op * m * 0.03); c.clip();
    c.drawImage(img, M.ox, M.oy, M.iw * M.s, M.ih * M.s);
    c.restore();
    /* הפנים */
    const lw = Math.max(2, m * 0.012);
    FACES.forEach((f, i) => {
      const [x, y] = M.px(f[0], f[1]), sz = f[2] * M.iw * M.s * 0.9, outer = i === 0 || i === 3;
      const a = outer ? u.clamp((t - T.cut) / 0.35) : u.clamp(t / 0.4);
      if (a <= 0) return;
      const inNow = inside(M, f, M.bx0, M.bx1), col = outer ? (t >= T.done && inNow ? GREEN : RED) : '#fff';
      c.save(); c.globalAlpha = a * u.clamp(1 - (t - (T.flash - 0.2)) * 3);
      c.beginPath(); c.rect(M.bx0, M.by0, M.bx1 - M.bx0, M.by1 - M.by0); c.clip();
      mark(c, x, y, sz, col, lw, '', m);
      c.restore();
    });
    /* תוויות: «נחתך» ליד הקצוות, ואחר כך «4 בפריים» */
    if (labels) {
      const cutA = u.clamp((t - T.cut - 0.2) / 0.3) * u.clamp(1 - (t - T.open0) / 0.4);
      if (cutA > 0) {
        c.save(); c.globalAlpha = cutA;
        [0, 3].forEach(i => {
          const f = FACES[i], [x, y] = M.px(f[0], f[1]), sz = f[2] * M.iw * M.s * 0.9;
          u.pill(c, 'נחתך', u.clamp(x, W * 0.17, W * 0.83), y - sz / 2 - m * 0.06, m * 0.056, '#fff', RED, 'rtl');
        });
        c.restore();
      }
    }
    const okA = u.clamp((t - T.done) / 0.4);
    if (okA > 0) {
      c.save(); c.globalAlpha = okA;
      u.pill(c, 'Center Stage', W / 2, M.by0 - m * 0.06, m * 0.045, '#000', u.acc(I, 1), 'ltr');
      c.restore();
      c.save(); c.globalAlpha = okA;
      u.pill(c, 'כל הארבעה בפריים', W / 2, M.by1 + m * 0.07, m * 0.045, '#000', GREEN, 'rtl');
      c.restore();
    }
    const fl = u.clamp(1 - Math.abs(t - T.flash) * 5);
    if (fl > 0) { c.fillStyle = `rgba(255,255,255,${fl * 0.8})`; c.fillRect(0, 0, W, H); }
    K.shutter(c, W, H, `${I.tg.sm}MP`);
    return M;
  };

  /* ───────── 4 · העולם שמחוץ למסך ─────────
     הצילום ממשיך על הבמה, מעומעם, בדיוק בהמשך למסך. החברים שבקצוות נראים מחוץ לטלפון ומסומנים באדום.
     הפריים נפתח, כל הצילום נאסף אל תוך המסך, והם נכנסים. הטלפון לא זז */
  S['self-4'] = {
    dur: T.dur,
    glow: false,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I, { f0: 0.34, labels: false }); },
    stage(c, W, H, t, I, scr) {
      const img = K.img('selfie-group'); if (!img) return;
      const m = Math.min(W, H), M = mapper(img, scr.x, scr.y, scr.w, scr.h, fracAt(t, 0.34)), op = openAt(t);
      const Lr = K2.layer('s4', W, H), x = Lr.x;
      x.save(); x.beginPath(); x.rect(0, M.by0, W, M.by1 - M.by0); x.clip();
      x.drawImage(img, M.ox, M.oy, M.iw * M.s, M.ih * M.s);
      x.restore();
      /* דהייה לשני הצדדים, בלי קצה חד */
      x.save(); x.globalCompositeOperation = 'destination-in';
      const g = x.createLinearGradient(0, 0, W, 0); g.addColorStop(0, 'rgba(0,0,0,0)'); g.addColorStop(0.12, '#000'); g.addColorStop(0.88, '#000'); g.addColorStop(1, 'rgba(0,0,0,0)');
      x.fillStyle = g; x.fillRect(0, 0, W, H); x.restore();
      c.globalAlpha = 0.42 * (1 - op * 0.6); c.drawImage(Lr.cv, 0, 0, W, H); c.globalAlpha = 1;
      /* מסגרת מקווקוות: הגבול של הצילום כולו */
      c.save(); c.setLineDash([5, 5]); c.strokeStyle = `rgba(255,255,255,${0.35 * (1 - op)})`; c.lineWidth = 1;
      c.strokeRect(M.ox, M.by0, M.iw * M.s, M.by1 - M.by0); c.restore();
      /* החברים שבחוץ */
      const a = u.clamp((t - T.cut) / 0.35) * u.clamp(1 - (t - T.flash + 0.2) * 3);
      if (a > 0) {
        [0, 3].forEach(i => {
          const f = FACES[i], [px, py] = M.px(f[0], f[1]), sz = f[2] * M.iw * M.s * 0.9, inNow = inside(M, f, scr.x, scr.x + scr.w);
          if (inNow && t >= T.done) return;
          c.save(); c.globalAlpha = a;
          mark(c, px, py, sz, RED, Math.max(2, m * 0.008), '', m);
          /* התווית כולה בתוך הבמה: נחתכה בקצה אצל יובל (צילום 17.09). הרוחב נמדד לפני המיקום */
          const bez = scr.w * 0.06, pad = 5;
          if (t < T.open0 + 0.3) pillIn(c, 'מחוץ לפריים', px, py + sz / 2 + m * 0.07, Math.max(10, m * 0.034), '#fff', RED, i === 0 ? pad : scr.x + scr.w + bez + pad, i === 0 ? scr.x - bez - pad : W - pad);
          c.restore();
        });
      }
      const la = u.clamp((t - T.done - 0.2) / 0.5);
      if (la > 0) u.text(c, 'הטלפון לא זז. הפריים נפתח', scr.x + scr.w / 2, Math.min(H - m * 0.04, scr.y + scr.h + m * 0.05), Math.max(12, m * 0.036), `rgba(255,255,255,${0.75 * la})`, 500, 'center', 'rtl');
    },
  };

  /* ───────── 5 · חתוכים, ואז בפנים ─────────
     הכול על המסך. שני חברים בקצוות חתוכים וסימונם אדום, עם «נחתך». הפריים נפתח לרוחב, והסימון נעשה ירוק */
  S['self-5'] = {
    dur: T.dur,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I, { f0: 0.42 }); },
  };

  /* ───────── 6 · שלושה צעדים ─────────
     המסך של 5, וליד הטלפון שלושה צעדים שנדלקים לפי הרגע */
  const STEPS = [['phoneUp', 'מחזיקים לאורך', 0], ['walk', 'חברים נכנסים לקצה', T.cut], ['photoWide', 'הפריים נפתח לרוחב', T.open0 + 0.4]];
  S['self-6'] = {
    dur: T.dur,
    shift: 0.22,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I, { f0: 0.42 }); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr);
      const r = Math.max(14, Math.min(room * 0.12, H * 0.07)), gap = Math.max(r * 3.4, H * 0.2), y0 = H / 2 - gap;
      const active = STEPS.reduce((a, s, i) => (t >= s[2] ? i : a), 0);
      /* קו אנכי שמחבר את הצעדים */
      const xb = room - r - m * 0.03;
      c.strokeStyle = 'rgba(255,255,255,0.14)'; c.lineWidth = 2;
      c.beginPath(); c.moveTo(xb, y0); c.lineTo(xb, y0 + gap * 2); c.stroke();
      const prog = u.clamp((t - STEPS[1][2]) / (STEPS[2][2] - STEPS[1][2] + 0.6));
      c.strokeStyle = u.acc(I, 0.9); c.beginPath(); c.moveTo(xb, y0); c.lineTo(xb, y0 + gap * 2 * prog); c.stroke();
      STEPS.forEach(([icon, text, at], i) => {
        const y = y0 + i * gap, on = i === active, done = i < active, a = u.clamp((t - at + 0.2) / 0.35);
        K2.badge(c, icon, xb, y, r, { fg: on ? '#000' : done ? u.acc(I, 1) : 'rgba(255,255,255,0.5)', bg: on ? u.acc(I, 1) : '#111114', ring: on ? '' : done ? u.acc(I, 0.7) : 'rgba(255,255,255,0.18)' });
        c.save(); c.globalAlpha = 0.35 + 0.65 * a;
        const avail = xb - r - m * 0.03 - 6, fs2 = Math.min(r * 0.62, m * 0.042, K2.fit(c, 'חברים נכנסים לקצה', avail, 99, 700));
        u.text(c, text, xb - r - m * 0.03, y, Math.max(9, fs2), on ? '#fff' : done ? 'rgba(255,255,255,0.7)' : 'rgba(255,255,255,0.4)', on ? 700 : 500, 'right', 'rtl');
        c.restore();
      });
    },
  };

  /* לסבב 3 (scenes-r3-self.js): אותו רצף בדיוק, בלי להעתיק */
  L.selfKit = { FACES, RED, GREEN, T, openAt, fracAt, mapper, mark, inside, screen, pillIn, stage4: S['self-4'].stage };
})();

/* ── js/scenes-r3-self.js ── */
/* סלפי, סבב 3 (17.09.2026). יובל: «הכי אהבתי את 4», ואחרי ההסבר (החיישן ריבועי, התמונה נשמרת לרוחב):
   «צריך לראות איך מסבירים יותר טוב שהתמונה לרוחב. אולי אחרי הצילום הוא יפתח גלריה ויראה שזה לרוחב?»
   ⟹ שלושתן הן 4 בדיוק עד הצילום (L.selfKit), ומה שמשתנה הוא הסוף: איך רואים שהתמונה נשמרה לרוחב.
   העובדה: Center Stage נכנס ב-iPhone 17. החיישן הקדמי ריבועי, ולכן תמונה לרוחב כשהטלפון לאורך (claims.md).
   self-7 הגלריה נפתחת · self-8 התמונה יוצאת החוצה · self-9 בין הסלפי הישנים */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, SK = L.selfKit;
  const T = SK.T, END = 6.0, DUR = 10.2;

  /* הצילום שנשמר: כל הרוחב של הצילום, בדיוק מה שנראה במסך בסוף 4 */
  const saved = (c, x, y, w, h, img) => { if (img) u.cover(c, img, x, y, w, h, 0.515, 0.42); else { c.fillStyle = '#222'; c.fillRect(x, y, w, h); } };

  /* מסך הגלריה: תמונה אחת פתוחה, ממורכזת, עם שוליים שחורים מעל ומתחת */
  const viewer = (c, W, H, t, I, k) => {
    const m = Math.min(W, H), img = K.img('selfie-group');
    c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
    u.status(c, W, H, { level: 0.7 });
    u.text(c, 'היום', W / 2, H * 0.1, m * 0.05, '#fff', 600, 'center', 'rtl');
    u.text(c, '9:41', W / 2, H * 0.135, m * 0.036, 'rgba(255,255,255,0.6)', 500, 'center', 'ltr');
    /* התמונה גדלה מהכפתור הקטן של הגלריה לרוחב המסך */
    const g = u.ease(k), bw = u.lerp(m * 0.12, W, g), bh = bw * 0.75, bx = u.lerp(W * 0.2 - m * 0.06, 0, g), by = u.lerp(H * 0.9 - m * 0.06, H * 0.46 - bh / 2, g);
    c.save(); c.beginPath(); c.roundRect(bx, by, bw, bh, (1 - g) * m * 0.02); c.clip(); saved(c, bx, by, bw, bh, img); c.restore();
    [0.18, 0.39, 0.61, 0.82].forEach(fx => { c.strokeStyle = 'rgba(255,255,255,0.75)'; K2.icon[fx < 0.3 ? 'photoWide' : fx < 0.5 ? 'note' : fx < 0.7 ? 'chat' : 'camera'](c, W * fx, H * 0.93, m * 0.07); });
    return { bx, by, bw, bh };
  };

  /* הזוג: רוחב ושוליים מסומנים */
  const dimLabels = (c, r, I, m, a) => {
    c.save(); c.globalAlpha = a;
    c.strokeStyle = u.acc(I, 1); c.lineWidth = 1.5;
    const y = r.by - m * 0.04;
    c.beginPath(); c.moveTo(r.bx + m * 0.03, y); c.lineTo(r.bx + r.bw - m * 0.03, y); c.stroke();
    [[r.bx + m * 0.03, 1], [r.bx + r.bw - m * 0.03, -1]].forEach(([x, d]) => { c.beginPath(); c.moveTo(x + d * m * 0.025, y - m * 0.018); c.lineTo(x, y); c.lineTo(x + d * m * 0.025, y + m * 0.018); c.stroke(); });
    u.pill(c, 'נשמרה לרוחב', r.bx + r.bw / 2, r.by + r.bh + m * 0.08, m * 0.05, '#000', u.acc(I, 1), 'rtl');
    c.restore();
  };

  /* סבב 5 משתמש בהם (scenes-r5-self.js) */
  L.selfKit3 = { saved, viewer, dimLabels, END, DUR };

  /* ───────── 7 · הגלריה נפתחת ─────────
     4 עד הצילום. אחרי הצילום הגלריה נפתחת על המסך: התמונה ברוחב המסך, עם שוליים שחורים מעל ומתחת,
     חץ רוחב מעליה ו«נשמרה לרוחב». ליד הטלפון: «הטלפון לאורך» */
  S['self-7'] = {
    dur: DUR,
    glow: false,
    draw(c, W, H, t, side, I) {
      if (t < END) { SK.screen(c, W, H, t, I, { f0: 0.34, labels: false }); return; }
      const k = u.clamp((t - END) / 0.7), r = viewer(c, W, H, t, I, k);
      if (k >= 1) dimLabels(c, r, I, Math.min(W, H), u.clamp((t - END - 0.8) / 0.5));
    },
    stage(c, W, H, t, I, scr) {
      if (t < END) { SK.stage4(c, W, H, t, I, scr); return; }
      const m = Math.min(W, H), a = u.clamp((t - END - 1.2) / 0.5);
      if (a > 0) { c.save(); c.globalAlpha = a; c.strokeStyle = 'rgba(255,255,255,0.85)'; K2.icon.phoneUp(c, scr.x + scr.w / 2 - m * 0.2, scr.y + scr.h + m * 0.045, m * 0.06); c.restore(); u.text(c, 'הטלפון לאורך, התמונה לרוחב', scr.x + scr.w / 2 + m * 0.02, Math.min(H - m * 0.03, scr.y + scr.h + m * 0.045), Math.max(12, m * 0.036), `rgba(255,255,255,${0.8 * a})`, 500, 'center', 'rtl'); }
    },
  };

  /* ───────── 8 · התמונה יוצאת החוצה ─────────
     4 עד הצילום. אחרי הצילום התמונה יוצאת מהמסך אל הבמה ומתיישבת ליד הטלפון, גדולה ולרוחב.
     שתי תוויות: «צילמת לאורך» עם חץ אל הטלפון, «קיבלת לרוחב» עם חץ אל התמונה */
  S['self-8'] = {
    dur: DUR,
    shift: 0.24,
    draw(c, W, H, t, side, I) {
      if (t < END) { SK.screen(c, W, H, t, I, { f0: 0.34, labels: false }); return; }
      /* המסך חוזר למצלמה, רגוע, אחרי הצילום */
      SK.screen(c, W, H, T.done + 0.8, I, { f0: 0.34, labels: false });
    },
    stage(c, W, H, t, I, scr) {
      const img = K.img('selfie-group');
      if (t < END) {
        /* במעבר ל-shift הטלפון זז ימינה, ולכן הרקע של 4 נעלם כבר מהצילום */
        if (t < T.flash) SK.stage4(c, W, H, t, I, scr);
        return;
      }
      const { room, ax, m } = K.room(W, H, scr), k = u.easeOut(u.clamp((t - END) / 0.9));
      const w = Math.min(room * 0.92, H * 0.62), h = w * 0.75, cx = u.lerp(scr.x + scr.w / 2, ax, k), cy = u.lerp(scr.y + scr.h * 0.46, H * 0.44, k);
      c.save(); c.shadowColor = 'rgba(0,0,0,0.6)'; c.shadowBlur = m * 0.05;
      u.rr(c, cx - (w * u.lerp(0.5, 1, k)) / 2 - 4, cy - (h * u.lerp(0.5, 1, k)) / 2 - 4, w * u.lerp(0.5, 1, k) + 8, h * u.lerp(0.5, 1, k) + 8, 6, '#F4F4F2');
      c.restore();
      const ww = w * u.lerp(0.5, 1, k), hh = h * u.lerp(0.5, 1, k);
      c.save(); c.beginPath(); c.rect(cx - ww / 2, cy - hh / 2, ww, hh); c.clip(); saved(c, cx - ww / 2, cy - hh / 2, ww, hh, img); c.restore();
      const a = u.clamp((t - END - 1.0) / 0.5);
      if (a > 0) {
        c.save(); c.globalAlpha = a;
        u.text(c, 'קיבלת לרוחב', cx, cy + hh / 2 + m * 0.07, Math.max(14, m * 0.05), u.acc(I, 1), 700, 'center', 'rtl');
        u.text(c, 'צילמת לאורך', cx, cy - hh / 2 - m * 0.06, Math.max(12, m * 0.04), 'rgba(255,255,255,0.8)', 500, 'center', 'rtl');
        /* חץ מ«צילמת לאורך» אל הטלפון */
        c.strokeStyle = 'rgba(255,255,255,0.6)'; c.lineWidth = 1.5; c.lineCap = 'round';
        const x0 = cx + m * 0.14, y0 = cy - hh / 2 - m * 0.06, x1 = scr.x - m * 0.02, y1 = scr.y + scr.h * 0.12;
        c.beginPath(); c.moveTo(x0, y0); c.quadraticCurveTo((x0 + x1) / 2, y0 - m * 0.06, x1, y1); c.stroke();
        c.beginPath(); c.moveTo(x1 - m * 0.02, y1 - m * 0.015); c.lineTo(x1, y1); c.lineTo(x1 - m * 0.025, y1 + m * 0.01); c.stroke();
        c.restore();
      }
    },
  };

  /* ───────── 9 · בין הסלפי הישנים ─────────
     4 עד הצילום. אחרי הצילום הגלריה, בתצוגה ששומרת על צורת התמונות: הסלפי הקודמים צרים וגבוהים,
     והחדש רחב, מסומן, ונכנס אחרון. רואים את ההבדל במבט אחד */
  const OLD = [['ap-18', 0.52], ['selfie-group', 0.3], ['ap-148', 0.57], ['selfie-group', 0.75], ['ap-28', 0.55]];
  S['self-9'] = {
    dur: DUR,
    glow: false,
    draw(c, W, H, t, side, I) {
      if (t < END) { SK.screen(c, W, H, t, I, { f0: 0.34, labels: false }); return; }
      const m = Math.min(W, H), k = u.easeOut(u.clamp((t - END) / 0.6));
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      u.status(c, W, H, { level: 0.7 });
      u.text(c, 'סלפי', W * 0.93, H * 0.1, m * 0.08, '#fff', 700, 'right', 'rtl');
      const gap = Math.max(2, W * 0.012), cw = (W - gap) / 2, tallH = cw * 1.333, top = H * 0.15;
      /* הישנים: שתי עמודות, לאורך */
      OLD.slice(0, 4).forEach(([key, fx], i) => {
        const col = i % 2, row = Math.floor(i / 2), x = W - (col + 1) * cw - col * gap, y = top + row * (tallH + gap) + (1 - k) * m * 0.2;
        const im = K.img(key);
        c.save(); c.beginPath(); c.rect(x, y, cw, tallH); c.clip();
        if (im) u.cover(c, im, x, y, cw, tallH, fx, 0.5); else { c.fillStyle = '#222'; c.fillRect(x, y, cw, tallH); }
        c.restore();
      });
      /* החדש: לרוחב, מעל כולם */
      const nk = u.easeOut(u.clamp((t - END - 0.7) / 0.7)), nh = W * 0.75, ny = u.lerp(H, top - nh * 0.02, nk);
      if (nk > 0) {
        c.save(); c.shadowColor = 'rgba(0,0,0,0.8)'; c.shadowBlur = m * 0.08; c.fillStyle = '#000'; c.fillRect(0, ny - gap, W, nh + gap * 2); c.restore();
        c.save(); c.beginPath(); c.rect(0, ny, W, nh); c.clip(); saved(c, 0, ny, W, nh, K.img('selfie-group')); c.restore();
        c.strokeStyle = u.acc(I, 1); c.lineWidth = 3; c.strokeRect(1.5, ny + 1.5, W - 3, nh - 3);
        const la = u.clamp((t - END - 1.5) / 0.4);
        if (la > 0) { c.save(); c.globalAlpha = la; u.pill(c, 'החדש, לרוחב', W / 2, ny + nh + m * 0.08, m * 0.05, '#000', u.acc(I, 1), 'rtl'); c.restore(); }
      }
    },
    stage(c, W, H, t, I, scr) {
      if (t < END) { SK.stage4(c, W, H, t, I, scr); return; }
      const m = Math.min(W, H), a = u.clamp((t - END - 1.8) / 0.5);
      if (a > 0) u.text(c, 'הסלפי הקודמים לאורך. החדש לרוחב', scr.x + scr.w / 2, Math.min(H - m * 0.03, scr.y + scr.h + m * 0.045), Math.max(12, m * 0.036), `rgba(255,255,255,${0.8 * a})`, 500, 'center', 'rtl');
    },
  };
})();

/* ── js/scenes-r2-bat.js ── */
/* סוללה, סבב 2 (17.09.2026). יובל: אהב את היום והלילה (bat-1). «אף אחד כמעט לא רואה סרטים בטלפון»,
   וכל האפשרויות היו תמונה ומונה סרטים. ביקש כיוונים שונים גם במסך הטלפון.
   ⟹ הנתון עובר ל«שימוש רגיל» של Apple: t.use (18 Pro 23 שעות בדגם הישראלי). זה המדד של Apple לשימוש מעורב:
   הודעות, תמונות, מוזיקה, רשתות, סרטונים, משחקים, גלישה וניווט (claims.md, הערה 7).
   היום מתחיל ב-07:00. 23 שעות מביאות ל-06:00 למחרת. הסוללה במסך יורדת לפי השעות, ונעצרת ב-5% ולא בכיבוי.
   bat-4 יום רגיל על המסך · bat-5 ציר היום · bat-6 האי הדינמי */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, UI = L.ui2;
  const RUN = 7.4, DUR = RUN + 1.2;
  const hoursAt = (t, v) => u.clamp(t / RUN) * v.use * 0.95;
  const clockOf = h => { const x = (7 + h) % 24; return `${Math.floor(x)}:${String(Math.floor((x % 1) * 60)).padStart(2, '0')}`; };
  const levelAt = (h, v) => u.clamp(1 - h / v.use);
  const shown = (t, h, v) => (t >= RUN ? v.use : Math.floor(h / 0.95));

  /* היום: [שעות מההתחלה, מסך, מילה, אייקון] */
  const DAY = [[0, 'lock', 'בוקר', 'sun'], [1.4, 'maps', 'ניווט', 'pin'], [2.8, 'chat', 'הודעות', 'chat'], [5.5, 'photos', 'צילום', 'camera'], [7.5, 'music', 'מוזיקה', 'note'], [10.5, 'chat', 'הודעות', 'chat'], [12.5, 'video', 'סדרה בערב', 'tv'], [16, 'lockN', 'לילה', 'moon']];
  const segAt = h => DAY.reduce((a, s, i) => (h >= s[0] ? i : a), 0);

  /* מסך לפי השעה, עם מעבר קצר */
  const appScreen = (c, W, H, t, h, v, I) => {
    const i = segAt(h), s = DAY[i], local = h - s[0];
    const draw = (seg, lt) => {
      if (seg[1] === 'lock') UI.lock(c, 0, 0, W, H, { time: clockOf(h), light: 0.85, note: 'השכמה, 7:00', I });
      else if (seg[1] === 'lockN') UI.lock(c, 0, 0, W, H, { time: clockOf(h), light: 0.2, I });
      else if (seg[1] === 'maps') UI.maps(c, 0, 0, W, H, lt * 3);
      else if (seg[1] === 'chat') UI.chat(c, 0, 0, W, H, lt * 1.6, I);
      else if (seg[1] === 'photos') UI.photos(c, 0, 0, W, H, lt * 4);
      else if (seg[1] === 'music') UI.music(c, 0, 0, W, H, lt * 4);
      else if (seg[1] === 'video') UI.video(c, 0, 0, W, H, lt * 2);
    };
    draw(s, local);
    /* מעבר: המסך הקודם דועך במהלך 0.25 שעות */
    if (i > 0 && local < 0.35) { c.save(); c.globalAlpha = 1 - local / 0.35; draw(DAY[i - 1], DAY[i][0] - DAY[i - 1][0]); c.restore(); }
    u.status(c, W, H, { time: clockOf(h), level: levelAt(h, v), color: '#fff' });
    return i;
  };

  /* שמיים, שמש וירח לפי השעה. מבוסס על bat-1 */
  const sky = (c, W, H, h, I, room, ax, m, { arcY = 0.36, R0 = 0.42 } = {}) => {
    const x = (7 + h) % 24, day = x >= 6 && x < 18, ph = day ? (x - 6) / 12 : ((x + 6) % 24) / 12, light = day ? Math.sin(ph * Math.PI) : 0;
    const g = c.createLinearGradient(0, 0, 0, H);
    g.addColorStop(0, `rgba(${Math.round(u.lerp(4, 40, light))},${Math.round(u.lerp(6, 30, light))},${Math.round(u.lerp(14, 52, light))},1)`);
    g.addColorStop(0.75, '#000');
    c.fillStyle = g; c.fillRect(0, 0, W, H);
    K.fade(c, W, H, W / 2, H * 0.3, W * 0.75, H * 0.7, 0.2);
    const hy = H * arcY, R = Math.min(room * R0, H * 0.22);
    c.strokeStyle = 'rgba(255,255,255,0.16)'; c.lineWidth = 1; c.setLineDash([2, 5]); c.beginPath(); c.arc(ax, hy, R, Math.PI, 0); c.stroke(); c.setLineDash([]);
    c.strokeStyle = 'rgba(255,255,255,0.26)'; c.beginPath(); c.moveTo(ax - R * 1.2, hy); c.lineTo(ax + R * 1.2, hy); c.stroke();
    const a = Math.PI + ph * Math.PI, bx = ax + Math.cos(a) * R, by = hy + Math.sin(a) * R, br = Math.max(6, m * 0.032);
    c.save();
    if (day) { c.shadowColor = 'rgba(255,214,120,0.8)'; c.shadowBlur = br * 2.2; c.fillStyle = '#FFD27A'; c.beginPath(); c.arc(bx, by, br, 0, Math.PI * 2); c.fill(); }
    else { c.shadowColor = u.acc(I, 0.7); c.shadowBlur = br * 1.6; c.fillStyle = '#E8ECF4'; c.beginPath(); c.arc(bx, by, br, 0, Math.PI * 2); c.fill(); c.shadowColor = 'transparent'; c.fillStyle = '#04060C'; c.beginPath(); c.arc(bx + br * 0.45, by - br * 0.25, br * 0.85, 0, Math.PI * 2); c.fill(); }
    c.restore();
    return { hy, R, light };
  };

  /* ───────── 4 · יום רגיל על המסך ─────────
     היום והלילה של bat-1 ליד הטלפון, ובמסך מתחלפות אפליקציות לפי השעה. מתחת לשמיים: מה עושים עכשיו, והשעות רצות */
  S['bat-4'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { const h = hoursAt(t, I.tg); appScreen(c, W, H, t, h, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const v = I.tg, h = hoursAt(t, v), { room, ax, m } = K.room(W, H, scr);
      const sk = sky(c, W, H, h, I, room, ax, m, { arcY: 0.34 });
      const seg = DAY[segAt(h)];
      u.text(c, clockOf(h), ax, sk.hy + m * 0.06, Math.max(12, m * 0.042), 'rgba(255,255,255,0.8)', 600, 'center', 'ltr');
      /* אייקון ומילה כיחידה אחת, ממורכזת */
      const fs2 = Math.max(12, m * 0.042), is = Math.max(12, m * 0.05);
      c.font = u.font(500, fs2); const tw = c.measureText(seg[2]).width, tot = tw + is + m * 0.02, x0 = ax + tot / 2;
      c.save(); c.strokeStyle = u.acc(I, 1); K2.icon[seg[3]](c, x0 - is / 2, sk.hy + m * 0.13, is); c.restore();
      u.text(c, seg[2], x0 - is - m * 0.02, sk.hy + m * 0.13, fs2, '#fff', 500, 'right', 'rtl');
      K.bigNumber(c, W, H, scr, String(shown(t, h, v)), 'שעות של שימוש', I, { sample: String(v.use), maxH: 0.2, y: 0.76 });
    },
  };

  /* ───────── 5 · ציר היום ─────────
     במסך הבית ווידג'ט הסוללה יורד לאט. ליד הטלפון ציר אנכי של היום, 07:00 למעלה ו-06:00 למטה,
     שמתמלא בקטעי פעילות צבעוניים עם אייקון. הקטע של עכשיו מסומן */
  const COL = { lock: '#8E8E93', maps: '#0A84FF', chat: '#30D158', photos: '#FFD60A', music: '#FF6961', video: '#BF5AF2', lockN: '#5E5CE6' };
  S['bat-5'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      const v = I.tg, h = hoursAt(t, v), x = (7 + h) % 24, light = x >= 6 && x < 19 ? 1 : x >= 19 && x < 22 ? 0.55 : 0.25;
      UI.home(c, 0, 0, W, H, { light, level: levelAt(h, v), I });
      u.status(c, W, H, { time: clockOf(h), level: levelAt(h, v) });
    },
    stage(c, W, H, t, I, scr) {
      const v = I.tg, h = hoursAt(t, v), { room, m } = K.room(W, H, scr);
      const y0 = H * 0.1, y1 = H * 0.9, xL = room - m * 0.04, bw = Math.max(10, Math.min(room * 0.14, m * 0.06));
      const yOf = hh => u.lerp(y0, y1, hh / v.use);
      c.fillStyle = 'rgba(255,255,255,0.06)'; u.rr(c, xL - bw, y0, bw, y1 - y0, bw / 2, 'rgba(255,255,255,0.06)');
      DAY.forEach((s, i) => {
        const a = s[0], b = i < DAY.length - 1 ? DAY[i + 1][0] : v.use * 0.95;
        if (h <= a) return;
        const e = Math.min(h, b), ya = yOf(a), yb = yOf(e);
        c.fillStyle = COL[s[1]]; c.globalAlpha = 0.85; c.fillRect(xL - bw, ya + 1, bw, Math.max(0, yb - ya - 2)); c.globalAlpha = 1;
        /* אייקון ומילה בצד, כשיש מקום */
        if (yb - ya > m * 0.05 || i === segAt(h)) {
          const yc = (ya + Math.max(yb, ya + m * 0.05)) / 2, on = i === segAt(h);
          c.save(); c.strokeStyle = on ? '#fff' : 'rgba(255,255,255,0.55)'; K2.icon[s[3]](c, xL - bw - m * 0.05, yc, Math.max(10, m * 0.04)); c.restore();
          u.text(c, s[2], xL - bw - m * 0.1, yc, Math.max(10, m * 0.034), on ? '#fff' : 'rgba(255,255,255,0.55)', on ? 600 : 500, 'right', 'rtl');
        }
      });
      /* השעות על הציר */
      [0, 6, 12, 18, v.use].forEach(hh => { const y = yOf(Math.min(hh, v.use)); u.text(c, clockOf(Math.min(hh, v.use)), xL + m * 0.01, y, Math.max(9, m * 0.028), 'rgba(255,255,255,0.45)', 500, 'left', 'ltr'); });
      const yn = yOf(h);
      c.fillStyle = '#fff'; c.beginPath(); c.moveTo(xL + 2, yn); c.lineTo(xL + m * 0.03, yn - m * 0.018); c.lineTo(xL + m * 0.03, yn + m * 0.018); c.closePath(); c.fill();
      const px = K2.fit(c, '23', room * 0.35, H * 0.14);
      K2.pop(c, String(shown(t, h, v)), room * 0.22, H * 0.84, px, I, { caption: '', age: 9 });
      u.text(c, 'שעות', room * 0.22, H * 0.84 + px * 0.55, Math.max(10, m * 0.032), 'rgba(255,255,255,0.6)', 500, 'center', 'rtl');
    },
  };

  /* ───────── 6 · האי הדינמי ─────────
     מסך הבית, שהאור שלו משתנה מבוקר ללילה. באי של 18 Pro מתחלפות פעילויות חיות: ניווט, מוזיקה, טיימר בישול.
     ליד הטלפון השעון רץ, והשעות גדלות */
  const LIVE = [[1.4, 2.8, 'nav'], [7.5, 10.5, 'music'], [11.2, 12.4, 'timer'], [12.5, 15.8, 'tv']];
  S['bat-6'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      const v = I.tg, h = hoursAt(t, v), x = (7 + h) % 24;
      const light = x >= 7 && x < 17 ? 1 : x >= 17 && x < 20 ? u.lerp(1, 0.45, (x - 17) / 3) : x >= 20 ? u.lerp(0.45, 0.18, u.clamp((x - 20) / 3)) : 0.18;
      UI.home(c, 0, 0, W, H, { light, level: levelAt(h, v), widget: false, rows: 2, I });
      /* שעון גדול על הטפט, כדי שהמעבר מיום ללילה ייקרא */
      u.text(c, clockOf(h), W / 2, H * 0.3, W * 0.2, `rgba(255,255,255,${u.lerp(0.55, 0.9, light)})`, 500, 'center', 'ltr');
      u.status(c, W, H, { time: clockOf(h), level: levelAt(h, v) });
      const act = LIVE.find(([a, b]) => h >= a && h < b);
      if (act) {
        const grow = u.clamp(Math.min(h - act[0], act[1] - h) / 0.4);
        const P = { nav: ['pin', '#30D158', "בעוד 300 מ'", 'פנו ימינה'], music: ['note', '#FF6961', 'שיר הבוקר', 'מתנגן עכשיו'], timer: ['sun', '#FF9F0A', 'טיימר בישול', `נשארו ${Math.max(1, Math.round((act[1] - h) * 20))} דקות`], tv: ['tv', '#BF5AF2', 'פרק 3', 'מתנגן עכשיו'] }[act[2]];
        K2.liveBig(c, W, H, { grow, icon: P[0], color: P[1], title: P[2], sub: P[3], prog: act[2] === 'nav' || act[2] === 'tv' ? u.clamp((h - act[0]) / (act[1] - act[0])) : act[2] === 'timer' ? u.clamp(1 - (h - act[0]) / (act[1] - act[0])) : null });
      }
    },
    stage(c, W, H, t, I, scr) {
      const v = I.tg, h = hoursAt(t, v), { room, ax, m } = K.room(W, H, scr);
      const sk = sky(c, W, H, h, I, room, ax, m, { arcY: 0.3, R0: 0.36 });
      u.text(c, clockOf(h), ax, sk.hy + m * 0.06, Math.max(12, m * 0.045), 'rgba(255,255,255,0.85)', 600, 'center', 'ltr');
      K.bigNumber(c, W, H, scr, String(shown(t, h, v)), 'שעות של שימוש', I, { sample: String(v.use), maxH: 0.26, y: 0.68 });
    },
  };

  /* לסבב 3: השמיים והשמש */
  L.batKit = { sky };
})();

/* ── js/scenes-r3-bat.js ── */
/* סוללה, סבב 3 (17.09.2026). יובל: «4 לגמרי מגניב, השימוש שלך בטלפון לצד היום והלילה. הביצוע פחות».
   ביקש יום עם חיוך: שעון מעורר ונודניק, «רק דקה» במיטה, ניווט לעבודה ואז גלילה במקום לעבוד,
   בלילה מכוונים שעון, סוגרים, ופותחים שוב «רק סרטון אחד». התסריט אושר בשיחה.
   הנתון: עד 23 שעות של שימוש רגיל (18 Pro, הדגם הישראלי). מ-06:30 עד 05:30 למחרת, ועדיין נשארה סוללה.
   בלי שמות של אפליקציות: הסרטונים, הפיד וההודעות נראים כמו הסוג, לא כמו מותג.
   bat-7 יום אמיתי, עם חיוך · bat-8 יומן היום · bat-9 מה עובר לו בראש */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, UI = L.ui2, BK = L.batKit;

  /* [שעות מ-06:30, מסך, שעה, מה קורה, אייקון]
     🆕 התסריט עודכן 20.09.2026: יובל בחר את הצעה 4 מהצ'אט («כמו היום, רק מהודק יותר»),
     ועוד שני תיקונים שלו: «רק דקה» ⟵ «תיכף אני קם», ו«הבוס שואל» ⟵ «הבוס לוחץ».
     🔴 זה התסריט של כל סצנות הסוללה (סבב 3 עד 5), ולא של אחת. שינוי כאן משנה את כולן. */
  const BEATS = [
    [0.0, 'alarm', '6:30', 'מצלצל', 'sun'],
    [0.15, 'alarm2', '6:39', 'נודניק. ושוב', 'sun'],
    [0.3, 'shorts', '6:48', '«תיכף אני קם»', 'tv'],
    [1.17, 'maps', '7:40', 'מאחרים, שוב', 'pin'],
    [2.5, 'feed', '9:00', 'פיד במקום דוח', 'photoWide'],
    [2.6, 'boss', '9:06', 'הבוס לוחץ', 'chat'],
    [6.5, 'lunch', '13:00', 'קודם כל תמונה', 'camera'],
    [11.5, 'music', '18:00', 'פלייליסט הביתה', 'note'],
    [14.5, 'series', '21:00', '«עוד פרק»', 'tv'],
    [16.5, 'next', '23:00', '«באמת האחרון»', 'tv'],
    [18.0, 'setAlarm', '0:30', 'שעון ל-6:30', 'sun'],
    [18.02, 'shorts2', '0:31', 'עוד סרטון', 'tv'],
    [19.17, 'off', '1:40', 'סוף סוף ישנים', 'moon'],
    [23.0, 'morning', '5:30', 'ועדיין יש סוללה', 'sun'],
  ];
  const BEAT = 0.85, DUR = BEATS.length * BEAT + 1.2;
  const beatAt = t => Math.min(BEATS.length - 1, Math.floor(Math.max(0, t) / BEAT));
  const hoursAt = t => { const i = beatAt(t), f = u.clamp((t - i * BEAT) / BEAT); return i >= BEATS.length - 1 ? BEATS[i][0] : u.lerp(BEATS[i][0], BEATS[i + 1][0], f * 0.25); };
  const clockOf = h => { const x = (6.5 + h) % 24; return `${Math.floor(x)}:${String(Math.floor((x % 1) * 60)).padStart(2, '0')}`; };
  /* הסוללה: 23 שעות מביאות ל-5%, כמו בסבב 2 */
  const levelAt = (h, v) => u.clamp(1 - (h / v.use) * 0.95);
  const BOSS = [['in', 'בוקר טוב'], ['in', 'איפה הדוח?'], ['out', 'שולח עוד רגע']];

  /* המסך של הרגע */
  /* המסך של רגע i, אחרי lt שניות בתוכו. beat: אורך רגע, כדי שסבב 4 יוכל להאט */
  const screenAt = (c, W, H, i, lt, h, v, I, beat = BEAT) => {
    const b = BEATS[i];
    const draw = (bb, tt) => {
      const key = bb[1];
      if (key === 'alarm' || key === 'alarm2') UI.alarm(c, 0, 0, W, H, tt, { time: bb[2], press: u.clamp((tt - 0.45) / 0.15), I });
      else if (key === 'shorts' || key === 'shorts2') UI.shorts(c, 0, 0, W, H, tt * 2.2 + (key === 'shorts2' ? 3 : 0));
      else if (key === 'maps') UI.maps(c, 0, 0, W, H, tt * 3);
      else if (key === 'feed') UI.feed(c, 0, 0, W, H, tt * 2);
      else if (key === 'boss') UI.chat(c, 0, 0, W, H, tt * 2.5, I, { msgs: BOSS, title: 'הבוס' });
      else if (key === 'lunch') UI.lunch(c, 0, 0, W, H, tt, { flash: u.clamp(1 - Math.abs(tt - 0.55) * 8) * 0.8 });
      else if (key === 'music') UI.music(c, 0, 0, W, H, tt * 4);
      else if (key === 'series') UI.video(c, 0, 0, W, H, tt * 2);
      else if (key === 'next') UI.nextEp(c, 0, 0, W, H, tt, { count: Math.max(1, 5 - Math.floor(tt * 5)) });
      else if (key === 'setAlarm') { UI.setAlarm(c, 0, 0, W, H, tt); if (tt > 0.55) { c.fillStyle = `rgba(3,3,4,${u.clamp((tt - 0.55) / 0.2)})`; c.fillRect(0, 0, W, H); } }
      else if (key === 'off') UI.off(c, 0, 0, W, H);
      else if (key === 'morning') UI.lock(c, 0, 0, W, H, { time: '5:30', light: 0.35, I });
    };
    draw(b, lt);
    /* מעבר קצר מהמסך הקודם */
    if (i > 0 && lt < 0.14) { c.save(); c.globalAlpha = 1 - lt / 0.14; draw(BEATS[i - 1], beat); c.restore(); }
    if (b[1] !== 'off') u.status(c, W, H, { time: clockOf(h), level: levelAt(h, v) });
    return { i, b, h };
  };
  const screen = (c, W, H, t, v, I) => { const i = beatAt(t); return screenAt(c, W, H, i, t - i * BEAT, hoursAt(t), v, I); };
  L.batKit3 = { BEATS, screenAt, clockOf, levelAt };

  /* ───────── 7 · יום אמיתי, עם חיוך ─────────
     4 מסבב 2, עם התסריט: השמיים ליד הטלפון, השעה, ומה קורה עכשיו בגדול. למטה השעות גדלות */
  S['bat-7'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const v = I.tg, i = beatAt(t), b = BEATS[i], h = hoursAt(t), { room, ax, m } = K.room(W, H, scr);
      const sk = BK.sky(c, W, H, h + 6.5 - 7, I, room, ax, m, { arcY: 0.3, R0: 0.38 });
      u.text(c, clockOf(h), ax, sk.hy + m * 0.06, Math.max(12, m * 0.045), 'rgba(255,255,255,0.8)', 600, 'center', 'ltr');
      const age = t - i * BEAT, px = Math.max(14, Math.min(m * 0.06, K2.fit(c, 'מכוונים שעון ל-6:30', room * 0.9, 99, 700)));
      c.save(); c.globalAlpha = u.clamp(age / 0.2);
      u.text(c, b[3], ax, H * 0.53, px, '#fff', 700, 'center', 'rtl');
      c.restore();
      K.bigNumber(c, W, H, scr, String(Math.round(h)), 'שעות של שימוש', I, { sample: '23', maxH: 0.2, y: 0.78 });
    },
  };

  /* ───────── 8 · יומן היום ─────────
     ליד הטלפון רשימה לפי השעה: כל רגע נכנס כשורה, הקודמים דוהים, והרשימה נגללת. למטה השעות והסוללה */
  S['bat-8'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const v = I.tg, i = beatAt(t), h = hoursAt(t), { room, m } = K.room(W, H, scr);
      /* השעה תופסת כ-3 גופנים, והמשפט מתחיל אחריה: הגופן נגזר מהרוחב שנשאר, בלי רצפה שגורמת לחיתוך (צילום 17.09) */
      const rowH = Math.max(22, H * 0.075); let fs = Math.min(rowH * 0.42, m * 0.04);
      for (let q = 0; q < 3; q++) fs = Math.min(fs, K2.fit(c, 'מכוונים שעון ל-6:30', Math.max(20, room - m * 0.04 - fs * 4.4), 99, 700));
      const listTop = H * 0.08, listBot = H * 0.7, xR = room - m * 0.02;
      /* הגלילה: השורה הנוכחית תמיד בתחתית הרשימה */
      const age = t - i * BEAT, slide = u.easeOut(u.clamp(age / 0.3));
      const yCur = listBot - rowH * 0.5;
      c.save(); c.beginPath(); c.rect(0, listTop, W, listBot - listTop); c.clip();
      for (let k = 0; k <= i; k++) {
        const y = yCur - (i - k) * rowH + (1 - slide) * rowH * (k === i ? 0.6 : 1);
        if (y < listTop - rowH || y > listBot + rowH) continue;
        const on = k === i, a = on ? u.clamp(age / 0.25) : u.clamp(1 - (i - k) * 0.16);
        c.save(); c.globalAlpha = a;
        c.fillStyle = on ? u.acc(I, 1) : 'rgba(255,255,255,0.35)'; c.beginPath(); c.arc(xR - fs * 0.3, y, Math.max(2.5, fs * 0.22), 0, Math.PI * 2); c.fill();
        u.text(c, BEATS[k][2], xR - fs * 1.0, y, fs * 0.92, on ? '#fff' : 'rgba(255,255,255,0.7)', 600, 'right', 'ltr');
        u.text(c, BEATS[k][3], xR - fs * 4.2, y, fs, on ? '#fff' : 'rgba(255,255,255,0.7)', on ? 700 : 500, 'right', 'rtl');
        c.restore();
      }
      c.restore();
      /* דהייה בראש הרשימה */
      const fg = c.createLinearGradient(0, listTop, 0, listTop + rowH * 1.5); fg.addColorStop(0, '#000'); fg.addColorStop(1, 'rgba(0,0,0,0)');
      c.fillStyle = fg; c.fillRect(0, listTop, W, rowH * 1.5);
      const px = K2.fit(c, '23', room * 0.3, H * 0.14);
      K2.pop(c, String(Math.round(h)), room * 0.7, H * 0.85, px, I, { age: 9 });
      u.text(c, 'שעות', room * 0.7, H * 0.85 + px * 0.55, Math.max(10, m * 0.034), 'rgba(255,255,255,0.6)', 500, 'center', 'rtl');
      const lv = Math.round(levelAt(h, v) * 100);
      K2.pop(c, `${lv}%`, room * 0.28, H * 0.85, px * 0.62, I, { age: 9, solid: lv < 20 ? '#FF9F0A' : '#fff' });
      u.text(c, 'סוללה', room * 0.28, H * 0.85 + px * 0.55, Math.max(10, m * 0.034), 'rgba(255,255,255,0.6)', 500, 'center', 'rtl');
    },
  };

  /* ───────── 9 · מה עובר לו בראש ─────────
     בועת מחשבה ליד הטלפון, עם המשפט של הרגע. מעליה השמש או הירח קטנים, ולמטה השעות */
  S['bat-9'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const v = I.tg, i = beatAt(t), b = BEATS[i], h = hoursAt(t), { room, ax, m } = K.room(W, H, scr);
      const x = (6.5 + h) % 24, day = x >= 6 && x < 19;
      /* שמש או ירח קטנים, ושעה */
      const sy = H * 0.12, sr = Math.max(8, m * 0.035);
      c.save();
      if (day) { c.shadowColor = 'rgba(255,214,120,0.8)'; c.shadowBlur = sr * 2; c.fillStyle = '#FFD27A'; c.beginPath(); c.arc(ax - m * 0.08, sy, sr, 0, Math.PI * 2); c.fill(); }
      else { c.fillStyle = '#E8ECF4'; c.beginPath(); c.arc(ax - m * 0.08, sy, sr, 0, Math.PI * 2); c.fill(); c.fillStyle = '#000'; c.beginPath(); c.arc(ax - m * 0.08 + sr * 0.45, sy - sr * 0.25, sr * 0.85, 0, Math.PI * 2); c.fill(); }
      c.restore();
      u.text(c, clockOf(h), ax + m * 0.06, sy, Math.max(12, m * 0.045), 'rgba(255,255,255,0.85)', 600, 'center', 'ltr');
      /* הבועה: נכנסת עם קפיצה קטנה בכל רגע */
      const age = t - i * BEAT, k = u.easeOut(u.clamp(age / 0.3)), s = u.lerp(0.85, 1, k);
      const bw = Math.min(room * 0.92, m * 0.62), bh = Math.max(56, H * 0.2), bx = ax - bw / 2, by = H * 0.3;
      c.save(); c.globalAlpha = u.clamp(age / 0.18);
      c.translate(ax, by + bh / 2); c.scale(s, s); c.translate(-ax, -(by + bh / 2));
      u.rr(c, bx, by, bw, bh, bh * 0.45, '#F4F1EC');
      /* עיגולים קטנים אל הטלפון */
      [[0.08, 0.2], [0.05, 0.12]].forEach(([dx, r], j) => { c.fillStyle = '#F4F1EC'; c.beginPath(); c.arc(bx + bw + m * (0.03 + j * 0.035), by + bh + m * (0.03 + j * 0.03), m * r * 0.25, 0, Math.PI * 2); c.fill(); });
      const fs = Math.max(9, Math.min(bh * 0.28, K2.fit(c, 'מכוונים שעון ל-6:30', bw * 0.8, 99, 700)));
      u.text(c, b[3], ax, by + bh / 2 + 1, fs, '#1C1C1E', 700, 'center', 'rtl');
      c.restore();
      K.bigNumber(c, W, H, scr, String(Math.round(h)), 'שעות של שימוש', I, { sample: '23', maxH: 0.2, y: 0.8 });
    },
  };
})();

/* ── js/scenes-r5-cam.js ── */
/* צמצם, סבב 5 (17.09.2026). יובל: «אתה חייב לבחור תמונה טובה. או שתיקח תמונה אמיתית ותעשה עליה עיבוד שממחיש
   את ההבדל באמת, או שתעשה אנימציה טובה. עדיף תמונה אמיתית, אבל תעשה עיבוד טוב».
   ⟹ צילום המדרגות של Apple (iPhone 18 Pro, הכול חד), ועליו טשטוש עדשה אמיתי לפי מפת עומק:
   · העומק: מודל Depth Anything V2 (בסיס, 1232 על 924), רץ מקומית על הצילום. הצלליות של שלושת האנשים נקיות.
   · הטשטוש: דיסק ולא גאוס, באור לינארי, בשכבות מאחור לפנים. שכבות שמאחורי הפוקוס בקונבולוציה מנורמלת,
     ולכן אין הילה כהה סביב האיש. המעקה שלפני הפוקוס מטושטש גם הוא, כמו בעדשה אמיתית.
   · רדיוס הטשטוש יחסי ל-1/N פחות 1/4. ƒ/4 = הצילום כמו שהוא. ƒ/1.48 = 36 פיקסל ברקע הרחוק (1600 רוחב).
   · שישה שלבים מוכנים מראש (img/apple/ap5), ומעבר הדרגתי ביניהם. הכלי: lab/tools/lensblur.mjs.
   🔴 Apple לא מפרסמת את אותו צילום בכמה צמצמים. דוגמאות של אתרי ביקורות אסורות (זכויות יוצרים).
   🔴 זו המחשה על צילום אמיתי, לא צילום בכל צמצם. אם הנוסח בחנות יזכיר את זה, לומר «המחשה».
   cam-13 המצלמה והמספר · cam-14 שני צמצמים באותו צילום · cam-15 שלוש זכוכיות מגדלות
   🆕 סבב 6 (20.09.2026). יובל: «אני רוצה את הבסיס של 13, איך שמוצג התמונה. אבל בין המעברים של הצמצם תעשה
   בטלפון עצמו שיהיה את האייקון של הצמצם שנפתח ונסגר, וכל פעם הוא נסגר או נפתח יותר בהתאם למצב. ובצד,
   באחד מהם היה כזה שני מדדים של אור ופוקוס ורואים את הטריידאוף ביניהם. אז אני רוצה את זה».
   ⟹ cam-13 עודכן במקום: הלהבים עברו אל פינת העינית במסך, והמספר הגדול נשאר. ליד הטלפון שני המדדים
   מ-cam-8 (סבב 3): אור שנכנס מול כמה מהתמונה חד. אחד עולה כשהשני יורד, וזה הטריידאוף. */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2;
  const YEL = '#FFD60A';
  const AP = [1.48, 1.8, 2.2, 2.8, 3.4, 4];
  /* 🔴 במעבדה הקבצים יושבים בנתיב יחסי, ובחנות הם נכסי תמה עם כתובת CDN.
     ⟹ אם המפתח קיים ב-L.A.images (הסקשן מזריק אותו), משתמשים בו. אחרת נופלים לנתיב. */
  const SRC = n => {
    const s = String(n).replace('.', '');
    const m = (L.A.images || {})[`ap5-${s}`];
    return (m && m.file) || `img/apple/ap5/ap-${s}.webp`;
  };
  /* 🔴 הטעינה המוקדמת מחכה לציור הראשון, ולא רצה בטעינת הקובץ.
     בחנות L.A.images מוזרק אחרי שהקובץ נטען, ולכן טעינה מוקדמת הייתה פונה
     לנתיב היחסי ומחזירה 404 על כל שש השכבות. נתפס בבדיקת החבילה, 20.09.2026. */
  let warmed = false;
  const warm = () => { if (warmed) return; warmed = true; AP.forEach(n => L.img(SRC(n))); };
  /* הפנים, כחלק מהצילום השלם */
  const FACE = { front: [0.378, 0.2], woman: [0.563, 0.3], back: [0.673, 0.285] };

  /* הצילום בצמצם N, במלבן (x, y, w, h). cx, cy מרכז החיתוך, zoom הגדלה מעבר ל-cover */
  const photo = (c, x, y, w, h, N, { cx = 0.5, cy = 0.5, zoom = 1 } = {}) => {
    warm();
    N = u.clamp(N, 1.48, 4);
    let i = 0;
    while (i < AP.length - 2 && N > AP[i + 1]) i++;
    const a = AP[i], b = AP[i + 1], k = u.clamp((1 / a - 1 / N) / (1 / a - 1 / b));
    const A = L.img(SRC(a)), B = L.img(SRC(b));
    c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip();
    if (!A && !B) { c.fillStyle = '#16161A'; c.fillRect(x, y, w, h); c.restore(); return; }
    c.imageSmoothingEnabled = true; c.imageSmoothingQuality = 'high';
    const put = (im, alpha) => {
      const iw = im.naturalWidth, ih = im.naturalHeight;
      let sh = ih / zoom, sw = sh * (w / h);
      if (sw > iw / zoom) { sw = iw / zoom; sh = sw * (h / w); }
      const sx = u.clamp(cx * iw - sw / 2, 0, iw - sw), sy = u.clamp(cy * ih - sh / 2, 0, ih - sh);
      c.globalAlpha = alpha; c.drawImage(im, sx, sy, sw, sh, x, y, w, h);
    };
    if (A) put(A, 1);
    if (B && (k > 0.002 || !A)) put(B, A ? k : 1);
    c.restore();
  };

  /* העצירות: פתוח לגמרי, ואז נסגר, ובסוף חוזר מהר. הלולאה נסגרת בלי קפיצה */
  /* 22.09.2026: 13 ⟵ 10.7 שנ', יובל: «צמצם גם אפשר לקצר מעט». אותו יחס בין העצירות */
  const NS = [1.48, 1.8, 2.8, 4.0, 1.48], HOLDS = [1.6, 1.2, 1.2, 1.8, 0.5], MOVE = 1.1, DUR = K2.total(HOLDS, MOVE);   /* 🔴 הוחזר 21.09.2026 למקור, 13 שנ'. יובל: «הפוקוס עוד לא טוב, תחזיר למה שהיה». הצמצם צריך זמן */
  const WORD = ['הרקע נמס, האיש חד', 'הרקע עדיין רך', 'מאחור מתחדד', 'כולם בפוקוס', 'הרקע נמס, האיש חד'];
  const stepAt = t => K2.steps(t, NS, HOLDS, MOVE);
  const labelOf = N => (N < 1.6 ? '1.48' : N.toFixed(1));
  const closeOf = N => u.clamp((N - 1.48) / (4 - 1.48));

  /* המצלמה במסך: עינית 3:4, מרכז החיתוך בין האיש לאנשים שמאחור */
  const VCX = 0.46;
  const viewfinder = (W, H) => { const vy = H * 0.12, vh = Math.min(H * 0.64, W * 1.333), vw = vh * 0.75; return { vx: (W - vw) / 2, vy, vw, vh }; };
  const faceIn = (v, f) => { const cw = 0.5625, x0 = u.clamp(VCX - cw / 2, 0, 1 - cw); return [v.vx + ((f[0] - x0) / cw) * v.vw, v.vy + f[1] * v.vh]; };
  const cameraUI = (c, W, H, I, val, { dial = false, irisRow = false } = {}) => {
    const m = Math.min(W, H), v = viewfinder(W, H);
    const [fx, fy] = faceIn(v, FACE.front), fs = v.vw * 0.2;
    K.brackets(c, fx - fs / 2, fy - fs / 2, fs, fs, YEL, Math.max(1.2, m * 0.005), fs * 0.22);
    u.status(c, W, H, { level: 0.8 });
    const y = v.vy + v.vh + (H - v.vy - v.vh) * 0.3;
    if (!dial) {
      u.text(c, 'פורטרט', W / 2, y - m * 0.03, m * 0.05, YEL, 600);
      [1.48, 1.8, 2.8, 4.0].forEach((n, k) => {
        const x = W / 2 - (1.5 - k) * W * 0.21, on = Math.abs(n - val) < 0.12;
        u.text(c, labelOf(n), x, y + m * 0.05, on ? m * 0.062 : m * 0.047, on ? YEL : 'rgba(255,255,255,0.6)', on ? 700 : 500, 'center', 'ltr');
      });
      /* במקום האות ƒ: הלהבים עצמם, נפתחים ונסגרים עם המספר (סבב 6, cam-18) */
      if (irisRow) {
        const r = m * 0.042, cx = W * 0.06, cy = y + m * 0.05;
        c.fillStyle = 'rgba(255,214,150,0.9)'; c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.fill();
        K.iris(c, cx, cy, r, u.lerp(0.95, 0.28, closeOf(val)), { blades: 6, fill: '#000', edge: 'rgba(255,255,255,0.25)', rot: 0.3 });
      } else u.text(c, 'ƒ', W * 0.06, y + m * 0.05, m * 0.056, 'rgba(255,255,255,0.8)', 600, 'center', 'ltr');
    } else {
      /* חוגה: סרגל שזז מתחת לסמן צהוב קבוע */
      const dy = y + m * 0.075, span = W * 0.9, pos = Math.log(val / 1.48) / Math.log(4 / 1.48);
      u.text(c, `ƒ ${labelOf(val)}`, W / 2, y - m * 0.02, m * 0.055, YEL, 600, 'center', 'ltr');
      c.save(); c.beginPath(); c.rect(W * 0.05, dy - m * 0.05, W * 0.9, m * 0.1); c.clip();
      for (let q = 0; q <= 40; q++) {
        const f = q / 40, x = W / 2 + (f - pos) * span * 1.6, big = q % 10 === 0;
        c.fillStyle = `rgba(255,255,255,${big ? 0.85 : 0.4})`;
        c.fillRect(x - 0.75, dy - (big ? m * 0.028 : m * 0.016), 1.5, big ? m * 0.056 : m * 0.032);
      }
      c.restore();
      const g = c.createLinearGradient(W * 0.05, 0, W * 0.95, 0); g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(0.2, 'rgba(0,0,0,0)'); g.addColorStop(0.8, 'rgba(0,0,0,0)'); g.addColorStop(1, 'rgba(0,0,0,1)');
      c.fillStyle = g; c.fillRect(W * 0.05, dy - m * 0.05, W * 0.9, m * 0.1);
      c.fillStyle = YEL; c.fillRect(W / 2 - 1, dy - m * 0.04, 2, m * 0.08);
    }
    K.shutter(c, W, H, '');
  };
  /* המספר החי, כולל בזמן מעבר */
  const liveOf = N => (N < 1.5 ? '1.48' : N.toFixed(1));
  /* הלהבים על המסך עצמו, בפינת העינית: נפתחים ונסגרים לפי המצב, ובמעבר נדלקת טבעת צהובה */
  const irisBadge = (c, W, H, val, moving, m, v) => {
    const R = m * 0.082, cx = v.vx + v.vw - R * 1.5, cy = v.vy + R * 1.55;
    c.save();
    c.fillStyle = 'rgba(0,0,0,0.5)'; c.beginPath(); c.arc(cx, cy, R * 1.32, 0, Math.PI * 2); c.fill();
    /* האור שעובר בפתח */
    const lg = c.createRadialGradient(cx, cy, 0, cx, cy, R);
    lg.addColorStop(0, 'rgba(255,226,172,0.95)'); lg.addColorStop(1, 'rgba(255,168,96,0.6)');
    c.fillStyle = lg; c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.fill();
    K.iris(c, cx, cy, R, u.lerp(0.95, 0.3, closeOf(val)), { blades: 6, fill: '#0C0C0F', edge: 'rgba(255,255,255,0.22)', rot: 0.3 });
    c.strokeStyle = moving ? YEL : 'rgba(255,255,255,0.45)'; c.lineWidth = moving ? Math.max(2, R * 0.1) : 1.5;
    c.beginPath(); c.arc(cx, cy, R * 1.2, 0, Math.PI * 2); c.stroke();
    /* המספר מתחת ללהבים, עם צל כדי שייקרא על כל צילום */
    c.shadowColor = 'rgba(0,0,0,0.8)'; c.shadowBlur = m * 0.02;
    u.text(c, `ƒ/${liveOf(val)}`, cx, cy + R * 1.75, m * 0.042, moving ? YEL : 'rgba(255,255,255,0.92)', 700, 'center', 'ltr');
    c.restore();
  };
  const camera = (c, W, H, I, val, opts = {}) => {
    c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
    const v = viewfinder(W, H);
    photo(c, v.vx, v.vy, v.vw, v.vh, val, { cx: VCX, cy: 0.5 });
    if (opts.iris) irisBadge(c, W, H, val, opts.moving, Math.min(W, H), v);
    cameraUI(c, W, H, I, val, opts);
  };

  /* שני המדדים, מ-cam-8 של סבב 3: אור שנכנס מול כמה מהתמונה חד. אחד עולה כשהשני יורד.
     האור הולך לפי 1 חלקי N בריבוע. החדות: ב-ƒ/1.48 רק האיש שמקדימה, וב-ƒ/4 כולם */
  /* 🆕 20.09.2026, הניסוח שיובל בחר: «כמות האור» ו«עומק הפוקוס».
     🔴 «חדות» ירדה מכל הגרסאות, כי היא אינה מדויקת: האיש שמקדימה חד באותה מידה בכל צמצם,
     ומה שגדל הוא כמה מהסצנה נמצא בפוקוס. זו גם הטענה של Apple, על הרקע של תמונות קבוצתיות. */
  const GAUGES = [
    ['כמות האור', 'sun', N => Math.pow(1.48 / N, 2), 'rgba(255,214,150,1)', 'rgba(255,160,90,0.85)'],
    ['עומק הפוקוס', 'photoWide', N => 0.34 + 0.66 * closeOf(N), 'rgba(200,232,255,1)', 'rgba(110,175,240,0.85)'],
  ];
  const gauges = (c, ax, room, H, m, N, I) => {
    const bw = Math.min(room * 0.84, m * 0.54), x1 = ax + bw / 2, bh = Math.max(7, m * 0.022);
    const fs = Math.max(11, Math.min(m * 0.04, K2.fit(c, 'עומק הפוקוס', bw - m * 0.1, 99, 500)));
    GAUGES.forEach(([label, icon, f, c0, c1], k) => {
      const y = H * (0.58 + k * 0.21), v = u.clamp(f(N));
      c.save(); c.strokeStyle = 'rgba(255,255,255,0.8)'; K2.icon[icon](c, x1 - m * 0.028, y - fs * 1.6, m * 0.058); c.restore();
      u.text(c, label, x1 - m * 0.07, y - fs * 1.6, fs, 'rgba(255,255,255,0.85)', 500, 'right', 'rtl');
      u.rr(c, x1 - bw, y, bw, bh, bh / 2, 'rgba(255,255,255,0.12)');
      const fw = Math.max(bh, bw * v), g = c.createLinearGradient(x1, 0, x1 - bw, 0);
      g.addColorStop(0, c0); g.addColorStop(1, c1);
      u.rr(c, x1 - fw, y, fw, bh, bh / 2, g);
    });
  };

  /* סבב 6 (scenes-r6-cam.js) משתמש בכל אלה, כדי שהצילום והמצלמה יהיו זהים בכל הגרסאות */
  L.camKit5 = { photo, viewfinder, VCX, FACE, camera, cameraUI, irisBadge, gauges, stepAt, NS, WORD, DUR, labelOf, liveOf, closeOf, YEL };

  /* ───────── 13 · המצלמה והמספר ─────────
     על המסך המצלמה על הצילום, והצמצם עובר מ-ƒ/1.48 ל-ƒ/4 וחוזר. האיש נשאר חד, והאנשים והקיר מאחור מתחדדים.
     בפינת העינית הלהבים נפתחים ונסגרים עם המספר, וליד הטלפון: המספר הגדול, מה קורה במילים, ושני המדדים */
  S['cam-13'] = {
    dur: DUR,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) { const st = stepAt(t); camera(c, W, H, I, st.val, { iris: true, moving: st.moving }); },
    stage(c, W, H, t, I, scr) {
      const st = stepAt(t), { room, ax, m } = K.room(W, H, scr);
      const px = K2.fit(c, 'ƒ/1.48', room * 0.78, H * 0.13);
      K2.pop(c, `ƒ/${labelOf(NS[st.idx])}`, ax, H * 0.22, px, I, { age: st.age });
      const fs = Math.max(12, Math.min(m * 0.05, K2.fit(c, WORD[0], room * 0.92, 99, 700)));
      c.save(); c.globalAlpha = u.clamp(st.age / 0.4);
      u.text(c, WORD[st.idx], ax, H * 0.22 + px * 0.78, fs, 'rgba(255,255,255,0.88)', 700, 'center', 'rtl');
      c.restore();
      gauges(c, ax, room, H, m, st.val, I);
    },
  };

  /* ───────── 14 · שני צמצמים באותו צילום ─────────
     קו אנכי זז לאט על המסך. מימינו ƒ/1.48 ומשמאלו ƒ/4, על אותו צילום בדיוק. האיש זהה בשני הצדדים,
     ורק מה שמאחוריו משתנה. ליד הטלפון שתי שורות: מה כל צד נותן */
  const DUR14 = 9;
  S['cam-14'] = {
    dur: DUR14,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) {
      const m = Math.min(W, H), v = viewfinder(W, H);
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      const s = u.ease(0.5 + 0.5 * Math.sin((t / DUR14) * Math.PI * 2 - Math.PI / 2)), dx = v.vx + v.vw * u.lerp(0.22, 0.9, s);
      c.save(); c.beginPath(); c.rect(dx, v.vy, v.vx + v.vw - dx, v.vh); c.clip(); photo(c, v.vx, v.vy, v.vw, v.vh, 1.48, { cx: VCX }); c.restore();
      c.save(); c.beginPath(); c.rect(v.vx, v.vy, dx - v.vx, v.vh); c.clip(); photo(c, v.vx, v.vy, v.vw, v.vh, 4.0, { cx: VCX }); c.restore();
      c.fillStyle = '#fff'; c.fillRect(dx - 1, v.vy, 2, v.vh);
      c.beginPath(); c.arc(dx, v.vy + v.vh * 0.62, m * 0.035, 0, Math.PI * 2); c.fill();
      c.fillStyle = '#000'; [-1, 1].forEach(sd => { c.beginPath(); c.moveTo(dx + sd * m * 0.012, v.vy + v.vh * 0.62 - m * 0.012); c.lineTo(dx + sd * m * 0.024, v.vy + v.vh * 0.62); c.lineTo(dx + sd * m * 0.012, v.vy + v.vh * 0.62 + m * 0.012); c.fill(); });
      u.pill(c, 'ƒ/4', v.vx + m * 0.08, v.vy + m * 0.06, m * 0.045, '#000', YEL, 'ltr');
      u.pill(c, 'ƒ/1.48', v.vx + v.vw - m * 0.1, v.vy + m * 0.06, m * 0.045, '#000', YEL, 'ltr');
      u.status(c, W, H, { level: 0.8 });
      const y = v.vy + v.vh + (H - v.vy - v.vh) * 0.3;
      u.text(c, 'פורטרט', W / 2, y - m * 0.03, m * 0.05, YEL, 600);
      K.shutter(c, W, H, '');
    },
    stage(c, W, H, t, I, scr) {
      const { room, m } = K.room(W, H, scr);
      const rows = [['ƒ/1.48', 'יותר אור', 'רקע רך, לפורטרט', 0.95], ['ƒ/4', 'פחות אור', 'כולם בפוקוס', 0.36]];
      const R = Math.min(room * 0.13, H * 0.075), tw = room - R * 2.6 - m * 0.05, fs = Math.min(m * 0.042, ...rows.map(r => K2.fit(c, r[2], tw, 99, 700)));
      rows.forEach(([n, l1, l2, open], k) => {
        const cy = H * (0.3 + k * 0.34), cx = room - R - m * 0.03;
        c.fillStyle = '#1A1A20'; c.beginPath(); c.arc(cx, cy, R * 1.08, 0, Math.PI * 2); c.fill();
        c.fillStyle = 'rgba(255,190,120,0.75)'; c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.fill();
        K.iris(c, cx, cy, R, open, { blades: 6, fill: '#101014', rot: 0.3 });
        const tx = cx - R * 1.6;
        u.text(c, n, tx, cy - fs * 1.2, fs * 1.5, YEL, 700, 'right', 'ltr');
        u.text(c, l1, tx, cy + fs * 0.3, fs, '#fff', 700, 'right', 'rtl');
        u.text(c, l2, tx, cy + fs * 1.6, fs, 'rgba(255,255,255,0.72)', 500, 'right', 'rtl');
      });
    },
  };

  /* ───────── 15 · שלוש זכוכיות מגדלות ─────────
     על המסך המצלמה עם חוגה שזזה לאט, ברצף, מ-ƒ/1.48 ל-ƒ/4 וחזרה. ליד הטלפון שלושה עיגולים מגדילים:
     האיש שמקדימה, האישה והאיש שמאחור. הראשון חד תמיד, והשניים שמאחור מתחדדים ככל שהמספר עולה */
  const DUR15 = 10;
  const val15 = t => 1.48 * Math.pow(4 / 1.48, u.ease(0.5 - 0.5 * Math.cos(u.clamp((t - 0.6) / (DUR15 - 1.2)) * Math.PI * 2)));
  const LOUPES = [['front', 'האיש מקדימה'], ['woman', 'האישה'], ['back', 'מאחור']];
  S['cam-15'] = {
    dur: DUR15,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) { camera(c, W, H, I, val15(t), { dial: true }); },
    stage(c, W, H, t, I, scr) {
      const N = val15(t), { room, m } = K.room(W, H, scr);
      const R = Math.min(room * 0.2, H * 0.12), cx = room - R - m * 0.04;
      const fs = Math.min(m * 0.04, ...LOUPES.map(l => K2.fit(c, l[1], Math.max(30, cx - R * 1.4 - m * 0.02), 99, 700)));
      LOUPES.forEach(([key, name], k) => {
        const cy = H * (0.2 + k * 0.28), f = FACE[key];
        c.save(); c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.clip();
        photo(c, cx - R, cy - R, R * 2, R * 2, N, { cx: f[0], cy: f[1] + 0.02, zoom: 7 });
        c.restore();
        const sharp = key === 'front' || N > 3.3;
        c.strokeStyle = sharp ? YEL : 'rgba(255,255,255,0.5)'; c.lineWidth = sharp ? 2.5 : 1.5;
        c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.stroke();
        u.text(c, name, cx - R * 1.3, cy - fs * 0.55, fs, '#fff', 700, 'right', 'rtl');
        u.text(c, key === 'front' ? 'חד תמיד' : sharp ? 'חד' : 'רך', cx - R * 1.3, cy + fs * 0.75, fs * 0.9, sharp ? YEL : 'rgba(255,255,255,0.6)', 500, 'right', 'rtl');
      });
      const px = K2.fit(c, 'ƒ/1.48', room * 0.6, H * 0.08);
      u.text(c, `ƒ/${labelOf(N)}`, room / 2, H * 0.92, px, YEL, 700, 'center', 'ltr');
    },
  };
})();

/* ── js/scenes-r4-vid.js ── */
/* וידאו, סבב 4 (17.09.2026). יובל: «זה לא נראה טוב. אולי צריך לחשוב על כל החלק הזה מהתחלה. מה אנחנו רוצים להראות?
   שהווידאו איכותי. למה? כי יש הרבה תמונות בשנייה. ואיך מדגימים את זה? צריך לחשוב».
   ⟹ מה 120 תמונות בשנייה נותנות בפועל: רגע מהיר שאפשר להאט, והוא נשאר חלק. בלי נקודות, פינקס או ציר.
   רגע אחד יפה ומוכר: תות נופל לכוס מים. בזמן אמת זו חצי שנייה, ואי אפשר לראות כלום. לאט רואים כל טיפה.
   הנתון: 4K ב-120 פריימים בשנייה (data.js). ההשוואה ל«וידאו רגיל» היא 30 בשנייה, בלי שם של טלפון.
   🔴 בלי הבהוב: ההתזה זזה, והתמונה לא מהבהבת (WCAG 2.3.1).
   vid-10 רגע אחד, בהילוך איטי · vid-11 איטי וחלק מול איטי וקופץ · vid-12 עוצרים בשיא */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2;
  const TI = 0.3;          // רגע הפגיעה במים, בשניות של האירוע
  const EVENT = 1.0;       // אורך האירוע כולו

  /* ── הגאומטריה, כחלק מהמלבן ── */
  const G = { cx: 0.5, yb: 0.84, gh: 0.46, topW: 0.25, botW: 0.205, level: 0.6 };
  const rng = u.rnd(19);
  const DROPS = Array.from({ length: 54 }, () => {
    const a = -Math.PI / 2 + (rng() - 0.5) * 2.3, sp = 0.55 + rng() * 1.25;
    return { vx: Math.cos(a) * sp * 0.55, vy: Math.sin(a) * sp * 1.05, r: 0.0035 + rng() * 0.009, d: rng() * 0.05, ox: (rng() - 0.5) * 0.12 };
  });
  const BUBBLES = Array.from({ length: 24 }, () => ({ t0: TI + rng() * 0.45, ox: (rng() - 0.5) * 0.14, oy: rng() * 0.08, r: 0.004 + rng() * 0.009, sp: 0.22 + rng() * 0.28, wob: rng() * 6 }));
  const SEEDS = Array.from({ length: 16 }, () => [(rng() - 0.5) * 0.7, (rng() - 0.3) * 0.75]);

  const strawberry = (c, x, y, s, rot) => {
    c.save(); c.translate(x, y); c.rotate(rot);
    c.beginPath();
    c.moveTo(0, -s * 0.36);
    c.bezierCurveTo(s * 0.34, -s * 0.52, s * 0.62, -s * 0.3, s * 0.5, s * 0.08);
    c.bezierCurveTo(s * 0.42, s * 0.34, s * 0.14, s * 0.58, 0, s * 0.64);
    c.bezierCurveTo(-s * 0.14, s * 0.58, -s * 0.42, s * 0.34, -s * 0.5, s * 0.08);
    c.bezierCurveTo(-s * 0.62, -s * 0.3, -s * 0.34, -s * 0.52, 0, -s * 0.36);
    const g = c.createRadialGradient(-s * 0.18, -s * 0.12, s * 0.05, 0, 0, s * 0.7);
    g.addColorStop(0, '#FF6B6B'); g.addColorStop(0.55, '#E3263A'); g.addColorStop(1, '#8E0E22');
    c.fillStyle = g; c.fill();
    c.fillStyle = 'rgba(255,255,255,0.22)'; c.beginPath(); c.ellipse(-s * 0.22, -s * 0.12, s * 0.08, s * 0.16, 0.4, 0, Math.PI * 2); c.fill();
    SEEDS.forEach(([fx, fy]) => { if (Math.abs(fx) < 0.52 - fy * 0.3) { c.fillStyle = '#FFD86B'; c.beginPath(); c.ellipse(fx * s * 0.8, fy * s * 0.75, s * 0.018, s * 0.03, fx, 0, Math.PI * 2); c.fill(); } });
    /* העלים */
    c.fillStyle = '#2E9E4F';
    for (let k = 0; k < 6; k++) { const a = -Math.PI / 2 + (k - 2.5) * 0.5; c.beginPath(); c.moveTo(0, -s * 0.36); c.quadraticCurveTo(Math.cos(a - 0.3) * s * 0.3, -s * 0.36 + Math.sin(a - 0.3) * s * 0.18, Math.cos(a) * s * 0.36, -s * 0.36 + Math.sin(a) * s * 0.14 - s * 0.04); c.quadraticCurveTo(Math.cos(a + 0.3) * s * 0.2, -s * 0.36 + Math.sin(a + 0.3) * s * 0.1, 0, -s * 0.36); c.fill(); }
    c.fillStyle = '#1F7A3A'; c.fillRect(-s * 0.02, -s * 0.52, s * 0.04, s * 0.16);
    c.restore();
  };

  /* הרגע ב-tau שניות מתחילת האירוע, במלבן (x, y, w, h). zoom מגדיל סביב (fx, fy) */
  const splash = (c, x, y, w, h, tau, { zoom = 1, fx = 0.5, fy = 0.5 } = {}) => {
    c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip();
    c.translate(x, y);
    if (zoom !== 1) { c.translate(fx * w, fy * h); c.scale(zoom, zoom); c.translate(-fx * w, -fy * h); }
    const U = Math.min(w, h * 0.75);
    const cx = G.cx * w, yb = G.yb * h, gh = G.gh * h, yt = yb - gh, tw = G.topW * U * 1.6, bw = G.botW * U * 1.6;
    const yw = yb - gh * G.level, ww = u.lerp(bw, tw, G.level), ery = ww * 0.16;
    /* רקע: סטודיו כהה עם אור מאחור */
    const bg = c.createRadialGradient(cx, h * 0.42, 0, cx, h * 0.42, h * 0.75);
    bg.addColorStop(0, '#2E3542'); bg.addColorStop(0.5, '#141820'); bg.addColorStop(1, '#07080B');
    c.fillStyle = bg; c.fillRect(-w, -h, w * 3, h * 3);
    const tb = c.createLinearGradient(0, yb, 0, h); tb.addColorStop(0, '#20242C'); tb.addColorStop(1, '#0B0C10');
    c.fillStyle = tb; c.fillRect(-w, yb - ery * 0.2, w * 3, h * 2);
    c.fillStyle = 'rgba(0,0,0,0.45)'; c.beginPath(); c.ellipse(cx, yb + ery * 0.2, bw * 1.15, ery * 1.1, 0, 0, Math.PI * 2); c.fill();
    const dt = tau - TI;
    /* התות */
    let sy, rot = -0.3 + tau * 1.2;
    if (tau < TI) sy = u.lerp(-h * 0.12, yw, (tau / TI) * (tau / TI));
    else sy = yw + gh * 0.36 * (1 - Math.exp(-dt * 5));
    const sx = cx + w * 0.01, s = U * 0.2;
    /* המים: גוף הכוס מתחת לפני המים */
    const wall = f => ({ l: cx - u.lerp(bw, tw, f), r: cx + u.lerp(bw, tw, f) });
    const waterPath = () => { c.beginPath(); c.moveTo(wall(G.level).l, yw); c.lineTo(wall(0).l, yb); c.ellipse(cx, yb, bw, ery * 0.9, 0, Math.PI, 0, true); c.lineTo(wall(G.level).r, yw); c.ellipse(cx, yw, ww, ery, 0, 0, Math.PI, true); c.closePath(); };
    waterPath();
    const wg = c.createLinearGradient(0, yw, 0, yb); wg.addColorStop(0, 'rgba(130,190,240,0.22)'); wg.addColorStop(1, 'rgba(60,120,190,0.42)');
    c.fillStyle = wg; c.fill();
    /* מתחת למים: התות ובועות */
    if (tau >= TI) {
      c.save(); waterPath(); c.clip();
      strawberry(c, sx, sy, s, rot);
      c.fillStyle = 'rgba(70,130,200,0.28)'; c.fillRect(cx - tw, yw, tw * 2, gh);
      BUBBLES.forEach(b => {
        const bt = tau - b.t0; if (bt < 0) return;
        const by = u.lerp(yw + gh * 0.3, yw, 0) + gh * (0.08 + b.oy) + Math.min(gh * 0.3, 0) - bt * b.sp * h;
        const bx = cx + b.ox * w + Math.sin(bt * 12 + b.wob) * U * 0.008;
        if (by < yw + ery * 0.2) return;
        c.strokeStyle = 'rgba(230,245,255,0.75)'; c.lineWidth = Math.max(0.8, U * 0.003); c.beginPath(); c.arc(bx, by, b.r * U, 0, Math.PI * 2); c.stroke();
        c.fillStyle = 'rgba(255,255,255,0.5)'; c.beginPath(); c.arc(bx - b.r * U * 0.3, by - b.r * U * 0.3, b.r * U * 0.25, 0, Math.PI * 2); c.fill();
      });
      c.restore();
    }
    /* פני המים וגלים */
    c.fillStyle = 'rgba(190,225,255,0.22)'; c.beginPath(); c.ellipse(cx, yw, ww, ery, 0, 0, Math.PI * 2); c.fill();
    c.strokeStyle = 'rgba(220,240,255,0.45)'; c.lineWidth = Math.max(1, U * 0.003); c.beginPath(); c.ellipse(cx, yw, ww, ery, 0, 0, Math.PI * 2); c.stroke();
    if (dt > 0) {
      c.save(); c.beginPath(); c.ellipse(cx, yw, ww, ery, 0, 0, Math.PI * 2); c.clip();
      for (let k = 0; k < 3; k++) { const rt = dt - k * 0.1; if (rt <= 0) continue; const rr = rt * ww * 1.6; c.strokeStyle = `rgba(230,245,255,${0.5 * u.clamp(1 - rt * 1.3)})`; c.lineWidth = Math.max(1, U * 0.004); c.beginPath(); c.ellipse(sx, yw, rr, rr * 0.16, 0, 0, Math.PI * 2); c.stroke(); }
      c.restore();
    }
    /* הכתר: קיר מים שעולה סביב נקודת הפגיעה ונופל */
    const cp = u.clamp(dt / 0.34);
    if (dt > 0 && cp < 1) {
      const rc = U * (0.06 + 0.13 * Math.pow(cp, 0.6)), hc = h * 0.13 * Math.sin(Math.PI * cp), n = 64;
      const pt = (th, top) => { const spike = Math.pow(Math.abs(Math.cos(th * 4.5)), 10); return [sx + Math.cos(th) * rc * (top ? 1.18 : 1), yw + Math.sin(th) * rc * 0.2 - (top ? hc * (0.7 + 0.45 * spike) : 0)]; };
      const half = (a0, a1, alpha) => {
        c.beginPath();
        for (let k = 0; k <= n; k++) { const th = u.lerp(a0, a1, k / n), p = pt(th, true); k ? c.lineTo(...p) : c.moveTo(...p); }
        for (let k = n; k >= 0; k--) { const th = u.lerp(a0, a1, k / n); c.lineTo(...pt(th, false)); }
        c.closePath();
        const cg = c.createLinearGradient(0, yw - hc, 0, yw); cg.addColorStop(0, `rgba(235,248,255,${alpha})`); cg.addColorStop(1, `rgba(140,200,245,${alpha * 0.5})`);
        c.fillStyle = cg; c.fill();
      };
      half(Math.PI, Math.PI * 2, 0.35);
      if (tau < TI + 0.08) strawberry(c, sx, sy, s, rot);
      half(0, Math.PI, 0.55);
    }
    if (tau < TI) strawberry(c, sx, sy, s, rot);
    /* הטיפות */
    DROPS.forEach(d => {
      const t = dt - d.d; if (t <= 0 || dt > 0.9) return;
      const px = sx + d.ox * U + d.vx * U * t * 1.9, py = yw - U * 0.02 + d.vy * h * t + 0.5 * 2.6 * h * t * t;
      if (t > 0.04 && py > yw && Math.abs(px - cx) < ww) return;
      if (py > yb) return;
      const r = d.r * U, dg = c.createRadialGradient(px - r * 0.3, py - r * 0.3, 0, px, py, r);
      dg.addColorStop(0, 'rgba(255,255,255,0.95)'); dg.addColorStop(0.5, 'rgba(190,225,255,0.8)'); dg.addColorStop(1, 'rgba(110,170,230,0.55)');
      c.fillStyle = dg; c.beginPath(); c.arc(px, py, r, 0, Math.PI * 2); c.fill();
    });
    /* הזכוכית: שפה, דפנות מבריקות ותחתית עבה */
    c.strokeStyle = 'rgba(255,255,255,0.28)'; c.lineWidth = Math.max(1, U * 0.004);
    c.beginPath(); c.ellipse(cx, yt, tw, tw * 0.16, 0, 0, Math.PI * 2); c.stroke();
    c.beginPath(); c.moveTo(cx - tw, yt); c.lineTo(cx - bw, yb); c.moveTo(cx + tw, yt); c.lineTo(cx + bw, yb); c.stroke();
    const hl = c.createLinearGradient(0, yt, 0, yb); hl.addColorStop(0, 'rgba(255,255,255,0.55)'); hl.addColorStop(0.5, 'rgba(255,255,255,0.12)'); hl.addColorStop(1, 'rgba(255,255,255,0.4)');
    c.strokeStyle = hl; c.lineWidth = Math.max(1.5, U * 0.012); c.lineCap = 'round';
    c.beginPath(); c.moveTo(cx - tw * 0.82, yt + gh * 0.08); c.lineTo(cx - bw * 0.82, yb - gh * 0.1); c.stroke();
    c.lineWidth = Math.max(1, U * 0.005); c.beginPath(); c.moveTo(cx + tw * 0.86, yt + gh * 0.12); c.lineTo(cx + bw * 0.86, yb - gh * 0.3); c.stroke();
    c.fillStyle = 'rgba(200,225,255,0.14)'; c.beginPath(); c.ellipse(cx, yb, bw, ery * 0.9, 0, 0, Math.PI * 2); c.fill();
    c.strokeStyle = 'rgba(255,255,255,0.3)'; c.lineWidth = Math.max(1, U * 0.004); c.beginPath(); c.ellipse(cx, yb, bw, ery * 0.9, 0, 0, Math.PI); c.stroke();
    c.restore();
  };
  L.splashKit = { splash };

  /* ממשק צילום מינימלי מעל הסצנה */
  const recUI = (c, W, H, t, { label = '4K · 120', rec = true, pill = '', pillCol = '#FFD60A' } = {}) => {
    const m = Math.min(W, H);
    u.status(c, W, H, { level: 0.8 });
    u.pill(c, label, W * 0.2, H * 0.085, m * 0.04, '#fff', 'rgba(0,0,0,0.55)', 'ltr');
    if (rec) { u.rr(c, W * 0.66, H * 0.085 - m * 0.04, m * 0.3, m * 0.08, m * 0.04, '#FF3B30'); u.text(c, `00:00:${String(Math.floor(t)).padStart(2, '0')}`, W * 0.66 + m * 0.15, H * 0.085, m * 0.038, '#fff', 600, 'center', 'ltr'); }
    if (pill) u.pill(c, pill, W / 2, H * 0.9, m * 0.05, '#000', pillCol, 'rtl');
  };

  /* ───────── 10 · רגע אחד, בהילוך איטי ─────────
     קודם במהירות אמיתית: חצי שנייה, והכול נגמר. אחר כך אותו רגע פי 4 לאט, וכל טיפה נראית.
     ליד הטלפון: «×1», ואז «×4 לאט», ומתחת המשפט */
  const T10 = { real0: 0.4, real1: 1.4, slow0: 2.3, slow1: 6.3, end: 7.2 };
  const tau10 = t => (t < T10.real0 ? 0 : t < T10.real1 ? t - T10.real0 : t < T10.slow0 ? EVENT : t < T10.slow1 ? (t - T10.slow0) / 4 : EVENT);
  const phase10 = t => (t < T10.real1 + 0.2 ? 'real' : t < T10.slow0 ? 'gap' : 'slow');
  S['vid-10'] = {
    dur: T10.end,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      const ph = phase10(t), tau = ph === 'gap' ? (t < T10.slow0 - 0.25 ? EVENT : 0) : tau10(t);
      splash(c, 0, 0, W, H, tau);
      if (ph === 'real') recUI(c, W, H, t, { rec: true });
      else recUI(c, W, H, t, { rec: false, label: '4K · 120', pill: ph === 'slow' ? 'הילוך איטי' : '' });
      if (ph === 'gap') { c.fillStyle = `rgba(0,0,0,${u.clamp(1 - Math.abs(t - (T10.slow0 - 0.25)) / 0.25) * 0.9})`; c.fillRect(0, 0, W, H); }
    },
    stage(c, W, H, t, I, scr) {
      const ph = phase10(t), { room, ax, m } = K.room(W, H, scr);
      const px = K2.fit(c, '×4', room * 0.5, H * 0.2);
      const slow = ph === 'slow';
      K2.pop(c, slow ? '×4' : '×1', ax, H * 0.4, px, I, { age: slow ? t - T10.slow0 : t });
      const l1 = slow ? 'אותו רגע, פי 4 לאט' : 'במהירות אמיתית', l2 = slow ? 'וכל טיפה נראית' : 'חצי שנייה, ונגמר';
      const fs = Math.min(m * 0.055, K2.fit(c, 'אותו רגע, פי 4 לאט', room * 0.88, 99, 700));
      u.text(c, l1, ax, H * 0.4 + px * 0.7, fs, '#fff', 700, 'center', 'rtl');
      u.text(c, l2, ax, H * 0.4 + px * 0.7 + fs * 1.35, fs * 0.9, 'rgba(255,255,255,0.7)', 500, 'center', 'rtl');
      const a = u.clamp((t - T10.slow0 - 1.2) / 0.5);
      if (a > 0) { c.save(); c.globalAlpha = a; const f2 = Math.min(m * 0.045, K2.fit(c, '120 תמונות בכל שנייה', room * 0.88, 99, 700)); u.text(c, '120 תמונות בכל שנייה', ax, H * 0.84, f2, u.acc(I, 1), 700, 'center', 'rtl'); c.restore(); }
    },
  };

  /* ───────── 11 · איטי וחלק, מול איטי וקופץ ─────────
     שני הצגות של אותו רגע, שתיהן פי 4 לאט. בטלפון מ-120 תמונות בשנייה: זורם.
     ליד הטלפון, בחלון קטן, מ-30 תמונות בשנייה: כל תמונה נשארת על המסך יותר זמן, וההתזה קופצת */
  const T11 = { s0: 0.4, s1: 4.4, end: 5.4 };
  const tau11 = t => u.clamp((t - T11.s0) / (T11.s1 - T11.s0)) * EVENT;
  S['vid-11'] = {
    dur: T11.end,
    shift: 0.24,
    draw(c, W, H, t, side, I) {
      splash(c, 0, 0, W, H, tau11(t));
      recUI(c, W, H, t, { rec: false, label: '120 בשנייה', pill: 'חלק' });
    },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr);
      const cw = Math.min(room * 0.9, H * 0.5), ch = cw * 1.2, cx = ax - cw / 2, cy = H * 0.43 - ch / 2;
      const tau = Math.floor(tau11(t) * 30) / 30;
      c.save(); c.beginPath(); c.roundRect(cx, cy, cw, ch, cw * 0.06); c.clip();
      splash(c, cx, cy, cw, ch, tau);
      c.restore();
      c.strokeStyle = 'rgba(255,255,255,0.25)'; c.lineWidth = 1; c.beginPath(); c.roundRect(cx, cy, cw, ch, cw * 0.06); c.stroke();
      const fs = Math.min(m * 0.05, K2.fit(c, '30 תמונות בשנייה', cw, 99, 700));
      u.text(c, '30 תמונות בשנייה', ax, cy - fs * 1.1, fs, '#fff', 700, 'center', 'rtl');
      u.pill(c, 'קופץ', ax, cy + ch + fs * 1.4, fs * 0.9, '#fff', 'rgba(255,69,58,0.9)', 'rtl');
      u.text(c, 'שניהם פי 4 לאט', ax, cy + ch + fs * 3.3, fs * 0.9, 'rgba(255,255,255,0.7)', 500, 'center', 'rtl');
    },
  };

  /* ───────── 12 · עוצרים בשיא ─────────
     ההילוך האיטי נעצר בדיוק כשהכתר בשיא. המסך מתקרב אל הטיפות, מחכה, וחוזר. אחר כך ממשיך */
  const TP = TI + 0.13;
  const T12 = { s0: 0.4, pause: 0.4 + TP * 4, resume: 0.4 + TP * 4 + 2.8 };
  T12.end = T12.resume + (EVENT - TP) * 4 + 0.7;
  const tau12 = t => (t < T12.s0 ? 0 : t < T12.pause ? (t - T12.s0) / 4 : t < T12.resume ? TP : Math.min(EVENT, TP + (t - T12.resume) / 4));
  const zoom12 = t => { const a = u.ease(u.clamp((t - T12.pause - 0.25) / 0.6)), b = u.ease(u.clamp((t - T12.resume + 0.75) / 0.6)); return 1 + 1.8 * a * (1 - b); };
  S['vid-12'] = {
    dur: T12.end,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      const z = zoom12(t), paused = t >= T12.pause && t < T12.resume;
      splash(c, 0, 0, W, H, tau12(t), { zoom: z, fx: 0.5, fy: 0.46 });
      recUI(c, W, H, t, { rec: false, label: '4K · 120', pill: paused ? 'עצירה' : 'הילוך איטי', pillCol: paused ? '#fff' : '#FFD60A' });
    },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), paused = t >= T12.pause && t < T12.resume;
      const a = paused ? u.clamp((t - T12.pause) / 0.3) : 0;
      const fs = Math.min(m * 0.06, K2.fit(c, 'יש תמונה בדיוק ברגע', room * 0.88, 99, 700));
      c.save(); c.globalAlpha = 1 - a;
      u.text(c, 'הילוך איטי', ax, H * 0.46, fs, '#fff', 700, 'center', 'rtl');
      c.restore();
      if (a > 0) {
        c.save(); c.globalAlpha = a;
        const px = K2.fit(c, '120', room * 0.6, H * 0.16);
        K2.pop(c, '120', ax, H * 0.36, px, I, { age: t - T12.pause });
        u.text(c, 'תמונות בכל שנייה', ax, H * 0.36 + px * 0.62, fs * 0.8, 'rgba(255,255,255,0.72)', 500, 'center', 'rtl');
        u.text(c, 'יש תמונה בדיוק ברגע', ax, H * 0.36 + px * 0.62 + fs * 1.6, fs, '#fff', 700, 'center', 'rtl');
        c.restore();
      }
    },
  };
})();

/* ── js/scenes-r4-chip.js ── */
/* מהירות, סבב 4 (17.09.2026). יובל: «אולי להראות טלפון שנפתחים בו הרבה דברים במהירות. משחק, ואז סרטים, ואז תמונות וכו'.
   ולקראת הסוף לכתוב משהו על המהירות. תהיה יצרתי».
   ⟹ שלוש דרכים להראות רצף מהיר של אפליקציות כבדות, והמשפט רק בסוף. בלי מותגים: כל אפליקציה נראית כמו הסוג.
   🔴 בלי מספרים של זמן טעינה: Apple לא מפרסמת כאלה. המשפט בסוף הוא המחשה.
   chip-10 נפתח מהאייקון · chip-11 מחליף האפליקציות · chip-12 החלקה בין אפליקציות */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, UI = L.ui2;

  /* [מפתח, שם, אייקון, צבע] */
  const APPS = [
    ['photos', 'תמונות', 'photoWide', '#E9A23B'],
    ['maps', 'מפות', 'pin', '#2FA85A'],
    ['music', 'מוזיקה', 'note', '#E8365D'],
    ['camera', 'מצלמה', 'camera', '#6E6E76'],
    ['video', 'סרטים', 'tv', '#C9243D'],
    ['shorts', 'סרטונים', 'film', '#3A3A44'],
    ['editor', 'עריכת וידאו', 'film', '#5E5CE6'],
    ['game', 'משחק', 'game', '#F26B3A'],
  ];
  const drawApp = (key, c, x, y, w, h, t, I) => {
    if (key === 'photos') UI.photos(c, x, y, w, h, t * 1.5);
    else if (key === 'maps') UI.maps(c, x, y, w, h, t * 3);
    else if (key === 'music') UI.music(c, x, y, w, h, t * 4);
    else if (key === 'camera') UI.camera(c, x, y, w, h, t);
    else if (key === 'video') UI.video(c, x, y, w, h, t * 2);
    else if (key === 'shorts') UI.shorts(c, x, y, w, h, t * 2.2);
    else if (key === 'editor') UI.editor(c, x, y, w, h, t, { I });
    else UI.game(c, x, y, w, h, t * 1.4);
  };
  const appIcon = (c, x, y, s, app, press = 0) => {
    u.rr(c, x, y, s, s, s * 0.24, app[3]);
    const g = c.createLinearGradient(0, y, 0, y + s); g.addColorStop(0, 'rgba(255,255,255,0.18)'); g.addColorStop(1, 'rgba(0,0,0,0.12)');
    u.rr(c, x, y, s, s, s * 0.24, g);
    c.strokeStyle = '#fff'; K2.icon[app[2]](c, x + s / 2, y + s / 2, s * 0.55);
    if (press > 0) u.rr(c, x, y, s, s, s * 0.24, `rgba(0,0,0,${0.35 * press})`);
  };
  /* אותה גאומטריה של UI.home עם ווידג'ט: שתי השורות הראשונות הן שמונה האפליקציות שלנו */
  const iconRect = (W, H, idx) => {
    const iw = W * 0.16, gx = (W - iw * 4) / 5, wh = iw * 2 + gx, top = H * 0.1 + wh + gx * 1.4, r = Math.floor(idx / 4), k = idx % 4;
    return { x: W - gx - (k + 1) * iw - k * gx, y: top + r * (iw + gx * 1.5), s: iw };
  };
  const homeBar = (c, W, H, dx = 0) => u.rr(c, W * 0.35 + dx, H * 0.975, W * 0.3, Math.max(3, H * 0.006), 3, 'rgba(255,255,255,0.75)');
  /* המשפט בסוף: שם השבב גדול, ומתחתיו משפט אחד */
  const endCard = (c, W, H, scr, I, a, lines) => {
    if (a <= 0) return;
    const { room, ax, m } = K.room(W, H, scr);
    c.save(); c.globalAlpha = a;
    const px = K2.fit(c, 'A20 Pro', room * 0.86, H * 0.13);
    K2.pop(c, 'A20 Pro', ax, H * 0.42, px, I, { age: a * 0.4 });
    /* שורה או שתיים, בגודל אחד שנכנס ברוחב */
    const fs = Math.min(m * 0.06, ...lines.map(l => K2.fit(c, l, room * 0.88, 99, 700)));
    lines.forEach((l, k) => u.text(c, l, ax, H * 0.42 + px * 0.72 + k * fs * 1.3, fs, '#fff', 700, 'center', 'rtl'));
    c.restore();
  };

  /* סבב 5 משתמש בהם (scenes-r5-chip.js) */
  L.chipKit4 = { APPS, drawApp, appIcon, homeBar, endCard };

  /* ───────── 10 · נפתח מהאייקון ─────────
     מסך הבית. כל אפליקציה גדלה מהאייקון שלה למסך מלא, רצה רגע, וחוזרת. הקצב מאיץ.
     המשחק נפתח אחרון ונשאר. ליד הטלפון האייקונים שנפתחו מצטרפים, ובסוף המשפט */
  const INTRO = 0.7, SEG10 = [1.5, 1.28, 1.1, 0.95, 0.84, 0.75, 0.68, 3.2];
  const ST10 = SEG10.reduce((a, s, i) => (a.push(i ? a[i - 1] + SEG10[i - 1] : INTRO), a), []);
  const DUR10 = ST10[ST10.length - 1] + SEG10[SEG10.length - 1];
  const at10 = t => {
    let i = -1;
    for (let k = 0; k < ST10.length; k++) if (t >= ST10[k]) i = k;
    if (i < 0) return { i: -1, lt: 0, press: 0, frac: 0 };
    const lt = t - ST10[i], last = i === APPS.length - 1;
    const open = u.ease(u.clamp((lt - 0.1) / 0.26)), close = last ? 0 : u.ease(u.clamp((lt - (SEG10[i] - 0.24)) / 0.24));
    return { i, lt, press: lt < 0.18 ? u.clamp(lt / 0.08) : 0, frac: open * (1 - close) };
  };
  S['chip-10'] = {
    dur: DUR10,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      const st = at10(t);
      UI.home(c, 0, 0, W, H, { I, level: 0.82 });
      APPS.forEach((a, k) => { const r = iconRect(W, H, k); appIcon(c, r.x, r.y, r.s, a, k === st.i && st.frac < 0.05 ? st.press : 0); });
      if (st.i >= 0 && st.frac > 0.001) {
        const app = APPS[st.i], r = iconRect(W, H, st.i), f = st.frac;
        const rx = u.lerp(r.x, 0, f), ry = u.lerp(r.y, 0, f), rw = u.lerp(r.s, W, f), rh = u.lerp(r.s, H, f), rad = u.lerp(r.s * 0.24, W * 0.04, f);
        c.save(); c.beginPath(); c.roundRect(rx, ry, rw, rh, rad); c.clip();
        c.translate(rx, ry); c.scale(rw / W, rh / H);
        drawApp(app[0], c, 0, 0, W, H, st.lt, I);
        c.restore();
        /* צבע האייקון דועך בתחילת הפתיחה, כמו ב-iOS */
        if (f < 0.6) { c.save(); c.beginPath(); c.roundRect(rx, ry, rw, rh, rad); c.clip(); c.fillStyle = app[3]; c.globalAlpha = 1 - f / 0.6; c.fillRect(rx, ry, rw, rh); c.restore(); }
      }
      u.status(c, W, H, { level: 0.82 });
      homeBar(c, W, H);
    },
    stage(c, W, H, t, I, scr) {
      const st = at10(t), { room, ax, m } = K.room(W, H, scr);
      const endA = u.clamp((t - (ST10[7] + 0.9)) / 0.6);
      /* המגש: שורה של ארבעה, שתי שורות */
      const s = Math.min(room * 0.17, H * 0.1), gap = s * 0.35, gw = s * 4 + gap * 3, x0 = ax + gw / 2, y0 = H * 0.36;
      c.save(); c.globalAlpha = 1 - endA;
      const n = st.i < 0 ? 0 : st.i + (st.lt > 0.12 ? 1 : 0);
      u.text(c, 'נפתחו', ax, y0 - s * 0.9, Math.max(12, m * 0.042), 'rgba(255,255,255,0.7)', 600, 'center', 'rtl');
      APPS.forEach((a, k) => {
        const x = x0 - (k % 4 + 1) * s - (k % 4) * gap, y = y0 + Math.floor(k / 4) * (s + gap);
        if (k >= n) { u.rr(c, x, y, s, s, s * 0.24, 'rgba(255,255,255,0.06)'); return; }
        const age = t - ST10[k] - 0.12, sc = 1 + 0.2 * (1 - u.easeOut(u.clamp(age / 0.3)));
        c.save(); c.translate(x + s / 2, y + s / 2); c.scale(sc, sc); appIcon(c, -s / 2, -s / 2, s, a); c.restore();
        if (k === st.i) { c.strokeStyle = u.acc(I, 1); c.lineWidth = 2; c.beginPath(); c.roundRect(x - 3, y - 3, s + 6, s + 6, s * 0.28); c.stroke(); }
      });
      c.restore();
      endCard(c, W, H, scr, I, endA, ['הכול נפתח מיד']);
    },
  };

  /* ───────── 11 · מחליף האפליקציות ─────────
     מחליקים למחליף, עוברים לכרטיס הבא, נכנסים. כל כרטיס חי: המשחק נוסע, הסרט מתנגן. הקצב מאיץ.
     ליד הטלפון: כמה אפליקציות פתוחות עכשיו, ובסוף המשפט */
  const KF11 = (() => {
    const k = [[0, 0, 1]]; let t = 1.0; k.push([t, 0, 1]);
    const holds = [0.85, 0.7, 0.6, 0.5, 0.42, 0.36, 3.0], moves = [0.36, 0.32, 0.28, 0.25, 0.22, 0.2, 0.2];
    for (let j = 1; j < APPS.length; j++) {
      const mv = moves[j - 1];
      t += 0.26; k.push([t, j - 1, 0]);
      t += mv; k.push([t, j, 0]);
      t += 0.24; k.push([t, j, 1]);
      t += holds[j - 1]; k.push([t, j, 1]);
    }
    return k;
  })();
  const DUR11 = KF11[KF11.length - 1][0];
  const at11 = t => {
    for (let i = 0; i < KF11.length - 1; i++) {
      const [t0, p0, z0] = KF11[i], [t1, p1, z1] = KF11[i + 1];
      if (t <= t1) { const f = t1 > t0 ? u.ease(u.clamp((t - t0) / (t1 - t0))) : 1; return { p: u.lerp(p0, p1, f), z: u.lerp(z0, z1, f), seen: Math.max(p0, p1) }; }
    }
    const e = KF11[KF11.length - 1]; return { p: e[1], z: e[2], seen: e[1] };
  };
  S['chip-11'] = {
    dur: DUR11,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      const st = at11(t), m = Math.min(W, H);
      UI.wall(c, 0, 0, W, H, 0.5, I);
      c.fillStyle = 'rgba(0,0,0,0.45)'; c.fillRect(0, 0, W, H);
      const sc = u.lerp(0.64, 1, st.z), cw = W * sc, ch = H * sc, cy = H * u.lerp(0.48, 0.5, st.z), step = W * u.lerp(0.72, 1.06, st.z), rad = u.lerp(m * 0.09, 0, st.z);
      APPS.forEach((a, j) => {
        const cx = W / 2 - (j - st.p) * step;
        if (cx + cw / 2 < -2 || cx - cw / 2 > W + 2) return;
        c.save();
        if (st.z < 0.95) { c.shadowColor = 'rgba(0,0,0,0.55)'; c.shadowBlur = 18; }
        u.rr(c, cx - cw / 2, cy - ch / 2, cw, ch, rad, '#000');
        c.restore();
        c.save(); c.beginPath(); c.roundRect(cx - cw / 2, cy - ch / 2, cw, ch, rad); c.clip();
        c.translate(cx - cw / 2, cy - ch / 2); c.scale(sc, sc);
        drawApp(a[0], c, 0, 0, W, H, t, I);
        c.restore();
        if (st.z < 0.6) {
          const la = 1 - st.z / 0.6, is = m * 0.07;
          c.save(); c.globalAlpha = la;
          appIcon(c, cx + cw / 2 - is, cy - ch / 2 - is * 1.35, is, a);
          u.text(c, a[1], cx + cw / 2 - is * 1.3, cy - ch / 2 - is * 0.85, m * 0.042, '#fff', 600, 'right', 'rtl');
          c.restore();
        }
      });
      u.status(c, W, H, { level: 0.8 });
      homeBar(c, W, H);
    },
    stage(c, W, H, t, I, scr) {
      const st = at11(t), { room, ax, m } = K.room(W, H, scr);
      const endA = u.clamp((t - (DUR11 - 2.4)) / 0.6), n = Math.round(st.seen) + 1;
      c.save(); c.globalAlpha = 1 - u.clamp(endA * 1.6);
      const px = K2.fit(c, '8', room * 0.4, H * 0.2);
      K2.pop(c, String(n), ax, H * 0.3, px, I, { age: 9 });
      u.text(c, 'אפליקציות פתוחות', ax, H * 0.3 + px * 0.62, Math.max(12, m * 0.042), 'rgba(255,255,255,0.72)', 600, 'center', 'rtl');
      /* הכרטיסים הקטנים בערימה */
      const s = Math.min(room * 0.12, H * 0.07), y = H * 0.3 + px * 0.62 + m * 0.08;
      for (let j = 0; j < n; j++) { const x = ax + (j - (n - 1) / 2) * s * 0.55 - s / 2; appIcon(c, x, y, s, APPS[j]); }
      c.restore();
      endCard(c, W, H, scr, I, endA, ['עוברים בין הכול,', 'והכול ממשיך לרוץ']);
    },
  };

  /* ───────── 12 · החלקה בין אפליקציות ─────────
     החלקה על פס הבית עוברת לאפליקציה הבאה, מסך מלא אחרי מסך מלא. ההחלקות מאיצות עד שהן נמרחות,
     ונעצרות על המשחק. ליד הטלפון קווי מהירות שמתחזקים עם הקצב, ובסוף המשפט */
  const KF12 = (() => {
    const k = [[0, 0]]; let t = 1.0; k.push([t, 0]);
    const holds = [0.8, 0.55, 0.4, 0.3, 0.24, 0.2, 3.0], moves = [0.36, 0.3, 0.25, 0.21, 0.18, 0.16, 0.2];
    for (let j = 1; j < APPS.length; j++) { t += moves[j - 1]; k.push([t, j]); t += holds[j - 1]; k.push([t, j]); }
    return k;
  })();
  const DUR12 = KF12[KF12.length - 1][0];
  const at12 = t => {
    for (let i = 0; i < KF12.length - 1; i++) {
      const [t0, p0] = KF12[i], [t1, p1] = KF12[i + 1];
      if (t <= t1) {
        const f = t1 > t0 ? u.clamp((t - t0) / (t1 - t0)) : 1, e = u.ease(f);
        /* מהירות: נגזרת של ease, בתמונות מסך לשנייה */
        const v = p1 !== p0 ? (Math.abs(u.ease(Math.min(1, f + 0.02)) - u.ease(Math.max(0, f - 0.02))) / 0.04) / (t1 - t0) : 0;
        return { p: u.lerp(p0, p1, e), v };
      }
    }
    return { p: APPS.length - 1, v: 0 };
  };
  S['chip-12'] = {
    dur: DUR12,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      const st = at12(t);
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      const gap = W * 0.04;
      APPS.forEach((a, j) => {
        const x = -(j - st.p) * (W + gap);
        if (x > W || x + W < 0) return;
        c.save(); c.beginPath(); c.rect(x, 0, W, H); c.clip();
        drawApp(a[0], c, x, 0, W, H, t, I);
        c.restore();
      });
      /* מריחה בקצב גבוה: עותק שקוף של המסך, מוזז לכיוון התנועה */
      if (st.v > 2.2) {
        const j = Math.round(st.p), x = -(j - st.p) * (W + gap);
        c.save(); c.globalAlpha = u.clamp((st.v - 2.2) / 4) * 0.35; c.beginPath(); c.rect(0, 0, W, H); c.clip();
        drawApp(APPS[j][0], c, x + W * 0.06, 0, W, H, t, I);
        c.restore();
      }
      u.status(c, W, H, { level: 0.8 });
      homeBar(c, W, H, -Math.sin((st.p % 1) * Math.PI) * W * 0.12);
    },
    stage(c, W, H, t, I, scr) {
      const st = at12(t), { room, ax, m } = K.room(W, H, scr);
      const endA = u.clamp((t - (DUR12 - 2.4)) / 0.6), speed = u.clamp(st.v / 6);
      /* קווי מהירות */
      const rng = u.rnd(12);
      c.save(); c.lineCap = 'round';
      for (let k = 0; k < 26; k++) {
        const y = H * (0.08 + 0.84 * rng()), len = room * (0.15 + 0.35 * rng()), sp = 0.6 + rng();
        const x = ((rng() + t * sp * (0.4 + speed * 2.4)) % 1.2) * (room + len) - len;
        const a = (0.05 + 0.5 * speed) * (1 - endA);
        const g = c.createLinearGradient(x, 0, x + len, 0); g.addColorStop(0, u.acc(I, 0)); g.addColorStop(1, u.acc(I, a));
        c.strokeStyle = g; c.lineWidth = Math.max(1, m * (0.003 + 0.004 * rng())); c.beginPath(); c.moveTo(x, y); c.lineTo(Math.min(x + len, room), y); c.stroke();
      }
      c.restore();
      /* שם האפליקציה שעל המסך, מתחלף עם ההחלקה */
      const j = Math.round(st.p), fs = Math.max(14, Math.min(m * 0.08, K2.fit(c, 'עריכת וידאו', room * 0.85, 99, 700)));
      c.save(); c.globalAlpha = (1 - u.clamp(endA * 2)) * (1 - u.clamp(Math.abs(st.p - j) * 2.2));
      u.text(c, APPS[j][1], ax, H * 0.5, fs, '#fff', 700, 'center', 'rtl');
      c.restore();
      endCard(c, W, H, scr, I, endA, ['מאפליקציה לאפליקציה,', 'בלי לחכות']);
    },
  };
})();

/* ── js/scenes-r5-chg.js ── */
/* טעינה, סבב 5 (17.09.2026). יובל על 7 אחרי הליטוש: «לא, לא טוב. בוא נחזור לאחד מהדברים הראשונים שעשית,
   שרואים רק את הכוס קפה, כל פעם לאט לאט נגמרת».
   ⟹ חזרה ל-1 מסבב 1 (כוס שמתרוקנת ליד הטלפון), עם כוס מצוירת טוב יותר ובקצב איטי. בלי אדם, בלי עיתון,
   ובלי מספר גדול ליד הכוס: האחוזים רק במסך (יובל, סבב 3). משפט קטן אחד מתחת לכוס, רק בסוף.
   הנתון: עד 50% בכ-15 דקות, עם מטען 60W.
   chg-10 הכוס השקופה מתרוקנת · chg-11 לגימה אחרי לגימה · chg-12 מלמעלה */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, UI = L.ui2;
  /* 22.09.2026: 8.8 ⟵ 7.2 שנ', יובל: «את הטעינה אתה גם יכול לעשות הכל קצת יותר מהר» */
  const RUN = 6.0, DUR = RUN + 1.2, GREEN = '#30D158';   /* 21.09.2026: קוצר ל-5.5 ואז הוארך ל-7.2. יובל: «נראה חתוך» */
  const minAt = (t, v) => u.clamp(t / RUN) * v.ch;

  /* מסך נעילה בטעינה, כמו 7: השעה, טבעת ירוקה עד 50%, ו«חצי סוללה» בסוף */
  const lock = (c, W, H, t, v, I) => {
    const m = Math.min(W, H), lvl = (minAt(t, v) / v.ch) * 0.5, done = t >= RUN;
    UI.wall(c, 0, 0, W, H, 0.5, I);
    c.fillStyle = 'rgba(0,0,0,0.35)'; c.fillRect(0, 0, W, H);
    u.status(c, W, H, { level: lvl, charging: true });
    u.text(c, `8:${String(Math.floor(minAt(t, v))).padStart(2, '0')}`, W / 2, H * 0.19, W * 0.2, '#fff', 500, 'center', 'ltr');
    const cx = W / 2, cy = H * 0.54, r = m * 0.3;
    c.lineCap = 'round'; c.lineWidth = m * 0.05;
    c.strokeStyle = 'rgba(48,209,88,0.18)'; c.beginPath(); c.arc(cx, cy, r, 0, Math.PI * 2); c.stroke();
    c.strokeStyle = GREEN; c.beginPath(); c.arc(cx, cy, r, -Math.PI / 2, -Math.PI / 2 + Math.max(0.02, lvl) * Math.PI * 2); c.stroke(); c.lineCap = 'butt';
    c.strokeStyle = GREEN; K2.icon.bolt(c, cx, cy - r * 0.42, r * 0.3);
    u.text(c, `${Math.round(lvl * 100)}%`, cx, cy + r * 0.1, m * 0.17, '#fff', 700, 'center', 'ltr');
    if (done) u.pill(c, 'חצי סוללה', cx, H * 0.8, m * 0.05, '#000', GREEN, 'rtl');
  };
  /* המשפט מתחת לכוס: רק כשהכוס ריקה */
  const caption = (c, x, y, t, m, room) => {
    const a = u.clamp((t - RUN - 0.1) / 0.5);
    if (a <= 0) return;
    const fs = Math.max(12, Math.min(m * 0.048, K2.fit(c, 'כוס קפה אחת, חצי סוללה', room * 0.92, 99, 600)));
    c.save(); c.globalAlpha = a; u.text(c, 'כוס קפה אחת, חצי סוללה', x, y, fs, 'rgba(255,255,255,0.85)', 600, 'center', 'rtl'); c.restore();
  };
  /* אדים: שלושה קווים גלים שדוהים עם הקפה */
  const steam = (c, cx, y, w, h, t, a, m) => {
    if (a <= 0.02) return;
    c.save(); c.globalAlpha = 0.5 * a; c.strokeStyle = '#fff'; c.lineWidth = Math.max(1.5, m * 0.007); c.lineCap = 'round';
    [-0.2, 0, 0.2].forEach((dx, i) => {
      c.beginPath();
      for (let s = 0; s <= 1.001; s += 0.08) { const yy = y - s * h, xx = cx + dx * w + Math.sin(s * 5 + t * 2.4 + i * 1.7) * w * 0.05; s ? c.lineTo(xx, yy) : c.moveTo(xx, yy); }
      const g = c.createLinearGradient(0, y, 0, y - h); g.addColorStop(0, 'rgba(255,255,255,0)'); g.addColorStop(0.3, 'rgba(255,255,255,1)'); g.addColorStop(1, 'rgba(255,255,255,0)');
      c.strokeStyle = g; c.stroke();
    });
    c.restore();
  };

  /* כמה קפה נשאר.
     🆕 20.09.2026, יובל: «עכשיו זה נראה שזה תיכף נגמר כבר. לקראת הסוף שייראה שיש יותר, וממש בסוף נגמר».
     ⟹ לא ירידה אחידה. הכוס יורדת כל הזמן, אבל לאט, ומאיצה רק בסוף: אחרי שני שלישים מהזמן
     עדיין נשאר בה יותר מחצי. הנוסחה מונוטונית לגמרי, ולכן אין רגע שבו הקפה עולה או עומד. */
  const drainAt = t => { const x = u.clamp(t / RUN); return 1 - (0.42 * x + 0.58 * x * x * x); };

  /* סבב 6 (scenes-r6-chg.js) משתמש באותו מסך נעילה, אותו משפט, אותם אדים ואותו קצב */
  L.chgKit5 = { RUN, DUR, lock, caption, steam, drainAt, GREEN };

  /* ───────── 10 · הכוס מתרוקנת ─────────
     🆕 סבב 6 (20.09.2026), יובל: «אני רוצה שהכוס של הקפה תהיה שקופה. תעשה את 10».
     ⟹ אותה סצנה בדיוק, ובמקום ספל החרסינה כוס זכוכית שקופה. רואים את הקפה יורד דרך הדופן, רצוף ובלי קפיצות,
     והזכוכית הריקה נשארת נראית. האדים נחלשים עם הקפה. בסוף «כוס קפה אחת, חצי סוללה».
     📌 הגרסאות הקודמות של הקפה נשארו בסטודיו: chg-1 (סבב 1) ו-chg-4 (סבב 2), וגם chg-11 ו-chg-12 מסבב 5. */
  const glass = (c, cx, top, w, level, t, m) => {
    const rx = w / 2, ry = rx * 0.3, h = w * 1.12, bot = top + h, bx = rx * 0.84, bry = ry * 0.84;
    const wall = f => u.lerp(bx, rx, f);
    /* גוף הכוס: דופן שמאל, תחתית מלפנים, דופן ימין, ושפה מאחור */
    const body = () => {
      c.beginPath();
      c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + rx, top);
      c.ellipse(cx, top, rx, ry, 0, 0, Math.PI, true);
      c.closePath();
    };
    /* צל על השולחן, ולידו בריכת אור שעברה דרך הזכוכית */
    c.fillStyle = 'rgba(0,0,0,0.45)'; c.beginPath(); c.ellipse(cx + w * 0.06, bot + bry * 0.35, bx * 1.5, bry * 1.1, 0, 0, Math.PI * 2); c.fill();
    if (level > 0.02) { c.save(); c.globalAlpha = 0.16 * level; c.fillStyle = '#C98B4E'; c.beginPath(); c.ellipse(cx - w * 0.1, bot + bry * 0.5, bx * 0.9, bry * 0.7, 0, 0, Math.PI * 2); c.fill(); c.restore(); }
    /* הזכוכית עצמה: גוון בהיר ושקוף, כדי שהחלק הריק ייקרא כזכוכית ולא כחור שחור.
       🔴 על רקע שחור זכוכית שקופה נקראת כספל כהה. מה שמסגיר שהיא שקופה הוא מה שרואים דרכה:
       הדופן האחורית של התחתית, ושתי הדפנות הפנימיות. בלעדיהן היא נראית אטומה (צילום 20.09) */
    const gg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
    gg.addColorStop(0, 'rgba(226,238,248,0.3)'); gg.addColorStop(0.32, 'rgba(226,238,248,0.09)');
    gg.addColorStop(0.68, 'rgba(226,238,248,0.12)'); gg.addColorStop(1, 'rgba(226,238,248,0.26)');
    body(); c.fillStyle = gg; c.fill();
    /* דרך הזכוכית: התחתית מאחור, והדפנות הפנימיות */
    c.strokeStyle = 'rgba(255,255,255,0.22)'; c.lineWidth = Math.max(1, w * 0.01);
    c.beginPath(); c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.16)'; c.lineWidth = Math.max(1, w * 0.008);
    c.beginPath();
    c.moveTo(cx - rx * 0.93, top + ry * 0.4); c.lineTo(cx - bx * 0.9, bot - bry * 0.3);
    c.moveTo(cx + rx * 0.93, top + ry * 0.4); c.lineTo(cx + bx * 0.9, bot - bry * 0.3);
    c.stroke();
    /* הקפה: מהתחתית עד המפלס. פני הקפה הם אליפסה שיורדת ומצטמצמת עם הדופן */
    const lf = 0.9 * level, ly = bot - h * lf, lrx = wall(lf), lry = ry * (lrx / rx);
    if (level > 0.012) {
      c.save(); body(); c.clip();
      c.beginPath();
      c.moveTo(cx - lrx, ly); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + lrx, ly);
      c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI, true);
      c.closePath();
      const cg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
      cg.addColorStop(0, '#42291A'); cg.addColorStop(0.3, '#7A4E2D'); cg.addColorStop(0.62, '#6B4327'); cg.addColorStop(1, '#3A2213');
      c.fillStyle = cg; c.fill();
      /* כהה יותר בתחתית, כמו קפה אמיתי */
      const dg = c.createLinearGradient(0, ly, 0, bot); dg.addColorStop(0, 'rgba(0,0,0,0)'); dg.addColorStop(1, 'rgba(0,0,0,0.35)');
      c.fillStyle = dg; c.fill();
      c.restore();
      /* פני הקפה: אליפסה מלאה, בהירה יותר, עם קרמה על השפה */
      const sg = c.createRadialGradient(cx - lrx * 0.3, ly - lry * 0.4, 0, cx, ly, lrx);
      sg.addColorStop(0, '#A9764A'); sg.addColorStop(1, '#6B4327');
      c.fillStyle = sg; c.beginPath(); c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI * 2); c.fill();
      c.strokeStyle = 'rgba(214,170,120,0.65)'; c.lineWidth = Math.max(1, w * 0.012);
      c.beginPath(); c.ellipse(cx, ly, lrx * 0.96, lry * 0.96, 0, 0, Math.PI * 2); c.stroke();
    }
    /* שובל דק שהקפה משאיר על הדופן מעל המפלס */
    if (level < 0.99) {
      c.save(); body(); c.clip();
      c.globalAlpha = 0.14; c.fillStyle = '#8A5A36';
      c.fillRect(cx - rx, Math.max(top, ly - h * 0.06), rx * 2, h * 0.06);
      c.restore();
    }
    /* הזכוכית מלפנים: שפה, דפנות, הבהק ותחתית עבה */
    c.strokeStyle = 'rgba(255,255,255,0.5)'; c.lineWidth = Math.max(1.5, w * 0.018);
    c.beginPath(); c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot); c.moveTo(cx + rx, top); c.lineTo(cx + bx, bot); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.82)'; c.lineWidth = Math.max(1.5, w * 0.022);
    c.beginPath(); c.ellipse(cx, top, rx, ry, 0, 0, Math.PI * 2); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.35)'; c.lineWidth = Math.max(1, w * 0.014);
    c.beginPath(); c.ellipse(cx, bot, bx, bry, 0, 0, Math.PI); c.stroke();
    const hl = c.createLinearGradient(0, top, 0, bot); hl.addColorStop(0, 'rgba(255,255,255,0.55)'); hl.addColorStop(1, 'rgba(255,255,255,0.1)');
    c.strokeStyle = hl; c.lineWidth = Math.max(2, w * 0.035); c.lineCap = 'round';
    c.beginPath(); c.moveTo(cx - rx * 0.78, top + h * 0.12); c.lineTo(cx - bx * 0.76, bot - h * 0.12); c.stroke();
    c.lineWidth = Math.max(1, w * 0.014);
    c.beginPath(); c.moveTo(cx + rx * 0.84, top + h * 0.16); c.lineTo(cx + bx * 0.82, bot - h * 0.3); c.stroke();
    c.lineCap = 'butt';
    /* התחתית העבה: רצועה בהירה שמפרידה את הכוס מהשולחן */
    c.save(); body(); c.clip();
    const bgd = c.createLinearGradient(0, bot - h * 0.07, 0, bot); bgd.addColorStop(0, 'rgba(255,255,255,0)'); bgd.addColorStop(1, 'rgba(255,255,255,0.22)');
    c.fillStyle = bgd; c.fillRect(cx - rx, bot - h * 0.07, rx * 2, h * 0.07);
    c.restore();
    return { bot, top, h };
  };
  S['chg-10'] = {
    dur: DUR,
    shift: 0.22,
    glow: false,
    draw(c, W, H, t, side, I) { lock(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), level = drainAt(t);
      const w = Math.min(room * 0.6, H * 0.34), top = H * 0.38;
      steam(c, ax, top - w * 0.1, w * 0.85, H * 0.18, t, u.clamp(level * 2.5), m);
      const r = glass(c, ax, top, w, level, t, m);
      caption(c, ax, r.bot + m * 0.12, t, m, room);
    },
  };

  /* ───────── 11 · לגימה אחרי לגימה ─────────
     כוס זכוכית שקופה של לאטה, מהצד. בכל לגימה הכוס נוטה לרגע, פני הקפה נשארים ישרים, והכוס חוזרת עם פחות.
     שש לגימות, לאט. אין יד ואין אדם: הנטייה לבדה מספרת את הלגימה */
  const SIPS = 6, SIP = RUN / SIPS;
  const sip11 = t => {
    const i = Math.min(SIPS, Math.floor(u.clamp(t, 0, RUN - 0.001) / SIP)), lt = t - i * SIP;
    const tilt = t >= RUN ? 0 : Math.sin(u.clamp((lt - SIP * 0.25) / (SIP * 0.55)) * Math.PI);
    const drop = u.ease(u.clamp((lt - SIP * 0.35) / (SIP * 0.4)));
    return { tilt, level: t >= RUN ? 0 : 1 - (i + drop) / SIPS };
  };
  const glassCup = (c, cx, bot, w, level, tilt, t, m) => {
    const h = w * 1.25, tw = w / 2, bw = w * 0.4, ang = -tilt * 0.26;
    c.fillStyle = 'rgba(0,0,0,0.45)'; c.beginPath(); c.ellipse(cx, bot + w * 0.03, w * 0.55 * (1 - tilt * 0.1), w * 0.07, 0, 0, Math.PI * 2); c.fill();
    c.save();
    /* נוטה סביב הפינה התחתונה השמאלית */
    const px = cx - bw, py = bot;
    c.translate(px, py); c.rotate(ang); c.translate(-px, -py);
    const shape = () => { c.beginPath(); c.moveTo(cx - tw, bot - h); c.lineTo(cx + tw, bot - h); c.lineTo(cx + bw, bot); c.lineTo(cx - bw, bot); c.closePath(); };
    /* הזכוכית הריקה: גוון בהיר ושקוף, כדי שהחלק הריק ייקרא כזכוכית ולא כקפה שחור (צילום 17.09) */
    const gg = c.createLinearGradient(cx - tw, 0, cx + tw, 0); gg.addColorStop(0, 'rgba(255,255,255,0.16)'); gg.addColorStop(0.5, 'rgba(255,255,255,0.05)'); gg.addColorStop(1, 'rgba(255,255,255,0.13)');
    shape(); c.fillStyle = gg; c.fill();
    /* הנוזל: פני שטח אופקיים בעולם, ולכן מסתובבים בחזרה בתוך הכוס */
    c.save(); shape(); c.clip();
    const vol = level, ly = bot - h * 0.9 * vol - h * 0.02;
    c.save();
    c.translate(cx, ly); c.rotate(-ang); c.translate(-cx, -ly);
    if (vol > 0.005) {
      /* השכבות נמתחות על גובה הנוזל: קצף למעלה, לאטה, ואספרסו בתחתית. כשהמפלס יורד, כולן מתכווצות יחד */
      const lh = Math.max(4, bot - ly), lg = c.createLinearGradient(0, ly, 0, ly + lh);
      lg.addColorStop(0, '#F1E6D6'); lg.addColorStop(Math.min(0.5, 6 / lh + 0.08), '#E3CBAA'); lg.addColorStop(0.45, '#C49467'); lg.addColorStop(0.85, '#8A5A36'); lg.addColorStop(1, '#5A361E');
      c.fillStyle = lg; c.fillRect(cx - w * 1.5, ly, w * 3, h * 2);
    }
    c.restore();
    /* עקבות קצף על הדופן מעל הקפה */
    const ft = bot - h * 0.92;
    if (vol < 0.98 && ly > ft) { c.fillStyle = 'rgba(236,222,200,0.16)'; c.fillRect(cx - w, ft, w * 2, ly - ft); }
    c.restore();
    /* הזכוכית: קווים והבהקים */
    c.strokeStyle = 'rgba(255,255,255,0.55)'; c.lineWidth = Math.max(1.5, w * 0.02); shape(); c.stroke();
    const hl = c.createLinearGradient(0, bot - h, 0, bot); hl.addColorStop(0, 'rgba(255,255,255,0.6)'); hl.addColorStop(1, 'rgba(255,255,255,0.08)');
    c.strokeStyle = hl; c.lineWidth = Math.max(2, w * 0.035); c.lineCap = 'round';
    c.beginPath(); c.moveTo(cx - tw * 0.8, bot - h * 0.9); c.lineTo(cx - bw * 0.78, bot - h * 0.12); c.stroke();
    c.fillStyle = 'rgba(255,255,255,0.12)'; c.fillRect(cx - bw, bot - h * 0.05, bw * 2, h * 0.05);
    c.restore();
    return { top: bot - h };
  };
  S['chg-11'] = {
    dur: DUR,
    shift: 0.22,
    glow: false,
    draw(c, W, H, t, side, I) { lock(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), s = sip11(t);
      const w = Math.min(room * 0.46, H * 0.3), bot = H * 0.74;
      steam(c, ax, bot - w * 1.3, w * 0.8, H * 0.16, t, u.clamp(s.level * 2.5) * (1 - s.tilt), m);
      glassCup(c, ax, bot, w, s.level, s.tilt, t, m);
      caption(c, ax, bot + m * 0.09, t, m, room);
    },
  };

  /* ───────── 12 · מלמעלה ─────────
     מבט מלמעלה על ספל על צלוחית. הספל רחב למעלה וצר למטה, ולכן ככל שהקפה יורד העיגול שלו קטן,
     והדופן הבהירה נחשפת. בכל לגימה נשארת טבעת דקה על הדופן. ציור הלב בקצף נמתח ונעלם לאט */
  const topView = (c, cx, cy, R, level, t, m) => {
    /* צלוחית וצל */
    c.fillStyle = 'rgba(0,0,0,0.5)'; c.beginPath(); c.arc(cx + R * 0.08, cy + R * 0.1, R * 1.52, 0, Math.PI * 2); c.fill();
    const sg = c.createRadialGradient(cx - R * 0.4, cy - R * 0.4, R * 0.2, cx, cy, R * 1.5); sg.addColorStop(0, '#FFFFFF'); sg.addColorStop(1, '#D9D5CE');
    c.fillStyle = sg; c.beginPath(); c.arc(cx, cy, R * 1.48, 0, Math.PI * 2); c.fill();
    c.strokeStyle = 'rgba(0,0,0,0.08)'; c.lineWidth = Math.max(1, R * 0.03); c.beginPath(); c.arc(cx, cy, R * 1.2, 0, Math.PI * 2); c.stroke();
    /* ידית */
    c.fillStyle = '#EDEAE4'; u.rr(c, cx + R * 0.95, cy - R * 0.14, R * 0.42, R * 0.28, R * 0.14, '#EDEAE4');
    /* הספל: שפה, ודופן פנימית בגרדיאנט רדיאלי */
    c.fillStyle = '#FBFAF7'; c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.fill();
    const wg = c.createRadialGradient(cx, cy, R * 0.45, cx, cy, R * 0.93); wg.addColorStop(0, '#CFC9BF'); wg.addColorStop(1, '#F3F0EA');
    c.fillStyle = wg; c.beginPath(); c.arc(cx, cy, R * 0.93, 0, Math.PI * 2); c.fill();
    /* טבעות שהקפה השאיר בכל שישית */
    for (let k = 1; k < 6; k++) { const lv = 1 - k / 6; if (level < lv - 0.01) { const rr = R * u.lerp(0.5, 0.92, lv); c.strokeStyle = 'rgba(120,80,48,0.22)'; c.lineWidth = Math.max(1, R * 0.012); c.beginPath(); c.arc(cx, cy, rr, 0, Math.PI * 2); c.stroke(); } }
    /* הקפה: עיגול שקטן ככל שהמפלס יורד */
    if (level > 0.01) {
      const rr = R * u.lerp(0.5, 0.92, level);
      const cg = c.createRadialGradient(cx - rr * 0.25, cy - rr * 0.25, 0, cx, cy, rr); cg.addColorStop(0, '#B07D52'); cg.addColorStop(0.7, '#8A5A36'); cg.addColorStop(1, '#5C3920');
      c.fillStyle = cg; c.beginPath(); c.arc(cx, cy, rr, 0, Math.PI * 2); c.fill();
      /* לב בקצף: דוהה ונמתח */
      const ha = u.clamp((level - 0.25) / 0.5), hs = rr * 0.5;
      if (ha > 0) {
        c.save(); c.globalAlpha = 0.9 * ha; c.fillStyle = '#F2E6D6';
        c.translate(cx, cy + hs * 0.05); c.rotate(Math.sin(t * 0.3) * 0.05);
        c.beginPath(); c.moveTo(0, hs * 0.55); c.bezierCurveTo(-hs * 1.1, -hs * 0.1, -hs * 0.45, -hs * 0.85, 0, -hs * 0.3); c.bezierCurveTo(hs * 0.45, -hs * 0.85, hs * 1.1, -hs * 0.1, 0, hs * 0.55); c.fill();
        c.restore();
      }
      c.strokeStyle = 'rgba(214,170,120,0.6)'; c.lineWidth = Math.max(1, R * 0.02); c.beginPath(); c.arc(cx, cy, rr * 0.98, 0, Math.PI * 2); c.stroke();
    }
    c.strokeStyle = 'rgba(0,0,0,0.1)'; c.lineWidth = Math.max(1, R * 0.02); c.beginPath(); c.arc(cx, cy, R * 0.93, 0, Math.PI * 2); c.stroke();
  };
  S['chg-12'] = {
    dur: DUR,
    shift: 0.22,
    glow: false,
    draw(c, W, H, t, side, I) { lock(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), level = drainAt(t);
      const R = Math.min(room * 0.31, H * 0.21), cy = H * 0.45;
      topView(c, ax - R * 0.1, cy, R, level, t, m);
      caption(c, ax, cy + R * 1.5 + m * 0.08, t, m, room);
    },
  };
})();

/* ── js/scenes-r2-zoom.js ── */
/* זום, סבב 2 (17.09.2026). בקשת יובל: «את 2 עם שילוב של 3», המספר בגדול, ומעבר ברור בין הזומים עם האטה.
   ⟹ כל האפשרויות עוצרות בכל עדשה: 0.5 · 1 · 2 · 4 · 8, עמידה של שנייה בכל אחת ויותר ב-4 וב-8.
   ⟹ הפנים חדות כבר מפי 1: צילום פי 8 נכנס על הרחב מוקדם יותר מבסבב 1 (סף 0.2 במקום 0.55 מרוחב המסך).
   zoom-4 מסגרת ומספר · zoom-5 חמש תמונות בטור · zoom-6 המספר מאחורי הנוף */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, Z = L.zoomKit;
  const LBL = ['0.5', '1', '2', '4', '8'], SHORT = ['.5', '1', '2', '4', '8'];
  /* קוצר 21.09.2026: 9.75 ⟵ 7.9 שנ'. ושוב 22.09.2026: 7.9 ⟵ 5.85, יובל: «להוריד את החצי שנייה
     שבסוף, ובכלל לקצר כל הצגה של קירבה». כל עצירה קצרה יותר, והזנב של 0.3 בסוף ירד */
  const HOLDS = [0.6, 0.6, 0.6, 0.75, 0.9], MOVE = 0.6;
  const DUR = K2.total(HOLDS, MOVE);
  const stepAt = (t, g) => K2.steps(t, [g.base, 1, 2, 4, 8], HOLDS, MOVE);

  /* הרחב, ועליו פי 8 במקומו המדויק. נכנס מפי 1, ולכן הפנים חדות בכל עצירה */
  const drawSharp = (c, g, v, x0, y0, W, H) => {
    c.drawImage(g.wide, v.sx, v.sy, v.cw, v.ch, x0, y0, W, H);
    if (!g.tele) return;
    const tx = x0 + ((g.Rx - v.sx) / v.cw) * W, ty = y0 + ((g.Ry - v.sy) / v.ch) * H, tw = (g.Rw / v.cw) * W, th = (g.Rh / v.ch) * H;
    const a = u.clamp((tw / W - 0.2) / 0.2);
    if (a <= 0) return;
    c.globalAlpha = a; c.drawImage(Z.feathered(g.tele), tx, ty, tw, th);
    const b = u.clamp((th / H - 0.8) / 0.2);
    if (b > 0) { c.globalAlpha = b; c.drawImage(g.tele, tx, ty, tw, th); }
    c.globalAlpha = 1;
  };

  /* מסך הטלפון: התצוגה, שורת עדשות ומספר קטן מעל */
  const phone = (c, W, H, t, I) => {
    c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
    const g = Z.geo(); if (!g) return null;
    const st = stepAt(t, g);
    drawSharp(c, g, Z.viewAt(g, st.val, W, H), 0, 0, W, H);
    const gr = c.createLinearGradient(0, H * 0.78, 0, H); gr.addColorStop(0, 'rgba(0,0,0,0)'); gr.addColorStop(1, 'rgba(0,0,0,0.55)');
    c.fillStyle = gr; c.fillRect(0, H * 0.78, W, H * 0.22);
    const live = st.moving ? (st.val < 0.75 ? '.5' : String(+st.val.toFixed(1))) : '';
    K2.lenses(c, W, H, SHORT, st.idx, H * 0.915, { live: st.idx === 0 && !st.moving ? '.5' : live });
    u.status(c, W, H, { level: 0.8 });
    return { g, st };
  };

  /* הנוף על הבמה, כשהפנים ב-(ax, ay). מחזיר את קנה המידה והמוצא */
  const place = (g, bh, ax, ay) => { const sc = bh / g.ih; return { sc, ox: ax - g.fcx * sc, oy: ay - g.fcy * sc, bw: g.iw * sc, bh }; };
  const landscape = (c, W, H, g, P, ax, ay) => {
    c.drawImage(g.wide, P.ox, P.oy, P.bw, P.bh);
    c.save();
    c.globalCompositeOperation = 'destination-in';
    c.translate(ax, ay); c.scale(1.6, 1);
    const mg = c.createRadialGradient(0, 0, P.bh * 0.22, 0, 0, P.bh * 0.5);
    mg.addColorStop(0, '#000'); mg.addColorStop(1, 'rgba(0,0,0,0)');
    c.fillStyle = mg; c.fillRect(-W * 2, -H * 2, W * 4, H * 4);
    c.restore();
    K.edgeFade(c, W, H, Math.min(W, H) * 0.12);
  };

  /* ───────── 4 · מסגרת ומספר ─────────
     כמו 2: הנוף ליד הטלפון, מסגרת מתכווצת אל האישה וקווים אל המסך. מעל הנוף המספר של העדשה, גדול, וקופץ בכל עצירה */
  S['zoom-4'] = {
    dur: DUR,
    shift: 0.2,
    glow: false,
    draw(c, W, H, t, side, I) { phone(c, W, H, t, I); },
    stage(c, W, H, t, I, scr) {
      const g = Z.geo(); if (!g) return;
      const st = stepAt(t, g), v = Z.viewAt(g, st.val, scr.w, scr.h);
      const { room, m } = K.room(W, H, scr);
      const bh = H * 0.62, fw0 = ((g.ih * scr.w) / scr.h) * (bh / g.ih);
      const ax = Math.max(scr.x * 0.5, fw0 / 2 + 16), ay = H * 0.62;
      const P = place(g, bh, ax, ay);
      const Lr = K2.layer('z4', W, H);
      landscape(Lr.x, W, H, g, P, ax, ay);
      c.drawImage(Lr.cv, 0, 0, W, H);
      K.frame(c, W, H, P.ox + v.sx * P.sc, P.oy + v.sy * P.sc, v.cw * P.sc, v.ch * P.sc, scr, I, { dim: 0.45 });
      const px = K2.fit(c, '0.5×', room * 0.8, H * 0.2);
      K2.pop(c, `${LBL[st.idx]}×`, room / 2 + m * 0.02, H * 0.15, px, I, { age: st.age });
    },
  };

  /* ───────── 5 · חמש תמונות בטור ─────────
     הטלפון עוצר בכל עדשה. בכל עצירה «צילום» של המסך יורד לטור ליד הטלפון, עם המספר שלו בגדול.
     בסוף רואים את חמש העדשות זו מעל זו: אותה נקודה, חמישה מרחקים */
  S['zoom-5'] = {
    dur: DUR + 0.6,
    shift: 0.2,
    draw(c, W, H, t, side, I) { phone(c, W, H, t, I); },
    stage(c, W, H, t, I, scr) {
      const g = Z.geo(); if (!g) return;
      const st = stepAt(t, g), { room, m } = K.room(W, H, scr);
      const gap = Math.max(5, H * 0.018), th = Math.min((H * 0.86 - gap * 4) / 5, room * 0.52 * 0.75), tw = th / 0.75;
      const y0 = (H - (th * 5 + gap * 4)) / 2, xT = room - tw - m * 0.02, px = Math.min(th * 0.62, (xT - m * 0.04) * 0.5);
      for (let i = 0; i <= st.idx; i++) {
        const k = u.easeOut(u.clamp((t - st.starts[i]) / 0.55)), y = y0 + i * (th + gap);
        const x = u.lerp(scr.x + scr.w / 2 - tw / 2, xT, k), yy = u.lerp(scr.y + scr.h * 0.4, y, k), s = u.lerp(1.35, 1, k);
        const v = Z.viewAt(g, [g.base, 1, 2, 4, 8][i], tw, th), w2 = tw * s, h2 = th * s;
        c.save();
        c.globalAlpha = u.clamp(k * 3);
        c.beginPath(); c.roundRect(x, yy, w2, h2, Math.max(3, m * 0.012)); c.clip();
        drawSharp(c, g, v, x, yy, w2, h2);
        c.restore();
        const on = i === st.idx;
        c.save(); c.globalAlpha = u.clamp(k * 3);
        c.strokeStyle = on ? u.acc(I, 1) : 'rgba(255,255,255,0.18)'; c.lineWidth = on ? 2 : 1;
        c.beginPath(); c.roundRect(x, yy, w2, h2, Math.max(3, m * 0.012)); c.stroke();
        c.restore();
        if (k > 0.6) {
          const lx = xT - m * 0.03, ly = y + th / 2;
          c.save(); c.globalAlpha = u.clamp((k - 0.6) / 0.4);
          c.font = u.font(700, px); c.textAlign = 'right'; c.textBaseline = 'middle'; c.direction = 'ltr';
          c.fillStyle = on ? u.acc(I, 1) : 'rgba(255,255,255,0.5)';
          c.fillText(`${LBL[i]}×`, lx, ly + 1);
          c.restore();
        }
      }
    },
  };

  /* ───────── 6 · מספר ענק על הנוף ─────────
     כמו 2, ועל הנוף מספר ענק בקו מתאר, כמעט בגובה הבמה. הוא מתחלף בכל עצירה.
     נוסה מאחורי הנוף ונפסל: הנוף אטום במרכז והסתיר אותו לגמרי (צילום 17.09) */
  S['zoom-6'] = {
    dur: DUR,
    shift: 0.2,
    glow: false,
    draw(c, W, H, t, side, I) { phone(c, W, H, t, I); },
    stage(c, W, H, t, I, scr) {
      const g = Z.geo(); if (!g) return;
      const st = stepAt(t, g), v = Z.viewAt(g, st.val, scr.w, scr.h);
      const { room, m } = K.room(W, H, scr);
      const bh = H * 0.7, fw0 = ((g.ih * scr.w) / scr.h) * (bh / g.ih);
      const ax = Math.max(scr.x * 0.5, fw0 / 2 + 16), ay = H * 0.5;
      const P = place(g, bh, ax, ay);
      const Lr = K2.layer('z6', W, H);
      landscape(Lr.x, W, H, g, P, ax, ay);
      c.drawImage(Lr.cv, 0, 0, W, H);
      K.frame(c, W, H, P.ox + v.sx * P.sc, P.oy + v.sy * P.sc, v.cw * P.sc, v.ch * P.sc, scr, I, { dim: 0.4 });
      /* המספר: רוחב השטח הפנוי, עד 64% מהגובה. מילוי שקוף וקו מתאר, כדי שהנוף יישאר גלוי דרכו */
      const px = K2.fit(c, '0.5×', room * 0.98, H * 0.64), cx = room / 2 + m * 0.01, cy = H * 0.5;
      const k = u.clamp(st.age / 0.45), sc = 1 + 0.08 * (1 - u.easeOut(k)), label = `${LBL[st.idx]}×`;
      c.save();
      c.translate(cx, cy); c.scale(sc, sc);
      c.font = u.font(700, px); c.textAlign = 'center'; c.textBaseline = 'middle'; c.direction = 'ltr';
      c.shadowColor = 'rgba(0,0,0,0.5)'; c.shadowBlur = px * 0.06;
      c.globalAlpha = 0.3 * u.easeOut(k) + 0.1; c.fillStyle = u.acc(I, 1); c.fillText(label, 0, px * 0.04);
      c.shadowColor = 'transparent';
      c.globalAlpha = 0.95; c.lineWidth = Math.max(1.5, px * 0.012); c.strokeStyle = u.acc(I, 1); c.strokeText(label, 0, px * 0.04);
      c.restore();
      u.text(c, 'זום אופטי', cx, H * 0.93, Math.max(12, m * 0.036), 'rgba(255,255,255,0.6)', 500, 'center', 'rtl');
    },
  };
})();

/* ── js/scenes-r5-self.js ── */
/* סלפי, סבב 5 (17.09.2026), ועודכן בסבב 6 (20.09.2026).
   יובל בסבב 5: «תתחיל ב-7, ואז אחרי שהתמונה מצולמת תעשה את מה שאתה עושה ב-8».
   יובל בסבב 6: «יש את הקטע שהתמונה נפתחת ומוצגת בגלריה? את הקטע הזה תסיר, שיעבור ישר למה שהיה ב-8».
   ⟹ self-10 הוא 4 עד הצילום (הטלפון במרכז, העולם שמחוץ למסך, הפריים נפתח, הצילום), ומיד אחרי הפלאש
   הטלפון זז ימינה והתמונה יוצאת מהמסך אל הבמה, גדולה ולרוחב, עם «צילמת לאורך» ו«קיבלת לרוחב».
   🔴 אין יותר שלב גלריה ואין «נשמרה לרוחב» על המסך. selfKit3.viewer ו-dimLabels נשארו ל-self-7 בסבב 3.
   🔴 ההזזה באמצע הסצנה (shiftAt) היא יכולת של הסטודיו: studio.js ו-showcase.js קוראים אותה בכל פריים.
   גודל הטלפון נקבע לפי ההזזה המרבית (shiftMax), ולכן בתחילת הסצנה הוא מעט קטן מ-7. */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, SK = L.selfKit, S3 = L.selfKit3;
  const END = S3.END;                         /* 6.0, אחרי הפלאש ואחרי «כל הארבעה בפריים» */
  const SH0 = END + 0.1, SHD = 1.0;           /* הטלפון זז ימינה, ונותן מקום לתמונה */
  const OUT = END + 0.45, FLY = 0.95;         /* התמונה יוצאת מהמסך אל הבמה */
  const DUR = OUT + FLY + 1.4, SHIFT = 0.24;   /* קוצר 21.09.2026: העצירה בסוף 3.0 ⟵ 1.4, ‏10.4 ⟵ 8.8 שנ' */
  const shiftAt = t => SHIFT * u.ease(u.clamp((t - SH0) / SHD));

  S['self-10'] = {
    dur: DUR,
    shiftMax: SHIFT,
    shiftAt,
    glow: false,
    draw(c, W, H, t, side, I) {
      if (t < END) { SK.screen(c, W, H, t, I, { f0: 0.34, labels: false }); return; }
      /* אחרי הצילום המסך חוזר להיות מצלמה רגועה, בלי פלאש ובלי תוויות שקופצות */
      SK.screen(c, W, H, SK.T.done + 0.8, I, { f0: 0.34, labels: false });
    },
    stage(c, W, H, t, I, scr) {
      if (t < END) { SK.stage4(c, W, H, t, I, scr); return; }
      if (t < OUT) return;
      const img = K.img('selfie-group'), { room, ax, m } = K.room(W, H, scr), k = u.easeOut(u.clamp((t - OUT) / FLY));
      /* מאיפה: רצועת הצילום שעל המסך, ברוחב המסך וביחס 4:3. לאן: באמצע השטח הפנוי */
      const w0 = scr.w, c0x = scr.x + scr.w / 2, c0y = scr.y + scr.h * 0.46 + scr.w * 0.075;
      const w1 = Math.min(room * 0.92, H * 0.62), ww = u.lerp(w0, w1, k), hh = ww * 0.75;
      const cx = u.lerp(c0x, ax, k), cy = u.lerp(c0y, H * 0.44, k);
      const b = Math.max(3, ww * 0.025);
      c.save(); c.shadowColor = 'rgba(0,0,0,0.6)'; c.shadowBlur = m * 0.05 * k;
      u.rr(c, cx - ww / 2 - b, cy - hh / 2 - b, ww + b * 2, hh + b * 2, b * 1.4, `rgba(244,244,242,${u.clamp(k * 3)})`);
      c.restore();
      c.save(); c.beginPath(); c.rect(cx - ww / 2, cy - hh / 2, ww, hh); c.clip(); S3.saved(c, cx - ww / 2, cy - hh / 2, ww, hh, img); c.restore();
      const a = u.clamp((t - OUT - FLY - 0.15) / 0.5);
      if (a <= 0) return;
      c.save(); c.globalAlpha = a;
      u.text(c, 'קיבלת לרוחב', cx, cy + hh / 2 + m * 0.07, Math.max(14, m * 0.05), u.acc(I, 1), 700, 'center', 'rtl');
      u.text(c, 'צילמת לאורך', cx, cy - hh / 2 - m * 0.06, Math.max(12, m * 0.04), 'rgba(255,255,255,0.8)', 500, 'center', 'rtl');
      /* חץ מ«צילמת לאורך» אל הטלפון */
      c.strokeStyle = 'rgba(255,255,255,0.6)'; c.lineWidth = 1.5; c.lineCap = 'round';
      const x0 = cx + m * 0.14, y0 = cy - hh / 2 - m * 0.06, x1 = scr.x - m * 0.02, y1 = scr.y + scr.h * 0.12;
      c.beginPath(); c.moveTo(x0, y0); c.quadraticCurveTo((x0 + x1) / 2, y0 - m * 0.06, x1, y1); c.stroke();
      c.beginPath(); c.moveTo(x1 - m * 0.02, y1 - m * 0.015); c.lineTo(x1, y1); c.lineTo(x1 - m * 0.025, y1 + m * 0.01); c.stroke();
      c.restore();
    },
  };
})();

/* ── js/scenes-r6-cam.js ── */
/* צמצם, סבב 6 (20.09.2026). יובל על 13 המעודכן: «זה הכיוון, אבל זה צריך דיוק. צור לי 5 גרסאות
   כדי שנוכל לסיים עם זה. תציע כיוונים שונים באזור של מה שעשית».
   ⟹ בכל החמש הבסיס זהה ל-13: אותו צילום אמיתי של Apple עם טשטוש לפי מפת עומק, ואותן ארבע עצירות.
   מה שמשתנה הוא שני דברים בלבד: איך הלהבים מוצגים על הטלפון, ואיך רואים את הטרייד-אוף בצד.
   cam-16 העדשה על המסך · cam-17 מאזניים · cam-18 שני טורים · cam-19 הלהבים על הצילום · cam-20 עדשה עם קשתות
   🔴 זו המחשה על צילום אמיתי, לא צילום בכל צמצם. Apple אינה מפרסמת את אותו צילום בכמה צמצמים. */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, C5 = L.camKit5;
  const { photo, viewfinder, VCX, camera, stepAt, NS, WORD, DUR, labelOf, closeOf, YEL } = C5;

  /* שני הערכים. האור הולך לפי 1 חלקי N בריבוע. עומק הפוקוס: ב-ƒ/1.48 רק האיש שמקדימה, וב-ƒ/4 כולם.
     🔴 הניסוח «כמות האור» ו«עומק הפוקוס» הוא בחירת יובל 20.09.2026, ואינו קוסמטי:
     «חדות» היה שקרי, כי האיש שמקדימה חד באותה מידה בכל צמצם. מה שגדל הוא כמה מהסצנה בפוקוס. */
  const lightOf = N => u.clamp(Math.pow(1.48 / N, 2));
  const sharpOf = N => u.clamp(0.34 + 0.66 * closeOf(N));
  const WARM = '#FFC98A', COOL = '#9ED0FF';

  /* הכותרת ליד הטלפון: המספר הגדול ומה קורה במילים. זהה בכל חמש הגרסאות */
  const head = (c, ax, H, room, m, st, I, y) => {
    const px = K2.fit(c, 'ƒ/1.48', room * 0.78, H * 0.13);
    K2.pop(c, `ƒ/${labelOf(NS[st.idx])}`, ax, H * y, px, I, { age: st.age });
    const fs = Math.max(12, Math.min(m * 0.048, K2.fit(c, WORD[0], room * 0.92, 99, 700)));
    c.save(); c.globalAlpha = u.clamp(st.age / 0.4);
    u.text(c, WORD[st.idx], ax, H * y + px * 0.78, fs, 'rgba(255,255,255,0.88)', 700, 'center', 'rtl');
    c.restore();
    return px;
  };

  /* ───────── 16 · העדשה על המסך ─────────
     המסך עצמו הוא עדשה: הצילום בעיגול, ושישה להבים נכנסים אליו מבחוץ ככל שהמספר עולה.
     הצילום לעולם אינו מוסתר, ולכן רואים גם את הלהבים וגם את מה שקורה ברקע.
     ליד הטלפון: המספר, ושני מדדים בפסים, כמו ב-13 */
  const lensOnScreen = (c, W, H, val) => {
    const m = Math.min(W, H), cx = W / 2, cy = H * 0.42, R = Math.min(W * 0.39, H * 0.23);
    c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
    c.save(); c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.clip();
    photo(c, cx - R, cy - R, R * 2, R * 2, val, { cx: VCX + 0.03, cy: 0.42, zoom: 1.5 });
    c.restore();
    /* גוף העדשה: טבעת בלבד, עם חור בגודל הצילום */
    const Ro = R * 1.45, close = closeOf(val), r = u.lerp(Ro * 0.97, R * 1.07, Math.pow(close, 0.8));
    const g = c.createRadialGradient(cx, cy, R, cx, cy, Ro * 1.12);
    g.addColorStop(0, '#191920'); g.addColorStop(1, '#05050700');
    c.beginPath(); c.arc(cx, cy, Ro * 1.12, 0, Math.PI * 2); c.arc(cx, cy, R, 0, Math.PI * 2, true);
    c.fillStyle = g; c.fill('evenodd');
    /* הלהבים: משושה בגודל r, בתוך העיגול החיצוני */
    const rot = 0.25 + close * 0.9;
    c.beginPath(); c.arc(cx, cy, Ro, 0, Math.PI * 2);
    for (let i = 5; i >= 0; i--) { const a = rot + (i / 6) * Math.PI * 2, X = cx + Math.cos(a) * r, Y = cy + Math.sin(a) * r; i === 5 ? c.moveTo(X, Y) : c.lineTo(X, Y); }
    c.closePath();
    const bg = c.createLinearGradient(cx - Ro, cy - Ro, cx + Ro, cy + Ro); bg.addColorStop(0, '#2C2C34'); bg.addColorStop(1, '#0C0C10');
    c.fillStyle = bg; c.fill('evenodd');
    c.strokeStyle = 'rgba(255,255,255,0.18)'; c.lineWidth = Math.max(1, R * 0.008);
    c.beginPath();
    for (let i = 0; i < 6; i++) { const a = rot + (i / 6) * Math.PI * 2, X = cx + Math.cos(a) * r, Y = cy + Math.sin(a) * r, b = a + 1.15; c.moveTo(X, Y); c.lineTo(cx + Math.cos(b) * Ro, cy + Math.sin(b) * Ro); }
    c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.3)'; c.lineWidth = Math.max(1.5, R * 0.014);
    c.beginPath(); c.arc(cx, cy, R, 0, Math.PI * 2); c.stroke();
    /* שורת הצמצם למטה, בלי עינית */
    u.status(c, W, H, { level: 0.8 });
    const y = H * 0.76;
    u.text(c, 'פורטרט', W / 2, y - m * 0.03, m * 0.05, YEL, 600);
    [1.48, 1.8, 2.8, 4.0].forEach((n, k) => {
      const x = W / 2 - (1.5 - k) * W * 0.21, on = Math.abs(n - val) < 0.12;
      u.text(c, labelOf(n), x, y + m * 0.05, on ? m * 0.062 : m * 0.047, on ? YEL : 'rgba(255,255,255,0.6)', on ? 700 : 500, 'center', 'ltr');
    });
    u.text(c, 'ƒ', W * 0.06, y + m * 0.05, m * 0.056, 'rgba(255,255,255,0.8)', 600, 'center', 'ltr');
    K.shutter(c, W, H, '');
  };
  /* שני פסים, כמו ב-13 */
  const bars = (c, ax, room, H, m, N) => {
    const bw = Math.min(room * 0.84, m * 0.54), x1 = ax + bw / 2, bh = Math.max(7, m * 0.022);
    const fs = Math.max(11, Math.min(m * 0.04, K2.fit(c, 'עומק הפוקוס', bw - m * 0.1, 99, 500)));
    [['כמות האור', 'sun', lightOf(N), WARM, 'rgba(255,160,90,0.85)'], ['עומק הפוקוס', 'photoWide', sharpOf(N), COOL, 'rgba(110,175,240,0.85)']].forEach(([label, icon, v, c0, c1], k) => {
      const y = H * (0.58 + k * 0.21);
      c.save(); c.strokeStyle = 'rgba(255,255,255,0.8)'; K2.icon[icon](c, x1 - m * 0.028, y - fs * 1.6, m * 0.058); c.restore();
      u.text(c, label, x1 - m * 0.07, y - fs * 1.6, fs, 'rgba(255,255,255,0.85)', 500, 'right', 'rtl');
      u.rr(c, x1 - bw, y, bw, bh, bh / 2, 'rgba(255,255,255,0.12)');
      const fw = Math.max(bh, bw * v), g = c.createLinearGradient(x1, 0, x1 - bw, 0);
      g.addColorStop(0, c0); g.addColorStop(1, c1);
      u.rr(c, x1 - fw, y, fw, bh, bh / 2, g);
    });
  };
  S['cam-16'] = {
    dur: DUR,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) { lensOnScreen(c, W, H, stepAt(t).val); },
    stage(c, W, H, t, I, scr) {
      const st = stepAt(t), { room, ax, m } = K.room(W, H, scr);
      head(c, ax, H, room, m, st, I, 0.22);
      bars(c, ax, room, H, m, st.val);
    },
  };

  /* ───────── 17 · מאזניים ─────────
     הטלפון בדיוק כמו 13, עם הלהבים בפינת העינית. בצד, במקום שני פסים, מאזניים אחד:
     קורה שנוטה בין «אור» ל«פוקוס». כשאחד עולה השני יורד, וזה נראה בבת אחת */
  const seesaw = (c, ax, cy, w, m, light, sharp) => {
    const tilt = (light - sharp) * 0.32, r = Math.max(12, w * 0.15);
    const ex = Math.cos(tilt) * (w / 2), ey = Math.sin(tilt) * (w / 2);
    /* הבסיס */
    c.fillStyle = 'rgba(255,255,255,0.16)';
    c.beginPath(); c.moveTo(ax, cy - m * 0.01); c.lineTo(ax + m * 0.045, cy + m * 0.08); c.lineTo(ax - m * 0.045, cy + m * 0.08); c.closePath(); c.fill();
    c.save(); c.translate(ax, cy); c.rotate(tilt);
    u.rr(c, -w / 2, -m * 0.009, w, m * 0.018, m * 0.009, 'rgba(255,255,255,0.8)');
    c.restore();
    const fs = Math.max(12, m * 0.044);
    [[ax + ex, cy + ey, 'sun', 'אור', light, WARM], [ax - ex, cy - ey, 'photoWide', 'פוקוס', sharp, COOL]].forEach(([x, y, icon, label, v, col]) => {
      c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.fillStyle = 'rgba(14,14,18,0.92)'; c.fill();
      c.strokeStyle = 'rgba(255,255,255,0.14)'; c.lineWidth = Math.max(1.5, r * 0.1);
      c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.stroke();
      c.strokeStyle = col;
      c.beginPath(); c.arc(x, y, r, -Math.PI / 2, -Math.PI / 2 + Math.PI * 2 * Math.max(0.02, v)); c.stroke();
      c.save(); c.strokeStyle = col; K2.icon[icon](c, x, y, r * 0.95); c.restore();
      u.text(c, label, x, cy + w * 0.34, fs, '#fff', 700, 'center', 'rtl');
    });
  };
  S['cam-17'] = {
    dur: DUR,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) { const st = stepAt(t); camera(c, W, H, I, st.val, { iris: true, moving: st.moving }); },
    stage(c, W, H, t, I, scr) {
      const st = stepAt(t), { room, ax, m } = K.room(W, H, scr);
      head(c, ax, H, room, m, st, I, 0.2);
      seesaw(c, ax, H * 0.62, Math.min(room * 0.78, m * 0.5), m, lightOf(st.val), sharpOf(st.val));
    },
  };

  /* ───────── 18 · שני טורים ─────────
     על המסך הלהבים יושבים בשורת הצמצם עצמה, במקום האות ƒ, ונפתחים ונסגרים עם המספר.
     בצד שני טורים אנכיים שמתמלאים הפוך זה לזה, עם שנתות, כמו שני מדים על לוח */
  const columns = (c, ax, top, hc, m, light, sharp) => {
    const w = Math.max(16, m * 0.08), gap = Math.max(w * 2.4, m * 0.17), fs = Math.max(12, m * 0.044);
    [[ax + gap / 2, light, 'sun', 'אור', WARM, 'rgba(255,160,90,0.9)'], [ax - gap / 2, sharp, 'photoWide', 'פוקוס', COOL, 'rgba(110,175,240,0.9)']].forEach(([x, v, icon, label, c0, c1]) => {
      c.save(); c.strokeStyle = 'rgba(255,255,255,0.85)'; K2.icon[icon](c, x, top - m * 0.05, m * 0.06); c.restore();
      u.rr(c, x - w / 2, top, w, hc, w / 2, 'rgba(255,255,255,0.1)');
      const fh = Math.max(w, hc * v), g = c.createLinearGradient(0, top + hc, 0, top + hc - fh);
      g.addColorStop(0, c1); g.addColorStop(1, c0);
      u.rr(c, x - w / 2, top + hc - fh, w, fh, w / 2, g);
      /* שנתות */
      c.strokeStyle = 'rgba(255,255,255,0.22)'; c.lineWidth = 1;
      for (let k = 1; k < 4; k++) { const y = top + (hc * k) / 4; c.beginPath(); c.moveTo(x - w * 0.78, y); c.lineTo(x - w * 0.5, y); c.moveTo(x + w * 0.5, y); c.lineTo(x + w * 0.78, y); c.stroke(); }
      u.text(c, label, x, top + hc + fs * 1.5, fs, '#fff', 700, 'center', 'rtl');
    });
  };
  S['cam-18'] = {
    dur: DUR,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) { camera(c, W, H, I, stepAt(t).val, { irisRow: true }); },
    stage(c, W, H, t, I, scr) {
      const st = stepAt(t), { room, ax, m } = K.room(W, H, scr);
      head(c, ax, H, room, m, st, I, 0.2);
      columns(c, ax, H * 0.46, H * 0.32, m, lightOf(st.val), sharpOf(st.val));
    },
  };

  /* ───────── 19 · הלהבים על הצילום ─────────
     במנוחה המסך נקי לגמרי. בכל מעבר בין צמצמים הלהבים נסגרים על הצילום עצמו ונפתחים בחזרה,
     בדיוק כמו עדשה. בצד גרף אחד: קו האור יורד, קו החדות עולה, והם נחתכים באמצע */
  const graph = (c, x0, y0, w, h, m, N) => {
    const px = n => x0 + (Math.log(n / 1.48) / Math.log(4 / 1.48)) * w, py = v => y0 + h - v * h;
    c.strokeStyle = 'rgba(255,255,255,0.12)'; c.lineWidth = 1;
    c.beginPath(); c.moveTo(x0, y0); c.lineTo(x0, y0 + h); c.lineTo(x0 + w, y0 + h); c.stroke();
    const curve = (f, col) => {
      c.beginPath();
      for (let i = 0; i <= 40; i++) { const n = 1.48 * Math.pow(4 / 1.48, i / 40), X = px(n), Y = py(f(n)); i ? c.lineTo(X, Y) : c.moveTo(X, Y); }
      c.strokeStyle = col; c.lineWidth = Math.max(2, m * 0.007); c.lineCap = 'round'; c.stroke(); c.lineCap = 'butt';
    };
    curve(lightOf, WARM); curve(sharpOf, COOL);
    const X = px(N);
    c.save(); c.setLineDash([3, 4]); c.strokeStyle = 'rgba(255,255,255,0.4)'; c.lineWidth = 1;
    c.beginPath(); c.moveTo(X, y0 - m * 0.01); c.lineTo(X, y0 + h); c.stroke(); c.restore();
    [[lightOf(N), WARM], [sharpOf(N), COOL]].forEach(([v, col]) => {
      c.fillStyle = col; c.beginPath(); c.arc(X, py(v), Math.max(3, m * 0.011), 0, Math.PI * 2); c.fill();
      c.fillStyle = '#0A0A0C'; c.beginPath(); c.arc(X, py(v), Math.max(1.2, m * 0.004), 0, Math.PI * 2); c.fill();
    });
    const fs = Math.max(11, m * 0.036);
    u.text(c, 'אור', x0 + w * 0.06, py(1) - fs * 0.9, fs, WARM, 700, 'center', 'rtl');
    u.text(c, 'פוקוס', x0 + w * 0.94, py(1) - fs * 0.9, fs, COOL, 700, 'center', 'rtl');
    u.text(c, '1.48', x0, y0 + h + fs * 1.3, fs * 0.9, 'rgba(255,255,255,0.5)', 500, 'center', 'ltr');
    u.text(c, 'ƒ/4', x0 + w, y0 + h + fs * 1.3, fs * 0.9, 'rgba(255,255,255,0.5)', 500, 'center', 'ltr');
  };
  S['cam-19'] = {
    dur: DUR,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) {
      const st = stepAt(t), m = Math.min(W, H);
      camera(c, W, H, I, st.val);
      const a = st.moving ? Math.sin(Math.PI * st.k) : 0;
      if (a <= 0.01) return;
      const v = viewfinder(W, H), R = Math.min(v.vw, v.vh) * 0.66;
      c.save(); c.globalAlpha = a * 0.9;
      K.iris(c, v.vx + v.vw / 2, v.vy + v.vh / 2, R, u.lerp(0.95, 0.26, closeOf(st.val)), { blades: 6, fill: 'rgba(5,5,7,0.78)', edge: YEL, rot: 0.3 });
      u.text(c, `ƒ/${labelOf(NS[st.to])}`, v.vx + v.vw / 2, v.vy + v.vh * 0.5, m * 0.075, YEL, 700, 'center', 'ltr');
      c.restore();
    },
    stage(c, W, H, t, I, scr) {
      const st = stepAt(t), { room, ax, m } = K.room(W, H, scr);
      head(c, ax, H, room, m, st, I, 0.2);
      const w = Math.min(room * 0.8, m * 0.52);
      graph(c, ax - w / 2, H * 0.5, w, H * 0.26, m, st.val);
    },
  };

  /* ───────── 20 · עדשה עם קשתות ─────────
     הטלפון כמו 13. בצד עדשה גדולה עם הלהבים, ושתי קשתות סביבה: החיצונית אור והפנימית חדות.
     אחת מתמלאת כשהשנייה מתרוקנת, והמספר יושב מתחת */
  S['cam-20'] = {
    dur: DUR,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) { const st = stepAt(t); camera(c, W, H, I, st.val, { iris: true, moving: st.moving }); },
    stage(c, W, H, t, I, scr) {
      const st = stepAt(t), { room, ax, m } = K.room(W, H, scr), N = st.val;
      const R = Math.min(room * 0.26, H * 0.15), cy = H * 0.32;
      /* העדשה */
      c.fillStyle = '#16161B'; c.beginPath(); c.arc(ax, cy, R * 1.1, 0, Math.PI * 2); c.fill();
      const lg = c.createRadialGradient(ax, cy, 0, ax, cy, R); lg.addColorStop(0, 'rgba(255,226,172,0.95)'); lg.addColorStop(1, 'rgba(255,164,92,0.6)');
      c.fillStyle = lg; c.beginPath(); c.arc(ax, cy, R, 0, Math.PI * 2); c.fill();
      K.iris(c, ax, cy, R, u.lerp(0.95, 0.3, closeOf(N)), { blades: 6, fill: '#0C0C0F', edge: 'rgba(255,255,255,0.22)', rot: 0.3 });
      /* שתי הקשתות */
      /* בלי אייקונים על הקשתות: בשני הרדיוסים הם נוחתים כמעט באותה נקודה ונדבקים זה לזה */
      const arcs = [[R * 1.34, lightOf(N), WARM], [R * 1.62, sharpOf(N), COOL]];
      c.lineCap = 'round';
      arcs.forEach(([rr, v, col]) => {
        c.lineWidth = Math.max(4, m * 0.016);
        c.strokeStyle = 'rgba(255,255,255,0.1)';
        c.beginPath(); c.arc(ax, cy, rr, -Math.PI * 0.75, Math.PI * 0.75); c.stroke();
        c.strokeStyle = col;
        c.beginPath(); c.arc(ax, cy, rr, -Math.PI * 0.75, -Math.PI * 0.75 + Math.PI * 1.5 * Math.max(0.02, v)); c.stroke();
      });
      c.lineCap = 'butt';
      /* התוויות מתחת לעדשה, כדי שלא ייחתכו בקצה הבמה */
      const fs = Math.max(11, m * 0.038), ty = cy + R * 1.95;
      [['אור', WARM, ax + R * 0.95], ['פוקוס', COOL, ax - R * 0.95]].forEach(([tx, col, x]) => u.text(c, tx, x, ty, fs, col, 700, 'center', 'rtl'));
      head(c, ax, H, room, m, st, I, 0.74);
    },
  };
})();

/* ── js/scenes-r5-bat.js ── */
/* סוללה, סבב 5 (17.09.2026). יובל: «12, אבל זה צריך להיות יותר זורם, בלי התקעויות. גם אם הודעה לא באמת מסונכרנת
   לשעה. שתמיד ירוץ בקצב אחיד, ומקסימום ההודעות בקצב שלהן».
   ⟹ שני שעונים נפרדים, ושניהם אחידים מההתחלה ועד הסוף:
   · השעות: עולות בקו ישר מ-0 עד 23, בלי עמידה ובלי האצה. השמש והירח זזים בקצב קבוע.
   · הבועות: אחת בכל BEAT שניות, על מסוע שזז כל הזמן באותה מהירות. אין רגע שבו הכול עומד.
   הרגע על המסך מתחלף עם הבועה, ולכן הוא לא תמיד בשעה המדויקת שלו. יובל אישר את זה במפורש.
   בסוף «ועדיין יש סוללה» נשאר, והשעות נעצרות ב-23.
   bat-13 מסוע אנכי מתחת לקשת · bat-14 המחשבות עולות אל השמיים */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, BK = L.batKit, B3 = L.batKit3;
  /* 🔴 קוצר 21.09.2026 מ-14 רגעים לתשעה, בפעימה 1.35. ‏25.2 ⟵ 13.55 שניות.
     🔴 «קודם כל תמונה» (13:00) ירד בבקשת יובל.
     🔴 KEEP הוא האינדקס המקורי, כי B3.screenAt מקבל אינדקס לתוך B3.BEATS ולא את הרגע עצמו.
     חיתוך המערך בלי המיפוי הזה היה מצייר מסך שאינו שייך לבועה.

     🔴 הסוף נכתב מחדש 21.09.2026, והנימוק של יובל נכון: **שינה אינה שימוש.**
     «ועדיין יש סוללה» אחרי לילה של שינה אינו מוכיח כלום, כי הטלפון פשוט שכב.
     ⟹ כיבוי אור ב-0:30, קם אחרי חצי שעה, ובינג׳ עד הבוקר. ורק אז «ועדיין יש סוללה».
     🔴 KEEP אינו עולה (12 לפני 11) בכוונה: 12 הוא מסך כבוי ו-11 הוא וידאו,
     ולכן המסך נכבה ואז נדלק שוב. hoursAt לינארי ואינו נגזר מ-BEATS, ולכן הסדר חוקי. */
  const KEEP = [0, 3, 5, 7, 8, 9, 12, 11, 13];
  /* הנוסח של שלושת האחרונים נכתב כאן ולא ב-B3, כדי לא לשנות את סבבים 3 ו-4 */
  const SAY = { 12: 'אור כבוי ב-0:30', 11: 'קם, ובינג׳ עד הבוקר', 13: 'ועדיין יש סוללה' };
  const BEATS = KEEP.map(i => (SAY[i] ? [B3.BEATS[i][0], B3.BEATS[i][1], B3.BEATS[i][2], SAY[i], B3.BEATS[i][4]] : B3.BEATS[i]));
  const N = BEATS.length, BEAT = 1.35, RUN = (N - 1) * BEAT, DUR = N * BEAT + 1.4;
  const LONG = 'מכוונים שעון ל-6:30';
  /* השעות בקו ישר: 23 בדיוק כשהרגע האחרון מתחיל */
  const hoursAt = t => 23 * u.clamp(t / RUN);
  const beatAt = t => Math.min(N - 1, Math.floor(Math.max(0, t) / BEAT));
  const screen = (c, W, H, t, I) => { const i = beatAt(t); B3.screenAt(c, W, H, KEEP[i], t - i * BEAT, hoursAt(t), I.tg, I, BEAT); };

  /* בועה, בלי זנב או עם זנב קטן אל הטלפון */
  const bubble = (c, cx, cy, bw, bh, text, { alpha = 1, scale = 1, tail = false, fs = 14 } = {}) => {
    if (alpha <= 0.01) return;
    c.save(); c.globalAlpha = alpha;
    c.translate(cx, cy); c.scale(scale, scale);
    c.shadowColor = 'rgba(0,0,0,0.35)'; c.shadowBlur = bh * 0.25;
    u.rr(c, -bw / 2, -bh / 2, bw, bh, bh * 0.48, '#F4F1EC');
    c.shadowColor = 'transparent';
    if (tail) [[0.56, 0.62, 0.11], [0.66, 0.84, 0.07], [0.73, 1.0, 0.045]].forEach(([fx, fy, fr]) => { c.fillStyle = '#F4F1EC'; c.beginPath(); c.arc(bw * fx - bw * 0.02, bh * fy, bh * fr, 0, Math.PI * 2); c.fill(); });
    u.text(c, text, 0, 1, fs, '#1C1C1E', 700, 'center', 'rtl');
    c.restore();
  };
  const hoursRow = (c, W, H, scr, h, I, y) => K.bigNumber(c, W, H, scr, String(Math.floor(h)), 'שעות של שימוש', I, { sample: '23', maxH: 0.15, y });

  /* ───────── 13 · מסוע מתחת לקשת ─────────
     כמו 12: הקשת של השמש והירח למעלה, והבועות למטה. כל בועה נכנסת מלמטה, עולה בקצב קבוע, מתכווצת ודוהה.
     תמיד שלוש בועות בתנועה, ואף פעם לא עוצרות */
  S['bat-13'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I); },
    stage(c, W, H, t, I, scr) {
      const h = hoursAt(t), { room, ax, m } = K.room(W, H, scr);
      const sk = BK.sky(c, W, H, h + 6.5 - 7, I, room, ax, m, { arcY: 0.2, R0: 0.3 });
      u.text(c, B3.clockOf(h), ax, sk.hy + m * 0.05, Math.max(12, m * 0.042), 'rgba(255,255,255,0.85)', 600, 'center', 'ltr');
      const bw = Math.min(room * 0.9, m * 0.64), bh = Math.max(44, H * 0.12);
      const fs = Math.max(10, Math.min(bh * 0.3, K2.fit(c, LONG, bw * 0.82, 99, 700)));
      /* p: כמה BEAT עברו מאז שהבועה נכנסה. 0 נכנסת בתחתית, 3 נעלמת למעלה */
      const Y0 = H * 0.7, Y3 = H * 0.3, now = t / BEAT;
      for (let k = Math.max(0, Math.floor(now) - 3); k <= Math.min(N - 1, Math.floor(now)); k++) {
        const p = now - k;
        if (p < 0 || p > 3.2) continue;
        const y = u.lerp(Y0, Y3, p / 3), sc = u.lerp(1, 0.7, u.clamp(p / 3));
        const a = u.clamp(p / 0.35) * u.clamp((3.2 - p) / 0.9);
        /* הבועה האחרונה לא ממשיכה לעלות עד שנעלמת: היא מאטה בעדינות ונעצרת (אותה מהירות בהתחלה, בלי קפיצה) */
        const last = k === N - 1, pl = last ? 1.2 * (1 - Math.exp(-p / 1.2)) : p;
        bubble(c, ax, last ? u.lerp(Y0, Y3, pl / 3) : y, bw, bh, BEATS[k][3], { alpha: last ? u.clamp(p / 0.35) : a, scale: last ? u.lerp(1, 0.7, pl / 3) : sc, fs, tail: p < 1 });
      }
      hoursRow(c, W, H, scr, h, I, 0.88);
    },
  };

  /* ───────── 14 · המחשבות עולות אל השמיים ─────────
     הקשת גדולה ותופסת את רוב השטח. כל בועה יוצאת קטנה מצד הטלפון, גדלה בדרך, ועולה באלכסון רך אל השמיים,
     שם היא דוהה. כמה בועות תמיד באוויר, וכולן זזות באותה מהירות */
  S['bat-14'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { screen(c, W, H, t, I); },
    stage(c, W, H, t, I, scr) {
      const h = hoursAt(t), { room, ax, m } = K.room(W, H, scr);
      /* בלי שעה מתחת לקו האופק: הבועות עוברות שם, והשעה כבר כתובה בראש המסך (צילום 17.09) */
      BK.sky(c, W, H, h + 6.5 - 7, I, room, ax, m, { arcY: 0.58, R0: 0.44 });
      const bw = Math.min(room * 0.84, m * 0.58), bh = Math.max(40, H * 0.1);
      const fs = Math.max(10, Math.min(bh * 0.3, K2.fit(c, LONG, bw * 0.82, 99, 700)));
      /* המסלול: מהפינה שליד הטלפון, למטה, אל מרכז השמיים */
      const P0 = [room * 0.8, H * 0.64], P1 = [room * 0.46, H * 0.42], P2 = [room * 0.4, H * 0.08];
      const path = s => { const a = 1 - s; return [a * a * P0[0] + 2 * a * s * P1[0] + s * s * P2[0], a * a * P0[1] + 2 * a * s * P1[1] + s * s * P2[1]]; };
      const LIFE = 2.6, now = t / BEAT;
      for (let k = Math.max(0, Math.floor(now - LIFE)); k <= Math.min(N - 1, Math.floor(now)); k++) {
        const p = now - k;
        if (p < 0 || p > LIFE) continue;
        const last = k === N - 1, s = (last ? 1.1 * (1 - Math.exp(-p / 1.1)) : p) / LIFE, [x, y] = path(s);
        const sc = u.lerp(0.55, 1, u.easeOut(u.clamp(s / 0.35))) * u.lerp(1, 0.8, u.clamp((s - 0.5) / 0.5));
        const a = last ? u.clamp(p / 0.3) : u.clamp(p / 0.3) * u.clamp((LIFE - p) / 0.8);
        bubble(c, x, y, bw, bh, BEATS[k][3], { alpha: a, scale: sc, fs });
      }
      hoursRow(c, W, H, scr, h, I, 0.86);
    },
  };
})();

/* ── js/scenes-r5-vid.js ── */
/* וידאו, סבב 5 (17.09.2026). יובל: «סרטון של שנייה, ואז גוללים כל פריים ופריים, 120 כאלה באמת, וכל אחד מהם רואים
   את התנועה. עם הכוס מים. ואז בספלאש, איפה שעצרת ב-12, גם תעצור. פשוט סרטון של שנייה של התות, ואז רואים את כל
   הפריימים רצים מהר, ובספלאש אתה עוצר».
   ⟹ שני חלקים בכל אחת מהשלוש: ① מצלמים שנייה אחת של התות, בזמן אמת. ② 120 הפריימים של אותה שנייה, כל אחד ציור
   נפרד של הרגע שלו (tau = (k - 1) / 120), רצים ברצף ומאטים עד שנעצרים על הפריים של ההתזה, כמו ב-12.
   הפריים: 46 מתוך 120 (0.375 שניות, ההתזה הראשונה). כל פריים באמת שונה, ולכן המונה אמיתי.
   🔴 בלי הבהוב: הפריימים הם ציור רציף של תנועה, לא החלפה של בהיר וכהה (WCAG 2.3.1).
   vid-13 עריכה בטלפון · vid-14 פס צילום ליד הטלפון · vid-15 כל 120 על דף אחד
   🆕 סבב 6 (20.09.2026). יובל על 14: «עכשיו זה נראה כאילו התות פוגע במים, נעצר, ובצד זה ממשיך לרוץ.
   אני רוצה שזה ייראה שזה עוצר ביחד באותה שנייה, אולי בספלאש הראשון של התות, שיהיה יותר ברור».
   ⟹ שני שינויים: ① העצירה עברה לפריים 46, ההתזה הראשונה (הפגיעה בפריים 37, והטיפות עפות מיד אחריה),
   במקום 53 שהוא שיא הכתר. ② ההאטה התקצרה מ-1.07 שניות ל-0.4: 30 פריימים בשנייה עד 40, ואז האטה קצרה.
   ההאטה הארוכה היא מה שנראה כמו «הטלפון נעצר והפס ממשיך», כי 16 פריימים של כתר עולה נראים כמעט זהים.
   ③ ורגע העצירה מסומן בשני המקומות יחד: סוגריים צהובים על המסך, והפס בצד מתעמעם חוץ מהפריים שנעצר. */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, SP = L.splashKit;
  const FR = 120, PEAK = 46, YEL = '#FFD60A';
  const tauOf = k => (k - 1) / FR;

  /* ── הציר, משותף לשלוש ── */
  const T = { rec0: 0.5, rec1: 1.9, cut: 2.4, run0: 2.8 };   /* הוארך 21.09.2026, יובל: «נראה חתוך» */
  const SPEED = 20, CRUISE = 40;                       // 30 פריימים בשנייה עד פריים 40, ואז האטה קצרה עד 46
  T.cruise1 = T.run0 + (CRUISE - 1) / SPEED;
  T.stop = T.cruise1 + (2 * (PEAK - CRUISE)) / SPEED;   // האטה אחידה: מרחק = מהירות × זמן / 2
  T.end = T.stop + 3.2;
  /* הפריים שעל המסך, כמספר עשרוני (לתנועה חלקה של הפס), ו-k השלם */
  const frameAt = t => {
    if (t < T.run0) return 1;
    if (t < T.cruise1) return 1 + (t - T.run0) * SPEED;
    if (t < T.stop) { const d = T.stop - T.cruise1, x = (t - T.cruise1) / d; return CRUISE + (PEAK - CRUISE) * (1 - (1 - x) * (1 - x)); }
    return PEAK;
  };
  const phase = t => (t < T.cut ? 'rec' : t < T.run0 ? 'cut' : 'run');

  /* ── תמונות קטנות של פריימים, נשמרות לפי גודל. תקציב לכל ציור, כדי שהטעינה לא תתקע ── */
  const cache = {}; let budget = 0;
  const thumb = (k, w, h) => {
    const dpr = Math.min(2, window.devicePixelRatio || 1), W = Math.max(2, Math.round(w * dpr)), H = Math.max(2, Math.round(h * dpr));
    const key = `${k}:${W}x${H}`;
    if (cache[key]) return cache[key];
    if (budget <= 0) return null;
    budget--;
    const keys = Object.keys(cache); if (keys.length > 900) keys.slice(0, 200).forEach(q => delete cache[q]);
    const cv = document.createElement('canvas'); cv.width = W; cv.height = H;
    const x = cv.getContext('2d'); x.scale(W / w, H / h);
    SP.splash(x, 0, 0, w, h, tauOf(k));
    return (cache[key] = cv);
  };
  const putThumb = (c, k, x, y, w, h) => { const im = thumb(k, w, h); if (im) c.drawImage(im, x, y, w, h); else { c.fillStyle = '#10131A'; c.fillRect(x, y, w, h); } };

  /* ממשק הצילום: גלולה, והקלטה אדומה עם שניות ומאיות */
  const recUI = (c, W, H, t) => {
    const m = Math.min(W, H), on = t >= T.rec0 && t < T.rec1, el = u.clamp(t - T.rec0, 0, 1);
    u.status(c, W, H, { level: 0.8 });
    u.pill(c, '4K · 120', W * 0.2, H * 0.085, m * 0.04, '#fff', 'rgba(0,0,0,0.55)', 'ltr');
    u.rr(c, W * 0.62, H * 0.085 - m * 0.04, m * 0.34, m * 0.08, m * 0.04, on ? '#FF3B30' : 'rgba(0,0,0,0.55)');
    u.text(c, `00:0${Math.floor(el)}.${String(Math.floor((el % 1) * 100)).padStart(2, '0')}`, W * 0.62 + m * 0.17, H * 0.085, m * 0.038, '#fff', 600, 'center', 'ltr');
    /* כפתור ההקלטה */
    const sy = H * 0.92, r = m * 0.075;
    c.strokeStyle = '#fff'; c.lineWidth = m * 0.01; c.beginPath(); c.arc(W / 2, sy, r, 0, Math.PI * 2); c.stroke();
    if (on) u.rr(c, W / 2 - r * 0.4, sy - r * 0.4, r * 0.8, r * 0.8, r * 0.15, '#FF3B30');
    else { c.fillStyle = '#FF3B30'; c.beginPath(); c.arc(W / 2, sy, r * 0.8, 0, Math.PI * 2); c.fill(); }
  };
  /* החלק הראשון, משותף: שנייה אחת בזמן אמת, והמסך נסגר לרגע */
  const recording = (c, W, H, t) => {
    const tau = t < T.rec0 ? 0 : Math.min(1, t - T.rec0);
    SP.splash(c, 0, 0, W, H, tau);
    recUI(c, W, H, t);
    if (t > T.rec1) { c.fillStyle = `rgba(0,0,0,${u.clamp((t - T.rec1) / (T.cut - T.rec1)) * 0.85})`; c.fillRect(0, 0, W, H); }
  };
  const recStage = (c, W, H, t, I, scr) => {
    const { room, ax, m } = K.room(W, H, scr), a = u.clamp((t - 0.1) / 0.3) * (1 - u.clamp((t - T.cut) / 0.3));
    if (a <= 0) return;
    c.save(); c.globalAlpha = a;
    const px = K2.fit(c, '1', room * 0.3, H * 0.2);
    K2.pop(c, '1', ax, H * 0.42, px, I, { age: t, alpha: a });
    const fs = Math.min(m * 0.055, K2.fit(c, 'שנייה אחת של וידאו', room * 0.88, 99, 700));
    u.text(c, 'שנייה אחת של וידאו', ax, H * 0.42 + px * 0.7, fs, '#fff', 700, 'center', 'rtl');
    c.restore();
  };
  /* המונה ליד הטלפון: פריים, מתוך 120, ובעצירה המשפט */
  const counter = (c, ax, y, room, H, m, t, I, k, alpha = 1) => {
    const stopped = t >= T.stop, px = K2.fit(c, '120', room * 0.5, H * 0.16);
    K2.pop(c, String(k), ax, y, px, I, { age: stopped ? t - T.stop : 9, alpha });
    u.text(c, 'מתוך 120 בשנייה', ax, y + px * 0.62, Math.max(11, m * 0.04), 'rgba(255,255,255,0.72)', 500, 'center', 'rtl');
    const a = u.clamp((t - T.stop - 0.2) / 0.4);
    if (a > 0) {
      c.save(); c.globalAlpha = a;
      const fs = Math.min(m * 0.055, K2.fit(c, 'יש תמונה בדיוק ברגע', room * 0.9, 99, 700));
      u.text(c, 'יש תמונה בדיוק ברגע', ax, y + px * 0.62 + fs * 1.7, fs, u.acc(I, 1), 700, 'center', 'rtl');
      c.restore();
    }
  };

  /* ───────── 13 · עריכה בטלפון ─────────
     אחרי השנייה, הטלפון עובר לעריכה: למעלה הפריים הגדול, ולמטה פס של כל הפריימים. הפס רץ תחת סמן צהוב,
     פריים אחרי פריים, מאט ונעצר על ההתזה. ליד הטלפון המונה */
  S['vid-13'] = {
    dur: T.end,
    shift: 0.22,
    draw(c, W, H, t, side, I) {
      budget = 14;
      if (phase(t) !== 'run') { recording(c, W, H, t); return; }
      const m = Math.min(W, H), f = frameAt(t), k = Math.round(f), a = u.clamp((t - T.run0) / 0.3);
      c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
      /* הפריים הגדול */
      const pw = W, ph = H * 0.62, py = H * 0.1;
      SP.splash(c, 0, py, pw, ph, tauOf(k));
      u.status(c, W, H, { level: 0.8 });
      u.pill(c, `פריים ${k} מתוך 120`, W / 2, py + m * 0.07, m * 0.042, '#fff', 'rgba(0,0,0,0.6)', 'rtl');
      /* הפס: כל פריים משבצת, והסמן באמצע */
      const th = H * 0.13, tw = th * 0.75, gap = Math.max(1, tw * 0.06), sy = py + ph + H * 0.07, step = tw + gap;
      c.save(); c.globalAlpha = a; c.beginPath(); c.rect(0, sy - 4, W, th + 8); c.clip();
      const first = Math.max(1, Math.floor(f - W / step / 2) - 1), last = Math.min(FR, Math.ceil(f + W / step / 2) + 1);
      for (let q = first; q <= last; q++) {
        /* ב-RTL הזמן זורם מימין לשמאל: הפריימים הבאים משמאל לסמן */
        const x = W / 2 - (q - f) * step - tw / 2;
        putThumb(c, q, x, sy, tw, th);
      }
      c.restore();
      c.fillStyle = YEL; u.rr(c, W / 2 - 1.5, sy - H * 0.02, 3, th + H * 0.04, 1.5, YEL);
      c.strokeStyle = YEL; c.lineWidth = 2; c.strokeRect(W / 2 - tw / 2 - 1, sy - 1, tw + 2, th + 2);
      u.text(c, 'גוללים פריים אחרי פריים', W / 2, sy + th + H * 0.045, m * 0.04, 'rgba(255,255,255,0.65)', 500, 'center', 'rtl');
    },
    stage(c, W, H, t, I, scr) {
      if (phase(t) !== 'run') { recStage(c, W, H, t, I, scr); return; }
      const { room, ax, m } = K.room(W, H, scr), k = Math.round(frameAt(t));
      const fa = u.clamp((t - T.run0) / 0.3);
      c.save(); c.globalAlpha = fa;
      counter(c, ax, H * 0.4, room, H, m, t, I, k, fa);
      c.restore();
    },
  };

  /* ───────── 14 · פס צילום ליד הטלפון ─────────
     אחרי השנייה, המסך מציג את הפריימים ברצף, והם יוצאים ממנו לפס צילום אנכי ליד הטלפון. הפס עולה פריים אחרי פריים,
     עם מספר ליד כל אחד, מאט, ונעצר כשההתזה הראשונה במרכז, מוגדלת ובמסגרת צהובה.
     רגע העצירה מסומן בשני המקומות באותה שנייה: סוגריים על המסך, והפס מתעמעם חוץ מהפריים שנעצר */
  S['vid-14'] = {
    dur: T.end,
    shift: 0.24,
    draw(c, W, H, t, side, I) {
      if (phase(t) !== 'run') { recording(c, W, H, t); return; }
      const m = Math.min(W, H), k = Math.round(frameAt(t));
      SP.splash(c, 0, 0, W, H, tauOf(k));
      u.status(c, W, H, { level: 0.8 });
      /* העצירה: הסוגריים נסגרים פנימה על הפריים, באותו רגע שבו הפס בצד נעצר */
      const sa = u.easeOut(u.clamp((t - T.stop) / 0.28));
      if (sa > 0) {
        const grow = (1 - sa) * m * 0.05, bx = W * 0.07 - grow, by = H * 0.2 - grow;
        c.save(); c.globalAlpha = sa;
        K.brackets(c, bx, by, W - bx * 2, H * 0.6 + grow * 2, YEL, Math.max(2, m * 0.008), m * 0.07);
        c.restore();
      }
      u.pill(c, `פריים ${k} מתוך 120`, W / 2, H * 0.9, m * 0.05, '#000', t >= T.stop ? YEL : '#fff', 'rtl');
    },
    stage(c, W, H, t, I, scr) {
      budget = 14;
      if (phase(t) !== 'run') { recStage(c, W, H, t, I, scr); return; }
      const { room, m } = K.room(W, H, scr), f = frameAt(t), a = u.clamp((t - T.run0) / 0.3);
      const fw = Math.min(room * 0.5, H * 0.26), fh = fw * 1.2, gap = fw * 0.16, step = fh + gap;
      const sx = room * 0.62 - fw / 2, cy = H * 0.48, stripW = fw * 1.36;
      c.save(); c.globalAlpha = a;
      /* הפס: שחור עם חורים בצדדים, שזזים עם הפריימים */
      const g = c.createLinearGradient(0, 0, 0, H); g.addColorStop(0, 'rgba(22,22,26,0)'); g.addColorStop(0.15, '#16161A'); g.addColorStop(0.85, '#16161A'); g.addColorStop(1, 'rgba(22,22,26,0)');
      c.fillStyle = g; c.fillRect(sx - (stripW - fw) / 2, 0, stripW, H);
      const hole = fw * 0.07, holeOff = ((f * step) % (hole * 3));
      for (let y = -hole * 3; y < H + hole * 3; y += hole * 3) [sx - (stripW - fw) / 4 - hole / 2, sx + fw + (stripW - fw) / 4 - hole / 2].forEach(hx => u.rr(c, hx, y - holeOff, hole, hole * 1.4, hole * 0.25, 'rgba(255,255,255,0.18)'));
      const n = Math.ceil(H / step / 2) + 1, dim = u.clamp((t - T.stop) / 0.3);
      for (let q = Math.max(1, Math.floor(f) - n); q <= Math.min(FR, Math.ceil(f) + n); q++) {
        const y = cy + (q - f) * step - fh / 2;
        if (y > H || y + fh < 0) continue;
        const on = q === PEAK && t >= T.stop;
        /* בעצירה כל הפס מתעמעם חוץ מהפריים שנעצר, וכך רואים שהשניים נעצרו יחד */
        c.save(); c.globalAlpha = a * (on ? 1 : 1 - dim * 0.6);
        putThumb(c, q, sx, y, fw, fh);
        u.text(c, String(q), sx - (stripW - fw) / 2 - m * 0.02, y + fh / 2, Math.max(10, m * 0.034), on ? YEL : 'rgba(255,255,255,0.55)', 600, 'right', 'ltr');
        c.restore();
      }
      /* הפריים שבמרכז: מסגרת, ובעצירה הוא גדל */
      const z = 1 + 0.18 * u.easeOut(u.clamp((t - T.stop) / 0.4));
      const zw = fw * z, zh = fh * z;
      if (z > 1.001) { c.save(); c.shadowColor = 'rgba(0,0,0,0.7)'; c.shadowBlur = m * 0.04; putThumb(c, PEAK, sx + fw / 2 - zw / 2, cy - zh / 2, zw, zh); c.restore(); }
      c.strokeStyle = t >= T.stop ? YEL : 'rgba(255,255,255,0.85)'; c.lineWidth = 2; c.strokeRect(sx + fw / 2 - zw / 2, cy - zh / 2, zw, zh);
      c.restore();
      const ta = u.clamp((t - T.stop - 0.3) / 0.4);
      if (ta > 0) {
        c.save(); c.globalAlpha = ta;
        const fs = Math.min(m * 0.045, K2.fit(c, '53 מתוך 120', room * 0.9, 99, 700)), bw = K2.fit(c, 'x', 1, 1) * 0 + fs * 6.2, by = cy + zh / 2 + fs * 0.5;
        /* רקע כהה מתחת לטקסט, כי הוא יושב על הפס (צילום 17.09) */
        u.rr(c, room * 0.62 - bw / 2, by, bw, fs * 3.2, fs * 0.5, 'rgba(0,0,0,0.82)');
        u.text(c, `${PEAK} מתוך 120`, room * 0.62, by + fs * 1.05, fs, YEL, 700, 'center', 'rtl');
        u.text(c, 'בשנייה אחת', room * 0.62, by + fs * 2.3, fs * 0.85, 'rgba(255,255,255,0.8)', 500, 'center', 'rtl');
        c.restore();
      }
    },
  };

  /* ───────── 15 · כל 120 על דף אחד ─────────
     אחרי השנייה, ליד הטלפון נפרש דף של 120 משבצות, 10 בשורה, כל אחת פריים. סמן צהוב רץ עליהן לפי הסדר,
     והטלפון מציג את הפריים שתחת הסמן. הסמן מאט ונעצר על ההתזה, והמשבצת שלה מתרוממת וגדלה */
  S['vid-15'] = {
    dur: T.end,
    shift: 0.24,
    glow: false,
    draw(c, W, H, t, side, I) {
      if (phase(t) !== 'run') { recording(c, W, H, t); return; }
      const m = Math.min(W, H), k = Math.round(frameAt(t));
      SP.splash(c, 0, 0, W, H, tauOf(k));
      u.status(c, W, H, { level: 0.8 });
      u.pill(c, `פריים ${k}`, W / 2, H * 0.9, m * 0.05, '#000', t >= T.stop ? YEL : '#fff', 'rtl');
    },
    stage(c, W, H, t, I, scr) {
      budget = 24;
      if (phase(t) !== 'run') recStage(c, W, H, t, I, scr);
      if (t < T.cut - 0.1) return;
      const { room, m } = K.room(W, H, scr), cols = 10, rows = 12;
      const cw = Math.min((room * 0.94) / cols, (H * 0.74) / rows / 1.2), ch = cw * 1.2, gw = cols * cw, x0 = room / 2 + gw / 2, y0 = H * 0.08;
      const f = frameAt(t), k = Math.round(f);
      /* הדף נפרש בגל, מהפריים הראשון לאחרון */
      const lay = (t - (T.cut - 0.1)) / 0.9;
      for (let q = 1; q <= FR; q++) {
        const a = u.clamp(lay * FR / 14 - (q - 1) / 14);
        if (a <= 0) continue;
        const col = (q - 1) % cols, row = Math.floor((q - 1) / cols), x = x0 - (col + 1) * cw, y = y0 + row * ch;
        c.save(); c.globalAlpha = a * (t >= T.stop && q !== PEAK ? 0.55 : 1);
        putThumb(c, q, x + 0.5, y + 0.5, cw - 1, ch - 1);
        c.restore();
      }
      if (t >= T.run0) {
        const col = (k - 1) % cols, row = Math.floor((k - 1) / cols), x = x0 - (col + 1) * cw, y = y0 + row * ch;
        c.strokeStyle = YEL; c.lineWidth = 2; c.strokeRect(x, y, cw, ch);
        /* בעצירה: המשבצת גדלה מעל הדף */
        const z = u.easeOut(u.clamp((t - T.stop) / 0.5));
        if (z > 0) {
          const zw = u.lerp(cw, Math.min(room * 0.42, H * 0.3), z), zh = zw * 1.2, zx = u.lerp(x + cw / 2, room / 2, z) - zw / 2, zy = u.lerp(y + ch / 2, H * 0.44, z) - zh / 2;
          c.save(); c.shadowColor = 'rgba(0,0,0,0.8)'; c.shadowBlur = m * 0.06; c.fillStyle = '#000'; c.fillRect(zx, zy, zw, zh); c.restore();
          putThumb(c, PEAK, zx, zy, zw, zh);
          c.strokeStyle = YEL; c.lineWidth = 2.5; c.strokeRect(zx, zy, zw, zh);
        }
      }
      const fs = Math.min(m * 0.045, K2.fit(c, 'פריים 53 מתוך 120', room * 0.9, 99, 700)), ty = y0 + rows * ch + fs * 1.2;
      u.text(c, t >= T.run0 ? `פריים ${k} מתוך 120` : '120 פריימים, שנייה אחת', room / 2, ty, fs, t >= T.stop ? YEL : '#fff', 700, 'center', 'rtl');
      const ta = u.clamp((t - T.stop - 0.4) / 0.4);
      if (ta > 0) { c.save(); c.globalAlpha = ta; u.text(c, 'יש תמונה בדיוק ברגע', room / 2, ty + fs * 1.4, fs * 0.9, 'rgba(255,255,255,0.8)', 500, 'center', 'rtl'); c.restore(); }
    },
  };
})();

/* ── js/scenes-r5-chip.js ── */
/* מהירות, סבב 5 (17.09.2026). יובל: «12 זה הכיוון באמת, אבל אולי תעשה יותר דברים, שירוץ בין עוד דברים.
   ומההתחלה שיהיה מהיר בקצב אחיד. עכשיו זה מתחיל לאט ומגביר».
   ⟹ ההחלקה של 12, עם 12 אפליקציות במקום 8, ובקצב אחד קבוע מהשנייה הראשונה: 0.3 שניות על כל מסך ו-0.2 להחלקה.
   נוספו: פיד, צ'אט, מזג אוויר וחדשות (שני האחרונים מצוירים כאן). בלי מותגים.
   🔴 בלי מספרים של זמן טעינה: Apple לא מפרסמת כאלה. המשפט בסוף הוא המחשה.
   chip-13 12 אפליקציות, קצב אחיד · chip-14 אותו קצב, והאייקונים זורמים ליד הטלפון */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, K2 = L.kit2, UI = L.ui2, CK = L.chipKit4;

  /* ── שני מסכים חדשים ── */
  const weather = (c, x, y, w, h, t) => {
    c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip();
    const g = c.createLinearGradient(0, y, 0, y + h); g.addColorStop(0, '#2F7FD6'); g.addColorStop(1, '#79B8F0');
    c.fillStyle = g; c.fillRect(x, y, w, h);
    const m = Math.min(w, h);
    u.text(c, 'תל אביב', x + w / 2, y + h * 0.16, m * 0.075, '#fff', 500, 'center', 'rtl');
    u.text(c, '28°', x + w / 2, y + h * 0.28, m * 0.24, '#fff', 300, 'center', 'ltr');
    u.text(c, 'שמשי', x + w / 2, y + h * 0.38, m * 0.055, 'rgba(255,255,255,0.9)', 500, 'center', 'rtl');
    u.rr(c, x + w * 0.06, y + h * 0.46, w * 0.88, h * 0.16, m * 0.05, 'rgba(255,255,255,0.16)');
    for (let k = 0; k < 5; k++) {
      const hx = x + w * (0.82 - k * 0.16), hy = y + h * 0.54;
      u.text(c, `${12 + k}`, hx, hy - h * 0.045, m * 0.04, 'rgba(255,255,255,0.85)', 500, 'center', 'ltr');
      c.strokeStyle = '#FFD60A'; K2.icon.sun(c, hx, hy, m * 0.07);
      u.text(c, `${28 - (k > 2 ? 1 : 0)}°`, hx, hy + h * 0.045, m * 0.042, '#fff', 600, 'center', 'ltr');
    }
    u.rr(c, x + w * 0.06, y + h * 0.66, w * 0.88, h * 0.26, m * 0.05, 'rgba(255,255,255,0.16)');
    for (let k = 0; k < 4; k++) { const ry = y + h * (0.7 + k * 0.055); u.rr(c, x + w * 0.5, ry, w * 0.36, h * 0.012, 3, 'rgba(255,255,255,0.7)'); u.rr(c, x + w * 0.12, ry, w * 0.24, h * 0.012, 3, 'rgba(255,255,255,0.35)'); }
    c.restore();
  };
  const news = (c, x, y, w, h, t) => {
    c.save(); c.beginPath(); c.rect(x, y, w, h); c.clip();
    c.fillStyle = '#F2F2F4'; c.fillRect(x, y, w, h);
    const m = Math.min(w, h), off = (t * h * 0.08) % (h * 0.5);
    for (let k = 0; k < 4; k++) {
      const by = y + h * 0.13 + k * h * 0.5 - off;
      u.rr(c, x + w * 0.05, by, w * 0.9, h * 0.24, m * 0.03, ['#C9D6E8', '#E8D5C4', '#D0E3D2', '#E4CFE0'][k]);
      u.rr(c, x + w * 0.2, by + h * 0.27, w * 0.75, h * 0.02, 3, '#1C1C1E');
      u.rr(c, x + w * 0.35, by + h * 0.31, w * 0.6, h * 0.02, 3, '#1C1C1E');
      for (let q = 0; q < 3; q++) u.rr(c, x + w * (0.12 + (q === 2 ? 0.3 : 0)), by + h * (0.36 + q * 0.03), w * (0.83 - (q === 2 ? 0.3 : 0)), h * 0.011, 2, 'rgba(0,0,0,0.25)');
    }
    c.fillStyle = '#F2F2F4'; c.fillRect(x, y, w, h * 0.1);
    u.text(c, 'חדשות', x + w * 0.93, y + h * 0.075, m * 0.07, '#1C1C1E', 700, 'right', 'rtl');
    c.restore();
  };
  const CHAT = [['in', 'מגיעים?'], ['out', 'עוד 5 דקות'], ['in', 'מעולה']];

  /* [מפתח, שם, אייקון, צבע] */
  const EXTRA = {
    feed: ['feed', 'פיד', 'photoWide', '#C13584'],
    chat: ['chat', 'הודעות', 'chat', '#30B45A'],
    weather: ['weather', 'מזג אוויר', 'sun', '#2F7FD6'],
    news: ['news', 'חדשות', 'news', '#E5484D'],
  };
  const A4 = Object.fromEntries(CK.APPS.map(a => [a[0], a]));
  const LIST = ['video', 'feed', 'maps', 'music', 'camera', 'photos', 'chat', 'weather', 'shorts', 'news', 'editor', 'game'].map(k => A4[k] || EXTRA[k]);
  const drawApp = (key, c, x, y, w, h, t, I) => {
    if (key === 'feed') UI.feed(c, x, y, w, h, t * 2);
    else if (key === 'chat') UI.chat(c, x, y, w, h, 3 + t * 2.5, I, { msgs: CHAT, title: 'חברים' });
    else if (key === 'weather') weather(c, x, y, w, h, t);
    else if (key === 'news') news(c, x, y, w, h, t);
    else CK.drawApp(key, c, x, y, w, h, t, I);
  };

  /* הציר: עמידה קבועה והחלקה קבועה, מהשנייה הראשונה. המשחק האחרון נשאר */
  const START = 0.35, HOLD = 0.3, MOVE = 0.2, LAST = 2.5;   /* 21.09.2026: קוצר ל-1.5 ואז הוארך בשנייה, 8.35 שנ' */
  const T0 = j => START + j * (HOLD + MOVE);
  const DUR = T0(LIST.length - 1) + LAST;
  const at = t => {
    const f = (t - START) / (HOLD + MOVE), j = Math.floor(f), lt = (f - j) * (HOLD + MOVE);
    if (t < START) return { p: 0, v: 0 };
    if (j >= LIST.length - 1) return { p: LIST.length - 1, v: 0 };
    if (lt < HOLD) return { p: j, v: 0 };
    const k = (lt - HOLD) / MOVE, e = u.ease(k), v = (Math.abs(u.ease(Math.min(1, k + 0.02)) - u.ease(Math.max(0, k - 0.02))) / 0.04) / MOVE;
    return { p: j + e, v };
  };
  const endAt = t => u.clamp((t - (T0(LIST.length - 1) + 0.5)) / 0.5);

  const phone = (c, W, H, t, I) => {
    const st = at(t), gap = W * 0.04;
    c.fillStyle = '#000'; c.fillRect(0, 0, W, H);
    LIST.forEach((a, j) => {
      const x = -(j - st.p) * (W + gap);
      if (x > W || x + W < 0) return;
      c.save(); c.beginPath(); c.rect(x, 0, W, H); c.clip();
      drawApp(a[0], c, x, 0, W, H, t, I);
      c.restore();
    });
    /* מריחה עדינה באמצע כל החלקה, באותה עוצמה בכולן */
    if (st.v > 4) {
      const j = Math.round(st.p), x = -(j - st.p) * (W + gap);
      c.save(); c.globalAlpha = u.clamp((st.v - 4) / 6) * 0.3; c.beginPath(); c.rect(0, 0, W, H); c.clip();
      drawApp(LIST[j][0], c, x + W * 0.05, 0, W, H, t, I);
      c.restore();
    }
    u.status(c, W, H, { level: 0.8 });
    CK.homeBar(c, W, H, -Math.sin((st.p % 1) * Math.PI) * W * 0.12);
  };

  /* קווי מהירות: עוצמה אחת לכל הסצנה, עד המשפט */
  const speedLines = (c, W, H, t, I, room, m, fade) => {
    const rng = u.rnd(12);
    c.save(); c.lineCap = 'round';
    for (let k = 0; k < 26; k++) {
      const y = H * (0.08 + 0.84 * rng()), len = room * (0.15 + 0.35 * rng()), sp = 0.6 + rng();
      const x = ((rng() + t * sp * 1.6) % 1.2) * (room + len) - len;
      const a = 0.32 * (1 - fade);
      const g = c.createLinearGradient(x, 0, x + len, 0); g.addColorStop(0, u.acc(I, 0)); g.addColorStop(1, u.acc(I, a));
      c.strokeStyle = g; c.lineWidth = Math.max(1, m * (0.003 + 0.004 * rng())); c.beginPath(); c.moveTo(x, y); c.lineTo(Math.min(x + len, room), y); c.stroke();
    }
    c.restore();
  };

  /* מסוע האייקונים: כל אפליקציה שנפתחת משאירה את האייקון שלה, וכולם זורמים שמאלה באותה מהירות קבועה.
     משותף ל-13 ול-14, ולכן אין שני מימושים שיכולים להיפרד */
  const conveyor = (c, t, room, H, m, y, s, n, fade) => {
    const step = s * 1.3, flow = (t - START) / (HOLD + MOVE);
    c.save(); c.globalAlpha = 1 - u.clamp(fade * 1.6);
    c.beginPath(); c.rect(0, y - s * 1.2, room, s * 2.4); c.clip();
    for (let j = 0; j < n; j++) {
      const x = room - s * 0.6 - (flow - j) * step;
      if (x < -s || x > room + s) continue;
      const age = t - T0(j) + MOVE * 0.5, pop = 1 + 0.25 * (1 - u.easeOut(u.clamp(age / 0.25)));
      c.save(); c.translate(x, y); c.scale(pop, pop); CK.appIcon(c, -s / 2, -s / 2, s, LIST[j]); c.restore();
    }
    c.restore();
    /* דהייה בקצה השמאלי, כדי שהאייקונים ייעלמו ולא ייחתכו */
    const g = c.createLinearGradient(0, 0, room * 0.35, 0); g.addColorStop(0, 'rgba(0,0,0,1)'); g.addColorStop(1, 'rgba(0,0,0,0)');
    c.fillStyle = g; c.fillRect(0, y - s * 1.2, room * 0.35, s * 2.4);
  };
  const iconSize = (room, H) => Math.min(room * 0.2, H * 0.11);
  const shown = st => Math.min(LIST.length, Math.floor(st.p + 0.5) + 1);

  /* ───────── 13 · 12 אפליקציות, קצב אחיד ─────────
     כמו 12: החלקה על פס הבית, מסך מלא אחרי מסך מלא. סרטים, פיד, מפות, מוזיקה, מצלמה, תמונות, הודעות,
     מזג אוויר, סרטונים, חדשות, עריכת וידאו ומשחק. אותו קצב מההתחלה ועד המשחק.
     ליד הטלפון שם האפליקציה, קווי מהירות, ומ-20.09.2026 גם מסוע האייקונים של 14 (בקשת יובל) */
  S['chip-13'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { phone(c, W, H, t, I); },
    stage(c, W, H, t, I, scr) {
      const st = at(t), { room, ax, m } = K.room(W, H, scr), endA = endAt(t);
      speedLines(c, W, H, t, I, room, m, endA);
      const j = Math.round(st.p), fs = Math.max(14, Math.min(m * 0.08, K2.fit(c, 'עריכת וידאו', room * 0.85, 99, 700)));
      c.save(); c.globalAlpha = (1 - u.clamp(endA * 2)) * (1 - u.clamp(Math.abs(st.p - j) * 2.2));
      u.text(c, LIST[j][1], ax, H * 0.42, fs, '#fff', 700, 'center', 'rtl');
      c.restore();
      conveyor(c, t, room, H, m, H * 0.66, iconSize(room, H), shown(st), endA);
      CK.endCard(c, W, H, scr, I, endA, ['מאפליקציה לאפליקציה,', 'בלי לחכות']);
    },
  };

  /* ───────── 14 · האייקונים זורמים ─────────
     אותו טלפון ואותו קצב. ליד הטלפון, כל אפליקציה שנפתחת משאירה את האייקון שלה, והאייקונים זורמים שמאלה
     בשורה, באותה מהירות קבועה. מעליהם המונה עולה עד 12, ובסוף המשפט */
  S['chip-14'] = {
    dur: DUR,
    shift: 0.22,
    draw(c, W, H, t, side, I) { phone(c, W, H, t, I); },
    stage(c, W, H, t, I, scr) {
      const st = at(t), { room, ax, m } = K.room(W, H, scr), endA = endAt(t);
      const n = shown(st);
      conveyor(c, t, room, H, m, H * 0.56, iconSize(room, H), n, endA);
      c.save(); c.globalAlpha = 1 - u.clamp(endA * 1.6);
      const px = K2.fit(c, '12', room * 0.34, H * 0.16);
      /* K2.pop קובע globalAlpha בעצמו, ולכן הדהייה עוברת כפרמטר */
      K2.pop(c, String(n), ax, H * 0.28, px, I, { age: t - T0(n - 1) + MOVE * 0.5, alpha: 1 - u.clamp(endA * 1.6) });
      u.text(c, 'אפליקציות', ax, H * 0.28 + px * 0.6, Math.max(12, m * 0.042), 'rgba(255,255,255,0.72)', 600, 'center', 'rtl');
      c.restore();
      CK.endCard(c, W, H, scr, I, endA, ['מאפליקציה לאפליקציה,', 'בלי לחכות']);
    },
  };
})();

/* ── js/scenes-r6-chg.js ── */
/* טעינה, סבב 6 (20.09.2026). יובל על 10 עם הכוס השקופה: «זה קרוב אבל עוד לא זה.
   תן עוד שלוש אפשרויות שונות של הקפה, תנסה לחשוב יצירתי».
   ⟹ אותו רעיון בדיוק בכל השלוש, וזה מה שיובל ביקש מלכתחילה: רק כוס אחת ליד הטלפון, שנגמרת לאט,
   והאחוזים רק במסך. מה שמשתנה הוא איזו כוס, ואיזה רגע ביום היא מספרת.
   chg-13 קפה קר עם קרח · chg-14 כוס על שולחן עם אור מהצד · chg-15 אספרסו קצר
   הנתון: עד 50% בכ-15 דקות, עם מטען 60W. */
(() => {
  const L = window.TYSH, u = L.u, S = L.scenes, K = L.kit, CK = L.chgKit5;
  const { RUN, DUR, lock, caption, steam } = CK;
  const levelAt = CK.drainAt;

  /* ───────── 13 · קפה קר עם קרח ─────────
     כוס טייקאווי שקופה עם מכסה כיפה וקשית. הקפה הקר יורד, ושלוש קוביות הקרח יורדות איתו
     ומתיישבות בתחתית. אין אדים, יש טיפות אדים על הדופן מבחוץ */
  const rng13 = u.rnd(7);
  const ICE = Array.from({ length: 4 }, () => ({ dx: (rng13() - 0.5) * 0.52, dy: rng13() * 0.22, s: 0.2 + rng13() * 0.1, rot: (rng13() - 0.5) * 0.9 }));
  const DROPS13 = Array.from({ length: 14 }, () => ({ fx: (rng13() - 0.5) * 1.6, fy: 0.15 + rng13() * 0.7, r: 0.012 + rng13() * 0.02 }));
  const iced = (c, cx, top, w, level, t, m) => {
    const rx = w / 2, ry = rx * 0.3, h = w * 1.5, bot = top + h, bx = rx * 0.68, bry = ry * 0.68;
    const wall = f => u.lerp(bx, rx, f);
    const body = () => {
      c.beginPath();
      c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + rx, top);
      c.ellipse(cx, top, rx, ry, 0, 0, Math.PI, true);
      c.closePath();
    };
    c.fillStyle = 'rgba(0,0,0,0.45)'; c.beginPath(); c.ellipse(cx + w * 0.05, bot + bry * 0.4, bx * 1.5, bry * 1.1, 0, 0, Math.PI * 2); c.fill();
    /* הפלסטיק */
    const gg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
    gg.addColorStop(0, 'rgba(228,240,250,0.28)'); gg.addColorStop(0.34, 'rgba(228,240,250,0.08)');
    gg.addColorStop(0.7, 'rgba(228,240,250,0.11)'); gg.addColorStop(1, 'rgba(228,240,250,0.24)');
    body(); c.fillStyle = gg; c.fill();
    c.strokeStyle = 'rgba(255,255,255,0.2)'; c.lineWidth = Math.max(1, w * 0.009);
    c.beginPath(); c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0); c.stroke();
    /* הקפה הקר */
    const lf = 0.86 * level, ly = bot - h * lf, lrx = wall(lf), lry = ry * (lrx / rx);
    c.save(); body(); c.clip();
    if (level > 0.012) {
      c.beginPath();
      c.moveTo(cx - lrx, ly); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + lrx, ly);
      c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI, true);
      c.closePath();
      const cg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
      cg.addColorStop(0, '#4A2E1C'); cg.addColorStop(0.32, '#8A5E38'); cg.addColorStop(0.62, '#77502F'); cg.addColorStop(1, '#3E2616');
      c.fillStyle = cg; c.fill();
      const sg = c.createRadialGradient(cx - lrx * 0.3, ly - lry * 0.4, 0, cx, ly, lrx);
      sg.addColorStop(0, '#B98A5C'); sg.addColorStop(1, '#7A5233');
      c.fillStyle = sg; c.beginPath(); c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI * 2); c.fill();
    }
    /* הקרח: יורד עם המפלס, ובסוף מונח בתחתית */
    ICE.forEach((q, i) => {
      /* בסוף הקרח מונח בתחתית, ולא כולו באותו גובה */
      const sz = w * q.s, rest = bot - bry * 0.55 - sz * 0.5 - (i % 2 ? sz * 0.66 : 0);
      const yy = Math.min(rest, ly + h * q.dy * (0.4 + level * 0.6) - sz * 0.2);
      const xx = cx + q.dx * lrx * (0.6 + level * 0.4) + Math.sin(t * 0.6 + i) * w * 0.006;
      c.save(); c.translate(xx, yy); c.rotate(q.rot + Math.sin(t * 0.4 + i) * 0.05);
      const ig = c.createLinearGradient(-sz / 2, -sz / 2, sz / 2, sz / 2);
      ig.addColorStop(0, 'rgba(226,244,255,0.82)'); ig.addColorStop(1, 'rgba(160,200,230,0.55)');
      u.rr(c, -sz / 2, -sz / 2, sz, sz, sz * 0.22, ig);
      c.strokeStyle = 'rgba(255,255,255,0.7)'; c.lineWidth = Math.max(1, sz * 0.06);
      c.beginPath(); c.roundRect(-sz / 2, -sz / 2, sz, sz, sz * 0.22); c.stroke();
      c.fillStyle = 'rgba(255,255,255,0.5)'; u.rr(c, -sz * 0.28, -sz * 0.34, sz * 0.3, sz * 0.14, sz * 0.07, 'rgba(255,255,255,0.5)');
      c.restore();
    });
    c.restore();
    /* הקשית: נכנסת מהמכסה אל תוך הקפה */
    const sw = Math.max(3, w * 0.075), sx0 = cx + rx * 0.24, sy0 = bot - h * 0.12, sx1 = cx + rx * 0.52, sy1 = top - h * 0.3;
    c.save(); c.lineCap = 'round';
    c.strokeStyle = '#D8DEE6'; c.lineWidth = sw; c.beginPath(); c.moveTo(sx0, sy0); c.lineTo(sx1, sy1); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.55)'; c.lineWidth = sw * 0.3;
    c.beginPath(); c.moveTo(sx0 - sw * 0.2, sy0); c.lineTo(sx1 - sw * 0.2, sy1); c.stroke();
    c.restore();
    /* המכסה: טבעת וכיפה */
    c.save();
    const lidg = c.createLinearGradient(cx - rx, top, cx + rx, top);
    lidg.addColorStop(0, 'rgba(236,244,252,0.5)'); lidg.addColorStop(0.5, 'rgba(236,244,252,0.2)'); lidg.addColorStop(1, 'rgba(236,244,252,0.45)');
    c.fillStyle = lidg;
    c.beginPath(); c.ellipse(cx, top - h * 0.1, rx * 0.92, ry * 0.92, 0, Math.PI, 0); c.ellipse(cx, top, rx * 1.06, ry * 1.06, 0, 0, Math.PI); c.closePath(); c.fill();
    c.strokeStyle = 'rgba(255,255,255,0.55)'; c.lineWidth = Math.max(1.5, w * 0.014);
    c.beginPath(); c.ellipse(cx, top, rx * 1.06, ry * 1.06, 0, 0, Math.PI * 2); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.3)'; c.lineWidth = Math.max(1, w * 0.01);
    c.beginPath(); c.ellipse(cx, top - h * 0.1, rx * 0.92, ry * 0.92, 0, Math.PI, 0); c.stroke();
    c.restore();
    /* הדפנות מלפנים והטיפות */
    c.strokeStyle = 'rgba(255,255,255,0.5)'; c.lineWidth = Math.max(1.5, w * 0.016);
    c.beginPath(); c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot); c.moveTo(cx + rx, top); c.lineTo(cx + bx, bot); c.stroke();
    const hl = c.createLinearGradient(0, top, 0, bot); hl.addColorStop(0, 'rgba(255,255,255,0.5)'); hl.addColorStop(1, 'rgba(255,255,255,0.08)');
    c.strokeStyle = hl; c.lineWidth = Math.max(2, w * 0.03); c.lineCap = 'round';
    c.beginPath(); c.moveTo(cx - rx * 0.76, top + h * 0.1); c.lineTo(cx - bx * 0.74, bot - h * 0.12); c.stroke(); c.lineCap = 'butt';
    c.save(); body(); c.clip();
    DROPS13.forEach(d => {
      const x = cx + d.fx * rx * 0.8, y = top + d.fy * h, r = d.r * w;
      c.fillStyle = 'rgba(255,255,255,0.3)'; c.beginPath(); c.arc(x, y, r, 0, Math.PI * 2); c.fill();
      c.fillStyle = 'rgba(255,255,255,0.6)'; c.beginPath(); c.arc(x - r * 0.3, y - r * 0.3, r * 0.35, 0, Math.PI * 2); c.fill();
    });
    c.restore();
    return { bot, top, h };
  };
  S['chg-13'] = {
    dur: DUR,
    shift: 0.22,
    glow: false,
    draw(c, W, H, t, side, I) { lock(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), level = levelAt(t);
      const w = Math.min(room * 0.5, H * 0.24), top = H * 0.36;
      const r = iced(c, ax, top, w, level, t, m);
      caption(c, ax, r.bot + m * 0.12, t, m, room);
    },
  };

  /* ───────── 14 · כוס על שולחן, אור מהצד ─────────
     אותה כוס, וסצנה שלמה סביבה: אור חם מצד אחד, צל ארוך לצד השני, ובריכת אור על השולחן
     שמצטמצמת יחד עם הקפה. האדים נצבעים באור. הכוס נמוכה ורחבה, ולכן היא נראית אחרת לגמרי */
  const lit = (c, cx, top, w, level, t, m) => {
    const rx = w / 2, ry = rx * 0.26, h = w * 0.92, bot = top + h, bx = rx * 0.93, bry = ry * 0.93;
    const wall = f => u.lerp(bx, rx, f);
    const body = () => {
      c.beginPath();
      c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + rx, top);
      c.ellipse(cx, top, rx, ry, 0, 0, Math.PI, true);
      c.closePath();
    };
    /* השולחן: קו אופק רך מאחורי הכוס */
    const tg = c.createLinearGradient(0, bot - h * 0.5, 0, bot + h * 0.5);
    tg.addColorStop(0, 'rgba(255,255,255,0)'); tg.addColorStop(0.55, 'rgba(255,236,214,0.07)'); tg.addColorStop(1, 'rgba(255,236,214,0)');
    c.fillStyle = tg; c.fillRect(cx - w * 2.4, bot - h * 0.5, w * 4.8, h);
    /* הצל: ארוך, לכיוון ההפוך מהאור */
    c.save(); c.globalAlpha = 0.55;
    const sg = c.createLinearGradient(cx, bot, cx + w * 1.5, bot);
    sg.addColorStop(0, 'rgba(0,0,0,0.75)'); sg.addColorStop(1, 'rgba(0,0,0,0)');
    c.fillStyle = sg; c.beginPath(); c.ellipse(cx + w * 0.55, bot + bry * 0.5, w * 1.05, bry * 1.2, 0, 0, Math.PI * 2); c.fill();
    c.restore();
    /* בריכת האור שעברה דרך הקפה, מצטמצמת איתו */
    if (level > 0.02) {
      c.save(); c.globalAlpha = 0.16 + 0.28 * level;
      const pg = c.createRadialGradient(cx + w * 0.5, bot + bry * 0.45, 0, cx + w * 0.5, bot + bry * 0.45, w * (0.35 + 0.35 * level));
      pg.addColorStop(0, '#E09A4E'); pg.addColorStop(1, 'rgba(224,154,78,0)');
      c.fillStyle = pg; c.beginPath(); c.ellipse(cx + w * 0.5, bot + bry * 0.45, w * (0.35 + 0.35 * level), bry * (1.1 + level * 0.6), 0, 0, Math.PI * 2); c.fill();
      c.restore();
    }
    /* הזכוכית, מוארת מצד שמאל */
    const gg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
    gg.addColorStop(0, 'rgba(255,240,222,0.42)'); gg.addColorStop(0.28, 'rgba(255,240,222,0.1)');
    gg.addColorStop(0.72, 'rgba(226,238,248,0.08)'); gg.addColorStop(1, 'rgba(226,238,248,0.2)');
    body(); c.fillStyle = gg; c.fill();
    c.strokeStyle = 'rgba(255,255,255,0.2)'; c.lineWidth = Math.max(1, w * 0.01);
    c.beginPath(); c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0); c.stroke();
    /* הדפנות הפנימיות, מה שרואים דרך הזכוכית. בלעדיהן כוס ריקה נקראת כספל כהה */
    c.strokeStyle = 'rgba(255,246,232,0.18)'; c.lineWidth = Math.max(1, w * 0.008);
    c.beginPath();
    c.moveTo(cx - rx * 0.92, top + ry * 0.4); c.lineTo(cx - bx * 0.9, bot - bry * 0.3);
    c.moveTo(cx + rx * 0.92, top + ry * 0.4); c.lineTo(cx + bx * 0.9, bot - bry * 0.3);
    c.stroke();
    /* הקפה */
    const lf = 0.82 * level, ly = bot - h * lf, lrx = wall(lf), lry = ry * (lrx / rx);
    if (level > 0.012) {
      c.save(); body(); c.clip();
      c.beginPath();
      c.moveTo(cx - lrx, ly); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + lrx, ly);
      c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI, true);
      c.closePath();
      const cg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
      cg.addColorStop(0, '#B4763F'); cg.addColorStop(0.22, '#8A5326'); cg.addColorStop(0.6, '#5E3618'); cg.addColorStop(1, '#2E1B0C');
      c.fillStyle = cg; c.fill();
      c.restore();
      /* פני הקפה, עם הבהק האור */
      const sg2 = c.createRadialGradient(cx - lrx * 0.45, ly - lry * 0.5, 0, cx, ly, lrx);
      sg2.addColorStop(0, '#D9A268'); sg2.addColorStop(0.5, '#8A5B33'); sg2.addColorStop(1, '#4E2F17');
      c.fillStyle = sg2; c.beginPath(); c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI * 2); c.fill();
      c.save(); c.globalAlpha = 0.5; c.fillStyle = '#FFE3BE';
      c.beginPath(); c.ellipse(cx - lrx * 0.42, ly - lry * 0.15, lrx * 0.3, lry * 0.4, -0.3, 0, Math.PI * 2); c.fill();
      c.restore();
    }
    /* הזכוכית מלפנים */
    c.strokeStyle = 'rgba(255,246,232,0.7)'; c.lineWidth = Math.max(1.5, w * 0.02);
    c.beginPath(); c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot); c.stroke();
    c.strokeStyle = 'rgba(226,238,248,0.4)';
    c.beginPath(); c.moveTo(cx + rx, top); c.lineTo(cx + bx, bot); c.stroke();
    c.strokeStyle = 'rgba(255,248,236,0.85)'; c.lineWidth = Math.max(1.5, w * 0.022);
    c.beginPath(); c.ellipse(cx, top, rx, ry, 0, 0, Math.PI * 2); c.stroke();
    const hl = c.createLinearGradient(0, top, 0, bot); hl.addColorStop(0, 'rgba(255,240,220,0.75)'); hl.addColorStop(1, 'rgba(255,240,220,0.12)');
    c.strokeStyle = hl; c.lineWidth = Math.max(2, w * 0.04); c.lineCap = 'round';
    c.beginPath(); c.moveTo(cx - rx * 0.8, top + h * 0.14); c.lineTo(cx - bx * 0.78, bot - h * 0.14); c.stroke(); c.lineCap = 'butt';
    /* תחתית עבה */
    c.save(); body(); c.clip();
    const bgd = c.createLinearGradient(0, bot - h * 0.09, 0, bot); bgd.addColorStop(0, 'rgba(255,240,220,0)'); bgd.addColorStop(1, 'rgba(255,240,220,0.3)');
    c.fillStyle = bgd; c.fillRect(cx - rx, bot - h * 0.09, rx * 2, h * 0.09);
    c.restore();
    return { bot, top, h };
  };
  S['chg-14'] = {
    dur: DUR,
    shift: 0.22,
    glow: false,
    draw(c, W, H, t, side, I) { lock(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), level = levelAt(t);
      const w = Math.min(room * 0.56, H * 0.32), top = H * 0.42;
      c.save(); c.globalAlpha = 0.85;
      steam(c, ax - w * 0.1, top - w * 0.06, w * 0.7, H * 0.16, t, u.clamp(level * 2.5), m);
      c.restore();
      const r = lit(c, ax, top, w, level, t, m);
      caption(c, ax, r.bot + m * 0.13, t, m, room);
    },
  };

  /* ───────── 15 · אספרסו קצר ─────────
     כוס אספרסו קטנה ועבה על צלוחית, עם כפית. שכבת הקרמה הבהירה מצטמצמת עם הקפה.
     הכוס קטנה ביחס לצלוחית, ולכן היא נקראת כרגע קצר ולא כישיבה ארוכה */
  const espresso = (c, cx, top, w, level, t, m) => {
    const rx = w / 2, ry = rx * 0.3, h = w * 0.78, bot = top + h, bx = rx * 0.82, bry = ry * 0.82;
    const wall = f => u.lerp(bx, rx, f);
    const body = () => {
      c.beginPath();
      c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + rx, top);
      c.ellipse(cx, top, rx, ry, 0, 0, Math.PI, true);
      c.closePath();
    };
    /* הצלוחית */
    const sr = w * 1.5, sry = sr * 0.3, sy = bot + bry * 0.7;
    c.fillStyle = 'rgba(0,0,0,0.5)'; c.beginPath(); c.ellipse(cx + w * 0.05, sy + sry * 0.35, sr * 1.02, sry * 0.9, 0, 0, Math.PI * 2); c.fill();
    const sg = c.createLinearGradient(cx - sr, 0, cx + sr, 0);
    sg.addColorStop(0, '#F7F4EE'); sg.addColorStop(0.55, '#DCD7CE'); sg.addColorStop(1, '#B9B4AB');
    c.fillStyle = sg; c.beginPath(); c.ellipse(cx, sy, sr, sry, 0, 0, Math.PI * 2); c.fill();
    c.strokeStyle = 'rgba(0,0,0,0.12)'; c.lineWidth = Math.max(1, w * 0.012);
    c.beginPath(); c.ellipse(cx, sy, sr * 0.7, sry * 0.7, 0, 0, Math.PI * 2); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.7)'; c.lineWidth = Math.max(1, w * 0.014);
    c.beginPath(); c.ellipse(cx, sy, sr, sry, 0, Math.PI, 0); c.stroke();
    /* כפית על הצלוחית */
    c.save();
    c.translate(cx + sr * 0.62, sy + sry * 0.12); c.rotate(-0.24);
    c.fillStyle = '#C9CDD3'; c.beginPath(); c.ellipse(0, 0, w * 0.1, w * 0.055, 0, 0, Math.PI * 2); c.fill();
    u.rr(c, w * 0.08, -w * 0.017, w * 0.42, w * 0.034, w * 0.017, '#C9CDD3');
    c.fillStyle = 'rgba(255,255,255,0.55)'; c.beginPath(); c.ellipse(-w * 0.02, -w * 0.012, w * 0.05, w * 0.022, 0, 0, Math.PI * 2); c.fill();
    c.restore();
    /* הזכוכית העבה */
    const gg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
    gg.addColorStop(0, 'rgba(236,244,252,0.32)'); gg.addColorStop(0.34, 'rgba(236,244,252,0.1)');
    gg.addColorStop(0.7, 'rgba(236,244,252,0.13)'); gg.addColorStop(1, 'rgba(236,244,252,0.28)');
    body(); c.fillStyle = gg; c.fill();
    c.strokeStyle = 'rgba(255,255,255,0.24)'; c.lineWidth = Math.max(1, w * 0.012);
    c.beginPath(); c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0); c.stroke();
    /* הדפנות הפנימיות, מה שרואים דרך הזכוכית */
    c.strokeStyle = 'rgba(255,255,255,0.18)'; c.lineWidth = Math.max(1, w * 0.009);
    c.beginPath();
    c.moveTo(cx - rx * 0.9, top + ry * 0.4); c.lineTo(cx - bx * 0.88, bot - bry * 0.3);
    c.moveTo(cx + rx * 0.9, top + ry * 0.4); c.lineTo(cx + bx * 0.88, bot - bry * 0.3);
    c.stroke();
    /* האספרסו: כהה מאוד, ומעליו קרמה */
    const lf = 0.62 * level, ly = bot - h * 0.2 - h * lf, lrx = wall(0.2 + lf), lry = ry * (lrx / rx);
    if (level > 0.015) {
      c.save(); body(); c.clip();
      c.beginPath();
      c.moveTo(cx - lrx, ly); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + lrx, ly);
      c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI, true);
      c.closePath();
      const cg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
      cg.addColorStop(0, '#2A180C'); cg.addColorStop(0.3, '#4A2C15'); cg.addColorStop(0.65, '#3A2210'); cg.addColorStop(1, '#1E1108');
      c.fillStyle = cg; c.fill();
      c.restore();
      /* הקרמה: טבעת בהירה שמצטמצמת */
      const ca = 0.45 + 0.55 * u.clamp(level * 1.4);
      const fg = c.createRadialGradient(cx - lrx * 0.3, ly - lry * 0.3, 0, cx, ly, lrx);
      fg.addColorStop(0, `rgba(214,168,112,${ca})`); fg.addColorStop(0.75, `rgba(176,126,74,${ca})`); fg.addColorStop(1, `rgba(120,80,44,${ca})`);
      c.fillStyle = fg; c.beginPath(); c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI * 2); c.fill();
      c.strokeStyle = `rgba(232,196,150,${ca * 0.8})`; c.lineWidth = Math.max(1, w * 0.014);
      c.beginPath(); c.ellipse(cx, ly, lrx * 0.95, lry * 0.95, 0, 0, Math.PI * 2); c.stroke();
    }
    /* הזכוכית מלפנים, ותחתית עבה מאוד */
    c.strokeStyle = 'rgba(255,255,255,0.52)'; c.lineWidth = Math.max(1.5, w * 0.022);
    c.beginPath(); c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot); c.moveTo(cx + rx, top); c.lineTo(cx + bx, bot); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.85)'; c.lineWidth = Math.max(1.5, w * 0.026);
    c.beginPath(); c.ellipse(cx, top, rx, ry, 0, 0, Math.PI * 2); c.stroke();
    const hl = c.createLinearGradient(0, top, 0, bot); hl.addColorStop(0, 'rgba(255,255,255,0.6)'); hl.addColorStop(1, 'rgba(255,255,255,0.12)');
    c.strokeStyle = hl; c.lineWidth = Math.max(2, w * 0.04); c.lineCap = 'round';
    c.beginPath(); c.moveTo(cx - rx * 0.76, top + h * 0.16); c.lineTo(cx - bx * 0.74, bot - h * 0.18); c.stroke(); c.lineCap = 'butt';
    c.save(); body(); c.clip();
    const bgd = c.createLinearGradient(0, bot - h * 0.2, 0, bot); bgd.addColorStop(0, 'rgba(255,255,255,0)'); bgd.addColorStop(1, 'rgba(255,255,255,0.28)');
    c.fillStyle = bgd; c.fillRect(cx - rx, bot - h * 0.2, rx * 2, h * 0.2);
    c.restore();
    return { bot: sy + sry, top, h };
  };
  S['chg-15'] = {
    dur: DUR,
    shift: 0.22,
    glow: false,
    draw(c, W, H, t, side, I) { lock(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), level = levelAt(t);
      const w = Math.min(room * 0.42, H * 0.24), top = H * 0.44;
      steam(c, ax, top - w * 0.08, w * 0.6, H * 0.13, t, u.clamp(level * 2.2), m);
      const r = espresso(c, ax, top, w, level, t, m);
      caption(c, ax, r.bot + m * 0.11, t, m, room);
    },
  };

  /* ───────── 16 · הכוס של 14, נקייה ─────────
     יובל: «תעשה את הקפה כמו 14, אבל כמו 13, בלי האור והשטויות».
     ⟹ אותה כוס נמוכה ורחבה של 14, ובלי הסצנה שסביבה: בלי שולחן, בלי צל ארוך ובלי בריכת אור.
     רק הכוס על רקע שחור, האדים, והקפה שיורד. הקצב החדש: נשאר מלא יותר לאורך הדרך, ונגמר בסוף */
  const plain = (c, cx, top, w, level, t, m) => {
    const rx = w / 2, ry = rx * 0.26, h = w * 0.92, bot = top + h, bx = rx * 0.93, bry = ry * 0.93;
    const wall = f => u.lerp(bx, rx, f);
    const body = () => {
      c.beginPath();
      c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + rx, top);
      c.ellipse(cx, top, rx, ry, 0, 0, Math.PI, true);
      c.closePath();
    };
    /* צל אחד, רך, מתחת לכוס */
    c.fillStyle = 'rgba(0,0,0,0.45)'; c.beginPath(); c.ellipse(cx + w * 0.04, bot + bry * 0.45, bx * 1.45, bry * 1.15, 0, 0, Math.PI * 2); c.fill();
    /* הידית: ספל ולא כוס, בקשת יובל 22.09.2026. זכוכית כמו הדופן, יוצאת מהצד ונכנסת בחזרה.
       נצמדת לדופן המשופעת בשני הגבהים, ולכן היא יושבת עליה גם כשהכוס צרה בתחתית */
    {
      const y1 = top + h * 0.2, y2 = top + h * 0.7, x1 = cx + wall(1 - 0.2), x2 = cx + wall(1 - 0.7), out = rx * 0.5;
      const loop = () => { c.beginPath(); c.moveTo(x1 - w * 0.01, y1); c.bezierCurveTo(x1 + out, y1 - h * 0.04, x2 + out, y2 + h * 0.04, x2 - w * 0.01, y2); };
      c.lineCap = 'round';
      loop(); c.strokeStyle = 'rgba(226,238,248,0.22)'; c.lineWidth = Math.max(4, w * 0.075); c.stroke();
      loop(); c.strokeStyle = 'rgba(255,255,255,0.55)'; c.lineWidth = Math.max(1.5, w * 0.016); c.stroke();
      c.lineCap = 'butt';
    }
    /* הזכוכית */
    const gg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
    gg.addColorStop(0, 'rgba(226,238,248,0.3)'); gg.addColorStop(0.32, 'rgba(226,238,248,0.09)');
    gg.addColorStop(0.68, 'rgba(226,238,248,0.12)'); gg.addColorStop(1, 'rgba(226,238,248,0.26)');
    body(); c.fillStyle = gg; c.fill();
    /* מה שרואים דרכה: התחתית מאחור, והדפנות הפנימיות */
    /* 🔴 20.09.2026: הקו הזה היה עבה, והוא נקרא עם התחתית כמו פס זר בתוך הכוס (צילום של יובל).
       הוא נשאר, כי בלעדיו הכוס נראית אטומה, אבל דק וחלש יותר */
    c.strokeStyle = 'rgba(255,255,255,0.12)'; c.lineWidth = Math.max(1, w * 0.006);
    c.beginPath(); c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.16)'; c.lineWidth = Math.max(1, w * 0.008);
    c.beginPath();
    c.moveTo(cx - rx * 0.93, top + ry * 0.45); c.lineTo(cx - bx * 0.9, bot - bry * 0.35);
    c.moveTo(cx + rx * 0.93, top + ry * 0.45); c.lineTo(cx + bx * 0.9, bot - bry * 0.35);
    c.stroke();
    /* הקפה */
    const lf = 0.86 * level, ly = bot - h * lf, lrx = wall(lf), lry = ry * (lrx / rx);
    if (level > 0.012) {
      c.save(); body(); c.clip();
      c.beginPath();
      c.moveTo(cx - lrx, ly); c.lineTo(cx - bx, bot);
      c.ellipse(cx, bot, bx, bry, 0, Math.PI, 0, true);
      c.lineTo(cx + lrx, ly);
      c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI, true);
      c.closePath();
      const cg = c.createLinearGradient(cx - rx, 0, cx + rx, 0);
      cg.addColorStop(0, '#42291A'); cg.addColorStop(0.3, '#7A4E2D'); cg.addColorStop(0.62, '#6B4327'); cg.addColorStop(1, '#3A2213');
      c.fillStyle = cg; c.fill();
      const dg = c.createLinearGradient(0, ly, 0, bot); dg.addColorStop(0, 'rgba(0,0,0,0)'); dg.addColorStop(1, 'rgba(0,0,0,0.35)');
      c.fillStyle = dg; c.fill();
      c.restore();
      const sg = c.createRadialGradient(cx - lrx * 0.3, ly - lry * 0.4, 0, cx, ly, lrx);
      sg.addColorStop(0, '#A9764A'); sg.addColorStop(1, '#6B4327');
      c.fillStyle = sg; c.beginPath(); c.ellipse(cx, ly, lrx, lry, 0, 0, Math.PI * 2); c.fill();
      c.strokeStyle = 'rgba(214,170,120,0.65)'; c.lineWidth = Math.max(1, w * 0.012);
      c.beginPath(); c.ellipse(cx, ly, lrx * 0.96, lry * 0.96, 0, 0, Math.PI * 2); c.stroke();
    }
    /* שובל דק שהקפה משאיר על הדופן. 🔴 נעלם כשהכוס כמעט ריקה, אחרת הוא נשאר כמלבן חום בתחתית */
    if (level > 0.06 && level < 0.99) {
      c.save(); body(); c.clip();
      c.globalAlpha = 0.14 * u.clamp((level - 0.06) / 0.12); c.fillStyle = '#8A5A36';
      c.fillRect(cx - rx, Math.max(top, ly - h * 0.05), rx * 2, h * 0.05);
      c.restore();
    }
    /* הזכוכית מלפנים */
    c.strokeStyle = 'rgba(255,255,255,0.5)'; c.lineWidth = Math.max(1.5, w * 0.018);
    c.beginPath(); c.moveTo(cx - rx, top); c.lineTo(cx - bx, bot); c.moveTo(cx + rx, top); c.lineTo(cx + bx, bot); c.stroke();
    c.strokeStyle = 'rgba(255,255,255,0.82)'; c.lineWidth = Math.max(1.5, w * 0.022);
    c.beginPath(); c.ellipse(cx, top, rx, ry, 0, 0, Math.PI * 2); c.stroke();
    const hl = c.createLinearGradient(0, top, 0, bot); hl.addColorStop(0, 'rgba(255,255,255,0.55)'); hl.addColorStop(1, 'rgba(255,255,255,0.1)');
    c.strokeStyle = hl; c.lineWidth = Math.max(2, w * 0.035); c.lineCap = 'round';
    c.beginPath(); c.moveTo(cx - rx * 0.78, top + h * 0.14); c.lineTo(cx - bx * 0.76, bot - h * 0.14); c.stroke();
    c.lineWidth = Math.max(1, w * 0.014);
    c.beginPath(); c.moveTo(cx + rx * 0.84, top + h * 0.18); c.lineTo(cx + bx * 0.82, bot - h * 0.32); c.stroke();
    c.lineCap = 'butt';
    /* התחתית העבה: זוהר רך סביב מרכז התחתית, ולא מלבן.
       🔴 מלבן נותן קצה ישר לרוחב הכוס, והוא זה שנראה כמו פס מוזר */
    c.save(); body(); c.clip();
    const bgd = c.createRadialGradient(cx, bot, 0, cx, bot, bx * 1.1);
    bgd.addColorStop(0, 'rgba(255,255,255,0.26)'); bgd.addColorStop(1, 'rgba(255,255,255,0)');
    c.fillStyle = bgd; c.beginPath(); c.ellipse(cx, bot, bx * 1.1, h * 0.15, 0, 0, Math.PI * 2); c.fill();
    c.restore();
    return { bot, top, h };
  };
  S['chg-16'] = {
    dur: DUR,
    shift: 0.22,
    glow: false,
    draw(c, W, H, t, side, I) { lock(c, W, H, t, I.tg, I); },
    stage(c, W, H, t, I, scr) {
      const { room, ax, m } = K.room(W, H, scr), level = levelAt(t);
      const w = Math.min(room * 0.6, H * 0.33), top = H * 0.42;
      steam(c, ax, top - w * 0.06, w * 0.7, H * 0.17, t, u.clamp(level * 2.5), m);
      const r = plain(c, ax, top, w, level, t, m);
      caption(c, ax, r.bot + m * 0.13, t, m, room);
    },
  };
})();

/* ── js/showcase.js ── */
/* היכולות של iPhone 18: אותו מנוע ההדגמות, טלפון אחד ובלי השוואה. ארבע פריסות לדף הבית.
   כל סצנה מציירת מסך אחד (draw(c, W, H, t, side, I)). ההשוואה הייתה שתי הרצות זו לצד זו,
   וכאן רצה רק side='new', עם I.o = I.tg. כך cam עובר מעצמו לצמצם המשתנה, ו-bat אינו מחפש יריב. */
(() => {
  const L = window.TYSH, { T } = L, u = L.u;
  /* 🔴 23.09.2026: הרצף לומד להכיר את הטלפון של הלקוח. `M` ו-`byName` באים מ-data.js,
     שכבר נארז כאן מהיום הראשון ופשוט לא היה בשימוש. אין קובץ חדש ואין נתון חדש. */
  const { M, byName } = L;

  /* מסגרות מצוירות בלבד, כמו מה שיעלה לחנות. הרישיון של המסגרות של Apple אינו מכסה אתר */
  L.A.bezels = {};
  /* אותו קובץ רץ במעבדה ובחנות. בחנות אין #v-a, ואין בקרות מעבדה */
  const IN_LAB = !!document.getElementById('v-a');

  /* 🔴 כותרת הסקשן, מקור אחד ל-12 הפריסות. הכרעת יובל 21.09.2026, אפשרות 4.
     קודם היא הייתה כתובה 12 פעמים, וכל שינוי היה חייב לגעת בכולן. */
  const HEAD = 'לא מפרט. הדגמה.';

  const PLAY = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M4 2.5v11l9-5.5z"/></svg>';
  const PAUSE = '<svg viewBox="0 0 16 16" aria-hidden="true"><path d="M3.5 2.5h3v11h-3zM9.5 2.5h3v11h-3z"/></svg>';

  /* משקל הצילומים של כל הדגמה. נמדד 16.09.2026 על img/apple */
  const KB = {
    'bat-video': 232, 'zoom-wide': 426, 'zoom-8x': 238, 'ap-148': 33, 'ap-18': 149, 'ap-28': 141, 'ap-4': 103,
    'selfie-group': 486, 'cam-photo': 306, 'chip-a20': 72,
    /* שכבות הטשטוש של הצמצם הנבחר (cam-16). נמדדו 20.09.2026 */
    'ap5-148': 49, 'ap5-18': 55, 'ap5-22': 69, 'ap5-28': 103, 'ap5-34': 131, 'ap5-4': 232,
  };
  const AP5 = ['ap5-148', 'ap5-18', 'ap5-22', 'ap5-28', 'ap5-34', 'ap5-4'];
  const IMGS = {
    bat: ['bat-video'], zoom: ['zoom-wide', 'zoom-8x'], cam: AP5, self: ['selfie-group'], scr: ['cam-photo'],
    vid: [], hz: ['cam-photo', 'ap-148', 'selfie-group', 'zoom-8x', 'ap-28', 'bat-video', 'ap-4', 'zoom-wide', 'ap-18'], chip: ['chip-a20'], chg: [], mp: ['cam-photo'], isl: [],
  };
  const kbOf = keys => [...new Set(keys.flatMap(k => IMGS[k]))].reduce((s, f) => s + KB[f], 0);
  const fmtKB = kb => (kb >= 1024 ? `${(kb / 1024).toFixed(1)}MB` : `${kb}KB`);

  /* הנוסח לכל יכולת, בלי «מול» ובלי «אצלכם» */
  const CAP = {
    /* סבב 2 (17.09.2026): שעות שימוש רגיל ולא שעות וידאו. יובל: «אף אחד כמעט לא רואה סרטים בטלפון» */
    bat: {
      label: 'סוללה',
      title: t => `עד ${t.use} שעות של שימוש`,
      stat: t => ({ n: String(t.use), u: 'שעות של שימוש' }),
      line: () => 'הודעות, מפות, מוזיקה, צילום וסדרה בערב. יום שלם בטעינה אחת.',
    },
    zoom: {
      label: 'זום',
      title: t => `זום אופטי פי ${t.z}`,
      stat: t => ({ n: `${t.z}×`, u: 'זום אופטי' }),
      line: t => `אותו צילום, מאותה נקודה. עוברים בין העדשות עד פי ${t.z}, ורואים מקרוב את מה שהיה רחוק.`,
    },
    cam: {
      label: 'צמצם',
      title: () => 'צמצם משתנה',
      stat: () => ({ n: 'ƒ/1.48', u: 'צמצם משתנה' }),
      line: () => 'הצמצם נפתח ונסגר כמו במצלמה מקצועית. רקע מטושטש לפורטרט, או הכול בפוקוס לנוף.',
    },
    self: {
      label: 'סלפי',
      title: () => 'סלפי שנפתח לבד',
      stat: t => ({ n: `${t.sm}MP`, u: 'סלפי שנפתח לבד' }),
      line: () => 'מחזיקים את הטלפון לאורך. כשחברים נכנסים לפריים, התמונה נפתחת לרוחב בלי לסובב.',
    },
    scr: {
      label: 'מסך',
      title: t => (t.duo ? 'מסך שנפתח' : `מסך של ${t.s} אינץ'`),
      stat: t => (t.duo ? { n: '7.6', u: "אינץ', מסך שנפתח" } : { n: String(t.s), u: "אינץ'" }),
      line: t => (t.duo ? "בכיס הוא טלפון עם מסך של 5.4 אינץ'. פותחים, ויש מסך של 7.6 אינץ'." : 'מסך מקצה לקצה, בגוף שנוח להחזיק ביד אחת.'),
    },
    /* ── חמש היכולות שנוספו 16.09.2026, לבחירה בסטודיו. הנתונים מ-data.js ומטבלאות Apple */
    vid: {
      label: 'וידאו',
      title: t => `וידאו 4K ב-${t.fps} פריימים`,
      stat: t => ({ n: String(t.fps), u: 'פריימים בשנייה, 4K' }),
      line: () => 'תנועה מהירה נשארת חדה, ואפשר להאט אותה בעריכה בלי קפיצות.',
    },
    hz: {
      label: 'חלקות מסך',
      title: t => `מסך של ${t.hz}Hz`,
      stat: t => ({ n: `${t.hz}Hz`, u: 'חלקות מסך' }),
      line: t => `המסך מצייר כל תנועה ${t.hz} פעמים בשנייה. גלילה, מעבר בין אפליקציות ומשחקים מרגישים חלקים.`,
    },
    chip: {
      label: 'מהירות',
      title: t => `שבב ${t.chip}`,
      stat: t => ({ n: t.chip, u: 'השבב' }),
      /* סבב 2 (17.09.2026): בלי השוואה ל-17. יובל: «להראות מה המעבד עושה» */
      line: () => 'משחקים כבדים, עריכת וידאו וכמה אפליקציות יחד. ביצועים יציבים גם לאורך זמן.',
    },
    chg: {
      label: 'טעינה',
      title: t => `עד 50% בכ-${t.ch} דקות`,
      stat: t => ({ n: String(t.ch), u: 'דקות ל-50%' }),
      /* «נמכר בנפרד» ירד, הכרעת יובל 17.09.2026 */
      /* 🔴 הנוסח של יובל, 21.09.2026, מילה במילה. הנוסח הקודם הזכיר מטען 60W, וירד.
         ⚠️ הטענה «50% בכ-15 דקות» נכונה עם מטען 60W, והתנאי הזה כבר אינו כתוב. */
      line: () => 'עד שתסיימו את הקפה, הטלפון כבר ב-50%.',
    },
    /* סבב 5 (17.09.2026): יובל ביקש משהו שיראה את היכולות של האי הדינמי החדש. רק מה שאומת מול Apple */
    isl: {
      label: 'האי הדינמי',
      title: () => 'אי דינמי קטן יותר',
      stat: () => ({ n: '3', u: 'פעילויות חיות יחד' }),
      line: () => 'אי קטן יותר, ועד שלוש פעילויות חיות יחד: תוצאה של משחק, ניווט ומוזיקה. מחליקים על האי כדי לעבור ביניהן.',
    },
    mp: {
      label: 'רזולוציה',
      title: t => `${t.mp} מגה פיקסל`,
      stat: t => ({ n: `${t.mp}MP`, u: 'מצלמה ראשית' }),
      line: () => 'חותכים חלק קטן מהתמונה, והפרטים נשארים חדים.',
    },
  };
  /* רק מה שהדגם באמת עושה: ל-Duo אין צמצם משתנה, והזום שלו פי 2 */
  const CAPS = { pro: ['bat', 'zoom', 'cam', 'self'], max: ['bat', 'zoom', 'cam', 'self'], duo: ['scr', 'bat', 'self'] };
  /* מה מותר לבחור בסדר מהגדרה. ברירת המחדל נשארת CAPS */
  const ALL10 = ['zoom', 'self', 'cam', 'bat', 'vid', 'hz', 'chip', 'scr', 'chg', 'mp', 'isl'];
  const ALLOW = { pro: ALL10, max: ALL10, duo: ['scr', 'bat', 'self', 'vid', 'hz', 'chip', 'chg', 'mp'] };
  /* הסוללה נעצרת בשעה 32 עם 6%: הדגמת יכולת לא מסתיימת במסך כבוי */
  const DUR = { bat: 6.2 };
  /* 🔴 ההכרעות של יובל, 20.09.2026. הסטודיו נסגר על אלה, והן ברירת המחדל בכל פריסה.
     הגדרה בסקשן דורסת יכולת בודדת, ולכן אפשר להשוות גרסה בלי לגעת בשאר. */
  const CHOSEN = { zoom: '4', self: '10', cam: '16', bat: '13', vid: '14', chip: '13', chg: '16' };
  /* גרסאות תצוגה ליכולת: { zoom: '2' } מריץ את הסצנה zoom-2 במקום zoom. '0' או ריק = הקיים */
  let VARS = Object.assign({}, CHOSEN);
  const sceneKey = k => (VARS[k] && VARS[k] !== '0' && L.scenes[`${k}-${VARS[k]}`] ? `${k}-${VARS[k]}` : k);
  const sceneOf = k => L.scenes[sceneKey(k)];
  /* סדר יכולות מהגדרה, רק מה שהדגם באמת עושה. ריק = ברירת המחדל של הדגם */
  let capsOvr = null;
  const capsOf = t => { const o = (capsOvr || []).filter(k => ALLOW[t.key].includes(k)); return o.length ? o : CAPS[t.key]; };
  const durOf = k => (sceneKey(k) === k && DUR[k]) || sceneOf(k).dur;
  const dims = t => (t.duo ? [t.wOpen, t.hOpen] : [t.w, t.h]);

  // ── משאבים לכל פריסה, כדי שאפשר לבנות אחת מחדש בלי לגעת בשאר
  function scope() {
    const s = { obs: [], timers: [], players: [], offs: [] };
    s.observe = (o, el) => { s.obs.push(o); o.observe(el); return o; };
    s.later = (fn, ms) => { const id = setTimeout(fn, ms); s.timers.push(id); return id; };
    s.on = (target, ev, fn, opt) => { target.addEventListener(ev, fn, opt); s.offs.push(() => target.removeEventListener(ev, fn, opt)); };
    s.dispose = () => {
      s.obs.forEach(o => o.disconnect()); s.timers.forEach(clearTimeout); s.offs.forEach(f => f());
      s.players.forEach(p => { p.playing = false; clearTimeout(p._duoTimer); const i = L.players.indexOf(p); if (i >= 0) L.players.splice(i, 1); });
    };
    return s;
  }

  /* טלפון אחד על במה. fitK(floor) מחזיר k, פיקסלים למ"מ */
  function mountPhone(s, floor, t, fitK) {
    floor.innerHTML = '';
    const fig = L.device(t, 'new', '');
    floor.append(fig);
    const p = L.register({
      key: null, t: 0, dur: 1, playing: false, visible: false, dirty: true, k: 2,
      figs: { new: fig }, I: { o: t, tg: t, acc: t.accRgb },
      draw() {
        if (!this.key) return;
        const { c, W, H } = L.fitCanvas(fig._canvas);
        c.clearRect(0, 0, W, H); c.save(); sceneOf(this.key).draw(c, W, H, this.t, 'new', this.I); c.restore();
        this.onDraw && this.onDraw();
      },
    });
    s.players.push(p);
    const fit = () => { p.k = fitK(floor); L.layoutDevice(fig, p.k); L.kick(); };
    fit(); s.observe(new ResizeObserver(fit), floor);
    /* ה-Duo חוזר לפתוח כשעוברים ליכולת שאינה המסך */
    p.openDuo = () => { if (!t.duo) return; const tt = p.t; p.t = 99; L.scenes.scr.onScrub(p, p.I, p.k); p.t = tt; };
    /* ההמשך האוטומטי אחרי סוף הדגמה. כל play מבטל אותו, אחרת לחיצה שנפלה בחלון
       שבין סוף הדגמה להמשך נדרסת כשהטיימר הישן יורה */
    p.after = (fn, ms) => { clearTimeout(p._adv); p._adv = s.later(fn, ms); };
    /* מצב מנוחה: פריים מייצג כבר בטעינה, כדי שהמסך לא יישאר שחור עד שגוללים אליו.
       בסוללה פריים באמצע (32%), כי הסוף הוא 6% באדום */
    p.rest = k => { p.key = k; p.dur = durOf(k); p.t = k === 'bat' ? 4.2 : p.dur; p.live = false; p.dirty = true; L.kick(); };
    p.play = k => {
      clearTimeout(p._adv); p.live = true;
      if (k !== 'scr') p.openDuo();
      p.key = k; p.dur = durOf(k); p.t = L.reduce ? p.dur : 0; p.playing = !L.reduce; p.last = 0;
      const sc = sceneOf(k); sc.onStart && sc.onStart(p, p.I, p.k);
      p.dirty = true; L.loop();
    };
    return p;
  }

  /* 🔴 ציור הסצנה על הבמה, ליד הטלפון ומאחוריו.
     לכל שבע הסצנות שנבחרו יש stage: הזום מצייר שם את הנוף, את המסגרת ואת המספר הגדול,
     הצמצם את שני המדדים, והמהירות את מסוע האייקונים.
     ⟹ פריסה בלי קנבס במה מציגה חצי הדגמה, בלי שום שגיאה. נתפס על ידי יובל 20.09.2026. */
  function wireStage(p, floor, back, stageEl) {
    let on = false;
    const clear = () => { if (!on) return; const { c, W, H } = L.fitCanvas(back); c.clearRect(0, 0, W, H); on = false; };
    /* ההזזה של הטלפון נקבעת לפני המדידה, אחרת הקווים על הבמה מפגרים פריים */
    p.applyShift = () => {
      const sc = sceneOf(p.key); if (!sc) return;
      if (stageEl) stageEl.classList.toggle('no-glow', sc.glow === false);
      if (sc.shiftAt) return;
      /* p.travel הוא נסיעה נוספת של הטלפון (פריסה מ). הציור על הבמה נמדד מהטלפון
         בכל פריים, ולכן הוא נוסע איתו. הזזת הבמה כולה הייתה חותכת אותו. */
      let v = (sc.shift || 0) + (p.travel || 0);
      /* 🔴 תקרה, ורק כשיש נסיעה. חצי הטלפון הוא כ-9% מרוחב הבמה, ולכן מעבר ל-0.32 הוא נחתך.
         בלי travel שום פריסה אחרת אינה משתנה. נתפס 21.09.2026 בצילום. */
      if (p.travel) v = Math.max(-0.32, Math.min(0.32, v));
      floor.style.transform = v ? `translateX(${v * 100}%)` : '';
    };
    return () => {
      const sc = sceneOf(p.key);
      if (!sc || !sc.stage) return clear();
      /* 🔴 הציור על הבמה הוא רקע גדול, ובטלפון הוא אינו זקוק לצפיפות 2.
         מסך הטלפון עצמו נשאר חד. נמדד: 8M פיקסל ⟵ 2M בפריסה כ. */
      back.dataset.dpr = back.clientWidth > 560 ? 2 : 1;
      if (sc.shiftAt) { const v = sc.shiftAt(p.t); floor.style.transform = v ? `translateX(${v * 100}%)` : ''; }
      const { c, W, H } = L.fitCanvas(back);
      c.clearRect(0, 0, W, H);
      const br = back.getBoundingClientRect(), cr = p.figs.new._canvas.getBoundingClientRect();
      sc.stage(c, W, H, p.t, p.I, { x: cr.left - br.left, y: cr.top - br.top, w: cr.width, h: cr.height });
      on = true;
    };
  }

  /* מתחיל כשהבמה נראית ביותר מ-40%, ומצייר רק מה שבמסך */
  function watch(s, p, el, onFirst) {
    let seen = false;
    s.observe(new IntersectionObserver(([e]) => {
      p.visible = e.isIntersecting;
      if (e.isIntersecting && e.intersectionRatio > 0.4 && !seen) { seen = true; onFirst(); }
      p.dirty = true; L.loop();
    }, { threshold: [0, 0.4] }), el);
  }

  /* כל הצילומים של הדגם יורדים כשהסקשן מתקרב למסך, במרחק של מסך אחד.
     L.img מתחיל הורדה רק בציור הראשון של סצנה, ובגלילה זה קורה כשהיכולת נעשית פעילה.
     נמדד 16.09.2026: המסך נשאר שחור עד סוף ההורדה, 17.9 שניות בחיבור איטי */
  function preload(s, el, t) {
    const files = [...new Set(capsOf(t).flatMap(k => IMGS[k]))];
    s.observe(new IntersectionObserver(([e], o) => {
      if (!e.isIntersecting) return;
      o.disconnect();
      files.forEach(f => { const im = (L.A.images || {})[f]; if (im) L.img(im.file); });
    }, { rootMargin: '100% 0px' }), el);
  }

  function pauser(s, btn, onPause, onResume) {
    const ctl = { paused: false };
    const paint = () => { btn.innerHTML = ctl.paused ? PLAY : PAUSE; btn.setAttribute('aria-label', ctl.paused ? 'הפעלת ההדגמה' : 'עצירת ההדגמה'); };
    ctl.set = v => { if (v === ctl.paused) return; ctl.paused = v; (v ? onPause : onResume)(); paint(); L.loop(); };
    s.on(btn, 'click', () => ctl.set(!ctl.paused));
    paint();
    return ctl;
  }

  /* השורה הקטנה מעל הכותרת. ברירת המחדל שם הדגם. הגדרת הסקשן «kicker» דורסת אותה בלבד,
     ושאר הרצף ממשיך לדבר על הדגם. בקשת יובל 22.09.2026: «iPhone 18» בדף הבית. */
  const kick = t => `<p class="kick"><bdi>${KICKER || t.name}</bdi></p>`;
  const statHTML = (k, t, tag = 'p') => { const st = CAP[k].stat(t); return `<${tag} class="stat"><b>${st.n}</b><span>${st.u}</span></${tag}>`; };
  const roHTML = (k, t) => `<span class="ro-l">${CAP[k].label}</span><p class="ro-t">${CAP[k].title(t)}</p><p class="ro-x">${CAP[k].line(t)}</p>`;
  /* 🔴 23.09.2026: בדף המוצר «לדף הדגם» מוביל לאותו דף, ובדפי אילת קופץ להוד.
     בקשת יובל: להוריד אותו שם. בדף הבית הוא נשאר, ולכן ברירת המחדל דלוקה.
     📌 ההערה המשפטית (FN) אינה חלק מזה ואינה יורדת. */
  const ctas = t => (!SHOWCTA ? '' : L.showLinks
    ? `<div class="ctas"><a class="cta" href="${L.showLinks[t.key]}">לדף הדגם</a></div>`
    : '<div class="ctas"><a class="cta" href="#" data-noop>לדף הדגם</a><button type="button" class="cta ghost" data-noop>עדכנו אותי</button></div>');
  const FN = '<p class="fn">הדגמה להמחשה, לפי נתוני Apple. הצילומים: Apple.</p>';
  const narrowOf = host => { const b = host.querySelector('.band'); return !b || b.clientWidth < 560; };

  /* ═══════════ טרייד אין: «השאלה פותחת, הרצף עונה» ═══════════
     הכרעת יובל 24.09.2026, אפשרות ג. כבוי כברירת מחדל, ולכן כל שימוש קיים
     ברצף אינו זז ולו בפיקסל. נדלק מהסקשן דרך opts.tradein. */
  const TI = { on: false, style: 'a', pick: [], tmeta: {}, prices: null, model: '', calcHref: '', head: '', ask: '', rec: '', buy: '', calcLabel: '' };
  /* ty-brand-copy >>> 30.09.2026, יובל: «השוואת יכולות» ראשי, וטרייד אין כהמלצה משנית (אפשרות א).
     כל שדה ריק משאיר את הנוסח של היום, ולכן דף המוצר ודף הטרייד אין הקיימים אינם זזים. */
  const headOf = () => (TI.on && TI.head) || HEAD;
  const recTag = () => (TI.on && TI.rec ? `<span class="ti-rec-tag">${TI.rec}</span>` : '');
  const recCls = () => (TI.on && TI.rec ? ' ti-rec' : '');
  /* <<< ty-brand-copy */
  const ils = n => '₪' + Number(n).toLocaleString('en-US');
  const myPhone = () => (TI.on ? byName(TI.model) : null);
  const tmetaOf = k => TI.tmeta[k] || {};
  /* השווי נקרא מהמחירון החי שהסקשן הזריק, והמספר שבקוד הוא נפילה חזרה. */
  const worthOf = o => {
    if (!o) return 0;
    const row = TI.prices && TI.prices[o.name];
    if (row) {
      const v = Object.values(row).map(a => (Array.isArray(a) ? +a[0] : +a)).filter(Number.isFinite);
      if (v.length) return Math.max(...v);
    }
    return o.tr || 0;
  };

  /* ═══ ההשוואה בתוך הפרק ═══
     🔴 בקשת יובל 24.09.2026: «תחזיר לפורמט הגולל, רק תשאיר את ההשוואה».
     ⟹ הרצף נשאר כמו שהוא, ובכל פרק נכנסת שורת ההשוואה עצמה: המספר שלכם,
     חץ, והמספר של הדגם החדש. אותה שפה של הסקשן שיובל אישר.
     🔴 המספרים באים מ-`compare()` שב-data.js, בדיוק אותו מקור של מנוע ההשוואה.
        אין כאן חישוב שני, ולכן שני המשטחים אינם יכולים לומר דברים שונים.
     🔴 שלושה מצבים, ולא אחד. שורה שאומרת «48MP ⟵ 48MP» היא רעש ולא שכנוע:
        · הערכים נבדלים            ⟵ זוג מספרים עם חץ
        · זהים אבל יש שדרוג        ⟵ הנוסח של `gain` («חדש: צמצם משתנה»)
        · זהים ואין שדרוג          ⟵ «זהה אצל שניכם»
     🔴 בסוללה התווית היא «שעות צפייה» ולא «סוללה». כותרת הפרק אומרת «שעות של
        שימוש», שהוא מדד אחר של Apple, ושני מספרים בלי תווית היו נקראים כסתירה. */
  const CMP_LABEL = { bat: 'שעות צפייה' };
  let cmpCache = null;
  const cmpOf = (k, t) => {
    const o = myPhone();
    if (!o) return null;
    const id = o.name + '|' + t.key;
    if (!cmpCache || cmpCache.id !== id) cmpCache = { id, data: L.compare(o, t) };
    return cmpCache.data.byKey[k] || null;
  };
  const cmpInner = (k, t) => {
    const x = cmpOf(k, t), o = myPhone();
    if (!x) return '';
    const lab = CMP_LABEL[k] || x.label;
    const un = x.unit ? `<small>${x.unit}</small>` : '';
    const head = `<span class="ti-cmp-l">${lab}</span>`;
    if (String(x.o) === String(x.n)) {
      return `${head}<p class="ti-cmp-one">${x.st === 'up' ? x.gain : 'זהה אצל שניכם'}</p>`;
    }
    return `${head}<div class="ti-cmp-v">
      <span class="ti-cmp-side ti-cmp-o"><i>שלכם</i><b class="num"><bdi>${x.o}</bdi></b>${un}</span>
      <span class="ti-cmp-a" aria-hidden="true">←</span>
      <span class="ti-cmp-side ti-cmp-n"><i><bdi>${t.short}</bdi></i><b class="num"><bdi>${x.n}</bdi></b>${un}</span>
    </div>`;
  };
  /* 🔴 כשהטרייד אין כבוי אין כאן אלמנט בכלל, גם לא ריק ומוסתר. כך הפלט בדף המוצר
     זהה למה שהיה, ואי אפשר שרכיב שלנו ישפיע שם בלי שאיש התכוון. */
  const cmpHTML = (k, t) => {
    if (!TI.on) return '';
    const inner = cmpInner(k, t);
    return `<div class="ti-cmp" data-ticmp="${k}"${inner ? '' : ' hidden'}>${inner}</div>`;
  };

  const optsHTML = sel => [...new Set(M.map(m => m.ser))].sort((a, b) => b - a)
    .map(s => `<optgroup label="iPhone ${s}">${M.filter(m => m.ser === s)
      .map(m => `<option value="${m.name}"${m.name === sel ? ' selected' : ''}>${m.name}</option>`).join('')}</optgroup>`).join('');

  /* ═══ הבלוק שפותח: מה יש לכם, איזה דגם, וכמה שלכם שווה ═══
     הוא מה שמציל את האורך, כי המספר האישי מופיע במסך הראשון ולא בסוף שבעה פרקים.

     🔴 יובל, 24.09.2026: «לא אהבתי את איך שאני אמור לבחור את הטלפון שלי
     והבחירה בין הפרו לפרו מקס». ⟹ ארבע גרסאות, ובוחרים אחת:
       a · הקיים: רשימה נפתחת, ושני כפתורים עם מחיר
       b · שבבים: שורת סדרה, שורת דגם, ומתג מפוצל
       c · משפט: «יש לי ___ ומעניין אותי ___», שני בוררים בתוך שורה אחת
       d · חיפוש: מקלידים דגם ובוחרים מהצעות, כמו במחשבון הטרייד אין
     כולן מדברות עם אותם שני שערים, `setMine` ו-`setTarget`, ולכן הוספת גרסה
     אינה נוגעת בשום מאזין. */
  const SERIES = () => [...new Set(M.map(m => m.ser))].sort((a, b) => b - a);
  const serOf = name => (byName(name) || {}).ser;

  /* 🔴 יובל, 27.09.2026: «למצוא דרך לכתוב את המחיר למעלה לפני הגלילה». המחיר אחרי
     הטרייד אין עלה מהסגירה אל שורת השווי, ולכן הוא במסך הראשון. אותו נוסח ואותו סייג
     של הסגירה, כי זו אותה הבטחה. בלי קו מוחק: טרייד אין אינו הנחה על המכשיר החדש. */
  const worthLine = t => {
    const o = myPhone(), w = worthOf(o);
    if (!(o && w)) return recTag() + 'הנה מה שתקבלו במקום.';
    const price = t ? tmetaOf(t.key).price : 0, after = price ? price - w : 0;
    const head = recTag() + `ה-<bdi>${o.name}</bdi> שלכם שווה <span class="ti-nw"><span class="ti-upto">עד</span> <b class="num">${ils(w)}</b></span>`;
    if (!after) return head + '. הנה מה שתקבלו במקום.';
    return head + `<span class="ti-worth-price"><bdi>${t.short}</bdi> אצלכם <span class="ti-nw"><span class="ti-upto">החל מ־</span><b class="num">${ils(after)}</b></span> אחרי הטרייד אין</span><span class="ti-worth-cond">הסכום תלוי במצב המכשיר: מסך, גוף, סוללה ותקינות. הסכום הסופי נקבע בבדיקה בסניף.</span>`;
  };
  const pickList = () => TI.pick.filter(k => T[k]);

  /* ── מתג מפוצל: גלולה אחת, שני חצאים. קטן מכפתורים, וקורא כבחירה ולא כשתי פעולות */
  const segHTML = t => {
    const ks = pickList();
    if (ks.length < 2) return '';
    return `<div class="ti-seg" role="group" aria-label="בחרו את הדגם החדש">${ks.map(k => {
      const x = T[k], p = tmetaOf(k).price;
      return `<button type="button" class="ti-sb" data-tset="${k}" aria-pressed="${String(k === t.key)}"><b><bdi>${x.short}</bdi></b>${p ? `<span>${ils(p)}</span>` : ''}</button>`;
    }).join('')}</div>`;
  };

  /* ── שבבי הדגמים של סדרה אחת */
  const mineChips = sel => {
    const ser = serOf(sel) || SERIES()[0];
    return M.filter(m => m.ser === ser).map(m =>
      `<button type="button" class="ti-chip${m.name === sel ? ' on' : ''}" data-mset="${m.name}" aria-pressed="${String(m.name === sel)}"><bdi>${m.name.replace('iPhone ', '')}</bdi></button>`).join('');
  };
  const serChips = sel => {
    const ser = serOf(sel);
    return SERIES().map(s =>
      `<button type="button" class="ti-chip ti-chip--ser${s === ser ? ' on' : ''}" data-tser="${s}" aria-pressed="${String(s === ser)}"><bdi>${s}</bdi></button>`).join('');
  };

  const askA = t => `<div class="ti-ask" data-style="a">
      <p class="ti-q">מה יש לכם היום?</p>
      <div class="ti-row">
        <label class="ti-mine" for="ti-mine"><span class="l">האייפון שלי</span><span class="v">${myPhone() ? myPhone().name : ''}</span><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4.5l4 4 4-4"/></svg><select id="ti-mine" data-mine>${optsHTML(TI.model)}</select></label>
        ${pickList().length > 1 ? `<div class="ti-pick" role="group" aria-label="בחרו את הדגם החדש">${pickList().map(k => {
          const x = T[k], p = tmetaOf(k).price;
          return `<button type="button" class="ti-pb" data-tset="${k}" aria-pressed="${String(k === t.key)}"><b><bdi>${x.short}</bdi></b><span>${p ? `החל מ־${ils(p)}` : ''}</span></button>`;
        }).join('')}</div>` : ''}
      </div>
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;

  /* ב · שבבים. 🔴 שורת הסדרה אינה בוחרת דגם, היא רק פותחת את השורה שמתחתיה.
     בלעדיה הרשימה היא 40 שבבים, וזה קיר. */
  const askB = t => `<div class="ti-ask" data-style="b">
      <p class="ti-q">מה יש לכם היום?</p>
      <div class="ti-chips ti-chips--ser" role="group" aria-label="סדרה">${serChips(TI.model)}</div>
      <div class="ti-chips ti-chips--mine" role="group" aria-label="דגם" data-minerow>${mineChips(TI.model)}</div>
      ${pickList().length > 1 ? `<p class="ti-q2">ומה אתם שוקלים?</p>${segHTML(t)}` : ''}
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;

  /* ג · משפט. שני בוררים בתוך שורה אחת, כדי ששתי הבחירות יקראו כהחלטה אחת */
  const askC = t => {
    const o = myPhone();
    const two = pickList().length > 1;
    return `<div class="ti-ask" data-style="c">
      <p class="ti-say">יש לי
        <label class="ti-inline" for="ti-mine"><bdi>${o ? o.name : ''}</bdi><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4.5l4 4 4-4"/></svg><select id="ti-mine" data-mine>${optsHTML(TI.model)}</select></label>
        ${two ? `ומעניין אותי
        <label class="ti-inline" for="ti-tgt"><bdi>${t.short}</bdi><svg viewBox="0 0 12 12" aria-hidden="true"><path d="M2 4.5l4 4 4-4"/></svg><select id="ti-tgt" data-tsel>${pickList().map(k => `<option value="${k}"${k === t.key ? ' selected' : ''}>${T[k].short}</option>`).join('')}</select></label>` : ''}
      </p>
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;
  };

  /* ד · חיפוש, באותה שפה של מחשבון הטרייד אין שיובל כבר אישר */
  /* ── חיפוש הדגם: אותו מנוע של מחשבון הטרייד אין ─────────────────────────
     🔴 בקשת יובל 24.09.2026: «תשים שם את החיפוש שיש בטרייד אין, עם ההשלמה
     האוטומטית שמזהה עברית ואנגלית». ⟹ הועתק מ-`snippets/trade-in-calculator.liquid`
     ולא נכתב מחדש: אותה מפת עברית, אותו מרחק עריכה, ואותו ציון.

     🔴 ההבדל היחיד מהמקור: שם לכל דגם יש נפחים, ולכן הדירוג נעשה ברמת הדגם
     כדי ש-«1TB» לא יקדים את «128GB». כאן יש שורה אחת לדגם, ולכן שובר השוויון
     הוא סדר המחירון (`i`) וזהו. */

  /* שמות הדגמים באנגלית, והלקוח מקליד בעברית. ממירים את מה שהוא הקליד לפני
     ההשוואה. הצירופים הארוכים קודם, אחרת «פרו» היה בולע את «פרו מקס». */
  const TI_HE = [
    ['פרו מקס', 'pro max'], ['פרומקס', 'pro max'],
    ['אייפון', 'iphone'], ['איפון', 'iphone'], ['אייפן', 'iphone'],
    ['אייפןן', 'iphone'], ['אייפו', 'iphone'], ['אפון', 'iphone'],
    ['פרו', 'pro'], ['מאקס', 'max'], ['מקס', 'max'], ['פלוס', 'plus'], ['מיני', 'mini'],
    ['אייר', 'air'], ['אולטרה', 'ultra'], ['אלטרה', 'ultra'],
    ['ג׳יגה', 'gb'], ['גיגה', 'gb'], ['טרה', 'tb'],
  ];

  /* מרחק עריכה עם תקרה, לשגיאות כתיב קרובות. יוצא מוקדם ברגע שכל השורה חצתה
     את התקרה, ולכן זול להריץ אותו על כל הדגמים בכל הקלדה. */
  function tiLev(a, b, max) {
    const la = a.length, lb = b.length;
    if (Math.abs(la - lb) > max) return max + 1;
    let prev = [], cur = [], i, j;
    for (j = 0; j <= lb; j++) prev[j] = j;
    for (i = 1; i <= la; i++) {
      cur[0] = i;
      let best = i;
      for (j = 1; j <= lb; j++) {
        const cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + cost);
        if (cur[j] < best) best = cur[j];
      }
      if (best > max) return max + 1;
      for (j = 0; j <= lb; j++) prev[j] = cur[j];
    }
    return prev[lb];
  }

  /* ציון התאמה. מדויק גובר על תחילית, תחילית על הכלה, והכלה על שגיאת כתיב.
     הפרש האורך מפריד בין «15 Pro» ל-«15 Pro Max», אבל רק כשנאמר מספר, אחרת
     חיפוש «אייפון» לבדו היה דוחף את הדגמים הפשוטים למעלה. */
  function tiScore(q, hay) {
    if (!q) return 1;
    if (hay === q) return 2000;
    const near = /[0-9]/.test(q) ? (hay.length - q.length) : 0;
    if (hay.indexOf(q) === 0) return 1000 - near;
    if (hay.indexOf(q) > -1) return 800 - near;
    const qt = q.split(' '), ht = hay.split(' ');
    let total = 0;
    for (let i = 0; i < qt.length; i++) {
      const tok = qt[i];
      let best = 0;
      for (let j = 0; j < ht.length; j++) {
        const cand = ht[j];
        if (cand === tok) { best = Math.max(best, 10); continue; }
        if (cand.indexOf(tok) === 0) { best = Math.max(best, 8); continue; }
        if (cand.indexOf(tok) > -1) { best = Math.max(best, 6); continue; }
        const allow = tok.length >= 5 ? 2 : (tok.length >= 3 ? 1 : 0);
        if (allow) {
          const d = tiLev(tok, cand, allow);
          if (d <= allow) best = Math.max(best, 5 - d);
        }
      }
      if (!best) return 0;
      total += best;
    }
    const extra = /[0-9]/.test(q) ? (ht.length - qt.length) : 0;
    if (extra > 0) total = Math.max(0.5, total - extra * 0.5);
    return total;
  }

  /* שמות הדגמים מגיעים מ-M שלנו ולא מהלקוח, ולכן זו הגנה ולא צורך. */
  const tiEsc = v => String(v).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

  /* ty-ti-search >>> 30.09.2026, יובל: «שיעבוד גם בעברית גם באנגלית ויציע השלמות».
     נמדד על 36 שאילתות בחי. נפלו: מספר צמוד למילה («15פרו», «15pro»), קיצורים («14 pm»,
     «promax»), «16 אי», ותחילית עברית («אייפ», «פר») שלא החזירה כלום.
     ⟹ ① רווח בין ספרה לאות. ② קיצורים כמילה שלמה. ③ מילה עברית חלקית מושלמת למילה המלאה
       שהיא תחילית שלה. ④ מילה עברית שאינה במילון יורדת: שמות הדגמים אינם נושאים עברית.
     🔴 אותה נורמליזציה רצה גם על שמות הדגמים, ולכן «16e» בשם נשאר «16e» (ה-e מוצמד בחזרה). */
  const TI_TOK = { pm: 'pro max', promax: 'pro max', pmax: 'pro max' };
  const TI_HE_WORDS = [['אייפון', 'iphone'], ['איפון', 'iphone'], ['פרו', 'pro'], ['מקס', 'max'], ['מאקס', 'max'], ['פלוס', 'plus'], ['מיני', 'mini'], ['אייר', 'air'], ['אולטרה', 'ultra']];
  const tiNorm = raw => {
    let t = String(raw || '').trim().toLowerCase().replace(/[׳״'"]/g, '');
    for (let i = 0; i < TI_HE.length; i++) t = t.split(TI_HE[i][0]).join(TI_HE[i][1]);
    t = t.replace(/(\d)([^\d\s])/g, '$1 $2').replace(/([^\d\s])(\d)/g, '$1 $2');
    const toks = t.split(/\s+/).filter(Boolean), out = [];
    for (let i = 0; i < toks.length; i++) {
      const k = toks[i];
      if (TI_TOK[k]) { out.push(TI_TOK[k]); continue; }
      /* «16 אי» = 16e. רק אחרי מספר, אחרת «אי» הוא תחילת «אייפון» */
      if (k === 'אי' && /^\d+$/.test(toks[i - 1] || '')) { out.push('e'); continue; }
      if (/[\u0590-\u05ff]/.test(k)) {
        const w = k.length >= 2 && TI_HE_WORDS.find(x => x[0].indexOf(k) === 0);
        if (w) out.push(w[1]);
        continue;
      }
      out.push(k);
    }
    return out.join(' ').replace(/(\d) e(?= |$)/g, '$1e').replace(/\s+/g, ' ').trim();
  };
  /* <<< ty-ti-search */

  /* מנורמל פעם אחת בבנייה ולא בכל הקלדה. */
  let TI_INDEX = null;
  const tiIndex = () => (TI_INDEX || (TI_INDEX = M.map((m, i) => ({ name: m.name, hay: tiNorm(m.name), i }))));

  const tiSearch = raw => {
    /* ty-ti-search: שדה ריק מציע את הדגמים החדשים, כדי שהלקוח יראה מה אפשר לבחור לפני שהוא מקליד */
    if (!String(raw || '').trim()) return tiIndex().slice(0, 8);
    const t = tiNorm(raw);
    /* הוקלד משהו שאינו מתורגם לשום מילה: «לא נמצא», ולא סגירה שקטה */
    if (!t) return [];
    return tiIndex()
      .map(d => ({ d, s: tiScore(t, d.hay) }))
      .filter(x => x.s > 0)
      .sort((a, b) => (b.s - a.s) || (a.d.i - b.d.i))
      .slice(0, 14)
      .map(x => x.d);
  };

  /* מציירים את ההצעות. ⚠️ «לא נמצא» הוא כפתור מושבת ולא תיבה ריקה, בדיוק כמו
     בטרייד אין: תיבה שנסגרת בשקט נקראת כאילו החיפוש מת. */
  /* q: שאילתה במקום ערך השדה. בלחיצה על שדה שיש בו דגם שלם מוצגת הרשימה המלאה (q = '') */
  const tiRenderSugs = (box, input, q) => {
    const hits = tiSearch(q == null ? input.value : q);
    if (!hits) { box.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
    box.innerHTML = hits.length
      ? hits.map(d => `<button type="button" class="ti-sug" role="option" data-msug="${tiEsc(d.name)}"><bdi>${tiEsc(d.name)}</bdi></button>`).join('')
      : '<button type="button" class="ti-sug" disabled>לא נמצא דגם בשם הזה</button>';
    box.hidden = false;
    input.setAttribute('aria-expanded', 'true');
  };

  const askD = t => {
    const o = myPhone();
    return `<div class="ti-ask" data-style="d">
      <p class="ti-q">מה יש לכם היום?</p>
      <div class="ti-find">
        <svg class="ti-find-ic" viewBox="0 0 20 20" aria-hidden="true"><circle cx="9" cy="9" r="6"/><path d="M13.5 13.5L18 18"/></svg>
        <input type="search" class="ti-find-in" data-msearch autocomplete="off" spellcheck="false"
          placeholder="הקלידו דגם, למשל 15 Pro או «אייפון 15 פרו»" value="${o ? o.name : ''}"
          aria-label="הדגם שלכם" role="combobox" aria-expanded="false" aria-autocomplete="list" aria-controls="ti-sugs">
        <div class="ti-sugs" data-msugs id="ti-sugs" role="listbox" hidden></div>
      </div>
      ${pickList().length > 1 ? `<p class="ti-q2">ומה אתם שוקלים?</p>${segHTML(t)}` : ''}
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;
  };

  /* ── 28.09.2026, יובל: «צריך לשפר את המקום בו המשתמש בוחר לאיזה טלפון הוא רוצה להשוות».
     ארבע גרסאות חדשות. בכולן החיפוש של ד נשאר לטלפון של הלקוח (אושר 24.09), והשינוי
     הוא בבחירת הדגם החדש. כולן מדברות עם אותם שני שערים, setMine ו-setTarget. */
  const findHTML = o => `<div class="ti-find">
        <svg class="ti-find-ic" viewBox="0 0 20 20" aria-hidden="true"><circle cx="9" cy="9" r="6"/><path d="M13.5 13.5L18 18"/></svg>
        <input type="search" class="ti-find-in" data-msearch autocomplete="off" spellcheck="false"
          placeholder="הקלידו דגם, למשל 15 Pro" value="${o ? o.name : ''}"
          aria-label="הדגם שלכם" role="combobox" aria-expanded="false" aria-autocomplete="list" aria-controls="ti-sugs">
        <div class="ti-sugs" data-msugs id="ti-sugs" role="listbox" hidden></div>
      </div>`;
  const netOf = k => { const w = worthOf(myPhone()), p = tmetaOf(k).price; return p && w ? p - w : 0; };

  /* ה · מול: שתי תיבות זו מול זו, בדיוק כמו ההשוואה שמתחתיהן */
  const askE = t => {
    const two = pickList().length > 1;
    return `<div class="ti-ask" data-style="e">
      <div class="ti-vs">
        <div class="ti-vs-box"><span class="ti-vs-l">הטלפון שלכם</span>${findHTML(myPhone())}</div>
        <span class="ti-vs-x" aria-hidden="true">מול</span>
        <div class="ti-vs-box"><span class="ti-vs-l">הדגם החדש</span>
          <div class="ti-vs-opts" role="group" aria-label="בחרו את הדגם החדש">${pickList().map(k => {
            const p = tmetaOf(k).price;
            return `<button type="button" class="ti-vo" data-tset="${k}" aria-pressed="${String(k === t.key)}"><b><bdi>${T[k].short}</bdi></b>${p ? `<span>${ils(p)}</span>` : ''}</button>`;
          }).join('')}</div>
        </div>
      </div>
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;
  };

  /* ו · כרטיסי מחיר: כל דגם מראה כמה הוא עולה לכם אחרי הטרייד אין, והבחירה נעשית על המספר */
  const askF = t => `<div class="ti-ask" data-style="f">
      <p class="ti-q">מה יש לכם היום?</p>
      ${findHTML(myPhone())}
      ${pickList().length > 1 ? `<p class="ti-q2">ומול איזה דגם להשוות?</p>
      <div class="ti-cards" role="group" aria-label="בחרו את הדגם החדש">${pickList().map(k => {
        const p = tmetaOf(k).price, n = netOf(k);
        return `<button type="button" class="ti-card" data-tset="${k}" aria-pressed="${String(k === t.key)}">
          <b class="ti-card-n"><bdi>${T[k].short}</bdi></b>
          ${n ? `<span class="ti-card-k">החל מ־</span><span class="ti-card-v num">${ils(n)}</span>` : ''}
          ${p ? `<span class="ti-card-s">מחיר מלא ${ils(p)}</span>` : ''}
        </button>`;
      }).join('')}</div>` : ''}
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;

  /* ז · שני שלבים ממוספרים בתוך מסגרת אחת */
  const askG = t => `<div class="ti-ask" data-style="g">
      <div class="ti-steps">
        <div class="ti-st"><span class="ti-st-n">1</span><span class="ti-st-l">האייפון שלכם</span>${findHTML(myPhone())}</div>
        ${pickList().length > 1 ? `<div class="ti-st"><span class="ti-st-n">2</span><span class="ti-st-l">מול איזה דגם</span>${segHTML(t)}</div>` : ''}
      </div>
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;

  /* ח · שורה אחת: החיפוש והדגם צמודים, כמו משפט של שתי מילים */
  const askH = t => `<div class="ti-ask" data-style="h">
      <p class="ti-q">${TI.ask || 'השוו את האייפון שלכם'}</p>
      <div class="ti-bar">
        ${findHTML(myPhone())}
        ${pickList().length > 1 ? `<span class="ti-bar-x" aria-hidden="true">מול</span>${segHTML(t)}` : ''}
      </div>
      <p class="ti-worth${recCls()}" data-tiworth>${worthLine(t)}</p>
    </div>`;

  const ASKS = { a: askA, b: askB, c: askC, d: askD, e: askE, f: askF, g: askG, h: askH };
  const askHTML = t => (TI.on ? (ASKS[TI.style] || askA)(t) : '');

  /* הסגירה. אותו נוסח ואותו סייג של מחשבון הטרייד אין, כי זו אותה הבטחה ללקוח.
     🔴 בלי קו מוחק ובלי «במקום»: טרייד אין אינו הנחה על המכשיר החדש. */
  const closeHTML = t => {
    if (!TI.on) return '';
    const o = myPhone(), w = worthOf(o), price = tmetaOf(t.key).price;
    const after = price && w ? price - w : 0;
    const bp = (TI.buy && TI.buy.includes('{m}') ? TI.buy : 'לרכישת {m}').split('{m}');
    const buy = tmetaOf(t.key).href ? `<a class="cta" href="${tmetaOf(t.key).href}"><span>${bp[0]}<bdi>${t.short}</bdi>${bp[1] || ''}</span></a>` : '';
    const calc = TI.calcHref ? `<a class="cta ghost" href="${TI.calcHref}">${TI.calcLabel || 'למחשבון הטרייד אין'}</a>` : '';
    return `<div class="ti-close" data-ticlose>
      <div class="ti-sum${recCls()}">${recTag()}
        <p class="ti-lead">${o && w ? `ה-<bdi>${o.name}</bdi> שלכם שווה <span class="ti-nw"><span class="ti-upto">עד</span> <b class="num">${ils(w)}</b></span>` : `ל-<bdi>${o ? o.name : 'מכשיר שלכם'}</bdi> אין עדיין מחיר טרייד אין באתר`}</p>
        ${after ? `<p class="ti-after"><bdi>${t.short}</bdi> אצלכם <span class="ti-nw"><span class="ti-upto">החל מ־</span><b class="num">${ils(after)}</b></span> אחרי הטרייד אין</p>` : ''}
        ${o && w ? '<p class="ti-worth-cond">הסכום תלוי במצב המכשיר. הפירוט מתחת.</p>' : ''}
      </div>
      ${tiersHTML(o, t)}
      <p class="ti-sub">הערכה ראשונית. הסכום הסופי נקבע בסניף.</p>
      <div class="ti-btns">${buy}${calc}</div>
    </div>`;
  };

  /* ── פירוט לפי מצב המכשיר. 29.09.2026, יובל: «בסוף הסקשן תציג את החלוקה של המחירים לפי
     מצב המכשיר». ⟵ המחירון החי שהסקשן הזריק, שורה לכל מצב ובורר נפח.
     🔴 שמות המצבים והתיאורים הועתקו מ-CONDITIONS ב-snippets/trade-in-calculator.liquid, כולל
        חריג ה-95% ב-17 Pro וב-17 Pro Max. שינוי שם מצב שם מחייב שינוי גם כאן.
     🔴 כאן המספרים מדויקים לכל מצב, ולכן אין «עד». «עד» נשאר רק על הסכום הכולל למעלה. */
  const TI_CONDS = [
    ['תקין לחלוטין', 'בריאות סוללה מעל 90%, מצב קוסמטי מושלם'],
    ['מכשיר תקין', 'בריאות סוללה מעל 80%, מצב קוסמטי טוב'],
    ['מכשיר תקין מינוס', 'סוללה מתחת ל-80%, שריטות על המסך או המסגרת, או רכיב שהוחלף ברכיב מקורי'],
    ['מכשיר תקול', 'שבר או תקלת חומרה, למשל זיהוי פנים או מצלמה, או רכיב שהוחלף ברכיב לא מקורי'],
  ];
  const TI_BEST95 = ['iPhone 17 Pro', 'iPhone 17 Pro Max'];
  const tiersHTML = (o, t) => {
    const row = o && TI.prices && TI.prices[o.name];
    if (!row) return '';
    const caps = Object.keys(row);
    if (!caps.length) return '';
    const cap = caps.includes(TI.cap) ? TI.cap : caps[caps.length - 1];
    const vals = (Array.isArray(row[cap]) ? row[cap] : [row[cap]]).map(Number);
    const price = tmetaOf(t.key).price;
    return `<div class="ti-tiers">
      <div class="ti-tiers-hd">
        <p class="ti-tiers-t">כמה שווה ה-<bdi>${o.name}</bdi> שלכם, לפי המצב</p>
        ${caps.length > 1 ? `<div class="ti-seg ti-caps" role="group" aria-label="נפח האחסון שלכם">${caps.map(c =>
          `<button type="button" class="ti-sb" data-ticap="${c}" aria-pressed="${String(c === cap)}"><b><bdi>${c}</bdi></b></button>`).join('')}</div>` : ''}
      </div>
      <ul class="ti-tlist">${TI_CONDS.map(([n, d], i) => {
        const v = vals[i];
        if (!Number.isFinite(v)) return '';
        const desc = i === 0 && TI_BEST95.includes(o.name) ? d.replace('90%', '95%') : d;
        return `<li class="ti-tier${i === 0 ? ' ti-tier--best' : ''}">
          <div class="ti-tier-txt"><b>${n}</b><span>${desc}</span></div>
          <div class="ti-tier-v"><b class="num">${ils(v)}</b>${price && v ? `<span><bdi>${t.short}</bdi> אצלכם ב־<bdi>${ils(price - v)}</bdi></span>` : ''}</div>
        </li>`;
      }).join('')}</ul>
    </div>`;
  };

  /* 🔴 החלפת דגם מעדכנת טקסט במקום, ואינה בונה מחדש. בנייה מחדש הייתה מאפסת את
     ההנפשה שרצה, והצופה היה רואה את הפרק קופץ להתחלה על כל בחירה. */
  const refreshTI = (host, t) => {
    if (!TI.on) return;
    const o = myPhone(), w = worthOf(o);
    const q = s => host.querySelector(s);
    const v = q('.ti-mine .v'); if (v && o) v.textContent = o.name;
    /* כל ארבע הגרסאות של הבורר מתעדכנות כאן, ולא רק הרשימה הנפתחת */
    const inl = q('.ti-inline bdi'); if (inl && o) inl.textContent = o.name;
    const fi = q('[data-msearch]'); if (fi && o) fi.value = o.name;
    host.querySelectorAll('[data-mset]').forEach(x => {
      const on = !!o && x.dataset.mset === o.name;
      x.classList.toggle('on', on); x.setAttribute('aria-pressed', String(on));
    });
    const sug = q('[data-msugs]'); if (sug) { sug.hidden = true; sug.innerHTML = ''; }
    const wo = q('[data-tiworth]');
    if (wo) wo.innerHTML = worthLine(t);
    host.querySelectorAll('[data-ticmp]').forEach(el => {
      const inner = cmpInner(el.dataset.ticmp, t);
      el.innerHTML = inner; el.hidden = !inner;
    });
    const cl = q('[data-ticlose]');
    if (cl) cl.outerHTML = closeHTML(t);
  };

  /* ───────── א · יכולת אחת ───────── */
  const aCap = {};
  const aCapOf = t => (capsOf(t).includes(aCap[t.key]) ? aCap[t.key] : (t.duo ? 'scr' : 'zoom'));
  function layoutA(host, t, s) {
    const caps = capsOf(t), k0 = aCapOf(t);
    host.innerHTML = `
      ${IN_LAB ? `<div class="labctl" role="group" aria-label="בחירת היכולת, במעבדה בלבד">
        <span>במעבדה בלבד · היכולת בסקשן:</span>
        <div class="seg">${caps.map(k => `<button type="button" data-acap="${k}" aria-pressed="${k === k0}">${CAP[k].label}</button>`).join('')}</div>
      </div>` : ''}
      <div class="band band-a">
        <div class="a-grid">
          <div class="a-head">${kick(t)}${statHTML(k0, t, 'h3')}</div>
          <div class="sfloor a-floor"></div>
          <div class="a-body"><p class="ro-x">${CAP[k0].line(t)}</p>${ctas(t)}</div>
        </div>
        ${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const floor = host.querySelector('.a-floor');
    const p = mountPhone(s, floor, t, f => {
      const [w, h] = dims(t), narrow = narrowOf(host);
      return Math.min((f.clientWidth * 0.66) / w, (narrow ? 340 : 490) / h, 3.3);
    });
    const ctl = pauser(s, host.querySelector('.pz'), () => { p.playing = false; }, () => { if (p.t >= p.dur) p.play(k0); else { p.playing = true; p.last = 0; } });
    p.onEnd = () => p.after(() => { if (!ctl.paused) p.play(k0); }, 1600);
    p.rest(k0);
    watch(s, p, floor, () => p.play(k0));
  }

  /* ───────── ב · שבבים ───────── */
  function layoutB(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-b">
        <div class="b-grid">
          <div class="b-head">${kick(t)}<h3>${headOf()}</h3></div>
          <div class="sfloor b-floor"></div>
          <div class="b-body">
            <div class="ro" aria-live="polite"></div>
            <div class="segs" role="tablist" aria-label="היכולות" style="--n:${caps.length}">${caps.map(k => `<button type="button" role="tab" class="segb" data-k="${k}" aria-selected="false" tabindex="-1"><span class="trk"><i></i></span><span class="lb">${CAP[k].label}</span></button>`).join('')}</div>
            ${ctas(t)}
          </div>
        </div>
        ${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const floor = host.querySelector('.b-floor'), ro = host.querySelector('.ro'), segs = [...host.querySelectorAll('.segb')];
    const p = mountPhone(s, floor, t, f => {
      const [w, h] = dims(t), narrow = narrowOf(host);
      return Math.min((f.clientWidth * 0.62) / w, (narrow ? 310 : 450) / h, 3);
    });
    let i = 0;
    const show = k => {
      ro.innerHTML = roHTML(k, t); ro.classList.remove('swap'); void ro.offsetWidth; ro.classList.add('swap');
      segs.forEach(b => { const on = b.dataset.k === k; b.setAttribute('aria-selected', String(on)); b.tabIndex = on ? 0 : -1; });
    };
    const go = idx => { i = (idx + caps.length) % caps.length; show(caps[i]); p.play(caps[i]); };
    const ctl = pauser(s, host.querySelector('.pz'), () => { p.playing = false; }, () => { if (p.t >= p.dur) go(i + 1); else { p.playing = true; p.last = 0; } });
    p.onDraw = () => segs.forEach((b, j) => b.style.setProperty('--p', (!p.live ? 0 : j < i ? 1 : j === i ? p.t / p.dur : 0).toFixed(3)));
    p.onEnd = () => p.after(() => { if (!ctl.paused) go(i + 1); }, 900);
    s.on(host, 'click', e => { const b = e.target.closest('.segb'); if (!b) return; ctl.paused && ctl.set(false); go(caps.indexOf(b.dataset.k)); });
    s.on(host, 'keydown', e => {
      const b = e.target.closest('.segb'); if (!b) return;
      const d = e.key === 'ArrowLeft' ? 1 : e.key === 'ArrowRight' ? -1 : 0; if (!d) return;
      e.preventDefault(); const j = (caps.indexOf(b.dataset.k) + d + caps.length) % caps.length; segs[j].focus(); go(j);
    });
    /* גובה הטקסט נמדד מהיכולת הארוכה ביותר, כדי שהשבבים לא יקפצו בכל החלפה ולא יישאר רווח מת */
    let roW = 0;
    const fitRo = () => {
      const w = ro.clientWidth; if (!w || w === roW) return; roW = w;
      const probe = document.createElement('div');
      probe.className = 'ro'; probe.setAttribute('aria-hidden', 'true');
      probe.style.cssText = 'position:absolute;visibility:hidden;inset-inline:0;top:0';
      ro.parentNode.append(probe);
      let max = 0;
      caps.forEach(k => { probe.innerHTML = roHTML(k, t); max = Math.max(max, probe.getBoundingClientRect().height); });
      probe.remove();
      ro.style.minHeight = Math.ceil(max) + 'px';
    };
    fitRo(); s.observe(new ResizeObserver(fitRo), ro);
    show(caps[0]); p.rest(caps[0]);
    watch(s, p, floor, () => go(0));
  }

  /* ───────── ג · גלילה ───────── */
  function layoutC(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-c">
        <div class="c-head">${kick(t)}<h3>${headOf()}</h3></div>
        <div class="c-wrap">
          <div class="c-stage"><canvas class="c-back" aria-hidden="true"></canvas><div class="sfloor c-floor"></div><div class="c-prog" aria-hidden="true"><i></i></div></div>
          <div class="c-panels">${caps.map((k, j) => `<article class="c-panel" data-k="${k}"><span class="c-idx num">${j + 1} מתוך ${caps.length}</span><div class="ro">${roHTML(k, t)}</div></article>`).join('')}</div>
        </div>
        ${ctas(t)}
        ${FN}
      </div>`;
    const floor = host.querySelector('.c-floor'), stg = host.querySelector('.c-stage'), prog = host.querySelector('.c-prog');
    const panels = [...host.querySelectorAll('.c-panel')];
    const p = mountPhone(s, floor, t, f => { const [w, h] = dims(t); return Math.min((f.clientWidth * 0.66) / w, (f.clientHeight * 0.86) / h, 3); });
    p.visible = true;
    preload(s, host, t);
    /* ציור על הבמה, מאחורי הטלפון, לסצנה שיש לה stage */
    const back = host.querySelector('.c-back');
    let backOn = false;
    p.onDraw = () => {
      const sc = sceneOf(p.key);
      if (!sc || !sc.stage) {
        if (backOn) { const { c, W, H } = L.fitCanvas(back); c.clearRect(0, 0, W, H); backOn = false; }
        return;
      }
      if (sc.shiftAt) { const v = sc.shiftAt(p.t); floor.style.transform = v ? `translateX(${v * 100}%)` : ''; }
      const { c, W, H } = L.fitCanvas(back);
      c.clearRect(0, 0, W, H);
      const br = back.getBoundingClientRect(), cr = p.figs.new._canvas.getBoundingClientRect();
      sc.stage(c, W, H, p.t, p.I, { x: cr.left - br.left, y: cr.top - br.top, w: cr.width, h: cr.height });
      backOn = true;
    };
    /* כשהטלפון זז (shift), הקווים על הבמה חייבים להתעדכן לאורך המעבר ולא רק בגלילה הבאה */
    const follow = ms => { const end = performance.now() + ms; const tick = () => { p.dirty = true; L.loop(); if (performance.now() < end) s.later(tick, 16); }; tick(); };
    let cur = null;
    /* בטלפון הבמה דביקה בראש ומכסה, ולכן האמצע נמדד בחלק שנשאר גלוי מתחתיה */
    const onScroll = () => {
      const sr = stg.getBoundingClientRect(), pr = panels[0].getBoundingClientRect();
      const narrow = pr.left < sr.right && pr.right > sr.left;
      const sb = Math.max(0, sr.bottom);
      const mid = narrow ? Math.min(innerHeight * 0.9, sb + (innerHeight - sb) * 0.4) : innerHeight * 0.55;
      let idx = -1, pp = 0;
      panels.forEach((el, j) => { const r = el.getBoundingClientRect(); if (idx < 0 && r.top <= mid && r.bottom > mid) { idx = j; pp = u.clamp((mid - r.top) / r.height); } });
      if (idx < 0) { const r0 = panels[0].getBoundingClientRect(); idx = r0.top > mid ? 0 : panels.length - 1; pp = r0.top > mid ? 0 : 1; }
      const k = panels[idx].dataset.k;
      if (k !== cur) {
        cur = k; panels.forEach((el, j) => el.classList.toggle('on', j === idx));
        if (k !== 'scr') p.openDuo();
        p.key = k; p.dur = durOf(k);
        const sc = sceneOf(k), sh = sc.shift || 0;
        stg.classList.toggle('no-glow', sc.glow === false);
        if (!sc.shiftAt && floor.style.transform !== (sh ? `translateX(${sh * 100}%)` : '')) { floor.style.transform = sh ? `translateX(${sh * 100}%)` : ''; follow(700); }
      }
      p.playing = false; p.t = Math.min(p.dur, pp * p.dur * 1.15);
      { const sc = sceneOf(k); if (sc.onScrub) sc.onScrub(p, p.I, p.k); }
      prog.style.setProperty('--p', ((idx + pp) / panels.length).toFixed(3));
      p.dirty = true; L.loop();
    };
    let raf = 0;
    s.on(window, 'scroll', () => { if (!raf) raf = requestAnimationFrame(() => { raf = 0; onScroll(); }); }, { passive: true });
    s.on(window, 'resize', onScroll);
    onScroll();
  }

  /* ───────── ד · כרטיסים ברצועה ───────── */
  /* כל דגם ביכולת הבולטת שלו. סדר הדגמים כמו בשלישייה החיה: Pro Max מימין, Pro, ו-Duo משמאל.
     ל-Pro הזום ולא הצמצם: הצמצם הוא ארבעה צילומים שונים שמתחלפים, ובכרטיס קטן רבע מהזמן נראית חשיפה כפולה */
  const D_CARDS = [['max', 'bat'], ['pro', 'zoom'], ['duo', 'scr']];
  function layoutD(host, _t, s) {
    host.innerHTML = `
      <div class="band band-d">
        <div class="d-hd"><h3>iPhone 18</h3></div>
        <div class="d-rail" role="list">${D_CARDS.map(([tk, k]) => { const t = T[tk], st = CAP[k].stat(t); return `
          <article class="d-card" role="listitem" style="--acc:${t.acc};--acc-rgb:${t.accRgb}">
            <div class="d-media"><div class="sfloor d-floor" data-model="${tk}" data-cap="${k}"></div></div>
            <div class="d-body">
              <h4><bdi>${t.name}</bdi></h4>
              <p class="d-cap"><b>${st.n}</b> ${st.u}</p>
              <p class="d-line">${CAP[k].line(t)}</p>
              <a class="cta ghost d-btn" href="${L.showLinks ? L.showLinks[tk] : '#'}"${L.showLinks ? '' : ' data-noop'}>לדף הדגם</a>
            </div>
          </article>`; }).join('')}</div>
        ${FN}
        <button type="button" class="pz"></button>
      </div>`;
    /* k אחד לשלושת הכרטיסים, כדי שהגדלים ביניהם יישארו אמיתיים */
    const fitShared = f => Math.min(...D_CARDS.map(([tk]) => { const [w, h] = dims(T[tk]); return Math.min((f.clientWidth * 0.66) / w, (f.clientHeight * 0.84) / h); }), 2.2);
    const ps = [...host.querySelectorAll('.d-floor')].map((f, j) => {
      const t = T[f.dataset.model], k = f.dataset.cap, p = mountPhone(s, f, t, fitShared);
      p.cap = k; p.rest(k);
      watch(s, p, f, () => p.after(() => p.play(k), j * 450));
      return p;
    });
    const ctl = pauser(s, host.querySelector('.pz'), () => ps.forEach(p => { p.playing = false; }), () => ps.forEach(p => { if (!p.key || p.t >= p.dur) p.play(p.cap); else { p.playing = true; p.last = 0; } }));
    ps.forEach(p => { p.onEnd = () => p.after(() => { if (!ctl.paused) p.play(p.cap); }, 1800); });
  }

  /* ───────── ה · בנטו: במה אחת, ולוויינים שמקדמים אליה ─────────
     התבנית Hero + Satellites. רק הבמה מחזיקה קנבס, והלוויינים טיפוגרפיה בלבד.
     ⟹ שבע היכולות נראות בבת אחת, והעלות נשארת קנבס אחד. */
  function layoutE(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-e">
        <div class="e-hd">${kick(t)}<h3>${headOf()}</h3></div>
        <div class="e-grid">
          <article class="e-hero">
            <div class="sfloor e-floor"></div>
            <div class="e-txt"><div class="ro" aria-live="polite"></div></div>
          </article>
          ${caps.map(k => { const st = CAP[k].stat(t); return `
            <button type="button" class="e-tile" data-k="${k}" aria-pressed="false">
              <span class="e-l">${CAP[k].label}</span>
              <span class="e-n num">${st.n}</span>
              <span class="e-u">${st.u}</span>
            </button>`; }).join('')}
          ${L.showLinks ? `<a class="e-tile e-go" href="${L.showLinks[t.key]}"><span class="e-l">iPhone 18</span><span class="e-go-t">לדף הדגם</span></a>`
            : '<span class="e-tile e-go"><span class="e-l">iPhone 18</span><span class="e-go-t">לדף הדגם</span></span>'}
        </div>
        ${FN}
        <button type="button" class="pz"></button>
      </div>`;
    preload(s, host, t);
    const floor = host.querySelector('.e-floor'), ro = host.querySelector('.ro');
    const tiles = [...host.querySelectorAll('.e-tile[data-k]')];
    /* 🔴 המידה נגזרת מהגובה שבאמת יש בתא, ולא ממספר קבוע.
       בבנטו הבמה היא תא ברשת, ומספר קבוע מוציא את הטלפון מחוץ לכרטיס. */
    const p = mountPhone(s, floor, t, f => {
      const [w, h] = dims(t);
      return Math.min((f.clientWidth * 0.86) / w, Math.max(f.clientHeight - 16, 120) / h, 3);
    });
    let i = 0;
    const show = k => {
      ro.innerHTML = roHTML(k, t); ro.classList.remove('swap'); void ro.offsetWidth; ro.classList.add('swap');
      tiles.forEach(b => b.setAttribute('aria-pressed', String(b.dataset.k === k)));
    };
    const go = idx => { i = (idx + caps.length) % caps.length; show(caps[i]); p.play(caps[i]); };
    const ctl = pauser(s, host.querySelector('.pz'), () => { p.playing = false; }, () => { if (p.t >= p.dur) go(i + 1); else { p.playing = true; p.last = 0; } });
    /* 🔴 הסוללה היא 25 שניות, פי 2.5 מהממוצע. בלי תקרה היא תופסת שליש מהסבב */
    p.onEnd = () => p.after(() => { if (!ctl.paused) go(i + 1); }, 900);
    s.on(host, 'click', e => { const b = e.target.closest('.e-tile[data-k]'); if (!b) return; ctl.paused && ctl.set(false); go(caps.indexOf(b.dataset.k)); });
    show(caps[0]); p.rest(caps[0]);
    watch(s, p, floor, () => go(0));
  }

  /* ───────── ו · קיר המספרים: שקט במנוחה, נפתח בלחיצה ─────────
     🔴 אפס קנבס ואפס צילומים עד שלוחצים. הטלפון נטען בפתיחה הראשונה בלבד. */
  function layoutF(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-f">
        <div class="f-hd">${kick(t)}<h3>${headOf()}</h3>
          <p class="f-sub">לחיצה על מספר פותחת את ההדגמה.</p></div>
        <div class="f-wall">
          ${caps.map(k => { const st = CAP[k].stat(t); return `
            <button type="button" class="f-cell" data-k="${k}" aria-expanded="false">
              <span class="f-n num">${st.n}</span>
              <span class="f-l">${CAP[k].label}</span>
            </button>`; }).join('')}
          ${L.showLinks ? `<a class="f-cell f-go" href="${L.showLinks[t.key]}"><span class="f-go-t">לדף הדגם</span><span class="f-l"><bdi>${t.name}</bdi></span></a>`
            : '<span class="f-cell f-go"><span class="f-go-t">לדף הדגם</span><span class="f-l">iPhone 18</span></span>'}
        </div>
        <div class="f-drawer" hidden>
          <div class="sfloor f-floor"></div>
          <div class="f-txt"><div class="ro" aria-live="polite"></div>${ctas(t)}</div>
          <button type="button" class="f-x" aria-label="סגירת ההדגמה">✕</button>
        </div>
        ${FN}
      </div>`;
    const wrap = host.querySelector('.f-drawer'), floor = host.querySelector('.f-floor'), ro = host.querySelector('.ro');
    const cells = [...host.querySelectorAll('.f-cell')];
    let p = null, open = null;
    const ensure = () => {
      if (p) return p;
      p = mountPhone(s, floor, t, f => {
        const [w, h] = dims(t);
        return Math.min((f.clientWidth * 0.8) / w, (narrowOf(host) ? 300 : 400) / h, 3);
      });
      p.onEnd = () => p.after(() => { if (open) p.play(open); }, 900);
      return p;
    };
    const close = () => {
      open = null; wrap.hidden = true;
      cells.forEach(c => c.setAttribute('aria-expanded', 'false'));
      if (p) p.playing = false;
    };
    const openCap = k => {
      open = k; wrap.hidden = false;
      cells.forEach(c => c.setAttribute('aria-expanded', String(c.dataset.k === k)));
      ro.innerHTML = roHTML(k, t); ro.classList.remove('swap'); void ro.offsetWidth; ro.classList.add('swap');
      ensure().play(k);
    };
    s.on(host, 'click', e => {
      if (e.target.closest('.f-x')) return close();
      const b = e.target.closest('.f-cell'); if (!b) return;
      b.dataset.k === open ? close() : openCap(b.dataset.k);
    });
    s.on(host, 'keydown', e => { if (e.key === 'Escape' && open) close(); });
  }

  /* ───────── ז · רצועת הצצה ─────────
     המידות נמדדו על apple.com/iphone-18-pro: 48% מהחלון במחשב, 67% בטלפון, רווח 20.
     רק הכרטיס שבמרכז מתנגן. הטלפון נטען בכרטיס רק כשהוא נראה בפעם הראשונה. */
  function layoutG(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-g">
        <div class="g-hd">
          <div>${kick(t)}<h3>${headOf()}</h3></div>
          <div class="g-nav">
            <button type="button" class="g-arw" data-d="-1" aria-label="היכולת הקודמת">→</button>
            <button type="button" class="g-arw" data-d="1" aria-label="היכולת הבאה">←</button>
          </div>
        </div>
        <div class="g-rail" role="list">
          ${caps.map((k, j) => { const st = CAP[k].stat(t); return `
            <article class="g-card" role="listitem" data-k="${k}" data-j="${j}">
              <div class="g-media"><div class="sfloor g-floor"></div></div>
              <div class="g-body">
                <span class="ro-l">${CAP[k].label}</span>
                <p class="g-stat"><b class="num">${st.n}</b> <span>${st.u}</span></p>
                <p class="g-line">${CAP[k].line(t)}</p>
              </div>
            </article>`; }).join('')}
        </div>
        ${ctas(t)}
        ${FN}
      </div>`;
    preload(s, host, t);
    const rail = host.querySelector('.g-rail');
    const cards = [...host.querySelectorAll('.g-card')];
    const players = new Map();
    const mount = card => {
      if (players.has(card)) return players.get(card);
      const p = mountPhone(s, card.querySelector('.g-floor'), t, f => {
        const [w, h] = dims(t);
        return Math.min((f.clientWidth * 0.78) / w, 330 / h, 2.6);
      });
      p.cap = card.dataset.k;
      p.onEnd = () => p.after(() => { if (card.dataset.on === '1') p.play(p.cap); }, 900);
      p.rest(p.cap);
      players.set(card, p);
      return p;
    };
    /* הכרטיס שבמרכז מתנגן, והשאר עומדים על פריים מנוחה */
    const io = new IntersectionObserver(es => {
      es.forEach(e => {
        const card = e.target, on = e.intersectionRatio > 0.72;
        card.dataset.on = on ? '1' : '0';
        card.classList.toggle('on', on);
        /* 🔴 טלפון מורכב רק לכרטיס שנראה. בלי זה כל שבעת הכרטיסים מרכיבים קנבס בטעינה,
           כי IntersectionObserver יורה פעם ראשונה גם על מה שמחוץ למסך. */
        if (!e.isIntersecting && !players.has(card)) return;
        const p = mount(card);
        if (on) p.play(p.cap); else { p.playing = false; p.rest(p.cap); }
      });
      L.loop();
    }, { root: rail, threshold: [0, 0.72] });
    s.obs.push(io);
    cards.forEach(c => io.observe(c));
    /* 🔴 ב-RTL «הבא» הוא שמאלה, ו-scrollBy עובד בפיקסלים פיזיים */
    const rtl = getComputedStyle(rail).direction === 'rtl';
    s.on(host, 'click', e => {
      const b = e.target.closest('.g-arw'); if (!b) return;
      const step = cards[0].getBoundingClientRect().width + 20;
      rail.scrollBy({ left: (rtl ? -1 : 1) * step * Number(b.dataset.d), behavior: 'smooth' });
    });
  }

  /* ───────── ח · רצף ─────────
     בקשת יובל 20.09.2026: «תציג לי את זה ברצף אחד אחרי השני, כאשר לצד ההנפשה
     יהיה כתוב טקסט שמסביר את מה שמציגים», ו«הגלילה כאילו מזרזת את ההנפשה».
     ⟹ כל יכולת היא שורה משלה: הבמה בצד אחד, ההסבר בצד השני.
     ⟹ ההנפשה רצה לבד, **וגלילה מוסיפה לה זמן על גבי זה**. היא אינה תלויה בגלילה. */
  const SEC_PER_PX = 0.0045;   /* מצב «דחיפה»: גלילה של 600 פיקסל מוסיפה כ-2.7 שניות */
  /* 🔴 שני מצבים, הכרעת יובל 21.09.2026:
     drive    · הגלילה גוררת את ההנפשה לפי מרחק. גלילה על כל הפרק = מחזור אחד בדיוק.
     autonext · כשפרק נגמר, הדף גולל לבא אחריו. כמו רילז.
     שניהם הגדרה בעורך, וברירת המחדל כבויה. */
  let DRIVE = false, AUTONEXT = false, KICKER = '', SHOWCTA = true;

  /* ───────── מנוע הרצף, משותף לכל גרסאות הרצף ─────────
     כל פרק מקבל טלפון, קנבס במה, חזרה מהתחלה בסוף, ופס התקדמות אם קיים.
     הגרסאות נבדלות במרקאפ ובמיפוי הגלילה בלבד, ולא במנוע. */
  function chapterPlayer(s, row, t, fit, isOn, onDone) {
    const floor = row.querySelector('.sq-floor'), back = row.querySelector('.sq-back');
    const stg = row.querySelector('.sq-stage') || floor.parentElement;
    const bar = row.querySelector('.sq-prog i');
    const p = mountPhone(s, floor, t, fit);
    p.cap = row.dataset.k;
    const drawStage = wireStage(p, floor, back, stg);
    p.onDraw = () => { drawStage(); if (bar) bar.style.width = `${Math.min(100, (p.t / p.dur) * 100).toFixed(1)}%`; };
    p.onEnd = () => p.after(() => {
      if (!isOn(row)) return;
      /* 🔴 מעבר לפרק הבא קודם. אם אין, חוזרים מהתחלה */
      if (onDone && onDone(row)) return;
      p.play(p.cap); p.applyShift();
    }, 700);
    p.key = p.cap; p.applyShift(); p.rest(p.cap);
    return p;
  }
  /* 🔴 הגלילה **מוסיפה** זמן ואינה קובעת אותו. בלי גלילה ההנפשה ממשיכה לרוץ */
  function scrollBoost(s, each) {
    let lastY = window.scrollY, raf = 0;
    const run = () => {
      raf = 0;
      const dy = window.scrollY - lastY; lastY = window.scrollY;
      if (!dy || L.reduce) return;
      each(Math.abs(dy) * SEC_PER_PX, dy);
      L.loop();
    };
    s.on(window, 'scroll', () => { if (!raf) raf = requestAnimationFrame(run); }, { passive: true });
  }
  /* כמה זמן להזיז על גלילה של dy פיקסל. במצב drive הפרק כולו שווה למחזור אחד.
     🔴 קדימה בלבד, הכרעת יובל 21.09.2026: «גלילה למעלה עולה ישירות ולא מריצה הכל לאחור».
     גלילה אחורה מוסיפה אפס, ולכן הדף עולה מיד וההנפשה ממשיכה בקצב שלה. */
  const stepTime = (dy, add, p, h) => (DRIVE ? Math.max(0, dy) * (p.dur / Math.max(320, h)) : add);

  /* 🔴 מעבר אוטומטי לפרק הבא, כמו רילז.
     המשתמש תמיד מנצח: גלילה ידנית בשנייה האחרונה מבטלת את המעבר הבא. */
  function autoNext(s, rows, ctl) {
    let lastUser = 0, ours = false, t = 0, armed = false;
    /* ty-autonext-arm >>> 30.09.2026, יובל: «אם אני לא מספיק להקליד את הטלפון שלי בתיבה אני כבר יורד למטה».
       הפרק הראשון נראה כבר מתחת לשאלה, ולכן הוא נגמר ומקפיץ בזמן שהלקוח מקליד, בלי שגלל.
       ⟹ המעבר נדלק רק אחרי גלילה של הלקוח שהביאה את הפרק הראשון לרבע העליון של המסך,
          ולעולם לא כשהפוקוס בשדה טקסט. */
    s.on(window, 'scroll', () => {
      if (ours) return;
      lastUser = performance.now();
      if (!armed && rows[0] && rows[0].getBoundingClientRect().top < innerHeight * 0.25) armed = true;
    }, { passive: true });
    return idx => {
      if (!AUTONEXT || ctl.paused || L.reduce) return false;
      if (!armed) return false;
      const ae = document.activeElement;
      if (ae && (ae.tagName === 'INPUT' || ae.tagName === 'TEXTAREA' || ae.isContentEditable)) return false;
      /* <<< ty-autonext-arm */
      const from = rows[idx], next = rows[idx + 1];
      if (!from || !next) return false;
      /* רק כשהפרק הנוכחי באמת על המסך */
      const r = from.getBoundingClientRect();
      if (r.bottom < 40 || r.top > innerHeight - 40) return false;
      /* המשתמש נגע לאחרונה? אז לא נוגעים בגלילה שלו */
      if (performance.now() - lastUser < 1200) return false;
      ours = true;
      next.scrollIntoView({ behavior: 'smooth', block: 'center' });
      clearTimeout(t); t = s.later(() => { ours = false; }, 1100);
      return true;
    };
  }
  /* מרכיב פרק רק כשהוא נראה, ומפעיל אותו. מחזיר את המפה של הנגנים */
  function chapterWatch(s, rows, t, fit, ctl, { ratio = 0.42, onChange } = {}) {
    const P = new Map();
    const isOn = row => row.dataset.on === '1';
    const nextOf = autoNext(s, rows, ctl);
    const onDone = row => nextOf(rows.indexOf(row));
    const io = new IntersectionObserver(es => {
      es.forEach(e => {
        const row = e.target, on = e.intersectionRatio > ratio;
        if (!e.isIntersecting && !P.has(row)) return;
        if (!P.has(row)) P.set(row, chapterPlayer(s, row, t, fit, isOn, onDone));
        const p = P.get(row);
        row.dataset.on = on ? '1' : '0';
        row.classList.toggle('on', on);
        p.visible = on;
        if (on && !ctl.paused) { p.play(p.cap); p.applyShift(); } else { p.playing = false; }
        if (on && onChange) onChange(row, p);
      });
      L.loop();
    }, { threshold: [0, ratio] });
    s.obs.push(io);
    rows.forEach(r => io.observe(r));
    scrollBoost(s, (add, dy) => P.forEach((p, row) => {
      if (!isOn(row) || !p.live || ctl.paused) return;
      const h = row.getBoundingClientRect().height || 700;
      p.t = Math.max(0, Math.min(p.dur, p.t + stepTime(dy, add, p, h)));
      p.dirty = true;
    }));
    return P;
  }
  /* כפתור עצירה אחד לכל הפרקים */
  function seqPauser(s, btn, P) {
    return pauser(s, btn,
      () => P.forEach(p => { p.playing = false; }),
      () => { P.forEach((p, row) => { if (row.dataset.on === '1') { if (p.t >= p.dur) p.play(p.cap); else { p.playing = true; p.last = 0; } } }); L.loop(); });
  }
  /* המרקאפ המשותף של פרק: במה עם קנבס, טלפון, ופס התקדמות */
  const sqStage = () => '<div class="sq-stage"><canvas class="sq-back" aria-hidden="true"></canvas><div class="sfloor sq-floor"></div></div>';
  const sqText = (k, t, j, n, extra = '') => `
    <div class="sq-txt">
      <span class="sq-idx num">${j + 1} מתוך ${n}</span>
      <div class="ro">${roHTML(k, t)}</div>
      ${extra}
      <div class="sq-prog" aria-hidden="true"><i></i></div>
    </div>`;
  function layoutH(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-h">
        <div class="h-hd">${kick(t)}<h3>${headOf()}</h3></div>
        ${caps.map((k, j) => `
          <section class="h-row" data-k="${k}" data-on="0">
            <div class="h-stage">
              <canvas class="h-back" aria-hidden="true"></canvas>
              <div class="sfloor h-floor"></div>
            </div>
            <div class="h-txt">
              <span class="h-idx num">${j + 1} מתוך ${caps.length}</span>
              <div class="ro">${roHTML(k, t)}</div>
              <div class="h-prog" aria-hidden="true"><i></i></div>
            </div>
          </section>`).join('')}
        ${ctas(t)}
        ${FN}
        <button type="button" class="pz"></button>
      </div>`;
    /* 🔴 בלי זה הבמה של הזום ריקה עד ש-664KB מגיעים, ואין שום שגיאה.
       preload מושך את כל הצילומים של היכולות כשהסקשן מתקרב למסך. */
    preload(s, host, t);
    const rows = [...host.querySelectorAll('.h-row')];
    const P = new Map();
    const ctl = pauser(s, host.querySelector('.pz'),
      () => P.forEach(p => { p.playing = false; }),
      () => { P.forEach((p, row) => { if (row.dataset.on === '1') { if (p.t >= p.dur) p.play(p.cap); else { p.playing = true; p.last = 0; } } }); L.loop(); });

    const mount = row => {
      if (P.has(row)) return P.get(row);
      const floor = row.querySelector('.h-floor'), back = row.querySelector('.h-back'), stg = row.querySelector('.h-stage');
      const bar = row.querySelector('.h-prog i');
      const p = mountPhone(s, floor, t, f => {
        const [w, h] = dims(t);
        return Math.min((f.clientWidth * 0.46) / w, (f.clientHeight * 0.92) / h, 3);
      });
      p.cap = row.dataset.k;
      const drawStage = wireStage(p, floor, back, stg);
      p.onDraw = () => { drawStage(); if (bar) bar.style.width = `${Math.min(100, (p.t / p.dur) * 100).toFixed(1)}%`; };
      /* חוזרת מהתחלה, כדי שההנפשה תמיד תהיה חיה כשמגיעים אליה */
      p.onEnd = () => p.after(() => { if (row.dataset.on === '1' && !ctl.paused) { p.play(p.cap); p.applyShift(); } }, 700);
      p.key = p.cap; p.applyShift();
      p.rest(p.cap);
      P.set(row, p);
      return p;
    };

    const io = new IntersectionObserver(es => {
      es.forEach(e => {
        const row = e.target, on = e.intersectionRatio > 0.42;
        if (!e.isIntersecting && !P.has(row)) return;
        const p = mount(row);
        row.dataset.on = on ? '1' : '0';
        row.classList.toggle('on', on);
        p.visible = on;
        if (on && !ctl.paused) { p.play(p.cap); p.applyShift(); } else { p.playing = false; }
      });
      L.loop();
    }, { threshold: [0, 0.42] });
    s.obs.push(io);
    rows.forEach(r => io.observe(r));

    /* 🔴 הגלילה מוסיפה זמן, ואינה קובעת אותו. בלי גלילה ההנפשה ממשיכה לרוץ לבדה */
    let lastY = window.scrollY, raf = 0;
    const boost = () => {
      raf = 0;
      const dy = Math.abs(window.scrollY - lastY); lastY = window.scrollY;
      if (!dy || ctl.paused || L.reduce) return;
      P.forEach((p, row) => {
        if (row.dataset.on !== '1' || !p.live) return;
        p.t = Math.min(p.dur, p.t + dy * SEC_PER_PX);
        p.dirty = true;
      });
      L.loop();
    };
    s.on(window, 'scroll', () => { if (!raf) raf = requestAnimationFrame(boost); }, { passive: true });
  }

  /* ═══════════ חמש גרסאות רצף, 20.09.2026 ═══════════
     כולן שומרות על מה שיובל ביקש: פרק אחרי פרק, הסבר לצד ההנפשה או מתחתיה,
     ההנפשה רצה לבד, והגלילה מזרזת. הן נבדלות במבנה ובתחושה. */

  /* ───────── ט · במה נעולה, הטקסט זורם מתחתיה ─────────
     🔴 זה המודל של Apple עצמה, נמדד על apple.com/iphone-18-pro: הבמה ננעצת,
     הטקסט **תמיד מתחתיה**, ואינו מתחלף צד. טלפון אחד לכל שבעת הפרקים. */
  function layoutI(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-i">
        <div class="i-hd">${kick(t)}<h3>${headOf()}</h3></div>
        <div class="i-wrap">
          <div class="i-stage sq-stage">
            <canvas class="sq-back" aria-hidden="true"></canvas>
            <div class="sfloor sq-floor"></div>
            <div class="i-dots" role="list">${caps.map((k, j) => `<span role="listitem" data-j="${j}"><i></i><b>${CAP[k].label}</b></span>`).join('')}</div>
          </div>
          <div class="i-steps">${caps.map((k, j) => `
            <article class="i-step" data-k="${k}" data-j="${j}">
              <span class="sq-idx num">${j + 1} מתוך ${caps.length}</span>
              <div class="ro">${roHTML(k, t)}</div>
            </article>`).join('')}</div>
        </div>
        ${ctas(t)}${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const stg = host.querySelector('.i-stage'), floor = host.querySelector('.sq-floor'), back = host.querySelector('.sq-back');
    const steps = [...host.querySelectorAll('.i-step')], dots = [...host.querySelectorAll('.i-dots span')];
    const p = mountPhone(s, floor, t, f => {
      const [w, h] = dims(t);
      return Math.min((f.clientWidth * 0.44) / w, (f.clientHeight * 0.9) / h, 3);
    });
    const drawStage = wireStage(p, floor, back, stg);
    p.onDraw = drawStage;
    p.visible = true;
    const ctl = pauser(s, host.querySelector('.pz'), () => { p.playing = false; }, () => { if (p.t >= p.dur) p.play(p.cap); else { p.playing = true; p.last = 0; } });
    const nextOf = autoNext(s, steps, ctl);
    /* 🔴 בסוף פרק: או שעוברים לבא (רילז), או שחוזרים מהתחלה */
    p.onEnd = () => p.after(() => {
      if (ctl.paused) return;
      if (nextOf(cur)) return;
      p.play(p.cap); p.applyShift();
    }, 700);
    let cur = -1;
    const go = j => {
      if (j === cur) return;
      cur = j; p.cap = caps[j];
      steps.forEach((e, i) => e.classList.toggle('on', i === j));
      dots.forEach((e, i) => e.classList.toggle('on', i === j));
      if (!ctl.paused) { p.play(caps[j]); p.applyShift(); } else { p.key = caps[j]; p.rest(caps[j]); p.applyShift(); }
    };
    /* הפרק הפעיל הוא זה שחוצה את קו האמצע שמתחת לבמה */
    const io = new IntersectionObserver(es => {
      es.forEach(e => { if (e.isIntersecting) go(Number(e.target.dataset.j)); });
    }, { threshold: 0.01, rootMargin: '-55% 0px -35% 0px' });
    s.obs.push(io); steps.forEach(e => io.observe(e));
    preload(s, host, t);
    go(0);
    scrollBoost(s, (add, dy) => {
      if (!p.live || ctl.paused) return;
      const h = steps[Math.max(0, cur)] ? steps[Math.max(0, cur)].getBoundingClientRect().height : 700;
      p.t = Math.max(0, Math.min(p.dur, p.t + stepTime(dy, add, p, h)));
      p.dirty = true;
    });
  }

  /* ───────── י · קלפים נערמים ─────────
     כל יכולת היא קלף שנעצר, והבא נכנס מעליו ומכסה אותו. שולי הקודמים נשארים למעלה,
     ולכן רואים את הרצף מצטבר. הדפוס היחיד שמתנהג זהה בטלפון בלי נפילה חזרה. */
  function layoutJ(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-j">
        <div class="j-hd">${kick(t)}<h3>${headOf()}</h3></div>
        <div class="j-stack">${caps.map((k, j) => `
          <section class="j-card" data-k="${k}" data-on="0" style="--i:${j}">
            <div class="j-inner">
              <span class="j-tab num">${j + 1} · ${CAP[k].label}</span>
              <div class="j-body">
                ${sqStage()}
                ${sqText(k, t, j, caps.length)}
              </div>
            </div>
          </section>`).join('')}</div>
        ${ctas(t)}${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const cards = [...host.querySelectorAll('.j-card')];
    const btn = host.querySelector('.pz');
    let P;
    const ctl = pauser(s, btn, () => P && P.forEach(q => { q.playing = false; }),
      () => { P && P.forEach((q, row) => { if (row.dataset.on === '1') { if (q.t >= q.dur) q.play(q.cap); else { q.playing = true; q.last = 0; } } }); L.loop(); });
    P = chapterWatch(s, cards, t, f => {
      const [w, h] = dims(t);
      return Math.min((f.clientWidth * 0.8) / w, (f.clientHeight * 0.92) / h, 3);
    }, ctl, { ratio: 0.3 });
    preload(s, host, t);
  }

  /* ───────── כ · מסך מלא, חשיפה מתחלפת ─────────
     בלי נעיצה ובלי חטיפת גלילה. כל פרק נחשף בווילון כיווני שמתחלף, והטקסט על גבי הבמה.
     הדפוס הבטוח ביותר: הגלילה נשארת נייטיבית לגמרי. */
  function layoutK(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-k">
        <div class="k-hd">${kick(t)}<h3>${headOf()}</h3></div>
        ${caps.map((k, j) => `
          <section class="k-ch" data-k="${k}" data-on="0" data-side="${j % 2 ? 'b' : 'a'}">
            ${sqStage()}
            <div class="k-over">
              <span class="k-num num">${String(j + 1).padStart(2, '0')}</span>
              ${sqText(k, t, j, caps.length)}
            </div>
          </section>`).join('')}
        ${ctas(t)}${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const chs = [...host.querySelectorAll('.k-ch')];
    let P;
    const ctl = pauser(s, host.querySelector('.pz'), () => P && P.forEach(q => { q.playing = false; }),
      () => { P && P.forEach((q, row) => { if (row.dataset.on === '1') { if (q.t >= q.dur) q.play(q.cap); else { q.playing = true; q.last = 0; } } }); L.loop(); });
    P = chapterWatch(s, chs, t, f => {
      const [w, h] = dims(t);
      return Math.min((f.clientWidth * 0.42) / w, (f.clientHeight * 0.88) / h, 3);
    }, ctl, { ratio: 0.35 });
    preload(s, host, t);
  }

  /* ───────── ל · ציר פרקים ממוספר ─────────
     לכל פרק פאנל דביק משלו עם מספר ענק. כשהפרק נגמר, הפאנל של הבא **דוחף אותו החוצה**,
     וזו התנהגות טבעית של sticky ולא קוד. */
  function layoutL(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-l">
        <div class="l-hd">${kick(t)}<h3>${headOf()}</h3></div>
        ${caps.map((k, j) => `
          <section class="l-ch" data-k="${k}" data-on="0">
            <div class="l-panel">
              <span class="l-num num">${String(j + 1).padStart(2, '0')}</span>
              <p class="l-lab">${CAP[k].label}</p>
              <div class="l-dots" aria-hidden="true">${caps.map((_, i) => `<i class="${i === j ? 'on' : ''}"></i>`).join('')}</div>
              <div class="sq-prog"><i></i></div>
            </div>
            <div class="l-body">
              ${sqStage()}
              <div class="sq-txt"><div class="ro">${roHTML(k, t)}</div></div>
            </div>
          </section>`).join('')}
        ${ctas(t)}${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const chs = [...host.querySelectorAll('.l-ch')];
    let P;
    const ctl = pauser(s, host.querySelector('.pz'), () => P && P.forEach(q => { q.playing = false; }),
      () => { P && P.forEach((q, row) => { if (row.dataset.on === '1') { if (q.t >= q.dur) q.play(q.cap); else { q.playing = true; q.last = 0; } } }); L.loop(); });
    P = chapterWatch(s, chs, t, f => {
      const [w, h] = dims(t);
      return Math.min((f.clientWidth * 0.5) / w, (f.clientHeight * 0.9) / h, 3);
    }, ctl, { ratio: 0.3 });
    preload(s, host, t);
  }

  /* ───────── מ · טלפון אחד שנוסע ─────────
     הטלפון אינו נעלם בין פרקים. הוא נשאר על המסך ונוסע מצד לצד, והטקסט נכנס מהצד הנגדי.
     🔴 זה אפשרי רק כי ציור הבמה מעוגן למלבן הטלפון, ולכן הוא נוסע איתו. */
  function layoutM(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-m">
        <div class="m-hd">${kick(t)}<h3>${headOf()}</h3></div>
        <div class="m-wrap">
          <div class="m-stage sq-stage">
            <canvas class="sq-back" aria-hidden="true"></canvas>
            <div class="sfloor sq-floor"></div>
          </div>
          <div class="m-steps">${caps.map((k, j) => `
            <article class="m-step" data-k="${k}" data-j="${j}" data-side="${j % 2 ? 'b' : 'a'}">
              <div class="m-card">
                <span class="sq-idx num">${j + 1} מתוך ${caps.length}</span>
                <div class="ro">${roHTML(k, t)}</div>
                <div class="sq-prog"><i></i></div>
              </div>
            </article>`).join('')}</div>
        </div>
        ${ctas(t)}${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const wrap = host.querySelector('.m-wrap'), stg = host.querySelector('.m-stage');
    const floor = host.querySelector('.sq-floor'), back = host.querySelector('.sq-back');
    const steps = [...host.querySelectorAll('.m-step')];
    const bars = [...host.querySelectorAll('.m-step .sq-prog i')];
    const p = mountPhone(s, floor, t, f => {
      const [w, h] = dims(t);
      return Math.min((f.clientWidth * 0.34) / w, (f.clientHeight * 0.86) / h, 3);
    });
    const drawStage = wireStage(p, floor, back, stg);
    let curJ = 0;
    p.onDraw = () => { drawStage(); const b = bars[curJ]; if (b) b.style.width = `${Math.min(100, (p.t / p.dur) * 100).toFixed(1)}%`; };
    p.visible = true;
    const ctl = pauser(s, host.querySelector('.pz'), () => { p.playing = false; }, () => { if (p.t >= p.dur) p.play(p.cap); else { p.playing = true; p.last = 0; } });
    const nextOf = autoNext(s, steps, ctl);
    /* 🔴 בסוף פרק: או שעוברים לבא (רילז), או שחוזרים מהתחלה */
    p.onEnd = () => p.after(() => {
      if (ctl.paused) return;
      if (nextOf(cur)) return;
      p.play(p.cap); p.applyShift();
    }, 700);
    let cur = -1;
    const go = j => {
      if (j === cur) return;
      cur = curJ = j; p.cap = caps[j];
      steps.forEach((e, i) => e.classList.toggle('on', i === j));
      /* 🔴 נוסע הטלפון, לא הבמה. הציור נמדד מהטלפון בכל פריים ולכן הוא נוסע איתו.
         הזזת הבמה כולה חתכה את הציור בקצה, ונתפס בצילום 20.09.2026. */
      /* 🔴 בטלפון אין לאן לנסוע: הבמה ברוחב מלא, ונסיעה הייתה מוציאה את הטלפון מהמסך */
      /* 🔴 לכל סצנה יש shift משלה, 0.20 עד 0.24. הנסיעה אינה נוספת עליה אלא מושכת אותה
         חזרה בצד השני, אחרת הטלפון יוצא מהבמה. */
      p.travel = narrowOf(host) ? 0 : (steps[j].dataset.side === 'a' ? 0 : -0.28);
      wrap.dataset.side = steps[j].dataset.side;
      bars.forEach((b, i) => { if (i !== j) b.style.width = '0'; });
      if (!ctl.paused) { p.play(caps[j]); p.applyShift(); } else { p.key = caps[j]; p.rest(caps[j]); p.applyShift(); }
    };
    const io = new IntersectionObserver(es => {
      es.forEach(e => { if (e.isIntersecting) go(Number(e.target.dataset.j)); });
    }, { threshold: 0.01, rootMargin: '-45% 0px -45% 0px' });
    s.obs.push(io); steps.forEach(e => io.observe(e));
    /* מעבר בין מחשב לטלפון משנה אם יש נסיעה, ולכן מחשבים מחדש */
    s.observe(new ResizeObserver(() => {
      if (cur < 0) return;
      p.travel = narrowOf(host) ? 0 : (steps[cur].dataset.side === 'a' ? 0 : -0.28);
      p.applyShift(); p.dirty = true; L.loop();
    }), host);
    preload(s, host, t);
    go(0);
    scrollBoost(s, (add, dy) => {
      if (!p.live || ctl.paused) return;
      const h = steps[Math.max(0, cur)] ? steps[Math.max(0, cur)].getBoundingClientRect().height : 700;
      p.t = Math.max(0, Math.min(p.dur, p.t + stepTime(dy, add, p, h)));
      p.dirty = true;
    });
  }

  /* ───────── נ · השילוב: המספור של ל עם הטלפון שנוסע של מ ─────────
     בקשת יובל 21.09.2026. טלפון אחד לכל שבעת הפרקים, שנוסע מצד לצד,
     ולצידו פאנל ממוספר עם המספר הגדול, הנקודות ופס ההתקדמות.
     🔴 שני קנבסים בלבד, כמו מ, כי הטלפון אינו מורכב מחדש בכל פרק. */
  function layoutN(host, t, s) {
    const caps = capsOf(t);
    host.innerHTML = `
      <div class="band band-n${TI.on ? ' band-ti' : ''}">
        <div class="n-hd">${kick(t)}<h3>${headOf()}</h3></div>
        ${askHTML(t)}
        <div class="n-wrap">
          <div class="n-col">
            <div class="n-stage sq-stage">
              <canvas class="sq-back" aria-hidden="true"></canvas>
              <div class="sfloor sq-floor"></div>
            </div>
          </div>
          <div class="n-steps">${caps.map((k, j) => `
            <article class="n-step" data-k="${k}" data-j="${j}" data-side="${j % 2 ? 'b' : 'a'}">
              <div class="n-panel">
                <div class="n-top">
                  <span class="n-num num">${String(j + 1).padStart(2, '0')}</span>
                  <div class="n-of">
                    <p class="n-lab">${CAP[k].label}</p>
                    <div class="n-dots" aria-hidden="true">${caps.map((_, i) => `<i class="${i === j ? 'on' : ''}"></i>`).join('')}</div>
                  </div>
                  <button type="button" class="n-rep" aria-label="נגן שוב"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5V2L7 6l5 4V7a5 5 0 1 1-5 5H5a7 7 0 1 0 7-7z"/></svg></button>
                </div>
                <div class="ro">${roHTML(k, t)}${cmpHTML(k, t)}</div>
                <div class="sq-prog"><i></i></div>
              </div>
            </article>`).join('')}</div>
        </div>
        ${closeHTML(t)}${ctas(t)}${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const wrap = host.querySelector('.n-wrap'), stg = host.querySelector('.n-stage');
    const floor = host.querySelector('.sq-floor'), back = host.querySelector('.sq-back');
    const steps = [...host.querySelectorAll('.n-step')];
    const bars = [...host.querySelectorAll('.n-step .sq-prog i')];
    const p = mountPhone(s, floor, t, f => {
      const [w, h] = dims(t);
      return Math.min((f.clientWidth * 0.32) / w, (f.clientHeight * 0.88) / h, 3);
    });
    const drawStage = wireStage(p, floor, back, stg);
    let curJ = 0;
    p.onDraw = () => { drawStage(); const b = bars[curJ]; if (b) b.style.width = `${Math.min(100, (p.t / p.dur) * 100).toFixed(1)}%`; };
    p.visible = true;
    let held = false;
    /* 🔴 ההנפשה אינה רצה עד שהבמה באמת מלאה על המסך, הכרעת יובל 21.09.2026:
       «רק אחרי שגוללים מהכותרת ומגיעים לכל המסך של הזום, רק אז זה יתחיל לרוץ». */
    let started = false;
    const ctl = pauser(s, host.querySelector('.pz'), () => { p.playing = false; }, () => { if (p.t >= p.dur) p.play(p.cap); else { p.playing = true; p.last = 0; } });
    const nextOf = autoNext(s, steps, ctl);
    /* 🔴 בסוף פרק: או שעוברים לבא (רילז), או שחוזרים מהתחלה */
    p.onEnd = () => p.after(() => {
      if (ctl.paused) return;
      if (!held && nextOf(cur)) return;
      p.play(p.cap); p.applyShift();
    }, 700);
    /* 🔴 «נעילה», הכרעת יובל 21.09.2026: לחיצה על פרק מנגנת אותו מחדש **ומשאירה אותו במקום**.
       המעבר האוטומטי חוזר רק כשהצופה עובר בעצמו לפרק אחר, ב-go(). */
    const replay = j => {
      held = true; started = true;
      steps.forEach((e, i) => e.classList.toggle('held', i === j));
      ctl.set(false);                     /* לחיצה על «נגן שוב» משחררת גם השהיה */
      p.play(caps[j]); p.applyShift(); p.dirty = true; L.loop();
    };
    steps.forEach((e, j) => s.on(e.querySelector('.n-panel'), 'click', () => replay(j)));
    /* 🔴 הפאנל יושב בעמודה משלו, ולכן הנסיעה היא לתנועה בלבד ולא לפינוי מקום.
       טווח קטן, כי העמודה צרה מהבמה הקודמת והציור חייב להישאר בתוכה.
       🔴 הסף 900 זהה ל-@container שב-showcase.css. מתחת לו הפריסה נערמת ואין לאן לנסוע. */
    const stacked = () => { const b = host.querySelector('.band'); return !b || b.clientWidth < 900; };
    const travelOf = j => (stacked() ? 0 : (steps[j].dataset.side === 'a' ? 0.06 : -0.12));
    let cur = -1;
    const go = j => {
      if (j === cur) return;
      /* 🔴 מעבר לפרק אחר משחרר את הנעילה, וזה בדיוק מה שיובל ביקש */
      held = false; steps.forEach(e => e.classList.remove('held'));
      cur = curJ = j; p.cap = caps[j];
      steps.forEach((e, i) => e.classList.toggle('on', i === j));
      p.travel = travelOf(j);
      wrap.dataset.side = steps[j].dataset.side;
      bars.forEach((b, i) => { if (i !== j) b.style.width = '0'; });
      if (!ctl.paused && started) { p.play(caps[j]); p.applyShift(); }
      else {
        p.key = caps[j]; p.rest(caps[j]); p.applyShift();
        /* 🔴 לפני ההתחלה מציגים את **תחילת** ההנפשה ולא את סופה.
           p.rest מחנה ב-p.dur, ולכן בלי זה רואים את סוף הזום לפני שהוא בכלל רץ. */
        if (!started) { p.t = 0; p.dirty = true; L.loop(); }
      }
    };
    const io = new IntersectionObserver(es => {
      es.forEach(e => { if (e.isIntersecting) go(Number(e.target.dataset.j)); });
    }, { threshold: 0.01, rootMargin: '-45% 0px -45% 0px' });
    s.obs.push(io); steps.forEach(e => io.observe(e));
    /* 🔴 0.9 ולא 1: הבמה דביקה, ובחלון נמוך היא לעולם אינה מגיעה ל-100% */
    const startIO = new IntersectionObserver(es => {
      es.forEach(e => {
        if (started || e.intersectionRatio < 0.9) return;
        started = true;
        if (!ctl.paused && cur >= 0) { p.play(caps[cur]); p.applyShift(); L.loop(); }
      });
    }, { threshold: [0.9] });
    s.obs.push(startIO); startIO.observe(stg);
    s.observe(new ResizeObserver(() => {
      if (cur < 0) return;
      p.travel = travelOf(cur); p.applyShift(); p.dirty = true; L.loop();
    }), host);
    preload(s, host, t);
    go(0);
    scrollBoost(s, (add, dy) => {
      if (!p.live || ctl.paused) return;
      const h = steps[Math.max(0, cur)] ? steps[Math.max(0, cur)].getBoundingClientRect().height : 700;
      p.t = Math.max(0, Math.min(p.dur, p.t + stepTime(dy, add, p, h)));
      p.dirty = true;
    });
  }


  /* ═══════════ ס · ההשוואה בתוך הרצף הגולל ═══════════
     🔴 בקשת יובל 24.09.2026: «אני רוצה את ההנפשות שיש לנו להשוואה בין הטלפונים,
     אבל שיהיה בגלילה, שיורד אוטומטי, והכל כמו בגרסה שעשית עכשיו».
     ⟹ הכרום של פריסה נ (ציר ממוספר, במה דביקה, מעבר אוטומטי, פס התקדמות),
     והבמה מציירת **שני מכשירים**, כל אחד עם המספרים שלו.

     🔴 הסצנות כאן הן `L.scenes[k]` ולא `sceneOf(k)`, וזה ההבדל כולו:
     · `scenes-a/b` (14.09) מקבלות `side` ומציירות את המכשיר של אותו צד ⟵ השוואה
     · סבב 2 עד 6 מקבלות `side` **ומתעלמות ממנו**, ותמיד מציירות את `I.tg`
     ⟹ ברצף הרגיל `sceneOf` נותן `bat-13`, וכאן חייבים את `bat` עצמה.
     אחרת שתי הבמות היו מציירות את אותו מכשיר פעמיים. */
  const PAIR_ORDER = ['zoom', 'cam', 'self', 'vid', 'chip', 'hz', 'chg', 'bat'];
  const pairCaps = t => {
    const want = (capsOvr || []).filter(k => L.scenes[k] && (PAIR_ORDER.includes(k) || k === 'scr'));
    if (want.length) return want;
    /* ל-Duo המסך הוא העיקר, ולשאר הוא נתון שולי */
    return t.duo ? ['scr', ...PAIR_ORDER] : PAIR_ORDER;
  };

  /* שני מכשירים על במה אחת. אותו חוזה של mountPhone, כדי שהכרום של נ יעבוד בלי שינוי. */
  function mountPair(s, floor, o, t, fitK) {
    floor.innerHTML = '';
    floor.classList.add('pair');
    const a = L.device(o, 'old', `<bdi>${o.name}</bdi><span>הטלפון שלכם</span>`);
    const b = L.device(t, 'new', `<bdi>${t.name}</bdi><span>${t.finishHe}</span>`);
    floor.append(a, b);
    const cmp = L.compare(o, t);
    const p = L.register({
      key: null, t: 0, dur: 1, playing: false, visible: false, dirty: true, k: 2,
      figs: { old: a, new: b }, I: { o, tg: t, acc: t.accRgb, cmp },
      draw() {
        if (!this.key) return;
        /* 🔴 הסצנה קוראת את `I.x`, ולכן הוא נקבע לפני הציור ולא אחריו */
        this.I.x = cmp.byKey[this.key];
        ['old', 'new'].forEach(side => {
          const { c, W, H } = L.fitCanvas(this.figs[side]._canvas);
          c.clearRect(0, 0, W, H); c.save();
          L.scenes[this.key].draw(c, W, H, this.t, side, this.I); c.restore();
        });
        this.onDraw && this.onDraw();
      },
    });
    s.players.push(p);
    const fit = () => { p.k = fitK(floor); L.layoutDevice(a, p.k); L.layoutDevice(b, p.k); L.kick(); };
    fit(); s.observe(new ResizeObserver(fit), floor);
    p.openDuo = () => { if (!t.duo) return; const tt = p.t; p.t = 99; L.scenes.scr.onScrub(p, p.I, p.k); p.t = tt; };
    p.after = (fn, ms) => { clearTimeout(p._adv); p._adv = s.later(fn, ms); };
    /* אין נסיעה: שני המכשירים ממורכזים, ואין לאן לפנות מקום */
    p.applyShift = () => {};
    p.rest = k => { p.key = k; p.dur = L.scenes[k].dur; p.t = k === 'bat' ? p.dur * 0.62 : p.dur; p.live = false; p.dirty = true; L.kick(); };
    p.play = k => {
      clearTimeout(p._adv); p.live = true;
      if (k !== 'scr') p.openDuo();
      p.key = k; p.dur = L.scenes[k].dur; p.t = L.reduce ? p.dur : 0; p.playing = !L.reduce; p.last = 0;
      const sc = L.scenes[k]; sc.onStart && sc.onStart(p, p.I, p.k);
      p.dirty = true; L.loop();
    };
    return p;
  }

  /* הקריאה בפאנל: המדד, שני המספרים עם החץ, ומשפט אחד. הכול מ-`compare()`. */
  const pairRo = x => `<span class="ro-l">${CMP_LABEL[x.k] || x.label}</span>
    <div class="p-vals">
      <span class="p-side p-o"><i>שלכם</i><b class="num"><bdi>${x.o}</bdi></b>${x.unit ? `<small>${x.unit}</small>` : ''}</span>
      <span class="p-arr" aria-hidden="true">←</span>
      <span class="p-side p-n"><i><bdi>${x.tgShort}</bdi></i><b class="num"><bdi>${x.n}</bdi></b>${x.unit ? `<small>${x.unit}</small>` : ''}</span>
    </div>
    <p class="ro-x">${x.human}</p>`;

  function layoutP(host, t, s) {
    const o = myPhone() || byName(TI.model) || M[0];
    const caps = pairCaps(t);
    const cmp = L.compare(o, t);
    const rowOf = k => Object.assign({ tgShort: t.short }, cmp.byKey[k]);
    host.innerHTML = `
      <div class="band band-n band-p${TI.on ? ' band-ti' : ''}">
        <div class="n-hd">${kick(t)}<h3>${headOf()}</h3></div>
        ${askHTML(t)}
        <div class="n-wrap">
          <div class="n-col">
            <div class="n-stage sq-stage no-glow">
              <div class="sfloor sq-floor"></div>
            </div>
          </div>
          <div class="n-steps">${caps.map((k, j) => `
            <article class="n-step" data-k="${k}" data-j="${j}">
              <div class="n-panel">
                <div class="n-top">
                  <span class="n-num num">${String(j + 1).padStart(2, '0')}</span>
                  <div class="n-of">
                    <p class="n-lab">${CMP_LABEL[k] || cmp.byKey[k].label}</p>
                    <div class="n-dots" aria-hidden="true">${caps.map((_, i) => `<i class="${i === j ? 'on' : ''}"></i>`).join('')}</div>
                  </div>
                  <button type="button" class="n-rep" aria-label="נגן שוב"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 5V2L7 6l5 4V7a5 5 0 1 1-5 5H5a7 7 0 1 0 7-7z"/></svg></button>
                </div>
                <div class="ro">${pairRo(rowOf(k))}</div>
                <div class="sq-prog"><i></i></div>
              </div>
            </article>`).join('')}</div>
        </div>
        ${closeHTML(t)}${ctas(t)}${FN}
        <button type="button" class="pz"></button>
      </div>`;
    const floor = host.querySelector('.sq-floor');
    const steps = [...host.querySelectorAll('.n-step')];
    const bars = [...host.querySelectorAll('.n-step .sq-prog i')];
    /* 🔴 המידה נגזרת משני המכשירים יחד ומגובה הבמה. מדידה על אחד בלבד
       מוציאה את השני מהמסגרת, כי ה-Duo הפתוח רחב פי שניים. */
    const p = mountPair(s, floor, o, t, f => {
      const [wN, hN] = dims(t);
      return Math.min((f.clientWidth * 0.86) / (o.w + wN + 18), (f.clientHeight * 0.80) / Math.max(o.h, hN), 2.6);
    });
    let curJ = 0;
    p.onDraw = () => { const b = bars[curJ]; if (b) b.style.width = `${Math.min(100, (p.t / p.dur) * 100).toFixed(1)}%`; };
    p.visible = true;
    let held = false, started = false;
    const ctl = pauser(s, host.querySelector('.pz'), () => { p.playing = false; }, () => { if (p.t >= p.dur) p.play(p.cap); else { p.playing = true; p.last = 0; } });
    const nextOf = autoNext(s, steps, ctl);
    p.onEnd = () => p.after(() => {
      if (ctl.paused) return;
      if (!held && nextOf(cur)) return;
      p.play(p.cap);
    }, 700);
    const replay = j => {
      held = true; started = true;
      steps.forEach((e, i) => e.classList.toggle('held', i === j));
      ctl.set(false);
      p.play(caps[j]); p.dirty = true; L.loop();
    };
    steps.forEach((e, j) => s.on(e.querySelector('.n-panel'), 'click', () => replay(j)));
    let cur = -1;
    const go = j => {
      if (j === cur) return;
      held = false; steps.forEach(e => e.classList.remove('held'));
      cur = curJ = j; p.cap = caps[j];
      steps.forEach((e, i) => e.classList.toggle('on', i === j));
      bars.forEach((b, i) => { if (i !== j) b.style.width = '0'; });
      if (!ctl.paused && started) p.play(caps[j]);
      else { p.key = caps[j]; p.rest(caps[j]); if (!started) { p.t = 0; p.dirty = true; L.loop(); } }
    };
    const io = new IntersectionObserver(es => {
      es.forEach(e => { if (e.isIntersecting) go(Number(e.target.dataset.j)); });
    }, { threshold: 0.01, rootMargin: '-45% 0px -45% 0px' });
    s.obs.push(io); steps.forEach(e => io.observe(e));
    const startIO = new IntersectionObserver(es => {
      es.forEach(e => {
        if (started || e.intersectionRatio < 0.9) return;
        started = true;
        if (!ctl.paused && cur >= 0) { p.play(caps[cur]); L.loop(); }
      });
    }, { threshold: [0.9] });
    s.obs.push(startIO); startIO.observe(host.querySelector('.n-stage'));
    preload(s, host, t);
    go(0);
    scrollBoost(s, (add, dy) => {
      if (!p.live || ctl.paused) return;
      const h = steps[Math.max(0, cur)] ? steps[Math.max(0, cur)].getBoundingClientRect().height : 700;
      p.t = Math.max(0, Math.min(p.dur, p.t + stepTime(dy, add, p, h)));
      p.dirty = true;
    });
  }

  const LAYOUTS = { a: layoutA, b: layoutB, c: layoutC, d: layoutD, e: layoutE, f: layoutF, g: layoutG, h: layoutH, i: layoutI, j: layoutJ, k: layoutK, l: layoutL, m: layoutM, n: layoutN, p: layoutP };

  /* 🔴 המאזינים יושבים על document, כי הפאנלים נמחקים ונבנים מחדש בכל רינדור,
     ובהחלפת דגם היעד הרצף כולו נבנה מאפס.
     🔴 שני שערים בלבד, ו**כל ארבע גרסאות הבורר מדברות רק איתם**. הוספת גרסה
     חמישית אינה נוגעת בשום מאזין. */
  let LAST = null;
  const setMine = name => {
    if (!LAST || !TI.on || !byName(name) || name === TI.model) return;
    TI.model = name;
    /* 🔴 בפריסה ס הטלפון של הלקוח **מצויר על הבמה**, ולכן החלפת דגם חייבת בנייה
       מחדש. עדכון טקסט לבדו היה משאיר על המסך מכשיר אחר ממה שכתוב בפאנל. */
    if (LAST.layout === 'p') { LAST.s.dispose(); L.show.mount(LAST.host, LAST.layout, LAST.opts); return; }
    refreshTI(LAST.host, T[LAST.opts.t] || T.pro);
  };
  const setTarget = k => {
    if (!LAST || !TI.on || !T[k] || k === LAST.opts.t) return;
    /* 🔴 החלפת דגם היעד מציירת טלפון אחר, ולכן חייבת בנייה מחדש.
       בלי dispose של ההיקף הקודם נשארים משקיפים ונגנים יתומים שממשיכים לצייר. */
    LAST.s.dispose();
    L.show.mount(LAST.host, LAST.layout, Object.assign({}, LAST.opts, { t: k }));
  };
  document.addEventListener('change', e => {
    if (!TI.on) return;
    if (e.target.matches('[data-mine]')) setMine(e.target.value);
    else if (e.target.matches('[data-tsel]')) setTarget(e.target.value);
  });
  document.addEventListener('click', e => {
    if (!TI.on || !LAST) return;
    /* נפח בפירוט המחירים: מחליף את הבלוק בלבד, בלי לבנות את הרצף מחדש */
    const cb = e.target.closest('[data-ticap]');
    if (cb) {
      TI.cap = cb.dataset.ticap;
      const cl = LAST.host.querySelector('[data-ticlose]');
      if (cl) cl.outerHTML = closeHTML(T[LAST.opts.t] || T.pro);
      return;
    }
    const tb = e.target.closest('[data-tset]');
    if (tb) { setTarget(tb.dataset.tset); return; }
    const mb = e.target.closest('[data-mset]');
    if (mb) { setMine(mb.dataset.mset); return; }
    const sb = e.target.closest('[data-tser]');
    if (sb) {
      /* 🔴 שורת הסדרה אינה בוחרת דגם. היא רק מחליפה את השורה שמתחתיה,
         ולכן אין כאן בנייה מחדש ואין הפסקה של ההנפשה שרצה. */
      const row = LAST.host.querySelector('[data-minerow]');
      if (!row) return;
      const ser = Number(sb.dataset.tser);
      const keep = serOf(TI.model) === ser ? TI.model : (M.find(m => m.ser === ser) || {}).name;
      row.innerHTML = mineChips(keep);
      LAST.host.querySelectorAll('[data-tser]').forEach(x => {
        const on = x === sb; x.classList.toggle('on', on); x.setAttribute('aria-pressed', String(on));
      });
      return;
    }
    const su = e.target.closest('[data-msug]');
    if (su) { setMine(su.dataset.msug); return; }
    /* לחיצה מחוץ לשדה החיפוש סוגרת את ההצעות */
    /* ty-ti-search, 01.10.2026: רק לחיצה של הלקוח סוגרת. דף הטרייד אין לוחץ בקוד על פתיחת המחשבון
       באירוע load, וזה סגר את ההצעות למי שהתחיל להקליד בשניות הראשונות (נמדד: 1 מתוך 6 טעינות). */
    if (e.isTrusted && !e.target.closest('.ti-find')) {
      const box = LAST.host.querySelector('[data-msugs]');
      if (box) box.hidden = true;
      const inp = LAST.host.querySelector('[data-msearch]');
      if (inp) inp.setAttribute('aria-expanded', 'false');
    }
  });
  /* ד · חיפוש. ⟵ tiSearch, אותו מנוע של הטרייד אין.
     🔴 פוקוס פותח, הקלדה מסננת, Escape סוגר ומשחרר, ולחיצה מחוץ לשדה סוגרת.
     ⚠️ `focus` אינו מבעבע, ולכן `focusin`. עם `focus` המאזין על document
        לעולם אינו נורה, והשדה נראה כאילו אינו נפתח בכלל. */
  const tiBox = () => LAST && LAST.host.querySelector('[data-msugs]');
  document.addEventListener('input', e => {
    if (!TI.on || !LAST || !e.target.matches('[data-msearch]')) return;
    const box = tiBox();
    if (box) tiRenderSugs(box, e.target);
  });
  document.addEventListener('focusin', e => {
    if (!TI.on || !LAST || !e.target.matches('[data-msearch]')) return;
    const box = tiBox();
    /* ty-ti-search: הדגם שנבחר מראש מסומן, ולכן ההקלדה הראשונה מחליפה אותו ואינה נדבקת לסופו.
       וכשבשדה דגם שלם, ההצעות הן הרשימה המלאה ולא רק הוא. */
    const inp = e.target;
    if (inp.value) setTimeout(() => { if (document.activeElement === inp) inp.select(); }, 0);
    if (box) tiRenderSugs(box, inp, inp.value && byName(inp.value) ? '' : null);
  });
  /* ty-ti-search: לחיצה על שדה שכבר בפוקוס אינה יורה focusin, ולכן הרשימה לא נפתחה לסירוגין
     (נמדד: 1 מתוך 3 ריצות). לחיצה פותחת כשהרשימה סגורה, גם אחרי Escape. */
  document.addEventListener('click', e => {
    if (!TI.on || !LAST || !e.target.matches || !e.target.matches('[data-msearch]')) return;
    const box = tiBox(), inp = e.target;
    if (!box || !box.hidden) return;
    if (inp.value && byName(inp.value)) inp.select();
    tiRenderSugs(box, inp, inp.value && byName(inp.value) ? '' : null);
  });
  /* ty-ti-search: חצים עוברים בין ההצעות, ו-Enter בשדה בוחר את הראשונה */
  document.addEventListener('keydown', e => {
    if (!TI.on || !LAST || !e.target.closest) return;
    const inField = e.target.matches('[data-msearch]');
    const inSug = e.target.closest('[data-msugs] .ti-sug');
    if (!inField && !inSug) return;
    const box = tiBox();
    if (!box || box.hidden) return;
    const list = [...box.querySelectorAll('.ti-sug:not([disabled])')];
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault();
      const i = inSug ? list.indexOf(inSug) : -1;
      const n = e.key === 'ArrowDown' ? Math.min(list.length - 1, i + 1) : i - 1;
      if (n < 0) LAST.host.querySelector('[data-msearch]').focus(); else if (list[n]) list[n].focus();
    } else if (e.key === 'Enter' && inField && list[0]) {
      e.preventDefault(); setMine(list[0].dataset.msug);
    }
  });
  document.addEventListener('keydown', e => {
    if (!TI.on || !LAST || !e.target.matches('[data-msearch]') || e.key !== 'Escape') return;
    const box = tiBox();
    if (box) box.hidden = true;
    e.target.setAttribute('aria-expanded', 'false');
    e.target.blur();
  });

  /* בחנות: L.show.mount(host, 'b', { t: 'pro', cap: 'zoom', links: { pro, max, duo } }) */
  L.show = {
    /* לסטודיו: הנוסח, מה מותר לכל דגם, וברירת המחדל */
    CAP, ALLOW, CAPS,
    mount(host, layout, opts = {}) {
      /* ty-mode-switch, 01.10.2026: הרכבה חוזרת על אותו host (מתג «הצגת יכולות / השוואה» בדף המוצר)
         מפרקת קודם את ההרכבה הקודמת. בלי זה ההנפשות והצופים של המצב הקודם ממשיכים לרוץ על DOM שנמחק. */
      if (LAST && LAST.host === host && LAST.s && LAST.s.dispose) LAST.s.dispose();
      const t = T[opts.t] || T.pro;
      /* טרייד אין: נדלק רק כשהסקשן מוסר אותו, ולכן שימוש קיים אינו משתנה */
      const ti = opts.tradein;
      TI.on = !!(ti && ti.tmeta);
      if (TI.on) {
        TI.pick = Array.isArray(ti.pick) && ti.pick.length ? ti.pick : ['pro'];
        TI.tmeta = ti.tmeta || {};
        TI.prices = ti.prices || null;
        TI.calcHref = ti.calcHref || '';
        TI.head = String(ti.head || '').trim(); TI.ask = String(ti.ask || '').trim(); TI.rec = String(ti.rec || '').trim();
        TI.buy = String(ti.buy || '').trim(); TI.calcLabel = String(ti.calcLabel || '').trim();
        /* גרסת הבורר. הכרעה פתוחה של יובל, ולכן זו הגדרה ולא קבוע */
        TI.style = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h'].includes(ti.style) ? ti.style : 'a';
        /* איך מודגש «עד». 29.09.2026, יובל לא אהב את הריבוע, ולכן זו הגדרה עד שיבחר */
        TI.upto = ['box', 'u1', 'u2', 'u3'].includes(ti.upto) ? ti.upto : 'box';
        /* הדגם נשמר בין בניות, אחרת החלפת Pro ל-Pro Max הייתה מאפסת את בחירת הלקוח */
        if (!TI.model || !byName(TI.model)) TI.model = ti.model || 'iPhone 15 Pro';
      }
      if (opts.cap) aCap[t.key] = opts.cap;
      if (opts.links) L.showLinks = opts.links;
      /* 🔴 מיזוג ולא דריסה: ערך ריק בהגדרה אינו מבטל את הבחירה של יובל.
         ו-'0' פירושו «ברירת המחדל», לא «הסצנה הבסיסית». ההגדרה zoom_style שולחת '0'
         כשלא נגעו בה, וקריאה שלו כבחירה מפורשת דרסה את zoom-4 בסצנה הישנה.
         נתפס 20.09.2026 אחרי שיובל ראה זום שאינו זה שבחר. */
      VARS = Object.assign({}, CHOSEN);
      Object.entries(opts.variants || {}).forEach(([k, v]) => { if (v && v !== '0') VARS[k] = v; });
      capsOvr = opts.caps && opts.caps.length ? opts.caps : null;
      DRIVE = !!opts.drive; AUTONEXT = !!opts.autonext; KICKER = String(opts.kicker || '').trim(); SHOWCTA = opts.cta !== false;
      if (TI.on) host.dataset.upto = TI.upto; else delete host.dataset.upto;
      host.style.setProperty('--acc', t.acc); host.style.setProperty('--acc-rgb', t.accRgb);
      const s = scope();
      (LAYOUTS[layout] || layoutB)(host, t, s);
      LAST = { host, layout, opts: Object.assign({}, opts, { t: t.key }), s };
      return s;
    },
  };

  if (!IN_LAB) return;

  // ── דף המעבדה
  const S = { t: 'pro', w: 'desk' };
  const scopes = {};

  function capsFor(id) {
    if (id === 'a') return [aCapOf(T[S.t])];
    if (id === 'd') return D_CARDS.map(x => x[1]);
    return CAPS[S.t];
  }
  function meta(id) {
    const caps = capsFor(id);
    /* ב-א וב-ב נטען בהתחלה רק הצילום של היכולת הראשונה. ב-ג הכול יורד מראש, וב-ד שלושת הכרטיסים גלויים יחד */
    const first = id === 'd' || id === 'c' ? kbOf(caps) : kbOf([caps[0]]), all = kbOf(caps);
    document.getElementById(`m-${id}`).innerHTML =
      `<span>גובה הסקשן: <b data-h>נמדד…</b></span><span>צילומים בטעינה: <b>${fmtKB(first)}</b></span>${all !== first ? `<span>אם צופים בכול: <b>${fmtKB(all)}</b></span>` : ''}`;
  }
  function measure(id) {
    const band = document.querySelector(`#v-${id} .band`), el = document.querySelector(`#m-${id} [data-h]`);
    if (band && el) el.textContent = `${Math.round(band.getBoundingClientRect().height).toLocaleString('en-US')} פיקסל`;
  }
  function buildOne(id) {
    if (scopes[id]) scopes[id].dispose();
    const s = scopes[id] = scope(), host = document.getElementById(`v-${id}`), t = T[S.t];
    host.style.setProperty('--acc', t.acc); host.style.setProperty('--acc-rgb', t.accRgb);
    LAYOUTS[id](host, t, s);
    meta(id);
    s.observe(new ResizeObserver(() => measure(id)), host.querySelector('.band'));
  }
  function paintBar() {
    document.querySelectorAll('.bar [data-t]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.t === S.t)));
    document.querySelectorAll('.bar [data-w]').forEach(b => b.setAttribute('aria-pressed', String(b.dataset.w === S.w)));
    document.querySelector('.page').classList.toggle('frame-phone', S.w === 'phone');
    const t = T[S.t];
    document.documentElement.style.setProperty('--acc', t.acc);
    document.documentElement.style.setProperty('--acc-rgb', t.accRgb);
  }
  function build() { paintBar(); Object.keys(LAYOUTS).forEach(buildOne); }

  document.addEventListener('click', e => {
    const b = e.target.closest('.bar button');
    if (b) { if (b.dataset.t) S.t = b.dataset.t; if (b.dataset.w) S.w = b.dataset.w; build(); return; }
    const a = e.target.closest('[data-acap]');
    if (a) { aCap[S.t] = a.dataset.acap; buildOne('a'); return; }
    if (e.target.closest('[data-noop]')) e.preventDefault();
  });

  // קישור ישיר: ?t=max&w=phone&acap=cam
  const q = new URLSearchParams(location.search);
  if (T[q.get('t')]) S.t = q.get('t');
  if (q.get('w') === 'phone') S.w = 'phone';
  if (q.get('acap')) aCap[S.t] = q.get('acap');
  /* ?zv=2 גרסת תצוגה לזום · ?caps=zoom,bat סדר יכולות */
  if (q.get('zv')) VARS.zoom = q.get('zv');
  if (q.get('caps')) capsOvr = q.get('caps').split(',');
  build();
  if (document.fonts) document.fonts.ready.then(() => Object.keys(LAYOUTS).forEach(measure));
})();

/* אתחול: כל סקשן .tysh בדף, והטעינה מחדש בעורך התמה */
(() => {
  const L = window.TYSH, META = {"bat-video":{"width":1200,"height":925,"credit":"Apple, דף iPhone 18 Pro (Apple TV)"},"zoom-wide":{"width":1392,"height":904,"credit":"Apple, דף iPhone 18 Pro, הדגמת הזום","focus":[0.4986,0.5337],"base":0.508},"zoom-8x":{"width":1392,"height":904,"credit":"Apple, דף iPhone 18 Pro, הדגמת הזום","level":8},"ap-148":{"width":1200,"height":699,"credit":"Apple, ƒ/1.48"},"ap-18":{"width":1200,"height":699,"credit":"Apple, ƒ/1.8"},"ap-28":{"width":1200,"height":699,"credit":"Apple, ƒ/2.8"},"ap-4":{"width":1200,"height":699,"credit":"Apple, ƒ/4.0"},"selfie-group":{"width":1600,"height":1200,"credit":"Apple Newsroom, Center Stage"},"cam-photo":{"width":1960,"height":1470,"credit":"Apple Newsroom, צולם ב-iPhone 18 Pro"},"ap5-148":{},"ap5-18":{},"ap5-22":{},"ap5-28":{},"ap5-34":{},"ap5-4":{}};
  /* ג נדבקת מתחת להדר הדביק של האתר: .section-header, נמדד 15.09 (60 בטלפון, 62 במחשב) */
  const setTop = () => {
    const h = document.querySelector('.section-header');
    const px = h && getComputedStyle(h).position === 'sticky' ? Math.round(h.getBoundingClientRect().height) : 0;
    document.querySelectorAll('.tysh').forEach(e => { e.style.setProperty('--tysh-top', (px + 16) + 'px'); e.style.setProperty('--tysh-top-m', px + 'px'); });
  };
  let rz = 0;
  addEventListener('resize', () => { cancelAnimationFrame(rz); rz = requestAnimationFrame(setTop); });
  const boot = () => { setTop(); document.querySelectorAll('.tysh[data-layout]:not([data-ready])').forEach(el => {
    el.dataset.ready = '1';
    let cfg = {};
    try { cfg = JSON.parse(document.getElementById('tysh-cfg-' + el.id.replace(/^tysh-/, '')).textContent); } catch (e) { cfg = {}; }
    const imgs = {};
    Object.keys(META).forEach(k => { if (cfg.images && cfg.images[k]) imgs[k] = Object.assign({}, META[k], { file: cfg.images[k] }); });
    L.A.images = imgs;
    const host = el.querySelector('.tysh-host');
    const base = {
      t: el.dataset.target || 'pro', cap: el.dataset.cap || '', links: cfg.links || null,
      variants: { zoom: el.dataset.zoom || '' },
      drive: el.dataset.drive === 'true', autonext: el.dataset.autonext === 'true', kicker: el.dataset.kicker || '', cta: el.dataset.cta !== 'false',
      caps: (el.dataset.caps || '').split(',').map(s => s.trim()).filter(Boolean),
    };
    /* ty-mode-switch, 01.10.2026, יובל: «למה לי להוציא מישהו מדף מוצר», ואחר כך «אחד אחרי השני».
       כשהסקשן מוסר data-ti-toggle: קודם הצגת היכולות (הפריסה שבהגדרה, בלי טרייד אין),
       ומתחתיה, באותו סקשן, ההשוואה לטלפון שלכם (פריסה p, עם טרייד אין). בלי ההגדרה: כמו קודם.
       🔴 ההשוואה מורכבת אחרונה בכוונה: החיפוש והכפתורים במנוע עובדים על ההרכבה האחרונה (LAST). */
    if (el.dataset.tiToggle === 'true' && cfg.tradein) {
      el.dataset.mode = 'stack';
      L.show.mount(host, el.dataset.layout, base);
      const cmp = document.createElement('div');
      cmp.className = 'tysh-host tysh-cmp'; cmp.id = 'ty-compare-pd';
      /* ty-sep: ההפרדה בין היכולות להשוואה. גרסאות a · b · c במעבדה (?tysep=), עד שיובל יבחר */
      let sep = ''; try { sep = new URLSearchParams(location.search).get('tysep') || ''; } catch (e) {}
      el.dataset.sep = /^(a|b|c|c1|c2|c3)$/.test(sep) ? sep : (el.dataset.tysep || 'c1');
      const div = document.createElement('div');
      div.className = 'tysh-sep'; div.setAttribute('aria-hidden', 'true');
      div.innerHTML = '<small>שלב הבא</small><span>ועכשיו, מול <em>הטלפון שלכם</em></span>';
      /* צבע הכיתוב, גרסאות k1 עד k5 במעבדה (?tycol=), עד שיובל יבחר */
      let col = ''; try { col = new URLSearchParams(location.search).get('tycol') || ''; } catch (e) {}
      el.dataset.sepcol = /^k[1-5]$/.test(col) ? col : (el.dataset.tysepcol || 'k2');
      host.after(div);
      div.after(cmp);
      L.show.mount(cmp, 'p', Object.assign({}, base, { tradein: cfg.tradein, caps: cfg.tradein.caps || base.caps }));
      /* הצבע של שורת המעבר הוא צבע ההדגשה של ההשוואה (כמו «iPhone 18» מעל הכותרת), ולא ברירת המחדל של הסקשן */
      div.style.setProperty('--acc', cmp.style.getPropertyValue('--acc'));
      window.tyshMode = (mode, scroll) => { if (scroll) (mode === 'compare' ? cmp : host).scrollIntoView({ behavior: 'smooth', block: 'start' }); };
      return;
    }
    L.show.mount(host, el.dataset.layout, Object.assign({}, base, {
      /* טרייד אין: מרונדר רק כשהסקשן מוסר tradein בקונפיג. בלעדיו הרצף זהה למה שהיה */
      tradein: cfg.tradein || null,
    }));
  }); };
  /* ty-mode-switch: כפתורים בדף המוצר שנשארים בדף.
     [data-tysh-mode] פותח מצב וגולל אליו · «קנו את» לאותו מוצר לוחץ על הוספה לעגלה של הדף ·
     #ty-tradein-buy לוחץ על «לרכישה עם טרייד-אין» שבקופסת הטרייד אין. אין כאן לוגיקת קנייה משלנו. */
  document.addEventListener('click', e => {
    const m = e.target.closest && e.target.closest('[data-tysh-mode]');
    if (m && window.tyshMode) { e.preventDefault(); window.tyshMode(m.dataset.tyshMode, true); return; }
    const a = e.target.closest && e.target.closest('.tysh a[href]');
    if (!a) return;
    const href = a.getAttribute('href');
    if (href === '#ty-tradein-buy') {
      const tb = document.querySelector('.ti-card__btn');
      if (!tb) return;
      /* הכפתור פותח את חלון האישור של אפליקציית הטרייד אין, ולכן אין צורך לגלול אליו */
      e.preventDefault(); tb.click(); return;
    }
    if (!a.closest('.ti-btns') || a.classList.contains('ghost')) return;
    let u; try { u = new URL(href, location.href); } catch (er) { return; }
    if (u.pathname !== location.pathname) return;
    const sb = document.getElementById('StickyBuyBarBtn');
    const real = document.querySelector('product-form button[name="add"], .product-form__submit[name="add"]');
    if (!sb && !real) return;
    e.preventDefault(); (sb || real).click();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
